!function (t, e) {
    "object" == typeof exports && "undefined" != typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define(e) : t.PointerEventsPolyfill = e()
}(this, function () {
    "use strict";
    function t() {
        this.array = [], this.size = 0
    }

    function e(t, e, n, i) {
        this.addCallback = t.bind(i), this.removeCallback = e.bind(i), this.changedCallback = n.bind(i), S && (this.observer = new S(this.mutationWatcher.bind(this)))
    }

    function n(t, e) {
        e = e || Object.create(null);
        var n = document.createEvent("Event");
        n.initEvent(t, e.bubbles || !1, e.cancelable || !1);
        for (var i, r = 2; r < $.length; r++)i = $[r], n[i] = e[i] || _[r];
        n.buttons = e.buttons || 0;
        var o = 0;
        return o = e.pressure ? e.pressure : n.buttons ? .5 : 0, n.x = n.clientX, n.y = n.clientY, n.pointerId = e.pointerId || 0, n.width = e.width || 0, n.height = e.height || 0, n.pressure = o, n.tiltX = e.tiltX || 0, n.tiltY = e.tiltY || 0, n.pointerType = e.pointerType || "", n.hwTimestamp = e.hwTimestamp || 0, n.isPrimary = e.isPrimary || !1, n
    }

    function i(t) {
        return "body /shadow-deep/ " + r(t)
    }

    function r(t) {
        return '[touch-action="' + t + '"]'
    }

    function o(t) {
        return "{ -ms-touch-action: " + t + "; touch-action: " + t + "; touch-action-delay: none; }"
    }

    function s() {
        if (A) {
            j.forEach(function (t) {
                String(t) === t ? (P += r(t) + o(t) + "\n", I && (P += i(t) + o(t) + "\n")) : (P += t.selectors.map(r) + o(t.rule) + "\n", I && (P += t.selectors.map(i) + o(t.rule) + "\n"))
            });
            var t = document.createElement("style");
            t.textContent = P, document.head.appendChild(t)
        }
    }

    function a() {
        if (!window.PointerEvent) {
            if (window.PointerEvent = F, window.navigator.msPointerEnabled) {
                var t = window.navigator.msMaxTouchPoints;
                Object.defineProperty(window.navigator, "maxTouchPoints", {
                    value: t,
                    enumerable: !0
                }), v.registerSource("ms", it)
            } else v.registerSource("mouse", q), void 0 !== window.ontouchstart && v.registerSource("touch", Z);
            v.register(document)
        }
    }

    function u(t) {
        if (!v.pointermap.has(t))throw new Error("InvalidPointerId")
    }

    function l() {
        window.Element && !Element.prototype.setPointerCapture && Object.defineProperties(Element.prototype, {
            setPointerCapture: {value: K},
            releasePointerCapture: {value: J}
        })
    }

    var c = window.Map && window.Map.prototype.forEach, d = c ? Map : t;
    t.prototype = {
        set: function (t, e) {
            return void 0 === e ? this["delete"](t) : (this.has(t) || this.size++, void(this.array[t] = e))
        }, has: function (t) {
            return void 0 !== this.array[t]
        }, "delete": function (t) {
            this.has(t) && (delete this.array[t], this.size--)
        }, get: function (t) {
            return this.array[t]
        }, clear: function () {
            this.array.length = 0, this.size = 0
        }, forEach: function (t, e) {
            return this.array.forEach(function (n, i) {
                t.call(e, n, i, this)
            }, this)
        }
    };
    var h = d, p = ["bubbles", "cancelable", "view", "detail", "screenX", "screenY", "clientX", "clientY", "ctrlKey", "altKey", "shiftKey", "metaKey", "button", "relatedTarget", "buttons", "pointerId", "width", "height", "pressure", "tiltX", "tiltY", "pointerType", "hwTimestamp", "isPrimary", "type", "target", "currentTarget", "which", "pageX", "pageY", "timeStamp"], f = [!1, !1, null, null, 0, 0, 0, 0, !1, !1, !1, !1, 0, null, 0, 0, 0, 0, 0, 0, 0, "", 0, !1, "", null, null, 0, 0, 0, 0], m = "undefined" != typeof SVGElementInstance, g = {
        pointermap: new h,
        eventMap: Object.create(null),
        captureInfo: Object.create(null),
        eventSources: Object.create(null),
        eventSourceList: [],
        registerSource: function (t, e) {
            var n = e, i = n.events;
            i && (i.forEach(function (t) {
                n[t] && (this.eventMap[t] = n[t].bind(n))
            }, this), this.eventSources[t] = n, this.eventSourceList.push(n))
        },
        register: function (t) {
            for (var e, n = this.eventSourceList.length, i = 0; n > i && (e = this.eventSourceList[i]); i++)e.register.call(e, t)
        },
        unregister: function (t) {
            for (var e, n = this.eventSourceList.length, i = 0; n > i && (e = this.eventSourceList[i]); i++)e.unregister.call(e, t)
        },
        contains: function (t, e) {
            try {
                return t.contains(e)
            } catch (n) {
                return !1
            }
        },
        down: function (t) {
            t.bubbles = !0, this.fireEvent("pointerdown", t)
        },
        move: function (t) {
            t.bubbles = !0, this.fireEvent("pointermove", t)
        },
        up: function (t) {
            t.bubbles = !0, this.fireEvent("pointerup", t)
        },
        enter: function (t) {
            t.bubbles = !1, this.fireEvent("pointerenter", t)
        },
        leave: function (t) {
            t.bubbles = !1, this.fireEvent("pointerleave", t)
        },
        over: function (t) {
            t.bubbles = !0, this.fireEvent("pointerover", t)
        },
        out: function (t) {
            t.bubbles = !0, this.fireEvent("pointerout", t)
        },
        cancel: function (t) {
            t.bubbles = !0, this.fireEvent("pointercancel", t)
        },
        leaveOut: function (t) {
            this.out(t), this.contains(t.target, t.relatedTarget) || this.leave(t)
        },
        enterOver: function (t) {
            this.over(t), this.contains(t.target, t.relatedTarget) || this.enter(t)
        },
        eventHandler: function (t) {
            if (!t._handledByPE) {
                var e = t.type, n = this.eventMap && this.eventMap[e];
                n && n(t), t._handledByPE = !0
            }
        },
        listen: function (t, e) {
            e.forEach(function (e) {
                this.addEvent(t, e)
            }, this)
        },
        unlisten: function (t, e) {
            e.forEach(function (e) {
                this.removeEvent(t, e)
            }, this)
        },
        addEvent: function (t, e) {
            t.addEventListener(e, this.boundHandler)
        },
        removeEvent: function (t, e) {
            t.removeEventListener(e, this.boundHandler)
        },
        makeEvent: function (t, e) {
            this.captureInfo[e.pointerId] && (e.relatedTarget = null);
            var n = new PointerEvent(t, e);
            return e.preventDefault && (n.preventDefault = e.preventDefault), n._target = n._target || e.target, n
        },
        fireEvent: function (t, e) {
            var n = this.makeEvent(t, e);
            return this.dispatchEvent(n)
        },
        cloneEvent: function (t) {
            for (var e, n = Object.create(null), i = 0; i < p.length; i++)e = p[i], n[e] = t[e] || f[i], !m || "target" !== e && "relatedTarget" !== e || n[e] instanceof SVGElementInstance && (n[e] = n[e].correspondingUseElement);
            return t.preventDefault && (n.preventDefault = function () {
                t.preventDefault()
            }), n
        },
        getTarget: function (t) {
            return this.captureInfo[t.pointerId] || t._target
        },
        setCapture: function (t, e) {
            this.captureInfo[t] && this.releaseCapture(t), this.captureInfo[t] = e;
            var n = document.createEvent("Event");
            n.initEvent("gotpointercapture", !0, !1), n.pointerId = t, this.implicitRelease = this.releaseCapture.bind(this, t), document.addEventListener("pointerup", this.implicitRelease), document.addEventListener("pointercancel", this.implicitRelease), n._target = e, this.asyncDispatchEvent(n)
        },
        releaseCapture: function (t) {
            var e = this.captureInfo[t];
            if (e) {
                var n = document.createEvent("Event");
                n.initEvent("lostpointercapture", !0, !1), n.pointerId = t, this.captureInfo[t] = void 0, document.removeEventListener("pointerup", this.implicitRelease), document.removeEventListener("pointercancel", this.implicitRelease), n._target = e, this.asyncDispatchEvent(n)
            }
        },
        dispatchEvent: function (t) {
            var e = this.getTarget(t);
            return e ? e.dispatchEvent(t) : void 0
        },
        asyncDispatchEvent: function (t) {
            requestAnimationFrame(this.dispatchEvent.bind(this, t))
        }
    };
    g.boundHandler = g.eventHandler.bind(g);
    var v = g, y = {
        shadow: function (t) {
            return t ? t.shadowRoot || t.webkitShadowRoot : void 0
        }, canTarget: function (t) {
            return t && Boolean(t.elementFromPoint)
        }, targetingShadow: function (t) {
            var e = this.shadow(t);
            return this.canTarget(e) ? e : void 0
        }, olderShadow: function (t) {
            var e = t.olderShadowRoot;
            if (!e) {
                var n = t.querySelector("shadow");
                n && (e = n.olderShadowRoot)
            }
            return e
        }, allShadows: function (t) {
            for (var e = [], n = this.shadow(t); n;)e.push(n), n = this.olderShadow(n);
            return e
        }, searchRoot: function (t, e, n) {
            if (t) {
                var i, r, o = t.elementFromPoint(e, n);
                for (r = this.targetingShadow(o); r;) {
                    if (i = r.elementFromPoint(e, n)) {
                        var s = this.targetingShadow(i);
                        return this.searchRoot(s, e, n) || i
                    }
                    r = this.olderShadow(r)
                }
                return o
            }
        }, owner: function (t) {
            for (var e = t; e.parentNode;)e = e.parentNode;
            return e.nodeType !== Node.DOCUMENT_NODE && e.nodeType !== Node.DOCUMENT_FRAGMENT_NODE && (e = document), e
        }, findTarget: function (t) {
            var e = t.clientX, n = t.clientY, i = this.owner(t.target);
            return i.elementFromPoint(e, n) || (i = document), this.searchRoot(i, e, n)
        }
    }, b = Array.prototype.forEach.call.bind(Array.prototype.forEach), w = Array.prototype.map.call.bind(Array.prototype.map), C = Array.prototype.slice.call.bind(Array.prototype.slice), x = Array.prototype.filter.call.bind(Array.prototype.filter), S = window.MutationObserver || window.WebKitMutationObserver, T = "[touch-action]", k = {
        subtree: !0,
        childList: !0,
        attributes: !0,
        attributeOldValue: !0,
        attributeFilter: ["touch-action"]
    };
    e.prototype = {
        watchSubtree: function (t) {
            this.observer && y.canTarget(t) && this.observer.observe(t, k)
        }, enableOnSubtree: function (t) {
            this.watchSubtree(t), t === document && "complete" !== document.readyState ? this.installOnLoad() : this.installNewSubtree(t)
        }, installNewSubtree: function (t) {
            b(this.findElements(t), this.addElement, this)
        }, findElements: function (t) {
            return t.querySelectorAll ? t.querySelectorAll(T) : []
        }, removeElement: function (t) {
            this.removeCallback(t)
        }, addElement: function (t) {
            this.addCallback(t)
        }, elementChanged: function (t, e) {
            this.changedCallback(t, e)
        }, concatLists: function (t, e) {
            return t.concat(C(e))
        }, installOnLoad: function () {
            document.addEventListener("readystatechange", function () {
                "complete" === document.readyState && this.installNewSubtree(document)
            }.bind(this))
        }, isElement: function (t) {
            return t.nodeType === Node.ELEMENT_NODE
        }, flattenMutationTree: function (t) {
            var e = w(t, this.findElements, this);
            return e.push(x(t, this.isElement)), e.reduce(this.concatLists, [])
        }, mutationWatcher: function (t) {
            t.forEach(this.mutationHandler, this)
        }, mutationHandler: function (t) {
            if ("childList" === t.type) {
                var e = this.flattenMutationTree(t.addedNodes);
                e.forEach(this.addElement, this);
                var n = this.flattenMutationTree(t.removedNodes);
                n.forEach(this.removeElement, this)
            } else"attributes" === t.type && this.elementChanged(t.target, t.oldValue)
        }
    };
    var E = e, $ = ["bubbles", "cancelable", "view", "detail", "screenX", "screenY", "clientX", "clientY", "ctrlKey", "altKey", "shiftKey", "metaKey", "button", "relatedTarget", "pageX", "pageY"], _ = [!1, !1, null, null, 0, 0, 0, 0, !1, !1, !1, !1, 0, null, 0, 0], F = n, j = ["none", "auto", "pan-x", "pan-y", {
        rule: "pan-x pan-y",
        selectors: ["pan-x pan-y", "pan-y pan-x"]
    }], P = "", A = window.PointerEvent || window.MSPointerEvent, I = !window.ShadowDOMPolyfill && document.head.createShadowRoot, L = v.pointermap, D = 25, N = [1, 4, 2, 8, 16], O = !1;
    try {
        O = 1 === new MouseEvent("test", {buttons: 1}).buttons
    } catch (M) {
    }
    var R, H = {
        POINTER_ID: 1,
        POINTER_TYPE: "mouse",
        events: ["mousedown", "mousemove", "mouseup", "mouseover", "mouseout"],
        register: function (t) {
            v.listen(t, this.events)
        },
        unregister: function (t) {
            v.unlisten(t, this.events)
        },
        lastTouches: [],
        isEventSimulatedFromTouch: function (t) {
            for (var e, n = this.lastTouches, i = t.clientX, r = t.clientY, o = 0, s = n.length; s > o && (e = n[o]); o++) {
                var a = Math.abs(i - e.x), u = Math.abs(r - e.y);
                if (D >= a && D >= u)return !0
            }
        },
        prepareEvent: function (t) {
            var e = v.cloneEvent(t), n = e.preventDefault;
            return e.preventDefault = function () {
                t.preventDefault(), n()
            }, e.pointerId = this.POINTER_ID, e.isPrimary = !0, e.pointerType = this.POINTER_TYPE, e
        },
        prepareButtonsForMove: function (t, e) {
            var n = L.get(this.POINTER_ID);
            t.buttons = n ? n.buttons : 0, e.buttons = t.buttons
        },
        mousedown: function (t) {
            if (!this.isEventSimulatedFromTouch(t)) {
                var e = L.get(this.POINTER_ID), n = this.prepareEvent(t);
                O || (n.buttons = N[n.button], e && (n.buttons |= e.buttons), t.buttons = n.buttons), L.set(this.POINTER_ID, t), e ? v.move(n) : v.down(n)
            }
        },
        mousemove: function (t) {
            if (!this.isEventSimulatedFromTouch(t)) {
                var e = this.prepareEvent(t);
                O || this.prepareButtonsForMove(e, t), v.move(e)
            }
        },
        mouseup: function (t) {
            if (!this.isEventSimulatedFromTouch(t)) {
                var e = L.get(this.POINTER_ID), n = this.prepareEvent(t);
                if (!O) {
                    var i = N[n.button];
                    n.buttons = e ? e.buttons & ~i : 0, t.buttons = n.buttons
                }
                L.set(this.POINTER_ID, t), 0 === n.buttons ? (this.cleanupMouse(), v.up(n)) : v.move(n)
            }
        },
        mouseover: function (t) {
            if (!this.isEventSimulatedFromTouch(t)) {
                var e = this.prepareEvent(t);
                O || this.prepareButtonsForMove(e, t), v.enterOver(e)
            }
        },
        mouseout: function (t) {
            if (!this.isEventSimulatedFromTouch(t)) {
                var e = this.prepareEvent(t);
                O || this.prepareButtonsForMove(e, t), v.leaveOut(e)
            }
        },
        cancel: function (t) {
            var e = this.prepareEvent(t);
            v.cancel(e), this.cleanupMouse()
        },
        cleanupMouse: function () {
            L["delete"](this.POINTER_ID)
        }
    }, q = H, z = v.captureInfo, B = y.findTarget.bind(y), V = y.allShadows.bind(y), U = v.pointermap, W = 2500, X = 200, Q = "touch-action", G = !1, Y = {
        events: ["touchstart", "touchmove", "touchend", "touchcancel"],
        register: function (t) {
            G ? v.listen(t, this.events) : R.enableOnSubtree(t)
        },
        unregister: function (t) {
            G && v.unlisten(t, this.events)
        },
        elementAdded: function (t) {
            var e = t.getAttribute(Q), n = this.touchActionToScrollType(e);
            n && (t._scrollType = n, v.listen(t, this.events), V(t).forEach(function (t) {
                t._scrollType = n, v.listen(t, this.events)
            }, this))
        },
        elementRemoved: function (t) {
            t._scrollType = void 0, v.unlisten(t, this.events), V(t).forEach(function (t) {
                t._scrollType = void 0, v.unlisten(t, this.events)
            }, this)
        },
        elementChanged: function (t, e) {
            var n = t.getAttribute(Q), i = this.touchActionToScrollType(n), r = this.touchActionToScrollType(e);
            i && r ? (t._scrollType = i, V(t).forEach(function (t) {
                t._scrollType = i
            }, this)) : r ? this.elementRemoved(t) : i && this.elementAdded(t)
        },
        scrollTypes: {
            EMITTER: "none",
            XSCROLLER: "pan-x",
            YSCROLLER: "pan-y",
            SCROLLER: /^(?:pan-x pan-y)|(?:pan-y pan-x)|auto$/
        },
        touchActionToScrollType: function (t) {
            var e = t, n = this.scrollTypes;
            return "none" === e ? "none" : e === n.XSCROLLER ? "X" : e === n.YSCROLLER ? "Y" : n.SCROLLER.exec(e) ? "XY" : void 0
        },
        POINTER_TYPE: "touch",
        firstTouch: null,
        isPrimaryTouch: function (t) {
            return this.firstTouch === t.identifier
        },
        setPrimaryTouch: function (t) {
            (0 === U.size || 1 === U.size && U.has(1)) && (this.firstTouch = t.identifier, this.firstXY = {
                X: t.clientX,
                Y: t.clientY
            }, this.scrolling = !1, this.cancelResetClickCount())
        },
        removePrimaryPointer: function (t) {
            t.isPrimary && (this.firstTouch = null, this.firstXY = null, this.resetClickCount())
        },
        clickCount: 0,
        resetId: null,
        resetClickCount: function () {
            var t = function () {
                this.clickCount = 0, this.resetId = null
            }.bind(this);
            this.resetId = setTimeout(t, X)
        },
        cancelResetClickCount: function () {
            this.resetId && clearTimeout(this.resetId)
        },
        typeToButtons: function (t) {
            var e = 0;
            return ("touchstart" === t || "touchmove" === t) && (e = 1), e
        },
        touchToPointer: function (t) {
            var e = this.currentTouchEvent, n = v.cloneEvent(t), i = n.pointerId = t.identifier + 2;
            n.target = z[i] || B(n), n.bubbles = !0, n.cancelable = !0, n.detail = this.clickCount, n.button = 0, n.buttons = this.typeToButtons(e.type), n.width = t.webkitRadiusX || t.radiusX || 0, n.height = t.webkitRadiusY || t.radiusY || 0, n.pressure = t.webkitForce || t.force || .5, n.isPrimary = this.isPrimaryTouch(t), n.pointerType = this.POINTER_TYPE;
            var r = this;
            return n.preventDefault = function () {
                r.scrolling = !1, r.firstXY = null, e.preventDefault()
            }, n
        },
        processTouches: function (t, e) {
            var n = t.changedTouches;
            this.currentTouchEvent = t;
            for (var i, r = 0; r < n.length; r++)i = n[r], e.call(this, this.touchToPointer(i))
        },
        shouldScroll: function (t) {
            if (this.firstXY) {
                var e, n = t.currentTarget._scrollType;
                if ("none" === n)e = !1; else if ("XY" === n)e = !0; else {
                    var i = t.changedTouches[0], r = n, o = "Y" === n ? "X" : "Y", s = Math.abs(i["client" + r] - this.firstXY[r]), a = Math.abs(i["client" + o] - this.firstXY[o]);
                    e = s >= a
                }
                return this.firstXY = null, e
            }
        },
        findTouch: function (t, e) {
            for (var n, i = 0, r = t.length; r > i && (n = t[i]); i++)if (n.identifier === e)return !0
        },
        vacuumTouches: function (t) {
            var e = t.touches;
            if (U.size >= e.length) {
                var n = [];
                U.forEach(function (t, i) {
                    if (1 !== i && !this.findTouch(e, i - 2)) {
                        var r = t.out;
                        n.push(r)
                    }
                }, this), n.forEach(this.cancelOut, this)
            }
        },
        touchstart: function (t) {
            this.vacuumTouches(t), this.setPrimaryTouch(t.changedTouches[0]), this.dedupSynthMouse(t), this.scrolling || (this.clickCount++, this.processTouches(t, this.overDown))
        },
        overDown: function (t) {
            U.set(t.pointerId, {target: t.target, out: t, outTarget: t.target}), v.over(t), v.enter(t), v.down(t)
        },
        touchmove: function (t) {
            this.scrolling || (this.shouldScroll(t) ? (this.scrolling = !0, this.touchcancel(t)) : (t.preventDefault(), this.processTouches(t, this.moveOverOut)))
        },
        moveOverOut: function (t) {
            var e = t, n = U.get(e.pointerId);
            if (n) {
                var i = n.out, r = n.outTarget;
                v.move(e), i && r !== e.target && (i.relatedTarget = e.target, e.relatedTarget = r, i.target = r, e.target ? (v.leaveOut(i), v.enterOver(e)) : (e.target = r, e.relatedTarget = null, this.cancelOut(e))), n.out = e, n.outTarget = e.target
            }
        },
        touchend: function (t) {
            this.dedupSynthMouse(t), this.processTouches(t, this.upOut)
        },
        upOut: function (t) {
            this.scrolling || (v.up(t), v.out(t), v.leave(t)), this.cleanUpPointer(t)
        },
        touchcancel: function (t) {
            this.processTouches(t, this.cancelOut)
        },
        cancelOut: function (t) {
            v.cancel(t), v.out(t), v.leave(t), this.cleanUpPointer(t)
        },
        cleanUpPointer: function (t) {
            U["delete"](t.pointerId), this.removePrimaryPointer(t)
        },
        dedupSynthMouse: function (t) {
            var e = q.lastTouches, n = t.changedTouches[0];
            if (this.isPrimaryTouch(n)) {
                var i = {x: n.clientX, y: n.clientY};
                e.push(i);
                var r = function (t, e) {
                    var n = t.indexOf(e);
                    n > -1 && t.splice(n, 1)
                }.bind(null, e, i);
                setTimeout(r, W)
            }
        }
    };
    G || (R = new E(Y.elementAdded, Y.elementRemoved, Y.elementChanged, Y));
    var K, J, Z = Y, tt = v.pointermap, et = window.MSPointerEvent && "number" == typeof window.MSPointerEvent.MSPOINTER_TYPE_MOUSE, nt = {
        events: ["MSPointerDown", "MSPointerMove", "MSPointerUp", "MSPointerOut", "MSPointerOver", "MSPointerCancel", "MSGotPointerCapture", "MSLostPointerCapture"],
        register: function (t) {
            v.listen(t, this.events)
        },
        unregister: function (t) {
            v.unlisten(t, this.events)
        },
        POINTER_TYPES: ["", "unavailable", "touch", "pen", "mouse"],
        prepareEvent: function (t) {
            var e = t;
            return et && (e = v.cloneEvent(t), e.pointerType = this.POINTER_TYPES[t.pointerType]), e
        },
        cleanup: function (t) {
            tt["delete"](t)
        },
        MSPointerDown: function (t) {
            tt.set(t.pointerId, t);
            var e = this.prepareEvent(t);
            v.down(e)
        },
        MSPointerMove: function (t) {
            var e = this.prepareEvent(t);
            v.move(e)
        },
        MSPointerUp: function (t) {
            var e = this.prepareEvent(t);
            v.up(e), this.cleanup(t.pointerId)
        },
        MSPointerOut: function (t) {
            var e = this.prepareEvent(t);
            v.leaveOut(e)
        },
        MSPointerOver: function (t) {
            var e = this.prepareEvent(t);
            v.enterOver(e)
        },
        MSPointerCancel: function (t) {
            var e = this.prepareEvent(t);
            v.cancel(e), this.cleanup(t.pointerId)
        },
        MSLostPointerCapture: function (t) {
            var e = v.makeEvent("lostpointercapture", t);
            v.dispatchEvent(e)
        },
        MSGotPointerCapture: function (t) {
            var e = v.makeEvent("gotpointercapture", t);
            v.dispatchEvent(e)
        }
    }, it = nt, rt = window.navigator;
    rt.msPointerEnabled ? (K = function (t) {
        u(t), this.msSetPointerCapture(t)
    }, J = function (t) {
        u(t), this.msReleasePointerCapture(t)
    }) : (K = function (t) {
        u(t), v.setCapture(t, this)
    }, J = function (t) {
        u(t), v.releaseCapture(t, this)
    }), s(), a(), l();
    var ot = {dispatcher: v, Installer: E, PointerEvent: F, PointerMap: h, targetFinding: y};
    return ot
}), function (t, e) {
    "object" == typeof module && "object" == typeof module.exports ? module.exports = t.document ? e(t, !0) : function (t) {
        if (!t.document)throw new Error("jQuery requires a window with a document");
        return e(t)
    } : e(t)
}("undefined" != typeof window ? window : this, function (t, e) {
    function n(t) {
        var e = "length" in t && t.length, n = Z.type(t);
        return "function" === n || Z.isWindow(t) ? !1 : 1 === t.nodeType && e ? !0 : "array" === n || 0 === e || "number" == typeof e && e > 0 && e - 1 in t
    }

    function i(t, e, n) {
        if (Z.isFunction(e))return Z.grep(t, function (t, i) {
            return !!e.call(t, i, t) !== n
        });
        if (e.nodeType)return Z.grep(t, function (t) {
            return t === e !== n
        });
        if ("string" == typeof e) {
            if (at.test(e))return Z.filter(e, t, n);
            e = Z.filter(e, t)
        }
        return Z.grep(t, function (t) {
            return W.call(e, t) >= 0 !== n
        })
    }

    function r(t, e) {
        for (; (t = t[e]) && 1 !== t.nodeType;);
        return t
    }

    function o(t) {
        var e = ft[t] = {};
        return Z.each(t.match(pt) || [], function (t, n) {
            e[n] = !0
        }), e
    }

    function s() {
        K.removeEventListener("DOMContentLoaded", s, !1), t.removeEventListener("load", s, !1), Z.ready()
    }

    function a() {
        Object.defineProperty(this.cache = {}, 0, {
            get: function () {
                return {}
            }
        }), this.expando = Z.expando + a.uid++
    }

    function u(t, e, n) {
        var i;
        if (void 0 === n && 1 === t.nodeType)if (i = "data-" + e.replace(wt, "-$1").toLowerCase(), n = t.getAttribute(i), "string" == typeof n) {
            try {
                n = "true" === n ? !0 : "false" === n ? !1 : "null" === n ? null : +n + "" === n ? +n : bt.test(n) ? Z.parseJSON(n) : n
            } catch (r) {
            }
            yt.set(t, e, n)
        } else n = void 0;
        return n
    }

    function l() {
        return !0
    }

    function c() {
        return !1
    }

    function d() {
        try {
            return K.activeElement
        } catch (t) {
        }
    }

    function h(t, e) {
        return Z.nodeName(t, "table") && Z.nodeName(11 !== e.nodeType ? e : e.firstChild, "tr") ? t.getElementsByTagName("tbody")[0] || t.appendChild(t.ownerDocument.createElement("tbody")) : t
    }

    function p(t) {
        return t.type = (null !== t.getAttribute("type")) + "/" + t.type, t
    }

    function f(t) {
        var e = Nt.exec(t.type);
        return e ? t.type = e[1] : t.removeAttribute("type"), t
    }

    function m(t, e) {
        for (var n = 0, i = t.length; i > n; n++)vt.set(t[n], "globalEval", !e || vt.get(e[n], "globalEval"))
    }

    function g(t, e) {
        var n, i, r, o, s, a, u, l;
        if (1 === e.nodeType) {
            if (vt.hasData(t) && (o = vt.access(t), s = vt.set(e, o), l = o.events)) {
                delete s.handle, s.events = {};
                for (r in l)for (n = 0, i = l[r].length; i > n; n++)Z.event.add(e, r, l[r][n])
            }
            yt.hasData(t) && (a = yt.access(t), u = Z.extend({}, a), yt.set(e, u))
        }
    }

    function v(t, e) {
        var n = t.getElementsByTagName ? t.getElementsByTagName(e || "*") : t.querySelectorAll ? t.querySelectorAll(e || "*") : [];
        return void 0 === e || e && Z.nodeName(t, e) ? Z.merge([t], n) : n
    }

    function y(t, e) {
        var n = e.nodeName.toLowerCase();
        "input" === n && Tt.test(t.type) ? e.checked = t.checked : ("input" === n || "textarea" === n) && (e.defaultValue = t.defaultValue)
    }

    function b(e, n) {
        var i, r = Z(n.createElement(e)).appendTo(n.body), o = t.getDefaultComputedStyle && (i = t.getDefaultComputedStyle(r[0])) ? i.display : Z.css(r[0], "display");
        return r.detach(), o
    }

    function w(t) {
        var e = K, n = Ht[t];
        return n || (n = b(t, e), "none" !== n && n || (Rt = (Rt || Z("<iframe frameborder='0' width='0' height='0'/>")).appendTo(e.documentElement), e = Rt[0].contentDocument, e.write(), e.close(), n = b(t, e), Rt.detach()), Ht[t] = n), n
    }

    function C(t, e, n) {
        var i, r, o, s, a = t.style;
        return n = n || Bt(t), n && (s = n.getPropertyValue(e) || n[e]), n && ("" !== s || Z.contains(t.ownerDocument, t) || (s = Z.style(t, e)), zt.test(s) && qt.test(e) && (i = a.width, r = a.minWidth, o = a.maxWidth, a.minWidth = a.maxWidth = a.width = s, s = n.width, a.width = i, a.minWidth = r, a.maxWidth = o)), void 0 !== s ? s + "" : s
    }

    function x(t, e) {
        return {
            get: function () {
                return t() ? void delete this.get : (this.get = e).apply(this, arguments)
            }
        }
    }

    function S(t, e) {
        if (e in t)return e;
        for (var n = e[0].toUpperCase() + e.slice(1), i = e, r = Gt.length; r--;)if (e = Gt[r] + n, e in t)return e;
        return i
    }

    function T(t, e, n) {
        var i = Ut.exec(e);
        return i ? Math.max(0, i[1] - (n || 0)) + (i[2] || "px") : e
    }

    function k(t, e, n, i, r) {
        for (var o = n === (i ? "border" : "content") ? 4 : "width" === e ? 1 : 0, s = 0; 4 > o; o += 2)"margin" === n && (s += Z.css(t, n + xt[o], !0, r)), i ? ("content" === n && (s -= Z.css(t, "padding" + xt[o], !0, r)), "margin" !== n && (s -= Z.css(t, "border" + xt[o] + "Width", !0, r))) : (s += Z.css(t, "padding" + xt[o], !0, r), "padding" !== n && (s += Z.css(t, "border" + xt[o] + "Width", !0, r)));
        return s
    }

    function E(t, e, n) {
        var i = !0, r = "width" === e ? t.offsetWidth : t.offsetHeight, o = Bt(t), s = "border-box" === Z.css(t, "boxSizing", !1, o);
        if (0 >= r || null == r) {
            if (r = C(t, e, o), (0 > r || null == r) && (r = t.style[e]), zt.test(r))return r;
            i = s && (Y.boxSizingReliable() || r === t.style[e]), r = parseFloat(r) || 0
        }
        return r + k(t, e, n || (s ? "border" : "content"), i, o) + "px"
    }

    function $(t, e) {
        for (var n, i, r, o = [], s = 0, a = t.length; a > s; s++)i = t[s], i.style && (o[s] = vt.get(i, "olddisplay"), n = i.style.display, e ? (o[s] || "none" !== n || (i.style.display = ""), "" === i.style.display && St(i) && (o[s] = vt.access(i, "olddisplay", w(i.nodeName)))) : (r = St(i), "none" === n && r || vt.set(i, "olddisplay", r ? n : Z.css(i, "display"))));
        for (s = 0; a > s; s++)i = t[s], i.style && (e && "none" !== i.style.display && "" !== i.style.display || (i.style.display = e ? o[s] || "" : "none"));
        return t
    }

    function _(t, e, n, i, r) {
        return new _.prototype.init(t, e, n, i, r)
    }

    function F() {
        return setTimeout(function () {
            Yt = void 0
        }), Yt = Z.now()
    }

    function j(t, e) {
        var n, i = 0, r = {height: t};
        for (e = e ? 1 : 0; 4 > i; i += 2 - e)n = xt[i], r["margin" + n] = r["padding" + n] = t;
        return e && (r.opacity = r.width = t), r
    }

    function P(t, e, n) {
        for (var i, r = (ne[e] || []).concat(ne["*"]), o = 0, s = r.length; s > o; o++)if (i = r[o].call(n, e, t))return i
    }

    function A(t, e, n) {
        var i, r, o, s, a, u, l, c, d = this, h = {}, p = t.style, f = t.nodeType && St(t), m = vt.get(t, "fxshow");
        n.queue || (a = Z._queueHooks(t, "fx"), null == a.unqueued && (a.unqueued = 0, u = a.empty.fire, a.empty.fire = function () {
            a.unqueued || u()
        }), a.unqueued++, d.always(function () {
            d.always(function () {
                a.unqueued--, Z.queue(t, "fx").length || a.empty.fire()
            })
        })), 1 === t.nodeType && ("height" in e || "width" in e) && (n.overflow = [p.overflow, p.overflowX, p.overflowY], l = Z.css(t, "display"), c = "none" === l ? vt.get(t, "olddisplay") || w(t.nodeName) : l, "inline" === c && "none" === Z.css(t, "float") && (p.display = "inline-block")), n.overflow && (p.overflow = "hidden", d.always(function () {
            p.overflow = n.overflow[0], p.overflowX = n.overflow[1], p.overflowY = n.overflow[2]
        }));
        for (i in e)if (r = e[i], Jt.exec(r)) {
            if (delete e[i], o = o || "toggle" === r, r === (f ? "hide" : "show")) {
                if ("show" !== r || !m || void 0 === m[i])continue;
                f = !0
            }
            h[i] = m && m[i] || Z.style(t, i)
        } else l = void 0;
        if (Z.isEmptyObject(h))"inline" === ("none" === l ? w(t.nodeName) : l) && (p.display = l); else {
            m ? "hidden" in m && (f = m.hidden) : m = vt.access(t, "fxshow", {}), o && (m.hidden = !f), f ? Z(t).show() : d.done(function () {
                Z(t).hide()
            }), d.done(function () {
                var e;
                vt.remove(t, "fxshow");
                for (e in h)Z.style(t, e, h[e])
            });
            for (i in h)s = P(f ? m[i] : 0, i, d), i in m || (m[i] = s.start, f && (s.end = s.start, s.start = "width" === i || "height" === i ? 1 : 0))
        }
    }

    function I(t, e) {
        var n, i, r, o, s;
        for (n in t)if (i = Z.camelCase(n), r = e[i], o = t[n], Z.isArray(o) && (r = o[1], o = t[n] = o[0]), n !== i && (t[i] = o, delete t[n]), s = Z.cssHooks[i], s && "expand" in s) {
            o = s.expand(o), delete t[i];
            for (n in o)n in t || (t[n] = o[n], e[n] = r)
        } else e[i] = r
    }

    function L(t, e, n) {
        var i, r, o = 0, s = ee.length, a = Z.Deferred().always(function () {
            delete u.elem
        }), u = function () {
            if (r)return !1;
            for (var e = Yt || F(), n = Math.max(0, l.startTime + l.duration - e), i = n / l.duration || 0, o = 1 - i, s = 0, u = l.tweens.length; u > s; s++)l.tweens[s].run(o);
            return a.notifyWith(t, [l, o, n]), 1 > o && u ? n : (a.resolveWith(t, [l]), !1)
        }, l = a.promise({
            elem: t,
            props: Z.extend({}, e),
            opts: Z.extend(!0, {specialEasing: {}}, n),
            originalProperties: e,
            originalOptions: n,
            startTime: Yt || F(),
            duration: n.duration,
            tweens: [],
            createTween: function (e, n) {
                var i = Z.Tween(t, l.opts, e, n, l.opts.specialEasing[e] || l.opts.easing);
                return l.tweens.push(i), i
            },
            stop: function (e) {
                var n = 0, i = e ? l.tweens.length : 0;
                if (r)return this;
                for (r = !0; i > n; n++)l.tweens[n].run(1);
                return e ? a.resolveWith(t, [l, e]) : a.rejectWith(t, [l, e]), this
            }
        }), c = l.props;
        for (I(c, l.opts.specialEasing); s > o; o++)if (i = ee[o].call(l, t, c, l.opts))return i;
        return Z.map(c, P, l), Z.isFunction(l.opts.start) && l.opts.start.call(t, l), Z.fx.timer(Z.extend(u, {
            elem: t,
            anim: l,
            queue: l.opts.queue
        })), l.progress(l.opts.progress).done(l.opts.done, l.opts.complete).fail(l.opts.fail).always(l.opts.always)
    }

    function D(t) {
        return function (e, n) {
            "string" != typeof e && (n = e, e = "*");
            var i, r = 0, o = e.toLowerCase().match(pt) || [];
            if (Z.isFunction(n))for (; i = o[r++];)"+" === i[0] ? (i = i.slice(1) || "*", (t[i] = t[i] || []).unshift(n)) : (t[i] = t[i] || []).push(n)
        }
    }

    function N(t, e, n, i) {
        function r(a) {
            var u;
            return o[a] = !0, Z.each(t[a] || [], function (t, a) {
                var l = a(e, n, i);
                return "string" != typeof l || s || o[l] ? s ? !(u = l) : void 0 : (e.dataTypes.unshift(l), r(l), !1)
            }), u
        }

        var o = {}, s = t === be;
        return r(e.dataTypes[0]) || !o["*"] && r("*")
    }

    function O(t, e) {
        var n, i, r = Z.ajaxSettings.flatOptions || {};
        for (n in e)void 0 !== e[n] && ((r[n] ? t : i || (i = {}))[n] = e[n]);
        return i && Z.extend(!0, t, i), t
    }

    function M(t, e, n) {
        for (var i, r, o, s, a = t.contents, u = t.dataTypes; "*" === u[0];)u.shift(), void 0 === i && (i = t.mimeType || e.getResponseHeader("Content-Type"));
        if (i)for (r in a)if (a[r] && a[r].test(i)) {
            u.unshift(r);
            break
        }
        if (u[0] in n)o = u[0]; else {
            for (r in n) {
                if (!u[0] || t.converters[r + " " + u[0]]) {
                    o = r;
                    break
                }
                s || (s = r)
            }
            o = o || s
        }
        return o ? (o !== u[0] && u.unshift(o), n[o]) : void 0
    }

    function R(t, e, n, i) {
        var r, o, s, a, u, l = {}, c = t.dataTypes.slice();
        if (c[1])for (s in t.converters)l[s.toLowerCase()] = t.converters[s];
        for (o = c.shift(); o;)if (t.responseFields[o] && (n[t.responseFields[o]] = e), !u && i && t.dataFilter && (e = t.dataFilter(e, t.dataType)), u = o, o = c.shift())if ("*" === o)o = u; else if ("*" !== u && u !== o) {
            if (s = l[u + " " + o] || l["* " + o], !s)for (r in l)if (a = r.split(" "), a[1] === o && (s = l[u + " " + a[0]] || l["* " + a[0]])) {
                s === !0 ? s = l[r] : l[r] !== !0 && (o = a[0], c.unshift(a[1]));
                break
            }
            if (s !== !0)if (s && t["throws"])e = s(e); else try {
                e = s(e)
            } catch (d) {
                return {state: "parsererror", error: s ? d : "No conversion from " + u + " to " + o}
            }
        }
        return {state: "success", data: e}
    }

    function H(t, e, n, i) {
        var r;
        if (Z.isArray(e))Z.each(e, function (e, r) {
            n || Te.test(t) ? i(t, r) : H(t + "[" + ("object" == typeof r ? e : "") + "]", r, n, i)
        }); else if (n || "object" !== Z.type(e))i(t, e); else for (r in e)H(t + "[" + r + "]", e[r], n, i)
    }

    function q(t) {
        return Z.isWindow(t) ? t : 9 === t.nodeType && t.defaultView
    }

    var z = [], B = z.slice, V = z.concat, U = z.push, W = z.indexOf, X = {}, Q = X.toString, G = X.hasOwnProperty, Y = {}, K = t.document, J = "2.1.4", Z = function (t, e) {
        return new Z.fn.init(t, e)
    }, tt = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, et = /^-ms-/, nt = /-([\da-z])/gi, it = function (t, e) {
        return e.toUpperCase()
    };
    Z.fn = Z.prototype = {
        jquery: J, constructor: Z, selector: "", length: 0, toArray: function () {
            return B.call(this)
        }, get: function (t) {
            return null != t ? 0 > t ? this[t + this.length] : this[t] : B.call(this)
        }, pushStack: function (t) {
            var e = Z.merge(this.constructor(), t);
            return e.prevObject = this, e.context = this.context, e
        }, each: function (t, e) {
            return Z.each(this, t, e)
        }, map: function (t) {
            return this.pushStack(Z.map(this, function (e, n) {
                return t.call(e, n, e)
            }))
        }, slice: function () {
            return this.pushStack(B.apply(this, arguments))
        }, first: function () {
            return this.eq(0)
        }, last: function () {
            return this.eq(-1)
        }, eq: function (t) {
            var e = this.length, n = +t + (0 > t ? e : 0);
            return this.pushStack(n >= 0 && e > n ? [this[n]] : [])
        }, end: function () {
            return this.prevObject || this.constructor(null)
        }, push: U, sort: z.sort, splice: z.splice
    }, Z.extend = Z.fn.extend = function () {
        var t, e, n, i, r, o, s = arguments[0] || {}, a = 1, u = arguments.length, l = !1;
        for ("boolean" == typeof s && (l = s, s = arguments[a] || {}, a++), "object" == typeof s || Z.isFunction(s) || (s = {}), a === u && (s = this, a--); u > a; a++)if (null != (t = arguments[a]))for (e in t)n = s[e], i = t[e], s !== i && (l && i && (Z.isPlainObject(i) || (r = Z.isArray(i))) ? (r ? (r = !1, o = n && Z.isArray(n) ? n : []) : o = n && Z.isPlainObject(n) ? n : {}, s[e] = Z.extend(l, o, i)) : void 0 !== i && (s[e] = i));
        return s
    }, Z.extend({
        expando: "jQuery" + (J + Math.random()).replace(/\D/g, ""), isReady: !0, error: function (t) {
            throw new Error(t)
        }, noop: function () {
        }, isFunction: function (t) {
            return "function" === Z.type(t)
        }, isArray: Array.isArray, isWindow: function (t) {
            return null != t && t === t.window
        }, isNumeric: function (t) {
            return !Z.isArray(t) && t - parseFloat(t) + 1 >= 0
        }, isPlainObject: function (t) {
            return "object" !== Z.type(t) || t.nodeType || Z.isWindow(t) ? !1 : t.constructor && !G.call(t.constructor.prototype, "isPrototypeOf") ? !1 : !0
        }, isEmptyObject: function (t) {
            var e;
            for (e in t)return !1;
            return !0
        }, type: function (t) {
            return null == t ? t + "" : "object" == typeof t || "function" == typeof t ? X[Q.call(t)] || "object" : typeof t
        }, globalEval: function (t) {
            var e, n = eval;
            t = Z.trim(t), t && (1 === t.indexOf("use strict") ? (e = K.createElement("script"), e.text = t, K.head.appendChild(e).parentNode.removeChild(e)) : n(t))
        }, camelCase: function (t) {
            return t.replace(et, "ms-").replace(nt, it)
        }, nodeName: function (t, e) {
            return t.nodeName && t.nodeName.toLowerCase() === e.toLowerCase()
        }, each: function (t, e, i) {
            var r, o = 0, s = t.length, a = n(t);
            if (i) {
                if (a)for (; s > o && (r = e.apply(t[o], i), r !== !1); o++); else for (o in t)if (r = e.apply(t[o], i), r === !1)break
            } else if (a)for (; s > o && (r = e.call(t[o], o, t[o]), r !== !1); o++); else for (o in t)if (r = e.call(t[o], o, t[o]), r === !1)break;
            return t
        }, trim: function (t) {
            return null == t ? "" : (t + "").replace(tt, "")
        }, makeArray: function (t, e) {
            var i = e || [];
            return null != t && (n(Object(t)) ? Z.merge(i, "string" == typeof t ? [t] : t) : U.call(i, t)), i
        }, inArray: function (t, e, n) {
            return null == e ? -1 : W.call(e, t, n)
        }, merge: function (t, e) {
            for (var n = +e.length, i = 0, r = t.length; n > i; i++)t[r++] = e[i];
            return t.length = r, t
        }, grep: function (t, e, n) {
            for (var i, r = [], o = 0, s = t.length, a = !n; s > o; o++)i = !e(t[o], o), i !== a && r.push(t[o]);
            return r
        }, map: function (t, e, i) {
            var r, o = 0, s = t.length, a = n(t), u = [];
            if (a)for (; s > o; o++)r = e(t[o], o, i), null != r && u.push(r); else for (o in t)r = e(t[o], o, i), null != r && u.push(r);
            return V.apply([], u)
        }, guid: 1, proxy: function (t, e) {
            var n, i, r;
            return "string" == typeof e && (n = t[e], e = t, t = n), Z.isFunction(t) ? (i = B.call(arguments, 2), r = function () {
                return t.apply(e || this, i.concat(B.call(arguments)))
            }, r.guid = t.guid = t.guid || Z.guid++, r) : void 0
        }, now: Date.now, support: Y
    }), Z.each("Boolean Number String Function Array Date RegExp Object Error".split(" "), function (t, e) {
        X["[object " + e + "]"] = e.toLowerCase()
    });
    var rt = function (t) {
        function e(t, e, n, i) {
            var r, o, s, a, u, l, d, p, f, m;
            if ((e ? e.ownerDocument || e : H) !== A && P(e), e = e || A, n = n || [], a = e.nodeType, "string" != typeof t || !t || 1 !== a && 9 !== a && 11 !== a)return n;
            if (!i && L) {
                if (11 !== a && (r = yt.exec(t)))if (s = r[1]) {
                    if (9 === a) {
                        if (o = e.getElementById(s), !o || !o.parentNode)return n;
                        if (o.id === s)return n.push(o), n
                    } else if (e.ownerDocument && (o = e.ownerDocument.getElementById(s)) && M(e, o) && o.id === s)return n.push(o), n
                } else {
                    if (r[2])return J.apply(n, e.getElementsByTagName(t)), n;
                    if ((s = r[3]) && C.getElementsByClassName)return J.apply(n, e.getElementsByClassName(s)), n
                }
                if (C.qsa && (!D || !D.test(t))) {
                    if (p = d = R, f = e, m = 1 !== a && t, 1 === a && "object" !== e.nodeName.toLowerCase()) {
                        for (l = k(t), (d = e.getAttribute("id")) ? p = d.replace(wt, "\\$&") : e.setAttribute("id", p), p = "[id='" + p + "'] ", u = l.length; u--;)l[u] = p + h(l[u]);
                        f = bt.test(t) && c(e.parentNode) || e, m = l.join(",")
                    }
                    if (m)try {
                        return J.apply(n, f.querySelectorAll(m)), n
                    } catch (g) {
                    } finally {
                        d || e.removeAttribute("id")
                    }
                }
            }
            return $(t.replace(ut, "$1"), e, n, i)
        }

        function n() {
            function t(n, i) {
                return e.push(n + " ") > x.cacheLength && delete t[e.shift()], t[n + " "] = i
            }

            var e = [];
            return t
        }

        function i(t) {
            return t[R] = !0, t
        }

        function r(t) {
            var e = A.createElement("div");
            try {
                return !!t(e)
            } catch (n) {
                return !1
            } finally {
                e.parentNode && e.parentNode.removeChild(e), e = null
            }
        }

        function o(t, e) {
            for (var n = t.split("|"), i = t.length; i--;)x.attrHandle[n[i]] = e
        }

        function s(t, e) {
            var n = e && t, i = n && 1 === t.nodeType && 1 === e.nodeType && (~e.sourceIndex || X) - (~t.sourceIndex || X);
            if (i)return i;
            if (n)for (; n = n.nextSibling;)if (n === e)return -1;
            return t ? 1 : -1
        }

        function a(t) {
            return function (e) {
                var n = e.nodeName.toLowerCase();
                return "input" === n && e.type === t
            }
        }

        function u(t) {
            return function (e) {
                var n = e.nodeName.toLowerCase();
                return ("input" === n || "button" === n) && e.type === t
            }
        }

        function l(t) {
            return i(function (e) {
                return e = +e, i(function (n, i) {
                    for (var r, o = t([], n.length, e), s = o.length; s--;)n[r = o[s]] && (n[r] = !(i[r] = n[r]))
                })
            })
        }

        function c(t) {
            return t && "undefined" != typeof t.getElementsByTagName && t
        }

        function d() {
        }

        function h(t) {
            for (var e = 0, n = t.length, i = ""; n > e; e++)i += t[e].value;
            return i
        }

        function p(t, e, n) {
            var i = e.dir, r = n && "parentNode" === i, o = z++;
            return e.first ? function (e, n, o) {
                for (; e = e[i];)if (1 === e.nodeType || r)return t(e, n, o)
            } : function (e, n, s) {
                var a, u, l = [q, o];
                if (s) {
                    for (; e = e[i];)if ((1 === e.nodeType || r) && t(e, n, s))return !0
                } else for (; e = e[i];)if (1 === e.nodeType || r) {
                    if (u = e[R] || (e[R] = {}),
                        (a = u[i]) && a[0] === q && a[1] === o)return l[2] = a[2];
                    if (u[i] = l, l[2] = t(e, n, s))return !0
                }
            }
        }

        function f(t) {
            return t.length > 1 ? function (e, n, i) {
                for (var r = t.length; r--;)if (!t[r](e, n, i))return !1;
                return !0
            } : t[0]
        }

        function m(t, n, i) {
            for (var r = 0, o = n.length; o > r; r++)e(t, n[r], i);
            return i
        }

        function g(t, e, n, i, r) {
            for (var o, s = [], a = 0, u = t.length, l = null != e; u > a; a++)(o = t[a]) && (!n || n(o, i, r)) && (s.push(o), l && e.push(a));
            return s
        }

        function v(t, e, n, r, o, s) {
            return r && !r[R] && (r = v(r)), o && !o[R] && (o = v(o, s)), i(function (i, s, a, u) {
                var l, c, d, h = [], p = [], f = s.length, v = i || m(e || "*", a.nodeType ? [a] : a, []), y = !t || !i && e ? v : g(v, h, t, a, u), b = n ? o || (i ? t : f || r) ? [] : s : y;
                if (n && n(y, b, a, u), r)for (l = g(b, p), r(l, [], a, u), c = l.length; c--;)(d = l[c]) && (b[p[c]] = !(y[p[c]] = d));
                if (i) {
                    if (o || t) {
                        if (o) {
                            for (l = [], c = b.length; c--;)(d = b[c]) && l.push(y[c] = d);
                            o(null, b = [], l, u)
                        }
                        for (c = b.length; c--;)(d = b[c]) && (l = o ? tt(i, d) : h[c]) > -1 && (i[l] = !(s[l] = d))
                    }
                } else b = g(b === s ? b.splice(f, b.length) : b), o ? o(null, s, b, u) : J.apply(s, b)
            })
        }

        function y(t) {
            for (var e, n, i, r = t.length, o = x.relative[t[0].type], s = o || x.relative[" "], a = o ? 1 : 0, u = p(function (t) {
                return t === e
            }, s, !0), l = p(function (t) {
                return tt(e, t) > -1
            }, s, !0), c = [function (t, n, i) {
                var r = !o && (i || n !== _) || ((e = n).nodeType ? u(t, n, i) : l(t, n, i));
                return e = null, r
            }]; r > a; a++)if (n = x.relative[t[a].type])c = [p(f(c), n)]; else {
                if (n = x.filter[t[a].type].apply(null, t[a].matches), n[R]) {
                    for (i = ++a; r > i && !x.relative[t[i].type]; i++);
                    return v(a > 1 && f(c), a > 1 && h(t.slice(0, a - 1).concat({value: " " === t[a - 2].type ? "*" : ""})).replace(ut, "$1"), n, i > a && y(t.slice(a, i)), r > i && y(t = t.slice(i)), r > i && h(t))
                }
                c.push(n)
            }
            return f(c)
        }

        function b(t, n) {
            var r = n.length > 0, o = t.length > 0, s = function (i, s, a, u, l) {
                var c, d, h, p = 0, f = "0", m = i && [], v = [], y = _, b = i || o && x.find.TAG("*", l), w = q += null == y ? 1 : Math.random() || .1, C = b.length;
                for (l && (_ = s !== A && s); f !== C && null != (c = b[f]); f++) {
                    if (o && c) {
                        for (d = 0; h = t[d++];)if (h(c, s, a)) {
                            u.push(c);
                            break
                        }
                        l && (q = w)
                    }
                    r && ((c = !h && c) && p--, i && m.push(c))
                }
                if (p += f, r && f !== p) {
                    for (d = 0; h = n[d++];)h(m, v, s, a);
                    if (i) {
                        if (p > 0)for (; f--;)m[f] || v[f] || (v[f] = Y.call(u));
                        v = g(v)
                    }
                    J.apply(u, v), l && !i && v.length > 0 && p + n.length > 1 && e.uniqueSort(u)
                }
                return l && (q = w, _ = y), m
            };
            return r ? i(s) : s
        }

        var w, C, x, S, T, k, E, $, _, F, j, P, A, I, L, D, N, O, M, R = "sizzle" + 1 * new Date, H = t.document, q = 0, z = 0, B = n(), V = n(), U = n(), W = function (t, e) {
            return t === e && (j = !0), 0
        }, X = 1 << 31, Q = {}.hasOwnProperty, G = [], Y = G.pop, K = G.push, J = G.push, Z = G.slice, tt = function (t, e) {
            for (var n = 0, i = t.length; i > n; n++)if (t[n] === e)return n;
            return -1
        }, et = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", nt = "[\\x20\\t\\r\\n\\f]", it = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+", rt = it.replace("w", "w#"), ot = "\\[" + nt + "*(" + it + ")(?:" + nt + "*([*^$|!~]?=)" + nt + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + rt + "))|)" + nt + "*\\]", st = ":(" + it + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + ot + ")*)|.*)\\)|)", at = new RegExp(nt + "+", "g"), ut = new RegExp("^" + nt + "+|((?:^|[^\\\\])(?:\\\\.)*)" + nt + "+$", "g"), lt = new RegExp("^" + nt + "*," + nt + "*"), ct = new RegExp("^" + nt + "*([>+~]|" + nt + ")" + nt + "*"), dt = new RegExp("=" + nt + "*([^\\]'\"]*?)" + nt + "*\\]", "g"), ht = new RegExp(st), pt = new RegExp("^" + rt + "$"), ft = {
            ID: new RegExp("^#(" + it + ")"),
            CLASS: new RegExp("^\\.(" + it + ")"),
            TAG: new RegExp("^(" + it.replace("w", "w*") + ")"),
            ATTR: new RegExp("^" + ot),
            PSEUDO: new RegExp("^" + st),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + nt + "*(even|odd|(([+-]|)(\\d*)n|)" + nt + "*(?:([+-]|)" + nt + "*(\\d+)|))" + nt + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + et + ")$", "i"),
            needsContext: new RegExp("^" + nt + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + nt + "*((?:-\\d)?\\d*)" + nt + "*\\)|)(?=[^-]|$)", "i")
        }, mt = /^(?:input|select|textarea|button)$/i, gt = /^h\d$/i, vt = /^[^{]+\{\s*\[native \w/, yt = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, bt = /[+~]/, wt = /'|\\/g, Ct = new RegExp("\\\\([\\da-f]{1,6}" + nt + "?|(" + nt + ")|.)", "ig"), xt = function (t, e, n) {
            var i = "0x" + e - 65536;
            return i !== i || n ? e : 0 > i ? String.fromCharCode(i + 65536) : String.fromCharCode(i >> 10 | 55296, 1023 & i | 56320)
        }, St = function () {
            P()
        };
        try {
            J.apply(G = Z.call(H.childNodes), H.childNodes), G[H.childNodes.length].nodeType
        } catch (Tt) {
            J = {
                apply: G.length ? function (t, e) {
                    K.apply(t, Z.call(e))
                } : function (t, e) {
                    for (var n = t.length, i = 0; t[n++] = e[i++];);
                    t.length = n - 1
                }
            }
        }
        C = e.support = {}, T = e.isXML = function (t) {
            var e = t && (t.ownerDocument || t).documentElement;
            return e ? "HTML" !== e.nodeName : !1
        }, P = e.setDocument = function (t) {
            var e, n, i = t ? t.ownerDocument || t : H;
            return i !== A && 9 === i.nodeType && i.documentElement ? (A = i, I = i.documentElement, n = i.defaultView, n && n !== n.top && (n.addEventListener ? n.addEventListener("unload", St, !1) : n.attachEvent && n.attachEvent("onunload", St)), L = !T(i), C.attributes = r(function (t) {
                return t.className = "i", !t.getAttribute("className")
            }), C.getElementsByTagName = r(function (t) {
                return t.appendChild(i.createComment("")), !t.getElementsByTagName("*").length
            }), C.getElementsByClassName = vt.test(i.getElementsByClassName), C.getById = r(function (t) {
                return I.appendChild(t).id = R, !i.getElementsByName || !i.getElementsByName(R).length
            }), C.getById ? (x.find.ID = function (t, e) {
                if ("undefined" != typeof e.getElementById && L) {
                    var n = e.getElementById(t);
                    return n && n.parentNode ? [n] : []
                }
            }, x.filter.ID = function (t) {
                var e = t.replace(Ct, xt);
                return function (t) {
                    return t.getAttribute("id") === e
                }
            }) : (delete x.find.ID, x.filter.ID = function (t) {
                var e = t.replace(Ct, xt);
                return function (t) {
                    var n = "undefined" != typeof t.getAttributeNode && t.getAttributeNode("id");
                    return n && n.value === e
                }
            }), x.find.TAG = C.getElementsByTagName ? function (t, e) {
                return "undefined" != typeof e.getElementsByTagName ? e.getElementsByTagName(t) : C.qsa ? e.querySelectorAll(t) : void 0
            } : function (t, e) {
                var n, i = [], r = 0, o = e.getElementsByTagName(t);
                if ("*" === t) {
                    for (; n = o[r++];)1 === n.nodeType && i.push(n);
                    return i
                }
                return o
            }, x.find.CLASS = C.getElementsByClassName && function (t, e) {
                    return L ? e.getElementsByClassName(t) : void 0
                }, N = [], D = [], (C.qsa = vt.test(i.querySelectorAll)) && (r(function (t) {
                I.appendChild(t).innerHTML = "<a id='" + R + "'></a><select id='" + R + "-\f]' msallowcapture=''><option selected=''></option></select>", t.querySelectorAll("[msallowcapture^='']").length && D.push("[*^$]=" + nt + "*(?:''|\"\")"), t.querySelectorAll("[selected]").length || D.push("\\[" + nt + "*(?:value|" + et + ")"), t.querySelectorAll("[id~=" + R + "-]").length || D.push("~="), t.querySelectorAll(":checked").length || D.push(":checked"), t.querySelectorAll("a#" + R + "+*").length || D.push(".#.+[+~]")
            }), r(function (t) {
                var e = i.createElement("input");
                e.setAttribute("type", "hidden"), t.appendChild(e).setAttribute("name", "D"), t.querySelectorAll("[name=d]").length && D.push("name" + nt + "*[*^$|!~]?="), t.querySelectorAll(":enabled").length || D.push(":enabled", ":disabled"), t.querySelectorAll("*,:x"), D.push(",.*:")
            })), (C.matchesSelector = vt.test(O = I.matches || I.webkitMatchesSelector || I.mozMatchesSelector || I.oMatchesSelector || I.msMatchesSelector)) && r(function (t) {
                C.disconnectedMatch = O.call(t, "div"), O.call(t, "[s!='']:x"), N.push("!=", st)
            }), D = D.length && new RegExp(D.join("|")), N = N.length && new RegExp(N.join("|")), e = vt.test(I.compareDocumentPosition), M = e || vt.test(I.contains) ? function (t, e) {
                var n = 9 === t.nodeType ? t.documentElement : t, i = e && e.parentNode;
                return t === i || !(!i || 1 !== i.nodeType || !(n.contains ? n.contains(i) : t.compareDocumentPosition && 16 & t.compareDocumentPosition(i)))
            } : function (t, e) {
                if (e)for (; e = e.parentNode;)if (e === t)return !0;
                return !1
            }, W = e ? function (t, e) {
                if (t === e)return j = !0, 0;
                var n = !t.compareDocumentPosition - !e.compareDocumentPosition;
                return n ? n : (n = (t.ownerDocument || t) === (e.ownerDocument || e) ? t.compareDocumentPosition(e) : 1, 1 & n || !C.sortDetached && e.compareDocumentPosition(t) === n ? t === i || t.ownerDocument === H && M(H, t) ? -1 : e === i || e.ownerDocument === H && M(H, e) ? 1 : F ? tt(F, t) - tt(F, e) : 0 : 4 & n ? -1 : 1)
            } : function (t, e) {
                if (t === e)return j = !0, 0;
                var n, r = 0, o = t.parentNode, a = e.parentNode, u = [t], l = [e];
                if (!o || !a)return t === i ? -1 : e === i ? 1 : o ? -1 : a ? 1 : F ? tt(F, t) - tt(F, e) : 0;
                if (o === a)return s(t, e);
                for (n = t; n = n.parentNode;)u.unshift(n);
                for (n = e; n = n.parentNode;)l.unshift(n);
                for (; u[r] === l[r];)r++;
                return r ? s(u[r], l[r]) : u[r] === H ? -1 : l[r] === H ? 1 : 0
            }, i) : A
        }, e.matches = function (t, n) {
            return e(t, null, null, n)
        }, e.matchesSelector = function (t, n) {
            if ((t.ownerDocument || t) !== A && P(t), n = n.replace(dt, "='$1']"), C.matchesSelector && L && (!N || !N.test(n)) && (!D || !D.test(n)))try {
                var i = O.call(t, n);
                if (i || C.disconnectedMatch || t.document && 11 !== t.document.nodeType)return i
            } catch (r) {
            }
            return e(n, A, null, [t]).length > 0
        }, e.contains = function (t, e) {
            return (t.ownerDocument || t) !== A && P(t), M(t, e)
        }, e.attr = function (t, e) {
            (t.ownerDocument || t) !== A && P(t);
            var n = x.attrHandle[e.toLowerCase()], i = n && Q.call(x.attrHandle, e.toLowerCase()) ? n(t, e, !L) : void 0;
            return void 0 !== i ? i : C.attributes || !L ? t.getAttribute(e) : (i = t.getAttributeNode(e)) && i.specified ? i.value : null
        }, e.error = function (t) {
            throw new Error("Syntax error, unrecognized expression: " + t)
        }, e.uniqueSort = function (t) {
            var e, n = [], i = 0, r = 0;
            if (j = !C.detectDuplicates, F = !C.sortStable && t.slice(0), t.sort(W), j) {
                for (; e = t[r++];)e === t[r] && (i = n.push(r));
                for (; i--;)t.splice(n[i], 1)
            }
            return F = null, t
        }, S = e.getText = function (t) {
            var e, n = "", i = 0, r = t.nodeType;
            if (r) {
                if (1 === r || 9 === r || 11 === r) {
                    if ("string" == typeof t.textContent)return t.textContent;
                    for (t = t.firstChild; t; t = t.nextSibling)n += S(t)
                } else if (3 === r || 4 === r)return t.nodeValue
            } else for (; e = t[i++];)n += S(e);
            return n
        }, x = e.selectors = {
            cacheLength: 50,
            createPseudo: i,
            match: ft,
            attrHandle: {},
            find: {},
            relative: {
                ">": {dir: "parentNode", first: !0},
                " ": {dir: "parentNode"},
                "+": {dir: "previousSibling", first: !0},
                "~": {dir: "previousSibling"}
            },
            preFilter: {
                ATTR: function (t) {
                    return t[1] = t[1].replace(Ct, xt), t[3] = (t[3] || t[4] || t[5] || "").replace(Ct, xt), "~=" === t[2] && (t[3] = " " + t[3] + " "), t.slice(0, 4)
                }, CHILD: function (t) {
                    return t[1] = t[1].toLowerCase(), "nth" === t[1].slice(0, 3) ? (t[3] || e.error(t[0]), t[4] = +(t[4] ? t[5] + (t[6] || 1) : 2 * ("even" === t[3] || "odd" === t[3])), t[5] = +(t[7] + t[8] || "odd" === t[3])) : t[3] && e.error(t[0]), t
                }, PSEUDO: function (t) {
                    var e, n = !t[6] && t[2];
                    return ft.CHILD.test(t[0]) ? null : (t[3] ? t[2] = t[4] || t[5] || "" : n && ht.test(n) && (e = k(n, !0)) && (e = n.indexOf(")", n.length - e) - n.length) && (t[0] = t[0].slice(0, e), t[2] = n.slice(0, e)), t.slice(0, 3))
                }
            },
            filter: {
                TAG: function (t) {
                    var e = t.replace(Ct, xt).toLowerCase();
                    return "*" === t ? function () {
                        return !0
                    } : function (t) {
                        return t.nodeName && t.nodeName.toLowerCase() === e
                    }
                }, CLASS: function (t) {
                    var e = B[t + " "];
                    return e || (e = new RegExp("(^|" + nt + ")" + t + "(" + nt + "|$)")) && B(t, function (t) {
                            return e.test("string" == typeof t.className && t.className || "undefined" != typeof t.getAttribute && t.getAttribute("class") || "")
                        })
                }, ATTR: function (t, n, i) {
                    return function (r) {
                        var o = e.attr(r, t);
                        return null == o ? "!=" === n : n ? (o += "", "=" === n ? o === i : "!=" === n ? o !== i : "^=" === n ? i && 0 === o.indexOf(i) : "*=" === n ? i && o.indexOf(i) > -1 : "$=" === n ? i && o.slice(-i.length) === i : "~=" === n ? (" " + o.replace(at, " ") + " ").indexOf(i) > -1 : "|=" === n ? o === i || o.slice(0, i.length + 1) === i + "-" : !1) : !0
                    }
                }, CHILD: function (t, e, n, i, r) {
                    var o = "nth" !== t.slice(0, 3), s = "last" !== t.slice(-4), a = "of-type" === e;
                    return 1 === i && 0 === r ? function (t) {
                        return !!t.parentNode
                    } : function (e, n, u) {
                        var l, c, d, h, p, f, m = o !== s ? "nextSibling" : "previousSibling", g = e.parentNode, v = a && e.nodeName.toLowerCase(), y = !u && !a;
                        if (g) {
                            if (o) {
                                for (; m;) {
                                    for (d = e; d = d[m];)if (a ? d.nodeName.toLowerCase() === v : 1 === d.nodeType)return !1;
                                    f = m = "only" === t && !f && "nextSibling"
                                }
                                return !0
                            }
                            if (f = [s ? g.firstChild : g.lastChild], s && y) {
                                for (c = g[R] || (g[R] = {}), l = c[t] || [], p = l[0] === q && l[1], h = l[0] === q && l[2], d = p && g.childNodes[p]; d = ++p && d && d[m] || (h = p = 0) || f.pop();)if (1 === d.nodeType && ++h && d === e) {
                                    c[t] = [q, p, h];
                                    break
                                }
                            } else if (y && (l = (e[R] || (e[R] = {}))[t]) && l[0] === q)h = l[1]; else for (; (d = ++p && d && d[m] || (h = p = 0) || f.pop()) && ((a ? d.nodeName.toLowerCase() !== v : 1 !== d.nodeType) || !++h || (y && ((d[R] || (d[R] = {}))[t] = [q, h]), d !== e)););
                            return h -= r, h === i || h % i === 0 && h / i >= 0
                        }
                    }
                }, PSEUDO: function (t, n) {
                    var r, o = x.pseudos[t] || x.setFilters[t.toLowerCase()] || e.error("unsupported pseudo: " + t);
                    return o[R] ? o(n) : o.length > 1 ? (r = [t, t, "", n], x.setFilters.hasOwnProperty(t.toLowerCase()) ? i(function (t, e) {
                        for (var i, r = o(t, n), s = r.length; s--;)i = tt(t, r[s]), t[i] = !(e[i] = r[s])
                    }) : function (t) {
                        return o(t, 0, r)
                    }) : o
                }
            },
            pseudos: {
                not: i(function (t) {
                    var e = [], n = [], r = E(t.replace(ut, "$1"));
                    return r[R] ? i(function (t, e, n, i) {
                        for (var o, s = r(t, null, i, []), a = t.length; a--;)(o = s[a]) && (t[a] = !(e[a] = o))
                    }) : function (t, i, o) {
                        return e[0] = t, r(e, null, o, n), e[0] = null, !n.pop()
                    }
                }), has: i(function (t) {
                    return function (n) {
                        return e(t, n).length > 0
                    }
                }), contains: i(function (t) {
                    return t = t.replace(Ct, xt), function (e) {
                        return (e.textContent || e.innerText || S(e)).indexOf(t) > -1
                    }
                }), lang: i(function (t) {
                    return pt.test(t || "") || e.error("unsupported lang: " + t), t = t.replace(Ct, xt).toLowerCase(), function (e) {
                        var n;
                        do if (n = L ? e.lang : e.getAttribute("xml:lang") || e.getAttribute("lang"))return n = n.toLowerCase(), n === t || 0 === n.indexOf(t + "-"); while ((e = e.parentNode) && 1 === e.nodeType);
                        return !1
                    }
                }), target: function (e) {
                    var n = t.location && t.location.hash;
                    return n && n.slice(1) === e.id
                }, root: function (t) {
                    return t === I
                }, focus: function (t) {
                    return t === A.activeElement && (!A.hasFocus || A.hasFocus()) && !!(t.type || t.href || ~t.tabIndex)
                }, enabled: function (t) {
                    return t.disabled === !1
                }, disabled: function (t) {
                    return t.disabled === !0
                }, checked: function (t) {
                    var e = t.nodeName.toLowerCase();
                    return "input" === e && !!t.checked || "option" === e && !!t.selected
                }, selected: function (t) {
                    return t.parentNode && t.parentNode.selectedIndex, t.selected === !0
                }, empty: function (t) {
                    for (t = t.firstChild; t; t = t.nextSibling)if (t.nodeType < 6)return !1;
                    return !0
                }, parent: function (t) {
                    return !x.pseudos.empty(t)
                }, header: function (t) {
                    return gt.test(t.nodeName)
                }, input: function (t) {
                    return mt.test(t.nodeName)
                }, button: function (t) {
                    var e = t.nodeName.toLowerCase();
                    return "input" === e && "button" === t.type || "button" === e
                }, text: function (t) {
                    var e;
                    return "input" === t.nodeName.toLowerCase() && "text" === t.type && (null == (e = t.getAttribute("type")) || "text" === e.toLowerCase())
                }, first: l(function () {
                    return [0]
                }), last: l(function (t, e) {
                    return [e - 1]
                }), eq: l(function (t, e, n) {
                    return [0 > n ? n + e : n]
                }), even: l(function (t, e) {
                    for (var n = 0; e > n; n += 2)t.push(n);
                    return t
                }), odd: l(function (t, e) {
                    for (var n = 1; e > n; n += 2)t.push(n);
                    return t
                }), lt: l(function (t, e, n) {
                    for (var i = 0 > n ? n + e : n; --i >= 0;)t.push(i);
                    return t
                }), gt: l(function (t, e, n) {
                    for (var i = 0 > n ? n + e : n; ++i < e;)t.push(i);
                    return t
                })
            }
        }, x.pseudos.nth = x.pseudos.eq;
        for (w in{radio: !0, checkbox: !0, file: !0, password: !0, image: !0})x.pseudos[w] = a(w);
        for (w in{submit: !0, reset: !0})x.pseudos[w] = u(w);
        return d.prototype = x.filters = x.pseudos, x.setFilters = new d, k = e.tokenize = function (t, n) {
            var i, r, o, s, a, u, l, c = V[t + " "];
            if (c)return n ? 0 : c.slice(0);
            for (a = t, u = [], l = x.preFilter; a;) {
                (!i || (r = lt.exec(a))) && (r && (a = a.slice(r[0].length) || a), u.push(o = [])), i = !1, (r = ct.exec(a)) && (i = r.shift(), o.push({
                    value: i,
                    type: r[0].replace(ut, " ")
                }), a = a.slice(i.length));
                for (s in x.filter)!(r = ft[s].exec(a)) || l[s] && !(r = l[s](r)) || (i = r.shift(), o.push({
                    value: i,
                    type: s,
                    matches: r
                }), a = a.slice(i.length));
                if (!i)break
            }
            return n ? a.length : a ? e.error(t) : V(t, u).slice(0)
        }, E = e.compile = function (t, e) {
            var n, i = [], r = [], o = U[t + " "];
            if (!o) {
                for (e || (e = k(t)), n = e.length; n--;)o = y(e[n]), o[R] ? i.push(o) : r.push(o);
                o = U(t, b(r, i)), o.selector = t
            }
            return o
        }, $ = e.select = function (t, e, n, i) {
            var r, o, s, a, u, l = "function" == typeof t && t, d = !i && k(t = l.selector || t);
            if (n = n || [], 1 === d.length) {
                if (o = d[0] = d[0].slice(0), o.length > 2 && "ID" === (s = o[0]).type && C.getById && 9 === e.nodeType && L && x.relative[o[1].type]) {
                    if (e = (x.find.ID(s.matches[0].replace(Ct, xt), e) || [])[0], !e)return n;
                    l && (e = e.parentNode), t = t.slice(o.shift().value.length)
                }
                for (r = ft.needsContext.test(t) ? 0 : o.length; r-- && (s = o[r], !x.relative[a = s.type]);)if ((u = x.find[a]) && (i = u(s.matches[0].replace(Ct, xt), bt.test(o[0].type) && c(e.parentNode) || e))) {
                    if (o.splice(r, 1), t = i.length && h(o), !t)return J.apply(n, i), n;
                    break
                }
            }
            return (l || E(t, d))(i, e, !L, n, bt.test(t) && c(e.parentNode) || e), n
        }, C.sortStable = R.split("").sort(W).join("") === R, C.detectDuplicates = !!j, P(), C.sortDetached = r(function (t) {
            return 1 & t.compareDocumentPosition(A.createElement("div"))
        }), r(function (t) {
            return t.innerHTML = "<a href='#'></a>", "#" === t.firstChild.getAttribute("href")
        }) || o("type|href|height|width", function (t, e, n) {
            return n ? void 0 : t.getAttribute(e, "type" === e.toLowerCase() ? 1 : 2)
        }), C.attributes && r(function (t) {
            return t.innerHTML = "<input/>", t.firstChild.setAttribute("value", ""), "" === t.firstChild.getAttribute("value")
        }) || o("value", function (t, e, n) {
            return n || "input" !== t.nodeName.toLowerCase() ? void 0 : t.defaultValue
        }), r(function (t) {
            return null == t.getAttribute("disabled")
        }) || o(et, function (t, e, n) {
            var i;
            return n ? void 0 : t[e] === !0 ? e.toLowerCase() : (i = t.getAttributeNode(e)) && i.specified ? i.value : null
        }), e
    }(t);
    Z.find = rt, Z.expr = rt.selectors, Z.expr[":"] = Z.expr.pseudos, Z.unique = rt.uniqueSort, Z.text = rt.getText, Z.isXMLDoc = rt.isXML, Z.contains = rt.contains;
    var ot = Z.expr.match.needsContext, st = /^<(\w+)\s*\/?>(?:<\/\1>|)$/, at = /^.[^:#\[\.,]*$/;
    Z.filter = function (t, e, n) {
        var i = e[0];
        return n && (t = ":not(" + t + ")"), 1 === e.length && 1 === i.nodeType ? Z.find.matchesSelector(i, t) ? [i] : [] : Z.find.matches(t, Z.grep(e, function (t) {
            return 1 === t.nodeType
        }))
    }, Z.fn.extend({
        find: function (t) {
            var e, n = this.length, i = [], r = this;
            if ("string" != typeof t)return this.pushStack(Z(t).filter(function () {
                for (e = 0; n > e; e++)if (Z.contains(r[e], this))return !0
            }));
            for (e = 0; n > e; e++)Z.find(t, r[e], i);
            return i = this.pushStack(n > 1 ? Z.unique(i) : i), i.selector = this.selector ? this.selector + " " + t : t, i
        }, filter: function (t) {
            return this.pushStack(i(this, t || [], !1))
        }, not: function (t) {
            return this.pushStack(i(this, t || [], !0))
        }, is: function (t) {
            return !!i(this, "string" == typeof t && ot.test(t) ? Z(t) : t || [], !1).length
        }
    });
    var ut, lt = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/, ct = Z.fn.init = function (t, e) {
        var n, i;
        if (!t)return this;
        if ("string" == typeof t) {
            if (n = "<" === t[0] && ">" === t[t.length - 1] && t.length >= 3 ? [null, t, null] : lt.exec(t), !n || !n[1] && e)return !e || e.jquery ? (e || ut).find(t) : this.constructor(e).find(t);
            if (n[1]) {
                if (e = e instanceof Z ? e[0] : e, Z.merge(this, Z.parseHTML(n[1], e && e.nodeType ? e.ownerDocument || e : K, !0)), st.test(n[1]) && Z.isPlainObject(e))for (n in e)Z.isFunction(this[n]) ? this[n](e[n]) : this.attr(n, e[n]);
                return this
            }
            return i = K.getElementById(n[2]), i && i.parentNode && (this.length = 1, this[0] = i), this.context = K, this.selector = t, this
        }
        return t.nodeType ? (this.context = this[0] = t, this.length = 1, this) : Z.isFunction(t) ? "undefined" != typeof ut.ready ? ut.ready(t) : t(Z) : (void 0 !== t.selector && (this.selector = t.selector, this.context = t.context), Z.makeArray(t, this))
    };
    ct.prototype = Z.fn, ut = Z(K);
    var dt = /^(?:parents|prev(?:Until|All))/, ht = {children: !0, contents: !0, next: !0, prev: !0};
    Z.extend({
        dir: function (t, e, n) {
            for (var i = [], r = void 0 !== n; (t = t[e]) && 9 !== t.nodeType;)if (1 === t.nodeType) {
                if (r && Z(t).is(n))break;
                i.push(t)
            }
            return i
        }, sibling: function (t, e) {
            for (var n = []; t; t = t.nextSibling)1 === t.nodeType && t !== e && n.push(t);
            return n
        }
    }), Z.fn.extend({
        has: function (t) {
            var e = Z(t, this), n = e.length;
            return this.filter(function () {
                for (var t = 0; n > t; t++)if (Z.contains(this, e[t]))return !0
            })
        }, closest: function (t, e) {
            for (var n, i = 0, r = this.length, o = [], s = ot.test(t) || "string" != typeof t ? Z(t, e || this.context) : 0; r > i; i++)for (n = this[i]; n && n !== e; n = n.parentNode)if (n.nodeType < 11 && (s ? s.index(n) > -1 : 1 === n.nodeType && Z.find.matchesSelector(n, t))) {
                o.push(n);
                break
            }
            return this.pushStack(o.length > 1 ? Z.unique(o) : o)
        }, index: function (t) {
            return t ? "string" == typeof t ? W.call(Z(t), this[0]) : W.call(this, t.jquery ? t[0] : t) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
        }, add: function (t, e) {
            return this.pushStack(Z.unique(Z.merge(this.get(), Z(t, e))))
        }, addBack: function (t) {
            return this.add(null == t ? this.prevObject : this.prevObject.filter(t))
        }
    }), Z.each({
        parent: function (t) {
            var e = t.parentNode;
            return e && 11 !== e.nodeType ? e : null
        }, parents: function (t) {
            return Z.dir(t, "parentNode")
        }, parentsUntil: function (t, e, n) {
            return Z.dir(t, "parentNode", n)
        }, next: function (t) {
            return r(t, "nextSibling")
        }, prev: function (t) {
            return r(t, "previousSibling")
        }, nextAll: function (t) {
            return Z.dir(t, "nextSibling")
        }, prevAll: function (t) {
            return Z.dir(t, "previousSibling")
        }, nextUntil: function (t, e, n) {
            return Z.dir(t, "nextSibling", n)
        }, prevUntil: function (t, e, n) {
            return Z.dir(t, "previousSibling", n)
        }, siblings: function (t) {
            return Z.sibling((t.parentNode || {}).firstChild, t)
        }, children: function (t) {
            return Z.sibling(t.firstChild)
        }, contents: function (t) {
            return t.contentDocument || Z.merge([], t.childNodes)
        }
    }, function (t, e) {
        Z.fn[t] = function (n, i) {
            var r = Z.map(this, e, n);
            return "Until" !== t.slice(-5) && (i = n), i && "string" == typeof i && (r = Z.filter(i, r)), this.length > 1 && (ht[t] || Z.unique(r), dt.test(t) && r.reverse()), this.pushStack(r)
        }
    });
    var pt = /\S+/g, ft = {};
    Z.Callbacks = function (t) {
        t = "string" == typeof t ? ft[t] || o(t) : Z.extend({}, t);
        var e, n, i, r, s, a, u = [], l = !t.once && [], c = function (o) {
            for (e = t.memory && o, n = !0, a = r || 0, r = 0, s = u.length, i = !0; u && s > a; a++)if (u[a].apply(o[0], o[1]) === !1 && t.stopOnFalse) {
                e = !1;
                break
            }
            i = !1, u && (l ? l.length && c(l.shift()) : e ? u = [] : d.disable())
        }, d = {
            add: function () {
                if (u) {
                    var n = u.length;
                    !function o(e) {
                        Z.each(e, function (e, n) {
                            var i = Z.type(n);
                            "function" === i ? t.unique && d.has(n) || u.push(n) : n && n.length && "string" !== i && o(n)
                        })
                    }(arguments), i ? s = u.length : e && (r = n, c(e))
                }
                return this
            }, remove: function () {
                return u && Z.each(arguments, function (t, e) {
                    for (var n; (n = Z.inArray(e, u, n)) > -1;)u.splice(n, 1), i && (s >= n && s--, a >= n && a--)
                }), this
            }, has: function (t) {
                return t ? Z.inArray(t, u) > -1 : !(!u || !u.length)
            }, empty: function () {
                return u = [], s = 0, this
            }, disable: function () {
                return u = l = e = void 0, this
            }, disabled: function () {
                return !u
            }, lock: function () {
                return l = void 0, e || d.disable(), this
            }, locked: function () {
                return !l
            }, fireWith: function (t, e) {
                return !u || n && !l || (e = e || [], e = [t, e.slice ? e.slice() : e], i ? l.push(e) : c(e)), this
            }, fire: function () {
                return d.fireWith(this, arguments), this
            }, fired: function () {
                return !!n
            }
        };
        return d
    }, Z.extend({
        Deferred: function (t) {
            var e = [["resolve", "done", Z.Callbacks("once memory"), "resolved"], ["reject", "fail", Z.Callbacks("once memory"), "rejected"], ["notify", "progress", Z.Callbacks("memory")]], n = "pending", i = {
                state: function () {
                    return n
                }, always: function () {
                    return r.done(arguments).fail(arguments), this
                }, then: function () {
                    var t = arguments;
                    return Z.Deferred(function (n) {
                        Z.each(e, function (e, o) {
                            var s = Z.isFunction(t[e]) && t[e];
                            r[o[1]](function () {
                                var t = s && s.apply(this, arguments);
                                t && Z.isFunction(t.promise) ? t.promise().done(n.resolve).fail(n.reject).progress(n.notify) : n[o[0] + "With"](this === i ? n.promise() : this, s ? [t] : arguments)
                            })
                        }), t = null
                    }).promise()
                }, promise: function (t) {
                    return null != t ? Z.extend(t, i) : i
                }
            }, r = {};
            return i.pipe = i.then, Z.each(e, function (t, o) {
                var s = o[2], a = o[3];
                i[o[1]] = s.add, a && s.add(function () {
                    n = a
                }, e[1 ^ t][2].disable, e[2][2].lock), r[o[0]] = function () {
                    return r[o[0] + "With"](this === r ? i : this, arguments), this
                }, r[o[0] + "With"] = s.fireWith
            }), i.promise(r), t && t.call(r, r), r
        }, when: function (t) {
            var e, n, i, r = 0, o = B.call(arguments), s = o.length, a = 1 !== s || t && Z.isFunction(t.promise) ? s : 0, u = 1 === a ? t : Z.Deferred(), l = function (t, n, i) {
                return function (r) {
                    n[t] = this, i[t] = arguments.length > 1 ? B.call(arguments) : r, i === e ? u.notifyWith(n, i) : --a || u.resolveWith(n, i)
                }
            };
            if (s > 1)for (e = new Array(s), n = new Array(s), i = new Array(s); s > r; r++)o[r] && Z.isFunction(o[r].promise) ? o[r].promise().done(l(r, i, o)).fail(u.reject).progress(l(r, n, e)) : --a;
            return a || u.resolveWith(i, o), u.promise()
        }
    });
    var mt;
    Z.fn.ready = function (t) {
        return Z.ready.promise().done(t), this
    }, Z.extend({
        isReady: !1, readyWait: 1, holdReady: function (t) {
            t ? Z.readyWait++ : Z.ready(!0)
        }, ready: function (t) {
            (t === !0 ? --Z.readyWait : Z.isReady) || (Z.isReady = !0, t !== !0 && --Z.readyWait > 0 || (mt.resolveWith(K, [Z]), Z.fn.triggerHandler && (Z(K).triggerHandler("ready"), Z(K).off("ready"))))
        }
    }), Z.ready.promise = function (e) {
        return mt || (mt = Z.Deferred(), "complete" === K.readyState ? setTimeout(Z.ready) : (K.addEventListener("DOMContentLoaded", s, !1), t.addEventListener("load", s, !1))), mt.promise(e)
    }, Z.ready.promise();
    var gt = Z.access = function (t, e, n, i, r, o, s) {
        var a = 0, u = t.length, l = null == n;
        if ("object" === Z.type(n)) {
            r = !0;
            for (a in n)Z.access(t, e, a, n[a], !0, o, s)
        } else if (void 0 !== i && (r = !0, Z.isFunction(i) || (s = !0), l && (s ? (e.call(t, i), e = null) : (l = e, e = function (t, e, n) {
                return l.call(Z(t), n)
            })), e))for (; u > a; a++)e(t[a], n, s ? i : i.call(t[a], a, e(t[a], n)));
        return r ? t : l ? e.call(t) : u ? e(t[0], n) : o
    };
    Z.acceptData = function (t) {
        return 1 === t.nodeType || 9 === t.nodeType || !+t.nodeType
    }, a.uid = 1, a.accepts = Z.acceptData, a.prototype = {
        key: function (t) {
            if (!a.accepts(t))return 0;
            var e = {}, n = t[this.expando];
            if (!n) {
                n = a.uid++;
                try {
                    e[this.expando] = {value: n}, Object.defineProperties(t, e)
                } catch (i) {
                    e[this.expando] = n, Z.extend(t, e)
                }
            }
            return this.cache[n] || (this.cache[n] = {}), n
        }, set: function (t, e, n) {
            var i, r = this.key(t), o = this.cache[r];
            if ("string" == typeof e)o[e] = n; else if (Z.isEmptyObject(o))Z.extend(this.cache[r], e); else for (i in e)o[i] = e[i];
            return o
        }, get: function (t, e) {
            var n = this.cache[this.key(t)];
            return void 0 === e ? n : n[e]
        }, access: function (t, e, n) {
            var i;
            return void 0 === e || e && "string" == typeof e && void 0 === n ? (i = this.get(t, e), void 0 !== i ? i : this.get(t, Z.camelCase(e))) : (this.set(t, e, n), void 0 !== n ? n : e)
        }, remove: function (t, e) {
            var n, i, r, o = this.key(t), s = this.cache[o];
            if (void 0 === e)this.cache[o] = {}; else {
                Z.isArray(e) ? i = e.concat(e.map(Z.camelCase)) : (r = Z.camelCase(e), e in s ? i = [e, r] : (i = r, i = i in s ? [i] : i.match(pt) || [])), n = i.length;
                for (; n--;)delete s[i[n]]
            }
        }, hasData: function (t) {
            return !Z.isEmptyObject(this.cache[t[this.expando]] || {})
        }, discard: function (t) {
            t[this.expando] && delete this.cache[t[this.expando]]
        }
    };
    var vt = new a, yt = new a, bt = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, wt = /([A-Z])/g;
    Z.extend({
        hasData: function (t) {
            return yt.hasData(t) || vt.hasData(t)
        }, data: function (t, e, n) {
            return yt.access(t, e, n)
        }, removeData: function (t, e) {
            yt.remove(t, e)
        }, _data: function (t, e, n) {
            return vt.access(t, e, n)
        }, _removeData: function (t, e) {
            vt.remove(t, e)
        }
    }), Z.fn.extend({
        data: function (t, e) {
            var n, i, r, o = this[0], s = o && o.attributes;
            if (void 0 === t) {
                if (this.length && (r = yt.get(o), 1 === o.nodeType && !vt.get(o, "hasDataAttrs"))) {
                    for (n = s.length; n--;)s[n] && (i = s[n].name, 0 === i.indexOf("data-") && (i = Z.camelCase(i.slice(5)), u(o, i, r[i])));
                    vt.set(o, "hasDataAttrs", !0)
                }
                return r
            }
            return "object" == typeof t ? this.each(function () {
                yt.set(this, t)
            }) : gt(this, function (e) {
                var n, i = Z.camelCase(t);
                if (o && void 0 === e) {
                    if (n = yt.get(o, t), void 0 !== n)return n;
                    if (n = yt.get(o, i), void 0 !== n)return n;
                    if (n = u(o, i, void 0), void 0 !== n)return n
                } else this.each(function () {
                    var n = yt.get(this, i);
                    yt.set(this, i, e), -1 !== t.indexOf("-") && void 0 !== n && yt.set(this, t, e)
                })
            }, null, e, arguments.length > 1, null, !0)
        }, removeData: function (t) {
            return this.each(function () {
                yt.remove(this, t)
            })
        }
    }), Z.extend({
        queue: function (t, e, n) {
            var i;
            return t ? (e = (e || "fx") + "queue", i = vt.get(t, e), n && (!i || Z.isArray(n) ? i = vt.access(t, e, Z.makeArray(n)) : i.push(n)), i || []) : void 0
        }, dequeue: function (t, e) {
            e = e || "fx";
            var n = Z.queue(t, e), i = n.length, r = n.shift(), o = Z._queueHooks(t, e), s = function () {
                Z.dequeue(t, e)
            };
            "inprogress" === r && (r = n.shift(), i--), r && ("fx" === e && n.unshift("inprogress"), delete o.stop, r.call(t, s, o)), !i && o && o.empty.fire()
        }, _queueHooks: function (t, e) {
            var n = e + "queueHooks";
            return vt.get(t, n) || vt.access(t, n, {
                    empty: Z.Callbacks("once memory").add(function () {
                        vt.remove(t, [e + "queue", n])
                    })
                })
        }
    }), Z.fn.extend({
        queue: function (t, e) {
            var n = 2;
            return "string" != typeof t && (e = t, t = "fx", n--), arguments.length < n ? Z.queue(this[0], t) : void 0 === e ? this : this.each(function () {
                var n = Z.queue(this, t, e);
                Z._queueHooks(this, t), "fx" === t && "inprogress" !== n[0] && Z.dequeue(this, t)
            })
        }, dequeue: function (t) {
            return this.each(function () {
                Z.dequeue(this, t)
            })
        }, clearQueue: function (t) {
            return this.queue(t || "fx", [])
        }, promise: function (t, e) {
            var n, i = 1, r = Z.Deferred(), o = this, s = this.length, a = function () {
                --i || r.resolveWith(o, [o])
            };
            for ("string" != typeof t && (e = t, t = void 0), t = t || "fx"; s--;)n = vt.get(o[s], t + "queueHooks"), n && n.empty && (i++, n.empty.add(a));
            return a(), r.promise(e)
        }
    });
    var Ct = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source, xt = ["Top", "Right", "Bottom", "Left"], St = function (t, e) {
        return t = e || t, "none" === Z.css(t, "display") || !Z.contains(t.ownerDocument, t)
    }, Tt = /^(?:checkbox|radio)$/i;
    !function () {
        var t = K.createDocumentFragment(), e = t.appendChild(K.createElement("div")), n = K.createElement("input");
        n.setAttribute("type", "radio"), n.setAttribute("checked", "checked"), n.setAttribute("name", "t"), e.appendChild(n), Y.checkClone = e.cloneNode(!0).cloneNode(!0).lastChild.checked, e.innerHTML = "<textarea>x</textarea>", Y.noCloneChecked = !!e.cloneNode(!0).lastChild.defaultValue
    }();
    var kt = "undefined";
    Y.focusinBubbles = "onfocusin" in t;
    var Et = /^key/, $t = /^(?:mouse|pointer|contextmenu)|click/, _t = /^(?:focusinfocus|focusoutblur)$/, Ft = /^([^.]*)(?:\.(.+)|)$/;
    Z.event = {
        global: {},
        add: function (t, e, n, i, r) {
            var o, s, a, u, l, c, d, h, p, f, m, g = vt.get(t);
            if (g)for (n.handler && (o = n, n = o.handler, r = o.selector), n.guid || (n.guid = Z.guid++), (u = g.events) || (u = g.events = {}), (s = g.handle) || (s = g.handle = function (e) {
                return typeof Z !== kt && Z.event.triggered !== e.type ? Z.event.dispatch.apply(t, arguments) : void 0
            }), e = (e || "").match(pt) || [""], l = e.length; l--;)a = Ft.exec(e[l]) || [], p = m = a[1], f = (a[2] || "").split(".").sort(), p && (d = Z.event.special[p] || {}, p = (r ? d.delegateType : d.bindType) || p, d = Z.event.special[p] || {}, c = Z.extend({
                type: p,
                origType: m,
                data: i,
                handler: n,
                guid: n.guid,
                selector: r,
                needsContext: r && Z.expr.match.needsContext.test(r),
                namespace: f.join(".")
            }, o), (h = u[p]) || (h = u[p] = [], h.delegateCount = 0, d.setup && d.setup.call(t, i, f, s) !== !1 || t.addEventListener && t.addEventListener(p, s, !1)), d.add && (d.add.call(t, c), c.handler.guid || (c.handler.guid = n.guid)), r ? h.splice(h.delegateCount++, 0, c) : h.push(c), Z.event.global[p] = !0)
        },
        remove: function (t, e, n, i, r) {
            var o, s, a, u, l, c, d, h, p, f, m, g = vt.hasData(t) && vt.get(t);
            if (g && (u = g.events)) {
                for (e = (e || "").match(pt) || [""], l = e.length; l--;)if (a = Ft.exec(e[l]) || [], p = m = a[1], f = (a[2] || "").split(".").sort(), p) {
                    for (d = Z.event.special[p] || {}, p = (i ? d.delegateType : d.bindType) || p, h = u[p] || [], a = a[2] && new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"), s = o = h.length; o--;)c = h[o], !r && m !== c.origType || n && n.guid !== c.guid || a && !a.test(c.namespace) || i && i !== c.selector && ("**" !== i || !c.selector) || (h.splice(o, 1), c.selector && h.delegateCount--, d.remove && d.remove.call(t, c));
                    s && !h.length && (d.teardown && d.teardown.call(t, f, g.handle) !== !1 || Z.removeEvent(t, p, g.handle), delete u[p])
                } else for (p in u)Z.event.remove(t, p + e[l], n, i, !0);
                Z.isEmptyObject(u) && (delete g.handle, vt.remove(t, "events"))
            }
        },
        trigger: function (e, n, i, r) {
            var o, s, a, u, l, c, d, h = [i || K], p = G.call(e, "type") ? e.type : e, f = G.call(e, "namespace") ? e.namespace.split(".") : [];
            if (s = a = i = i || K, 3 !== i.nodeType && 8 !== i.nodeType && !_t.test(p + Z.event.triggered) && (p.indexOf(".") >= 0 && (f = p.split("."), p = f.shift(), f.sort()), l = p.indexOf(":") < 0 && "on" + p, e = e[Z.expando] ? e : new Z.Event(p, "object" == typeof e && e), e.isTrigger = r ? 2 : 3, e.namespace = f.join("."), e.namespace_re = e.namespace ? new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, e.result = void 0, e.target || (e.target = i), n = null == n ? [e] : Z.makeArray(n, [e]), d = Z.event.special[p] || {}, r || !d.trigger || d.trigger.apply(i, n) !== !1)) {
                if (!r && !d.noBubble && !Z.isWindow(i)) {
                    for (u = d.delegateType || p, _t.test(u + p) || (s = s.parentNode); s; s = s.parentNode)h.push(s), a = s;
                    a === (i.ownerDocument || K) && h.push(a.defaultView || a.parentWindow || t)
                }
                for (o = 0; (s = h[o++]) && !e.isPropagationStopped();)e.type = o > 1 ? u : d.bindType || p, c = (vt.get(s, "events") || {})[e.type] && vt.get(s, "handle"), c && c.apply(s, n), c = l && s[l], c && c.apply && Z.acceptData(s) && (e.result = c.apply(s, n), e.result === !1 && e.preventDefault());
                return e.type = p, r || e.isDefaultPrevented() || d._default && d._default.apply(h.pop(), n) !== !1 || !Z.acceptData(i) || l && Z.isFunction(i[p]) && !Z.isWindow(i) && (a = i[l], a && (i[l] = null), Z.event.triggered = p, i[p](), Z.event.triggered = void 0, a && (i[l] = a)), e.result
            }
        },
        dispatch: function (t) {
            t = Z.event.fix(t);
            var e, n, i, r, o, s = [], a = B.call(arguments), u = (vt.get(this, "events") || {})[t.type] || [], l = Z.event.special[t.type] || {};
            if (a[0] = t, t.delegateTarget = this, !l.preDispatch || l.preDispatch.call(this, t) !== !1) {
                for (s = Z.event.handlers.call(this, t, u), e = 0; (r = s[e++]) && !t.isPropagationStopped();)for (t.currentTarget = r.elem, n = 0; (o = r.handlers[n++]) && !t.isImmediatePropagationStopped();)(!t.namespace_re || t.namespace_re.test(o.namespace)) && (t.handleObj = o, t.data = o.data, i = ((Z.event.special[o.origType] || {}).handle || o.handler).apply(r.elem, a), void 0 !== i && (t.result = i) === !1 && (t.preventDefault(), t.stopPropagation()));
                return l.postDispatch && l.postDispatch.call(this, t), t.result
            }
        },
        handlers: function (t, e) {
            var n, i, r, o, s = [], a = e.delegateCount, u = t.target;
            if (a && u.nodeType && (!t.button || "click" !== t.type))for (; u !== this; u = u.parentNode || this)if (u.disabled !== !0 || "click" !== t.type) {
                for (i = [], n = 0; a > n; n++)o = e[n], r = o.selector + " ", void 0 === i[r] && (i[r] = o.needsContext ? Z(r, this).index(u) >= 0 : Z.find(r, this, null, [u]).length), i[r] && i.push(o);
                i.length && s.push({elem: u, handlers: i})
            }
            return a < e.length && s.push({elem: this, handlers: e.slice(a)}), s
        },
        props: "altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
        fixHooks: {},
        keyHooks: {
            props: "char charCode key keyCode".split(" "), filter: function (t, e) {
                return null == t.which && (t.which = null != e.charCode ? e.charCode : e.keyCode), t
            }
        },
        mouseHooks: {
            props: "button buttons clientX clientY offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
            filter: function (t, e) {
                var n, i, r, o = e.button;
                return null == t.pageX && null != e.clientX && (n = t.target.ownerDocument || K, i = n.documentElement, r = n.body, t.pageX = e.clientX + (i && i.scrollLeft || r && r.scrollLeft || 0) - (i && i.clientLeft || r && r.clientLeft || 0), t.pageY = e.clientY + (i && i.scrollTop || r && r.scrollTop || 0) - (i && i.clientTop || r && r.clientTop || 0)), t.which || void 0 === o || (t.which = 1 & o ? 1 : 2 & o ? 3 : 4 & o ? 2 : 0), t
            }
        },
        fix: function (t) {
            if (t[Z.expando])return t;
            var e, n, i, r = t.type, o = t, s = this.fixHooks[r];
            for (s || (this.fixHooks[r] = s = $t.test(r) ? this.mouseHooks : Et.test(r) ? this.keyHooks : {}), i = s.props ? this.props.concat(s.props) : this.props, t = new Z.Event(o), e = i.length; e--;)n = i[e], t[n] = o[n];
            return t.target || (t.target = K), 3 === t.target.nodeType && (t.target = t.target.parentNode), s.filter ? s.filter(t, o) : t;
        },
        special: {
            load: {noBubble: !0}, focus: {
                trigger: function () {
                    return this !== d() && this.focus ? (this.focus(), !1) : void 0
                }, delegateType: "focusin"
            }, blur: {
                trigger: function () {
                    return this === d() && this.blur ? (this.blur(), !1) : void 0
                }, delegateType: "focusout"
            }, click: {
                trigger: function () {
                    return "checkbox" === this.type && this.click && Z.nodeName(this, "input") ? (this.click(), !1) : void 0
                }, _default: function (t) {
                    return Z.nodeName(t.target, "a")
                }
            }, beforeunload: {
                postDispatch: function (t) {
                    void 0 !== t.result && t.originalEvent && (t.originalEvent.returnValue = t.result)
                }
            }
        },
        simulate: function (t, e, n, i) {
            var r = Z.extend(new Z.Event, n, {type: t, isSimulated: !0, originalEvent: {}});
            i ? Z.event.trigger(r, null, e) : Z.event.dispatch.call(e, r), r.isDefaultPrevented() && n.preventDefault()
        }
    }, Z.removeEvent = function (t, e, n) {
        t.removeEventListener && t.removeEventListener(e, n, !1)
    }, Z.Event = function (t, e) {
        return this instanceof Z.Event ? (t && t.type ? (this.originalEvent = t, this.type = t.type, this.isDefaultPrevented = t.defaultPrevented || void 0 === t.defaultPrevented && t.returnValue === !1 ? l : c) : this.type = t, e && Z.extend(this, e), this.timeStamp = t && t.timeStamp || Z.now(), void(this[Z.expando] = !0)) : new Z.Event(t, e)
    }, Z.Event.prototype = {
        isDefaultPrevented: c,
        isPropagationStopped: c,
        isImmediatePropagationStopped: c,
        preventDefault: function () {
            var t = this.originalEvent;
            this.isDefaultPrevented = l, t && t.preventDefault && t.preventDefault()
        },
        stopPropagation: function () {
            var t = this.originalEvent;
            this.isPropagationStopped = l, t && t.stopPropagation && t.stopPropagation()
        },
        stopImmediatePropagation: function () {
            var t = this.originalEvent;
            this.isImmediatePropagationStopped = l, t && t.stopImmediatePropagation && t.stopImmediatePropagation(), this.stopPropagation()
        }
    }, Z.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function (t, e) {
        Z.event.special[t] = {
            delegateType: e, bindType: e, handle: function (t) {
                var n, i = this, r = t.relatedTarget, o = t.handleObj;
                return (!r || r !== i && !Z.contains(i, r)) && (t.type = o.origType, n = o.handler.apply(this, arguments), t.type = e), n
            }
        }
    }), Y.focusinBubbles || Z.each({focus: "focusin", blur: "focusout"}, function (t, e) {
        var n = function (t) {
            Z.event.simulate(e, t.target, Z.event.fix(t), !0)
        };
        Z.event.special[e] = {
            setup: function () {
                var i = this.ownerDocument || this, r = vt.access(i, e);
                r || i.addEventListener(t, n, !0), vt.access(i, e, (r || 0) + 1)
            }, teardown: function () {
                var i = this.ownerDocument || this, r = vt.access(i, e) - 1;
                r ? vt.access(i, e, r) : (i.removeEventListener(t, n, !0), vt.remove(i, e))
            }
        }
    }), Z.fn.extend({
        on: function (t, e, n, i, r) {
            var o, s;
            if ("object" == typeof t) {
                "string" != typeof e && (n = n || e, e = void 0);
                for (s in t)this.on(s, e, n, t[s], r);
                return this
            }
            if (null == n && null == i ? (i = e, n = e = void 0) : null == i && ("string" == typeof e ? (i = n, n = void 0) : (i = n, n = e, e = void 0)), i === !1)i = c; else if (!i)return this;
            return 1 === r && (o = i, i = function (t) {
                return Z().off(t), o.apply(this, arguments)
            }, i.guid = o.guid || (o.guid = Z.guid++)), this.each(function () {
                Z.event.add(this, t, i, n, e)
            })
        }, one: function (t, e, n, i) {
            return this.on(t, e, n, i, 1)
        }, off: function (t, e, n) {
            var i, r;
            if (t && t.preventDefault && t.handleObj)return i = t.handleObj, Z(t.delegateTarget).off(i.namespace ? i.origType + "." + i.namespace : i.origType, i.selector, i.handler), this;
            if ("object" == typeof t) {
                for (r in t)this.off(r, e, t[r]);
                return this
            }
            return (e === !1 || "function" == typeof e) && (n = e, e = void 0), n === !1 && (n = c), this.each(function () {
                Z.event.remove(this, t, n, e)
            })
        }, trigger: function (t, e) {
            return this.each(function () {
                Z.event.trigger(t, e, this)
            })
        }, triggerHandler: function (t, e) {
            var n = this[0];
            return n ? Z.event.trigger(t, e, n, !0) : void 0
        }
    });
    var jt = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi, Pt = /<([\w:]+)/, At = /<|&#?\w+;/, It = /<(?:script|style|link)/i, Lt = /checked\s*(?:[^=]|=\s*.checked.)/i, Dt = /^$|\/(?:java|ecma)script/i, Nt = /^true\/(.*)/, Ot = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g, Mt = {
        option: [1, "<select multiple='multiple'>", "</select>"],
        thead: [1, "<table>", "</table>"],
        col: [2, "<table><colgroup>", "</colgroup></table>"],
        tr: [2, "<table><tbody>", "</tbody></table>"],
        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
        _default: [0, "", ""]
    };
    Mt.optgroup = Mt.option, Mt.tbody = Mt.tfoot = Mt.colgroup = Mt.caption = Mt.thead, Mt.th = Mt.td, Z.extend({
        clone: function (t, e, n) {
            var i, r, o, s, a = t.cloneNode(!0), u = Z.contains(t.ownerDocument, t);
            if (!(Y.noCloneChecked || 1 !== t.nodeType && 11 !== t.nodeType || Z.isXMLDoc(t)))for (s = v(a), o = v(t), i = 0, r = o.length; r > i; i++)y(o[i], s[i]);
            if (e)if (n)for (o = o || v(t), s = s || v(a), i = 0, r = o.length; r > i; i++)g(o[i], s[i]); else g(t, a);
            return s = v(a, "script"), s.length > 0 && m(s, !u && v(t, "script")), a
        }, buildFragment: function (t, e, n, i) {
            for (var r, o, s, a, u, l, c = e.createDocumentFragment(), d = [], h = 0, p = t.length; p > h; h++)if (r = t[h], r || 0 === r)if ("object" === Z.type(r))Z.merge(d, r.nodeType ? [r] : r); else if (At.test(r)) {
                for (o = o || c.appendChild(e.createElement("div")), s = (Pt.exec(r) || ["", ""])[1].toLowerCase(), a = Mt[s] || Mt._default, o.innerHTML = a[1] + r.replace(jt, "<$1></$2>") + a[2], l = a[0]; l--;)o = o.lastChild;
                Z.merge(d, o.childNodes), o = c.firstChild, o.textContent = ""
            } else d.push(e.createTextNode(r));
            for (c.textContent = "", h = 0; r = d[h++];)if ((!i || -1 === Z.inArray(r, i)) && (u = Z.contains(r.ownerDocument, r), o = v(c.appendChild(r), "script"), u && m(o), n))for (l = 0; r = o[l++];)Dt.test(r.type || "") && n.push(r);
            return c
        }, cleanData: function (t) {
            for (var e, n, i, r, o = Z.event.special, s = 0; void 0 !== (n = t[s]); s++) {
                if (Z.acceptData(n) && (r = n[vt.expando], r && (e = vt.cache[r]))) {
                    if (e.events)for (i in e.events)o[i] ? Z.event.remove(n, i) : Z.removeEvent(n, i, e.handle);
                    vt.cache[r] && delete vt.cache[r]
                }
                delete yt.cache[n[yt.expando]]
            }
        }
    }), Z.fn.extend({
        text: function (t) {
            return gt(this, function (t) {
                return void 0 === t ? Z.text(this) : this.empty().each(function () {
                    (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) && (this.textContent = t)
                })
            }, null, t, arguments.length)
        }, append: function () {
            return this.domManip(arguments, function (t) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var e = h(this, t);
                    e.appendChild(t)
                }
            })
        }, prepend: function () {
            return this.domManip(arguments, function (t) {
                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                    var e = h(this, t);
                    e.insertBefore(t, e.firstChild)
                }
            })
        }, before: function () {
            return this.domManip(arguments, function (t) {
                this.parentNode && this.parentNode.insertBefore(t, this)
            })
        }, after: function () {
            return this.domManip(arguments, function (t) {
                this.parentNode && this.parentNode.insertBefore(t, this.nextSibling)
            })
        }, remove: function (t, e) {
            for (var n, i = t ? Z.filter(t, this) : this, r = 0; null != (n = i[r]); r++)e || 1 !== n.nodeType || Z.cleanData(v(n)), n.parentNode && (e && Z.contains(n.ownerDocument, n) && m(v(n, "script")), n.parentNode.removeChild(n));
            return this
        }, empty: function () {
            for (var t, e = 0; null != (t = this[e]); e++)1 === t.nodeType && (Z.cleanData(v(t, !1)), t.textContent = "");
            return this
        }, clone: function (t, e) {
            return t = null == t ? !1 : t, e = null == e ? t : e, this.map(function () {
                return Z.clone(this, t, e)
            })
        }, html: function (t) {
            return gt(this, function (t) {
                var e = this[0] || {}, n = 0, i = this.length;
                if (void 0 === t && 1 === e.nodeType)return e.innerHTML;
                if ("string" == typeof t && !It.test(t) && !Mt[(Pt.exec(t) || ["", ""])[1].toLowerCase()]) {
                    t = t.replace(jt, "<$1></$2>");
                    try {
                        for (; i > n; n++)e = this[n] || {}, 1 === e.nodeType && (Z.cleanData(v(e, !1)), e.innerHTML = t);
                        e = 0
                    } catch (r) {
                    }
                }
                e && this.empty().append(t)
            }, null, t, arguments.length)
        }, replaceWith: function () {
            var t = arguments[0];
            return this.domManip(arguments, function (e) {
                t = this.parentNode, Z.cleanData(v(this)), t && t.replaceChild(e, this)
            }), t && (t.length || t.nodeType) ? this : this.remove()
        }, detach: function (t) {
            return this.remove(t, !0)
        }, domManip: function (t, e) {
            t = V.apply([], t);
            var n, i, r, o, s, a, u = 0, l = this.length, c = this, d = l - 1, h = t[0], m = Z.isFunction(h);
            if (m || l > 1 && "string" == typeof h && !Y.checkClone && Lt.test(h))return this.each(function (n) {
                var i = c.eq(n);
                m && (t[0] = h.call(this, n, i.html())), i.domManip(t, e)
            });
            if (l && (n = Z.buildFragment(t, this[0].ownerDocument, !1, this), i = n.firstChild, 1 === n.childNodes.length && (n = i), i)) {
                for (r = Z.map(v(n, "script"), p), o = r.length; l > u; u++)s = n, u !== d && (s = Z.clone(s, !0, !0), o && Z.merge(r, v(s, "script"))), e.call(this[u], s, u);
                if (o)for (a = r[r.length - 1].ownerDocument, Z.map(r, f), u = 0; o > u; u++)s = r[u], Dt.test(s.type || "") && !vt.access(s, "globalEval") && Z.contains(a, s) && (s.src ? Z._evalUrl && Z._evalUrl(s.src) : Z.globalEval(s.textContent.replace(Ot, "")))
            }
            return this
        }
    }), Z.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function (t, e) {
        Z.fn[t] = function (t) {
            for (var n, i = [], r = Z(t), o = r.length - 1, s = 0; o >= s; s++)n = s === o ? this : this.clone(!0), Z(r[s])[e](n), U.apply(i, n.get());
            return this.pushStack(i)
        }
    });
    var Rt, Ht = {}, qt = /^margin/, zt = new RegExp("^(" + Ct + ")(?!px)[a-z%]+$", "i"), Bt = function (e) {
        return e.ownerDocument.defaultView.opener ? e.ownerDocument.defaultView.getComputedStyle(e, null) : t.getComputedStyle(e, null)
    };
    !function () {
        function e() {
            s.style.cssText = "-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;display:block;margin-top:1%;top:1%;border:1px;padding:1px;width:4px;position:absolute", s.innerHTML = "", r.appendChild(o);
            var e = t.getComputedStyle(s, null);
            n = "1%" !== e.top, i = "4px" === e.width, r.removeChild(o)
        }

        var n, i, r = K.documentElement, o = K.createElement("div"), s = K.createElement("div");
        s.style && (s.style.backgroundClip = "content-box", s.cloneNode(!0).style.backgroundClip = "", Y.clearCloneStyle = "content-box" === s.style.backgroundClip, o.style.cssText = "border:0;width:0;height:0;top:0;left:-9999px;margin-top:1px;position:absolute", o.appendChild(s), t.getComputedStyle && Z.extend(Y, {
            pixelPosition: function () {
                return e(), n
            }, boxSizingReliable: function () {
                return null == i && e(), i
            }, reliableMarginRight: function () {
                var e, n = s.appendChild(K.createElement("div"));
                return n.style.cssText = s.style.cssText = "-webkit-box-sizing:content-box;-moz-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;border:0;padding:0", n.style.marginRight = n.style.width = "0", s.style.width = "1px", r.appendChild(o), e = !parseFloat(t.getComputedStyle(n, null).marginRight), r.removeChild(o), s.removeChild(n), e
            }
        }))
    }(), Z.swap = function (t, e, n, i) {
        var r, o, s = {};
        for (o in e)s[o] = t.style[o], t.style[o] = e[o];
        r = n.apply(t, i || []);
        for (o in e)t.style[o] = s[o];
        return r
    };
    var Vt = /^(none|table(?!-c[ea]).+)/, Ut = new RegExp("^(" + Ct + ")(.*)$", "i"), Wt = new RegExp("^([+-])=(" + Ct + ")", "i"), Xt = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, Qt = {letterSpacing: "0", fontWeight: "400"}, Gt = ["Webkit", "O", "Moz", "ms"];
    Z.extend({
        cssHooks: {
            opacity: {
                get: function (t, e) {
                    if (e) {
                        var n = C(t, "opacity");
                        return "" === n ? "1" : n
                    }
                }
            }
        },
        cssNumber: {
            columnCount: !0,
            fillOpacity: !0,
            flexGrow: !0,
            flexShrink: !0,
            fontWeight: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0
        },
        cssProps: {"float": "cssFloat"},
        style: function (t, e, n, i) {
            if (t && 3 !== t.nodeType && 8 !== t.nodeType && t.style) {
                var r, o, s, a = Z.camelCase(e), u = t.style;
                return e = Z.cssProps[a] || (Z.cssProps[a] = S(u, a)), s = Z.cssHooks[e] || Z.cssHooks[a], void 0 === n ? s && "get" in s && void 0 !== (r = s.get(t, !1, i)) ? r : u[e] : (o = typeof n, "string" === o && (r = Wt.exec(n)) && (n = (r[1] + 1) * r[2] + parseFloat(Z.css(t, e)), o = "number"), null != n && n === n && ("number" !== o || Z.cssNumber[a] || (n += "px"), Y.clearCloneStyle || "" !== n || 0 !== e.indexOf("background") || (u[e] = "inherit"), s && "set" in s && void 0 === (n = s.set(t, n, i)) || (u[e] = n)), void 0)
            }
        },
        css: function (t, e, n, i) {
            var r, o, s, a = Z.camelCase(e);
            return e = Z.cssProps[a] || (Z.cssProps[a] = S(t.style, a)), s = Z.cssHooks[e] || Z.cssHooks[a], s && "get" in s && (r = s.get(t, !0, n)), void 0 === r && (r = C(t, e, i)), "normal" === r && e in Qt && (r = Qt[e]), "" === n || n ? (o = parseFloat(r), n === !0 || Z.isNumeric(o) ? o || 0 : r) : r
        }
    }), Z.each(["height", "width"], function (t, e) {
        Z.cssHooks[e] = {
            get: function (t, n, i) {
                return n ? Vt.test(Z.css(t, "display")) && 0 === t.offsetWidth ? Z.swap(t, Xt, function () {
                    return E(t, e, i)
                }) : E(t, e, i) : void 0
            }, set: function (t, n, i) {
                var r = i && Bt(t);
                return T(t, n, i ? k(t, e, i, "border-box" === Z.css(t, "boxSizing", !1, r), r) : 0)
            }
        }
    }), Z.cssHooks.marginRight = x(Y.reliableMarginRight, function (t, e) {
        return e ? Z.swap(t, {display: "inline-block"}, C, [t, "marginRight"]) : void 0
    }), Z.each({margin: "", padding: "", border: "Width"}, function (t, e) {
        Z.cssHooks[t + e] = {
            expand: function (n) {
                for (var i = 0, r = {}, o = "string" == typeof n ? n.split(" ") : [n]; 4 > i; i++)r[t + xt[i] + e] = o[i] || o[i - 2] || o[0];
                return r
            }
        }, qt.test(t) || (Z.cssHooks[t + e].set = T)
    }), Z.fn.extend({
        css: function (t, e) {
            return gt(this, function (t, e, n) {
                var i, r, o = {}, s = 0;
                if (Z.isArray(e)) {
                    for (i = Bt(t), r = e.length; r > s; s++)o[e[s]] = Z.css(t, e[s], !1, i);
                    return o
                }
                return void 0 !== n ? Z.style(t, e, n) : Z.css(t, e)
            }, t, e, arguments.length > 1)
        }, show: function () {
            return $(this, !0)
        }, hide: function () {
            return $(this)
        }, toggle: function (t) {
            return "boolean" == typeof t ? t ? this.show() : this.hide() : this.each(function () {
                St(this) ? Z(this).show() : Z(this).hide()
            })
        }
    }), Z.Tween = _, _.prototype = {
        constructor: _, init: function (t, e, n, i, r, o) {
            this.elem = t, this.prop = n, this.easing = r || "swing", this.options = e, this.start = this.now = this.cur(), this.end = i, this.unit = o || (Z.cssNumber[n] ? "" : "px")
        }, cur: function () {
            var t = _.propHooks[this.prop];
            return t && t.get ? t.get(this) : _.propHooks._default.get(this)
        }, run: function (t) {
            var e, n = _.propHooks[this.prop];
            return this.options.duration ? this.pos = e = Z.easing[this.easing](t, this.options.duration * t, 0, 1, this.options.duration) : this.pos = e = t, this.now = (this.end - this.start) * e + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), n && n.set ? n.set(this) : _.propHooks._default.set(this), this
        }
    }, _.prototype.init.prototype = _.prototype, _.propHooks = {
        _default: {
            get: function (t) {
                var e;
                return null == t.elem[t.prop] || t.elem.style && null != t.elem.style[t.prop] ? (e = Z.css(t.elem, t.prop, ""), e && "auto" !== e ? e : 0) : t.elem[t.prop]
            }, set: function (t) {
                Z.fx.step[t.prop] ? Z.fx.step[t.prop](t) : t.elem.style && (null != t.elem.style[Z.cssProps[t.prop]] || Z.cssHooks[t.prop]) ? Z.style(t.elem, t.prop, t.now + t.unit) : t.elem[t.prop] = t.now
            }
        }
    }, _.propHooks.scrollTop = _.propHooks.scrollLeft = {
        set: function (t) {
            t.elem.nodeType && t.elem.parentNode && (t.elem[t.prop] = t.now)
        }
    }, Z.easing = {
        linear: function (t) {
            return t
        }, swing: function (t) {
            return .5 - Math.cos(t * Math.PI) / 2
        }
    }, Z.fx = _.prototype.init, Z.fx.step = {};
    var Yt, Kt, Jt = /^(?:toggle|show|hide)$/, Zt = new RegExp("^(?:([+-])=|)(" + Ct + ")([a-z%]*)$", "i"), te = /queueHooks$/, ee = [A], ne = {
        "*": [function (t, e) {
            var n = this.createTween(t, e), i = n.cur(), r = Zt.exec(e), o = r && r[3] || (Z.cssNumber[t] ? "" : "px"), s = (Z.cssNumber[t] || "px" !== o && +i) && Zt.exec(Z.css(n.elem, t)), a = 1, u = 20;
            if (s && s[3] !== o) {
                o = o || s[3], r = r || [], s = +i || 1;
                do a = a || ".5", s /= a, Z.style(n.elem, t, s + o); while (a !== (a = n.cur() / i) && 1 !== a && --u)
            }
            return r && (s = n.start = +s || +i || 0, n.unit = o, n.end = r[1] ? s + (r[1] + 1) * r[2] : +r[2]), n
        }]
    };
    Z.Animation = Z.extend(L, {
        tweener: function (t, e) {
            Z.isFunction(t) ? (e = t, t = ["*"]) : t = t.split(" ");
            for (var n, i = 0, r = t.length; r > i; i++)n = t[i], ne[n] = ne[n] || [], ne[n].unshift(e)
        }, prefilter: function (t, e) {
            e ? ee.unshift(t) : ee.push(t)
        }
    }), Z.speed = function (t, e, n) {
        var i = t && "object" == typeof t ? Z.extend({}, t) : {
            complete: n || !n && e || Z.isFunction(t) && t,
            duration: t,
            easing: n && e || e && !Z.isFunction(e) && e
        };
        return i.duration = Z.fx.off ? 0 : "number" == typeof i.duration ? i.duration : i.duration in Z.fx.speeds ? Z.fx.speeds[i.duration] : Z.fx.speeds._default, (null == i.queue || i.queue === !0) && (i.queue = "fx"), i.old = i.complete, i.complete = function () {
            Z.isFunction(i.old) && i.old.call(this), i.queue && Z.dequeue(this, i.queue)
        }, i
    }, Z.fn.extend({
        fadeTo: function (t, e, n, i) {
            return this.filter(St).css("opacity", 0).show().end().animate({opacity: e}, t, n, i)
        }, animate: function (t, e, n, i) {
            var r = Z.isEmptyObject(t), o = Z.speed(e, n, i), s = function () {
                var e = L(this, Z.extend({}, t), o);
                (r || vt.get(this, "finish")) && e.stop(!0)
            };
            return s.finish = s, r || o.queue === !1 ? this.each(s) : this.queue(o.queue, s)
        }, stop: function (t, e, n) {
            var i = function (t) {
                var e = t.stop;
                delete t.stop, e(n)
            };
            return "string" != typeof t && (n = e, e = t, t = void 0), e && t !== !1 && this.queue(t || "fx", []), this.each(function () {
                var e = !0, r = null != t && t + "queueHooks", o = Z.timers, s = vt.get(this);
                if (r)s[r] && s[r].stop && i(s[r]); else for (r in s)s[r] && s[r].stop && te.test(r) && i(s[r]);
                for (r = o.length; r--;)o[r].elem !== this || null != t && o[r].queue !== t || (o[r].anim.stop(n), e = !1, o.splice(r, 1));
                (e || !n) && Z.dequeue(this, t)
            })
        }, finish: function (t) {
            return t !== !1 && (t = t || "fx"), this.each(function () {
                var e, n = vt.get(this), i = n[t + "queue"], r = n[t + "queueHooks"], o = Z.timers, s = i ? i.length : 0;
                for (n.finish = !0, Z.queue(this, t, []), r && r.stop && r.stop.call(this, !0), e = o.length; e--;)o[e].elem === this && o[e].queue === t && (o[e].anim.stop(!0), o.splice(e, 1));
                for (e = 0; s > e; e++)i[e] && i[e].finish && i[e].finish.call(this);
                delete n.finish
            })
        }
    }), Z.each(["toggle", "show", "hide"], function (t, e) {
        var n = Z.fn[e];
        Z.fn[e] = function (t, i, r) {
            return null == t || "boolean" == typeof t ? n.apply(this, arguments) : this.animate(j(e, !0), t, i, r)
        }
    }), Z.each({
        slideDown: j("show"),
        slideUp: j("hide"),
        slideToggle: j("toggle"),
        fadeIn: {opacity: "show"},
        fadeOut: {opacity: "hide"},
        fadeToggle: {opacity: "toggle"}
    }, function (t, e) {
        Z.fn[t] = function (t, n, i) {
            return this.animate(e, t, n, i)
        }
    }), Z.timers = [], Z.fx.tick = function () {
        var t, e = 0, n = Z.timers;
        for (Yt = Z.now(); e < n.length; e++)t = n[e], t() || n[e] !== t || n.splice(e--, 1);
        n.length || Z.fx.stop(), Yt = void 0
    }, Z.fx.timer = function (t) {
        Z.timers.push(t), t() ? Z.fx.start() : Z.timers.pop()
    }, Z.fx.interval = 13, Z.fx.start = function () {
        Kt || (Kt = setInterval(Z.fx.tick, Z.fx.interval))
    }, Z.fx.stop = function () {
        clearInterval(Kt), Kt = null
    }, Z.fx.speeds = {slow: 600, fast: 200, _default: 400}, Z.fn.delay = function (t, e) {
        return t = Z.fx ? Z.fx.speeds[t] || t : t, e = e || "fx", this.queue(e, function (e, n) {
            var i = setTimeout(e, t);
            n.stop = function () {
                clearTimeout(i)
            }
        })
    }, function () {
        var t = K.createElement("input"), e = K.createElement("select"), n = e.appendChild(K.createElement("option"));
        t.type = "checkbox", Y.checkOn = "" !== t.value, Y.optSelected = n.selected, e.disabled = !0, Y.optDisabled = !n.disabled, t = K.createElement("input"), t.value = "t", t.type = "radio", Y.radioValue = "t" === t.value
    }();
    var ie, re, oe = Z.expr.attrHandle;
    Z.fn.extend({
        attr: function (t, e) {
            return gt(this, Z.attr, t, e, arguments.length > 1)
        }, removeAttr: function (t) {
            return this.each(function () {
                Z.removeAttr(this, t)
            })
        }
    }), Z.extend({
        attr: function (t, e, n) {
            var i, r, o = t.nodeType;
            if (t && 3 !== o && 8 !== o && 2 !== o)return typeof t.getAttribute === kt ? Z.prop(t, e, n) : (1 === o && Z.isXMLDoc(t) || (e = e.toLowerCase(), i = Z.attrHooks[e] || (Z.expr.match.bool.test(e) ? re : ie)), void 0 === n ? i && "get" in i && null !== (r = i.get(t, e)) ? r : (r = Z.find.attr(t, e), null == r ? void 0 : r) : null !== n ? i && "set" in i && void 0 !== (r = i.set(t, n, e)) ? r : (t.setAttribute(e, n + ""), n) : void Z.removeAttr(t, e))
        }, removeAttr: function (t, e) {
            var n, i, r = 0, o = e && e.match(pt);
            if (o && 1 === t.nodeType)for (; n = o[r++];)i = Z.propFix[n] || n, Z.expr.match.bool.test(n) && (t[i] = !1), t.removeAttribute(n)
        }, attrHooks: {
            type: {
                set: function (t, e) {
                    if (!Y.radioValue && "radio" === e && Z.nodeName(t, "input")) {
                        var n = t.value;
                        return t.setAttribute("type", e), n && (t.value = n), e
                    }
                }
            }
        }
    }), re = {
        set: function (t, e, n) {
            return e === !1 ? Z.removeAttr(t, n) : t.setAttribute(n, n), n
        }
    }, Z.each(Z.expr.match.bool.source.match(/\w+/g), function (t, e) {
        var n = oe[e] || Z.find.attr;
        oe[e] = function (t, e, i) {
            var r, o;
            return i || (o = oe[e], oe[e] = r, r = null != n(t, e, i) ? e.toLowerCase() : null, oe[e] = o), r
        }
    });
    var se = /^(?:input|select|textarea|button)$/i;
    Z.fn.extend({
        prop: function (t, e) {
            return gt(this, Z.prop, t, e, arguments.length > 1)
        }, removeProp: function (t) {
            return this.each(function () {
                delete this[Z.propFix[t] || t]
            })
        }
    }), Z.extend({
        propFix: {"for": "htmlFor", "class": "className"}, prop: function (t, e, n) {
            var i, r, o, s = t.nodeType;
            if (t && 3 !== s && 8 !== s && 2 !== s)return o = 1 !== s || !Z.isXMLDoc(t), o && (e = Z.propFix[e] || e, r = Z.propHooks[e]), void 0 !== n ? r && "set" in r && void 0 !== (i = r.set(t, n, e)) ? i : t[e] = n : r && "get" in r && null !== (i = r.get(t, e)) ? i : t[e]
        }, propHooks: {
            tabIndex: {
                get: function (t) {
                    return t.hasAttribute("tabindex") || se.test(t.nodeName) || t.href ? t.tabIndex : -1
                }
            }
        }
    }), Y.optSelected || (Z.propHooks.selected = {
        get: function (t) {
            var e = t.parentNode;
            return e && e.parentNode && e.parentNode.selectedIndex, null
        }
    }), Z.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
        Z.propFix[this.toLowerCase()] = this
    });
    var ae = /[\t\r\n\f]/g;
    Z.fn.extend({
        addClass: function (t) {
            var e, n, i, r, o, s, a = "string" == typeof t && t, u = 0, l = this.length;
            if (Z.isFunction(t))return this.each(function (e) {
                Z(this).addClass(t.call(this, e, this.className))
            });
            if (a)for (e = (t || "").match(pt) || []; l > u; u++)if (n = this[u], i = 1 === n.nodeType && (n.className ? (" " + n.className + " ").replace(ae, " ") : " ")) {
                for (o = 0; r = e[o++];)i.indexOf(" " + r + " ") < 0 && (i += r + " ");
                s = Z.trim(i), n.className !== s && (n.className = s)
            }
            return this
        }, removeClass: function (t) {
            var e, n, i, r, o, s, a = 0 === arguments.length || "string" == typeof t && t, u = 0, l = this.length;
            if (Z.isFunction(t))return this.each(function (e) {
                Z(this).removeClass(t.call(this, e, this.className))
            });
            if (a)for (e = (t || "").match(pt) || []; l > u; u++)if (n = this[u], i = 1 === n.nodeType && (n.className ? (" " + n.className + " ").replace(ae, " ") : "")) {
                for (o = 0; r = e[o++];)for (; i.indexOf(" " + r + " ") >= 0;)i = i.replace(" " + r + " ", " ");
                s = t ? Z.trim(i) : "", n.className !== s && (n.className = s)
            }
            return this
        }, toggleClass: function (t, e) {
            var n = typeof t;
            return "boolean" == typeof e && "string" === n ? e ? this.addClass(t) : this.removeClass(t) : Z.isFunction(t) ? this.each(function (n) {
                Z(this).toggleClass(t.call(this, n, this.className, e), e)
            }) : this.each(function () {
                if ("string" === n)for (var e, i = 0, r = Z(this), o = t.match(pt) || []; e = o[i++];)r.hasClass(e) ? r.removeClass(e) : r.addClass(e); else(n === kt || "boolean" === n) && (this.className && vt.set(this, "__className__", this.className), this.className = this.className || t === !1 ? "" : vt.get(this, "__className__") || "")
            })
        }, hasClass: function (t) {
            for (var e = " " + t + " ", n = 0, i = this.length; i > n; n++)if (1 === this[n].nodeType && (" " + this[n].className + " ").replace(ae, " ").indexOf(e) >= 0)return !0;
            return !1
        }
    });
    var ue = /\r/g;
    Z.fn.extend({
        val: function (t) {
            var e, n, i, r = this[0];
            {
                if (arguments.length)return i = Z.isFunction(t), this.each(function (n) {
                    var r;
                    1 === this.nodeType && (r = i ? t.call(this, n, Z(this).val()) : t, null == r ? r = "" : "number" == typeof r ? r += "" : Z.isArray(r) && (r = Z.map(r, function (t) {
                        return null == t ? "" : t + ""
                    })), e = Z.valHooks[this.type] || Z.valHooks[this.nodeName.toLowerCase()], e && "set" in e && void 0 !== e.set(this, r, "value") || (this.value = r))
                });
                if (r)return e = Z.valHooks[r.type] || Z.valHooks[r.nodeName.toLowerCase()], e && "get" in e && void 0 !== (n = e.get(r, "value")) ? n : (n = r.value, "string" == typeof n ? n.replace(ue, "") : null == n ? "" : n)
            }
        }
    }), Z.extend({
        valHooks: {
            option: {
                get: function (t) {
                    var e = Z.find.attr(t, "value");
                    return null != e ? e : Z.trim(Z.text(t))
                }
            }, select: {
                get: function (t) {
                    for (var e, n, i = t.options, r = t.selectedIndex, o = "select-one" === t.type || 0 > r, s = o ? null : [], a = o ? r + 1 : i.length, u = 0 > r ? a : o ? r : 0; a > u; u++)if (n = i[u], (n.selected || u === r) && (Y.optDisabled ? !n.disabled : null === n.getAttribute("disabled")) && (!n.parentNode.disabled || !Z.nodeName(n.parentNode, "optgroup"))) {
                        if (e = Z(n).val(), o)return e;
                        s.push(e)
                    }
                    return s
                }, set: function (t, e) {
                    for (var n, i, r = t.options, o = Z.makeArray(e), s = r.length; s--;)i = r[s], (i.selected = Z.inArray(i.value, o) >= 0) && (n = !0);
                    return n || (t.selectedIndex = -1), o
                }
            }
        }
    }), Z.each(["radio", "checkbox"], function () {
        Z.valHooks[this] = {
            set: function (t, e) {
                return Z.isArray(e) ? t.checked = Z.inArray(Z(t).val(), e) >= 0 : void 0
            }
        }, Y.checkOn || (Z.valHooks[this].get = function (t) {
            return null === t.getAttribute("value") ? "on" : t.value
        })
    }), Z.each("blur focus focusin focusout load resize scroll unload click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup error contextmenu".split(" "), function (t, e) {
        Z.fn[e] = function (t, n) {
            return arguments.length > 0 ? this.on(e, null, t, n) : this.trigger(e)
        }
    }), Z.fn.extend({
        hover: function (t, e) {
            return this.mouseenter(t).mouseleave(e || t)
        }, bind: function (t, e, n) {
            return this.on(t, null, e, n)
        }, unbind: function (t, e) {
            return this.off(t, null, e)
        }, delegate: function (t, e, n, i) {
            return this.on(e, t, n, i)
        }, undelegate: function (t, e, n) {
            return 1 === arguments.length ? this.off(t, "**") : this.off(e, t || "**", n)
        }
    });
    var le = Z.now(), ce = /\?/;
    Z.parseJSON = function (t) {
        return JSON.parse(t + "")
    }, Z.parseXML = function (t) {
        var e, n;
        if (!t || "string" != typeof t)return null;
        try {
            n = new DOMParser, e = n.parseFromString(t, "text/xml")
        } catch (i) {
            e = void 0
        }
        return (!e || e.getElementsByTagName("parsererror").length) && Z.error("Invalid XML: " + t), e
    };
    var de = /#.*$/, he = /([?&])_=[^&]*/, pe = /^(.*?):[ \t]*([^\r\n]*)$/gm, fe = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, me = /^(?:GET|HEAD)$/, ge = /^\/\//, ve = /^([\w.+-]+:)(?:\/\/(?:[^\/?#]*@|)([^\/?#:]*)(?::(\d+)|)|)/, ye = {}, be = {}, we = "*/".concat("*"), Ce = t.location.href, xe = ve.exec(Ce.toLowerCase()) || [];
    Z.extend({
        active: 0,
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: Ce,
            type: "GET",
            isLocal: fe.test(xe[1]),
            global: !0,
            processData: !0,
            async: !0,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            accepts: {
                "*": we,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {xml: /xml/, html: /html/, json: /json/},
            responseFields: {xml: "responseXML", text: "responseText", json: "responseJSON"},
            converters: {"* text": String, "text html": !0, "text json": Z.parseJSON, "text xml": Z.parseXML},
            flatOptions: {url: !0, context: !0}
        },
        ajaxSetup: function (t, e) {
            return e ? O(O(t, Z.ajaxSettings), e) : O(Z.ajaxSettings, t)
        },
        ajaxPrefilter: D(ye),
        ajaxTransport: D(be),
        ajax: function (t, e) {
            function n(t, e, n, s) {
                var u, c, v, y, w, x = e;
                2 !== b && (b = 2, a && clearTimeout(a), i = void 0, o = s || "", C.readyState = t > 0 ? 4 : 0, u = t >= 200 && 300 > t || 304 === t, n && (y = M(d, C, n)), y = R(d, y, C, u), u ? (d.ifModified && (w = C.getResponseHeader("Last-Modified"), w && (Z.lastModified[r] = w), w = C.getResponseHeader("etag"), w && (Z.etag[r] = w)), 204 === t || "HEAD" === d.type ? x = "nocontent" : 304 === t ? x = "notmodified" : (x = y.state, c = y.data, v = y.error, u = !v)) : (v = x, (t || !x) && (x = "error", 0 > t && (t = 0))), C.status = t, C.statusText = (e || x) + "", u ? f.resolveWith(h, [c, x, C]) : f.rejectWith(h, [C, x, v]), C.statusCode(g), g = void 0, l && p.trigger(u ? "ajaxSuccess" : "ajaxError", [C, d, u ? c : v]), m.fireWith(h, [C, x]), l && (p.trigger("ajaxComplete", [C, d]), --Z.active || Z.event.trigger("ajaxStop")))
            }

            "object" == typeof t && (e = t, t = void 0), e = e || {};
            var i, r, o, s, a, u, l, c, d = Z.ajaxSetup({}, e), h = d.context || d, p = d.context && (h.nodeType || h.jquery) ? Z(h) : Z.event, f = Z.Deferred(), m = Z.Callbacks("once memory"), g = d.statusCode || {}, v = {}, y = {}, b = 0, w = "canceled", C = {
                readyState: 0,
                getResponseHeader: function (t) {
                    var e;
                    if (2 === b) {
                        if (!s)for (s = {}; e = pe.exec(o);)s[e[1].toLowerCase()] = e[2];
                        e = s[t.toLowerCase()]
                    }
                    return null == e ? null : e
                },
                getAllResponseHeaders: function () {
                    return 2 === b ? o : null
                },
                setRequestHeader: function (t, e) {
                    var n = t.toLowerCase();
                    return b || (t = y[n] = y[n] || t, v[t] = e), this
                },
                overrideMimeType: function (t) {
                    return b || (d.mimeType = t), this
                },
                statusCode: function (t) {
                    var e;
                    if (t)if (2 > b)for (e in t)g[e] = [g[e], t[e]]; else C.always(t[C.status]);
                    return this
                },
                abort: function (t) {
                    var e = t || w;
                    return i && i.abort(e), n(0, e), this
                }
            };
            if (f.promise(C).complete = m.add, C.success = C.done, C.error = C.fail, d.url = ((t || d.url || Ce) + "").replace(de, "").replace(ge, xe[1] + "//"), d.type = e.method || e.type || d.method || d.type, d.dataTypes = Z.trim(d.dataType || "*").toLowerCase().match(pt) || [""], null == d.crossDomain && (u = ve.exec(d.url.toLowerCase()), d.crossDomain = !(!u || u[1] === xe[1] && u[2] === xe[2] && (u[3] || ("http:" === u[1] ? "80" : "443")) === (xe[3] || ("http:" === xe[1] ? "80" : "443")))), d.data && d.processData && "string" != typeof d.data && (d.data = Z.param(d.data, d.traditional)), N(ye, d, e, C), 2 === b)return C;
            l = Z.event && d.global, l && 0 === Z.active++ && Z.event.trigger("ajaxStart"), d.type = d.type.toUpperCase(), d.hasContent = !me.test(d.type), r = d.url, d.hasContent || (d.data && (r = d.url += (ce.test(r) ? "&" : "?") + d.data, delete d.data), d.cache === !1 && (d.url = he.test(r) ? r.replace(he, "$1_=" + le++) : r + (ce.test(r) ? "&" : "?") + "_=" + le++)), d.ifModified && (Z.lastModified[r] && C.setRequestHeader("If-Modified-Since", Z.lastModified[r]), Z.etag[r] && C.setRequestHeader("If-None-Match", Z.etag[r])), (d.data && d.hasContent && d.contentType !== !1 || e.contentType) && C.setRequestHeader("Content-Type", d.contentType), C.setRequestHeader("Accept", d.dataTypes[0] && d.accepts[d.dataTypes[0]] ? d.accepts[d.dataTypes[0]] + ("*" !== d.dataTypes[0] ? ", " + we + "; q=0.01" : "") : d.accepts["*"]);
            for (c in d.headers)C.setRequestHeader(c, d.headers[c]);
            if (d.beforeSend && (d.beforeSend.call(h, C, d) === !1 || 2 === b))return C.abort();
            w = "abort";
            for (c in{success: 1, error: 1, complete: 1})C[c](d[c]);
            if (i = N(be, d, e, C)) {
                C.readyState = 1, l && p.trigger("ajaxSend", [C, d]), d.async && d.timeout > 0 && (a = setTimeout(function () {
                    C.abort("timeout")
                }, d.timeout));
                try {
                    b = 1, i.send(v, n)
                } catch (x) {
                    if (!(2 > b))throw x;
                    n(-1, x)
                }
            } else n(-1, "No Transport");
            return C
        },
        getJSON: function (t, e, n) {
            return Z.get(t, e, n, "json")
        },
        getScript: function (t, e) {
            return Z.get(t, void 0, e, "script")
        }
    }), Z.each(["get", "post"], function (t, e) {
        Z[e] = function (t, n, i, r) {
            return Z.isFunction(n) && (r = r || i, i = n, n = void 0), Z.ajax({
                url: t,
                type: e,
                dataType: r,
                data: n,
                success: i
            })
        }
    }), Z._evalUrl = function (t) {
        return Z.ajax({url: t, type: "GET", dataType: "script", async: !1, global: !1, "throws": !0})
    }, Z.fn.extend({
        wrapAll: function (t) {
            var e;
            return Z.isFunction(t) ? this.each(function (e) {
                Z(this).wrapAll(t.call(this, e))
            }) : (this[0] && (e = Z(t, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && e.insertBefore(this[0]), e.map(function () {
                for (var t = this; t.firstElementChild;)t = t.firstElementChild;
                return t
            }).append(this)), this)
        }, wrapInner: function (t) {
            return Z.isFunction(t) ? this.each(function (e) {
                Z(this).wrapInner(t.call(this, e))
            }) : this.each(function () {
                var e = Z(this), n = e.contents();
                n.length ? n.wrapAll(t) : e.append(t)
            })
        }, wrap: function (t) {
            var e = Z.isFunction(t);
            return this.each(function (n) {
                Z(this).wrapAll(e ? t.call(this, n) : t)
            })
        }, unwrap: function () {
            return this.parent().each(function () {
                Z.nodeName(this, "body") || Z(this).replaceWith(this.childNodes)
            }).end()
        }
    }), Z.expr.filters.hidden = function (t) {
        return t.offsetWidth <= 0 && t.offsetHeight <= 0
    }, Z.expr.filters.visible = function (t) {
        return !Z.expr.filters.hidden(t)
    };
    var Se = /%20/g, Te = /\[\]$/, ke = /\r?\n/g, Ee = /^(?:submit|button|image|reset|file)$/i, $e = /^(?:input|select|textarea|keygen)/i;
    Z.param = function (t, e) {
        var n, i = [], r = function (t, e) {
            e = Z.isFunction(e) ? e() : null == e ? "" : e, i[i.length] = encodeURIComponent(t) + "=" + encodeURIComponent(e)
        };
        if (void 0 === e && (e = Z.ajaxSettings && Z.ajaxSettings.traditional), Z.isArray(t) || t.jquery && !Z.isPlainObject(t))Z.each(t, function () {
            r(this.name, this.value)
        }); else for (n in t)H(n, t[n], e, r);
        return i.join("&").replace(Se, "+")
    }, Z.fn.extend({
        serialize: function () {
            return Z.param(this.serializeArray())
        }, serializeArray: function () {
            return this.map(function () {
                var t = Z.prop(this, "elements");
                return t ? Z.makeArray(t) : this
            }).filter(function () {
                var t = this.type;
                return this.name && !Z(this).is(":disabled") && $e.test(this.nodeName) && !Ee.test(t) && (this.checked || !Tt.test(t))
            }).map(function (t, e) {
                var n = Z(this).val();
                return null == n ? null : Z.isArray(n) ? Z.map(n, function (t) {
                    return {name: e.name, value: t.replace(ke, "\r\n")}
                }) : {name: e.name, value: n.replace(ke, "\r\n")}
            }).get()
        }
    }), Z.ajaxSettings.xhr = function () {
        try {
            return new XMLHttpRequest
        } catch (t) {
        }
    };
    var _e = 0, Fe = {}, je = {0: 200, 1223: 204}, Pe = Z.ajaxSettings.xhr();
    t.attachEvent && t.attachEvent("onunload", function () {
        for (var t in Fe)Fe[t]()
    }), Y.cors = !!Pe && "withCredentials" in Pe, Y.ajax = Pe = !!Pe, Z.ajaxTransport(function (t) {
        var e;
        return Y.cors || Pe && !t.crossDomain ? {
            send: function (n, i) {
                var r, o = t.xhr(), s = ++_e;
                if (o.open(t.type, t.url, t.async, t.username, t.password), t.xhrFields)for (r in t.xhrFields)o[r] = t.xhrFields[r];
                t.mimeType && o.overrideMimeType && o.overrideMimeType(t.mimeType), t.crossDomain || n["X-Requested-With"] || (n["X-Requested-With"] = "XMLHttpRequest");
                for (r in n)o.setRequestHeader(r, n[r]);
                e = function (t) {
                    return function () {
                        e && (delete Fe[s], e = o.onload = o.onerror = null, "abort" === t ? o.abort() : "error" === t ? i(o.status, o.statusText) : i(je[o.status] || o.status, o.statusText, "string" == typeof o.responseText ? {text: o.responseText} : void 0, o.getAllResponseHeaders()))
                    }
                }, o.onload = e(), o.onerror = e("error"), e = Fe[s] = e("abort");
                try {
                    o.send(t.hasContent && t.data || null)
                } catch (a) {
                    if (e)throw a
                }
            }, abort: function () {
                e && e()
            }
        } : void 0
    }), Z.ajaxSetup({
        accepts: {script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},
        contents: {script: /(?:java|ecma)script/},
        converters: {
            "text script": function (t) {
                return Z.globalEval(t), t
            }
        }
    }), Z.ajaxPrefilter("script", function (t) {
        void 0 === t.cache && (t.cache = !1), t.crossDomain && (t.type = "GET")
    }), Z.ajaxTransport("script", function (t) {
        if (t.crossDomain) {
            var e, n;
            return {
                send: function (i, r) {
                    e = Z("<script>").prop({
                        async: !0,
                        charset: t.scriptCharset,
                        src: t.url
                    }).on("load error", n = function (t) {
                        e.remove(), n = null, t && r("error" === t.type ? 404 : 200, t.type)
                    }), K.head.appendChild(e[0])
                }, abort: function () {
                    n && n()
                }
            }
        }
    });
    var Ae = [], Ie = /(=)\?(?=&|$)|\?\?/;
    Z.ajaxSetup({
        jsonp: "callback", jsonpCallback: function () {
            var t = Ae.pop() || Z.expando + "_" + le++;
            return this[t] = !0, t
        }
    }), Z.ajaxPrefilter("json jsonp", function (e, n, i) {
        var r, o, s, a = e.jsonp !== !1 && (Ie.test(e.url) ? "url" : "string" == typeof e.data && !(e.contentType || "").indexOf("application/x-www-form-urlencoded") && Ie.test(e.data) && "data");
        return a || "jsonp" === e.dataTypes[0] ? (r = e.jsonpCallback = Z.isFunction(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback, a ? e[a] = e[a].replace(Ie, "$1" + r) : e.jsonp !== !1 && (e.url += (ce.test(e.url) ? "&" : "?") + e.jsonp + "=" + r), e.converters["script json"] = function () {
            return s || Z.error(r + " was not called"), s[0]
        }, e.dataTypes[0] = "json", o = t[r], t[r] = function () {
            s = arguments
        }, i.always(function () {
            t[r] = o, e[r] && (e.jsonpCallback = n.jsonpCallback, Ae.push(r)), s && Z.isFunction(o) && o(s[0]), s = o = void 0
        }), "script") : void 0
    }), Z.parseHTML = function (t, e, n) {
        if (!t || "string" != typeof t)return null;
        "boolean" == typeof e && (n = e, e = !1), e = e || K;
        var i = st.exec(t), r = !n && [];
        return i ? [e.createElement(i[1])] : (i = Z.buildFragment([t], e, r), r && r.length && Z(r).remove(), Z.merge([], i.childNodes))
    };
    var Le = Z.fn.load;
    Z.fn.load = function (t, e, n) {
        if ("string" != typeof t && Le)return Le.apply(this, arguments);
        var i, r, o, s = this, a = t.indexOf(" ");
        return a >= 0 && (i = Z.trim(t.slice(a)), t = t.slice(0, a)), Z.isFunction(e) ? (n = e, e = void 0) : e && "object" == typeof e && (r = "POST"),
        s.length > 0 && Z.ajax({url: t, type: r, dataType: "html", data: e}).done(function (t) {
            o = arguments, s.html(i ? Z("<div>").append(Z.parseHTML(t)).find(i) : t)
        }).complete(n && function (t, e) {
                s.each(n, o || [t.responseText, e, t])
            }), this
    }, Z.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (t, e) {
        Z.fn[e] = function (t) {
            return this.on(e, t)
        }
    }), Z.expr.filters.animated = function (t) {
        return Z.grep(Z.timers, function (e) {
            return t === e.elem
        }).length
    };
    var De = t.document.documentElement;
    Z.offset = {
        setOffset: function (t, e, n) {
            var i, r, o, s, a, u, l, c = Z.css(t, "position"), d = Z(t), h = {};
            "static" === c && (t.style.position = "relative"), a = d.offset(), o = Z.css(t, "top"), u = Z.css(t, "left"), l = ("absolute" === c || "fixed" === c) && (o + u).indexOf("auto") > -1, l ? (i = d.position(), s = i.top, r = i.left) : (s = parseFloat(o) || 0, r = parseFloat(u) || 0), Z.isFunction(e) && (e = e.call(t, n, a)), null != e.top && (h.top = e.top - a.top + s), null != e.left && (h.left = e.left - a.left + r), "using" in e ? e.using.call(t, h) : d.css(h)
        }
    }, Z.fn.extend({
        offset: function (t) {
            if (arguments.length)return void 0 === t ? this : this.each(function (e) {
                Z.offset.setOffset(this, t, e)
            });
            var e, n, i = this[0], r = {top: 0, left: 0}, o = i && i.ownerDocument;
            if (o)return e = o.documentElement, Z.contains(e, i) ? (typeof i.getBoundingClientRect !== kt && (r = i.getBoundingClientRect()), n = q(o), {
                top: r.top + n.pageYOffset - e.clientTop,
                left: r.left + n.pageXOffset - e.clientLeft
            }) : r
        }, position: function () {
            if (this[0]) {
                var t, e, n = this[0], i = {top: 0, left: 0};
                return "fixed" === Z.css(n, "position") ? e = n.getBoundingClientRect() : (t = this.offsetParent(), e = this.offset(), Z.nodeName(t[0], "html") || (i = t.offset()), i.top += Z.css(t[0], "borderTopWidth", !0), i.left += Z.css(t[0], "borderLeftWidth", !0)), {
                    top: e.top - i.top - Z.css(n, "marginTop", !0),
                    left: e.left - i.left - Z.css(n, "marginLeft", !0)
                }
            }
        }, offsetParent: function () {
            return this.map(function () {
                for (var t = this.offsetParent || De; t && !Z.nodeName(t, "html") && "static" === Z.css(t, "position");)t = t.offsetParent;
                return t || De
            })
        }
    }), Z.each({scrollLeft: "pageXOffset", scrollTop: "pageYOffset"}, function (e, n) {
        var i = "pageYOffset" === n;
        Z.fn[e] = function (r) {
            return gt(this, function (e, r, o) {
                var s = q(e);
                return void 0 === o ? s ? s[n] : e[r] : void(s ? s.scrollTo(i ? t.pageXOffset : o, i ? o : t.pageYOffset) : e[r] = o)
            }, e, r, arguments.length, null)
        }
    }), Z.each(["top", "left"], function (t, e) {
        Z.cssHooks[e] = x(Y.pixelPosition, function (t, n) {
            return n ? (n = C(t, e), zt.test(n) ? Z(t).position()[e] + "px" : n) : void 0
        })
    }), Z.each({Height: "height", Width: "width"}, function (t, e) {
        Z.each({padding: "inner" + t, content: e, "": "outer" + t}, function (n, i) {
            Z.fn[i] = function (i, r) {
                var o = arguments.length && (n || "boolean" != typeof i), s = n || (i === !0 || r === !0 ? "margin" : "border");
                return gt(this, function (e, n, i) {
                    var r;
                    return Z.isWindow(e) ? e.document.documentElement["client" + t] : 9 === e.nodeType ? (r = e.documentElement, Math.max(e.body["scroll" + t], r["scroll" + t], e.body["offset" + t], r["offset" + t], r["client" + t])) : void 0 === i ? Z.css(e, n, s) : Z.style(e, n, i, s)
                }, e, o ? i : void 0, o, null)
            }
        })
    }), Z.fn.size = function () {
        return this.length
    }, Z.fn.andSelf = Z.fn.addBack, "function" == typeof define && define.amd && define("jquery", [], function () {
        return Z
    });
    var Ne = t.jQuery, Oe = t.$;
    return Z.noConflict = function (e) {
        return t.$ === Z && (t.$ = Oe), e && t.jQuery === Z && (t.jQuery = Ne), Z
    }, typeof e === kt && (t.jQuery = t.$ = Z), Z
}), void 0 === jQuery.migrateMute && (jQuery.migrateMute = !0), function (t, e, n) {
    function i(n) {
        var i = e.console;
        o[n] || (o[n] = !0, t.migrateWarnings.push(n), i && i.warn && !t.migrateMute && (i.warn("JQMIGRATE: " + n), t.migrateTrace && i.trace && i.trace()))
    }

    function r(e, r, o, s) {
        if (Object.defineProperty)try {
            return Object.defineProperty(e, r, {
                configurable: !0, enumerable: !0, get: function () {
                    return i(s), o
                }, set: function (t) {
                    i(s), o = t
                }
            }), n
        } catch (a) {
        }
        t._definePropertyBroken = !0, e[r] = o
    }

    var o = {};
    t.migrateWarnings = [], !t.migrateMute && e.console && e.console.log && e.console.log("JQMIGRATE: Logging is active"), t.migrateTrace === n && (t.migrateTrace = !0), t.migrateReset = function () {
        o = {}, t.migrateWarnings.length = 0
    }, "BackCompat" === document.compatMode && i("jQuery is not compatible with Quirks Mode");
    var s = t("<input/>", {size: 1}).attr("size") && t.attrFn, a = t.attr, u = t.attrHooks.value && t.attrHooks.value.get || function () {
            return null
        }, l = t.attrHooks.value && t.attrHooks.value.set || function () {
            return n
        }, c = /^(?:input|button)$/i, d = /^[238]$/, h = /^(?:autofocus|autoplay|async|checked|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped|selected)$/i, p = /^(?:checked|selected)$/i;
    r(t, "attrFn", s || {}, "jQuery.attrFn is deprecated"), t.attr = function (e, r, o, u) {
        var l = r.toLowerCase(), f = e && e.nodeType;
        return u && (4 > a.length && i("jQuery.fn.attr( props, pass ) is deprecated"), e && !d.test(f) && (s ? r in s : t.isFunction(t.fn[r]))) ? t(e)[r](o) : ("type" === r && o !== n && c.test(e.nodeName) && e.parentNode && i("Can't change the 'type' of an input or button in IE 6/7/8"), !t.attrHooks[l] && h.test(l) && (t.attrHooks[l] = {
            get: function (e, i) {
                var r, o = t.prop(e, i);
                return o === !0 || "boolean" != typeof o && (r = e.getAttributeNode(i)) && r.nodeValue !== !1 ? i.toLowerCase() : n
            }, set: function (e, n, i) {
                var r;
                return n === !1 ? t.removeAttr(e, i) : (r = t.propFix[i] || i, r in e && (e[r] = !0), e.setAttribute(i, i.toLowerCase())), i
            }
        }, p.test(l) && i("jQuery.fn.attr('" + l + "') may use property instead of attribute")), a.call(t, e, r, o))
    }, t.attrHooks.value = {
        get: function (t, e) {
            var n = (t.nodeName || "").toLowerCase();
            return "button" === n ? u.apply(this, arguments) : ("input" !== n && "option" !== n && i("jQuery.fn.attr('value') no longer gets properties"), e in t ? t.value : null)
        }, set: function (t, e) {
            var r = (t.nodeName || "").toLowerCase();
            return "button" === r ? l.apply(this, arguments) : ("input" !== r && "option" !== r && i("jQuery.fn.attr('value', val) no longer sets properties"), t.value = e, n)
        }
    };
    var f, m, g = t.fn.init, v = t.parseJSON, y = /^([^<]*)(<[\w\W]+>)([^>]*)$/;
    t.fn.init = function (e, n, r) {
        var o;
        return e && "string" == typeof e && !t.isPlainObject(n) && (o = y.exec(t.trim(e))) && o[0] && ("<" !== e.charAt(0) && i("$(html) HTML strings must start with '<' character"), o[3] && i("$(html) HTML text after last tag is ignored"), "#" === o[0].charAt(0) && (i("HTML string cannot start with a '#' character"), t.error("JQMIGRATE: Invalid selector string (XSS)")), n && n.context && (n = n.context), t.parseHTML) ? g.call(this, t.parseHTML(o[2], n, !0), n, r) : g.apply(this, arguments)
    }, t.fn.init.prototype = t.fn, t.parseJSON = function (t) {
        return t || null === t ? v.apply(this, arguments) : (i("jQuery.parseJSON requires a valid JSON string"), null)
    }, t.uaMatch = function (t) {
        t = t.toLowerCase();
        var e = /(chrome)[ \/]([\w.]+)/.exec(t) || /(webkit)[ \/]([\w.]+)/.exec(t) || /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(t) || /(msie) ([\w.]+)/.exec(t) || 0 > t.indexOf("compatible") && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(t) || [];
        return {browser: e[1] || "", version: e[2] || "0"}
    }, t.browser || (f = t.uaMatch(navigator.userAgent), m = {}, f.browser && (m[f.browser] = !0, m.version = f.version), m.chrome ? m.webkit = !0 : m.webkit && (m.safari = !0), t.browser = m), r(t, "browser", t.browser, "jQuery.browser is deprecated"), t.sub = function () {
        function e(t, n) {
            return new e.fn.init(t, n)
        }

        t.extend(!0, e, this), e.superclass = this, e.fn = e.prototype = this(), e.fn.constructor = e, e.sub = this.sub, e.fn.init = function (i, r) {
            return r && r instanceof t && !(r instanceof e) && (r = e(r)), t.fn.init.call(this, i, r, n)
        }, e.fn.init.prototype = e.fn;
        var n = e(document);
        return i("jQuery.sub() is deprecated"), e
    }, t.ajaxSetup({converters: {"text json": t.parseJSON}});
    var b = t.fn.data;
    t.fn.data = function (e) {
        var r, o, s = this[0];
        return !s || "events" !== e || 1 !== arguments.length || (r = t.data(s, e), o = t._data(s, e), r !== n && r !== o || o === n) ? b.apply(this, arguments) : (i("Use of jQuery.fn.data('events') is deprecated"), o)
    };
    var w = /\/(java|ecma)script/i, C = t.fn.andSelf || t.fn.addBack;
    t.fn.andSelf = function () {
        return i("jQuery.fn.andSelf() replaced by jQuery.fn.addBack()"), C.apply(this, arguments)
    }, t.clean || (t.clean = function (e, r, o, s) {
        r = r || document, r = !r.nodeType && r[0] || r, r = r.ownerDocument || r, i("jQuery.clean() is deprecated");
        var a, u, l, c, d = [];
        if (t.merge(d, t.buildFragment(e, r).childNodes), o)for (l = function (t) {
            return !t.type || w.test(t.type) ? s ? s.push(t.parentNode ? t.parentNode.removeChild(t) : t) : o.appendChild(t) : n
        }, a = 0; null != (u = d[a]); a++)t.nodeName(u, "script") && l(u) || (o.appendChild(u), u.getElementsByTagName !== n && (c = t.grep(t.merge([], u.getElementsByTagName("script")), l), d.splice.apply(d, [a + 1, 0].concat(c)), a += c.length));
        return d
    });
    var x = t.event.add, S = t.event.remove, T = t.event.trigger, k = t.fn.toggle, E = t.fn.live, $ = t.fn.die, _ = "ajaxStart|ajaxStop|ajaxSend|ajaxComplete|ajaxError|ajaxSuccess", F = RegExp("\\b(?:" + _ + ")\\b"), j = /(?:^|\s)hover(\.\S+|)\b/, P = function (e) {
        return "string" != typeof e || t.event.special.hover ? e : (j.test(e) && i("'hover' pseudo-event is deprecated, use 'mouseenter mouseleave'"), e && e.replace(j, "mouseenter$1 mouseleave$1"))
    };
    t.event.props && "attrChange" !== t.event.props[0] && t.event.props.unshift("attrChange", "attrName", "relatedNode", "srcElement"), t.event.dispatch && r(t.event, "handle", t.event.dispatch, "jQuery.event.handle is undocumented and deprecated"), t.event.add = function (t, e, n, r, o) {
        t !== document && F.test(e) && i("AJAX events should be attached to document: " + e), x.call(this, t, P(e || ""), n, r, o)
    }, t.event.remove = function (t, e, n, i, r) {
        S.call(this, t, P(e) || "", n, i, r)
    }, t.fn.error = function () {
        var t = Array.prototype.slice.call(arguments, 0);
        return i("jQuery.fn.error() is deprecated"), t.splice(0, 0, "error"), arguments.length ? this.bind.apply(this, t) : (this.triggerHandler.apply(this, t), this)
    }, t.fn.toggle = function (e, n) {
        if (!t.isFunction(e) || !t.isFunction(n))return k.apply(this, arguments);
        i("jQuery.fn.toggle(handler, handler...) is deprecated");
        var r = arguments, o = e.guid || t.guid++, s = 0, a = function (n) {
            var i = (t._data(this, "lastToggle" + e.guid) || 0) % s;
            return t._data(this, "lastToggle" + e.guid, i + 1), n.preventDefault(), r[i].apply(this, arguments) || !1
        };
        for (a.guid = o; r.length > s;)r[s++].guid = o;
        return this.click(a)
    }, t.fn.live = function (e, n, r) {
        return i("jQuery.fn.live() is deprecated"), E ? E.apply(this, arguments) : (t(this.context).on(e, this.selector, n, r), this)
    }, t.fn.die = function (e, n) {
        return i("jQuery.fn.die() is deprecated"), $ ? $.apply(this, arguments) : (t(this.context).off(e, this.selector || "**", n), this)
    }, t.event.trigger = function (t, e, n, r) {
        return n || F.test(t) || i("Global events are undocumented and deprecated"), T.call(this, t, e, n || document, r)
    }, t.each(_.split("|"), function (e, n) {
        t.event.special[n] = {
            setup: function () {
                var e = this;
                return e !== document && (t.event.add(document, n + "." + t.guid, function () {
                    t.event.trigger(n, null, e, !0)
                }), t._data(this, n, t.guid++)), !1
            }, teardown: function () {
                return this !== document && t.event.remove(document, n + "." + t._data(this, n)), !1
            }
        }
    })
}(jQuery, window);
var dialogPolyfill = function () {
    var t = window.CustomEvent;
    t || (t = function (t, e) {
        e = e || {};
        var n = document.createEvent("CustomEvent");
        return n.initCustomEvent(t, !!e.bubbles, !!e.cancelable, e.detail || null), n
    }, t.prototype = window.Event.prototype);
    var e = {};
    e.reposition = function (t) {
        var e = document.body.scrollTop || document.documentElement.scrollTop, n = e + (window.innerHeight - t.offsetHeight) / 2;
        t.style.top = Math.max(0, n) + "px", t.dialogPolyfillInfo.isTopOverridden = !0
    }, e.inNodeList = function (t, e) {
        for (var n = 0; n < t.length; ++n)if (t[n] == e)return !0;
        return !1
    }, e.isInlinePositionSetByStylesheet = function (t) {
        for (var n = 0; n < document.styleSheets.length; ++n) {
            var i = document.styleSheets[n], r = null;
            try {
                r = i.cssRules
            } catch (o) {
            }
            if (r)for (var s = 0; s < r.length; ++s) {
                var a = r[s], u = null;
                try {
                    u = document.querySelectorAll(a.selectorText)
                } catch (o) {
                }
                if (u && e.inNodeList(u, t)) {
                    var l = a.style.getPropertyValue("top"), c = a.style.getPropertyValue("bottom");
                    if (l && "auto" != l || c && "auto" != c)return !0
                }
            }
        }
        return !1
    }, e.needsCentering = function (t) {
        var n = window.getComputedStyle(t);
        return "absolute" != n.position ? !1 : "auto" != t.style.top && "" != t.style.top || "auto" != t.style.bottom && "" != t.style.bottom ? !1 : !e.isInlinePositionSetByStylesheet(t)
    }, e.showDialog = function (t) {
        if (this.open)throw"InvalidStateError: showDialog called on open dialog";
        if (this.open = !0, this.setAttribute("open", "open"), t) {
            var n = null, i = null, r = function (t) {
                if (t.children)for (var e = 0; e < t.children.length; e++) {
                    var o = t.children[e];
                    if (null !== n || o.disabled || "BUTTON" != o.nodeName && "INPUT" != o.nodeName && "KEYGEN" != o.nodeName && "SELECT" != o.nodeName && "TEXTAREA" != o.nodeName || (n = o), o.autofocus)return void(i = o);
                    if (r(o), null !== i)return
                }
            };
            r(this), null !== i ? i.focus() : null !== n && n.focus()
        }
        e.needsCentering(this) && e.reposition(this), t && (this.dialogPolyfillInfo.modal = !0, e.dm.pushDialog(this));
        try {
            null !== i ? i.focus() : null !== n && n.focus()
        } catch (o) {
        }
        this.style.zoom = 1
    }, e.close = function (t) {
        if (!this.open && !window.HTMLDialogElement)throw"InvalidStateError: close called on closed dialog";
        this.open = !1, this.removeAttribute("open"), "undefined" != typeof t && (this.returnValue = t), this.dialogPolyfillInfo.isTopOverridden && (this.style.top = "auto"), this.dialogPolyfillInfo.modal && e.dm.removeDialog(this);
        var n;
        return document.createEvent ? (n = document.createEvent("HTMLEvents"), n.initEvent("close", !0, !0)) : n = new Event("close"), this.dispatchEvent(n), this.returnValue
    }, e.registerDialog = function (t) {
        t.show && console.warn("This browser already supports <dialog>, the polyfill may not work correctly."), t.addEventListener("dialog_submit", function (e) {
            t.close(e.detail.target.value), e.preventDefault(), e.stopPropagation()
        }), t.show = e.showDialog.bind(t, !1), t.showModal = e.showDialog.bind(t, !0), t.close = e.close.bind(t), t.dialogPolyfillInfo = {}
    };
    var n = 1e5, i = 1e5;
    return e.DialogManager = function () {
        this.pendingDialogStack = [], this.overlay = document.createElement("div"), this.overlay.style.width = "100%", this.overlay.style.height = "100%", this.overlay.style.position = "fixed", this.overlay.style.left = "0px", this.overlay.style.top = "0px", this.overlay.style.backgroundColor = "rgba(0,0,0,0.0)", this.focusPageLast = this.createFocusable(), this.overlay.appendChild(this.focusPageLast), this.overlay.addEventListener("click", function (t) {
            var e = document.createEvent("MouseEvents");
            e.initMouseEvent(t.type, t.bubbles, t.cancelable, window, t.detail, t.screenX, t.screenY, t.clientX, t.clientY, t.ctrlKey, t.altKey, t.shiftKey, t.metaKey, t.button, t.relatedTarget), document.body.dispatchEvent(e)
        }), window.addEventListener("load", function () {
            for (var e = document.getElementsByTagName("form"), n = e.length; n--;)!function (e) {
                "dialog" == e.getAttribute("method") && e.addEventListener("click", function (e) {
                    if ("submit" == e.target.type) {
                        var n = new t("dialog_submit", {bubbles: !0, detail: {target: e.target}});
                        this.dispatchEvent(n), e.preventDefault()
                    }
                })
            }(e[n])
        })
    }, e.DialogManager.prototype.createFocusable = function (t) {
        var e = document.createElement("span");
        return e.tabIndex = t || 0, e.style.opacity = 0, e.style.position = "static", e
    }, e.DialogManager.prototype.blockDocument = function () {
        document.body.contains(this.overlay) || (document.body.appendChild(this.overlay), void 0 === this.needsDocumentElementFocus && (document.documentElement.focus(), this.needsDocumentElementFocus = document.activeElement != document.documentElement), this.needsDocumentElementFocus && (document.documentElement.tabIndex = 1))
    }, e.DialogManager.prototype.unblockDocument = function () {
        document.body.removeChild(this.overlay), this.needsDocumentElementFocus && (document.documentElement.tabIndex = "")
    }, e.DialogManager.prototype.updateStacking = function () {
        if (0 == this.pendingDialogStack.length)return void this.unblockDocument();
        this.blockDocument();
        for (var t = n, e = 0; e < this.pendingDialogStack.length; e++) {
            e == this.pendingDialogStack.length - 1 && (this.overlay.style.zIndex = t++);
            var i = this.pendingDialogStack[e];
            i.dialogPolyfillInfo.backdrop.style.zIndex = t++, i.style.zIndex = t++
        }
    }, e.DialogManager.prototype.handleKey = function (e) {
        var n = this.pendingDialogStack.length;
        if (0 != n) {
            var i = this.pendingDialogStack[n - 1], r = i.dialogPolyfillInfo;
            switch (e.keyCode) {
                case 9:
                    var o = document.activeElement, s = !e.shiftKey;
                    s ? o == document.documentElement || o == document.body || o == r.backdrop ? r.focusFirst.focus() : o == r.focusLast && r.focusFirst.focus() : o == r.focusFirst ? r.focusLast.focus() : o == this.focusPageLast && r.focusLast.focus();
                    break;
                case 27:
                    e.preventDefault(), e.stopPropagation();
                    var a = new t("cancel", {bubbles: !1, cancelable: !0});
                    i.dispatchEvent(a) && i.close()
            }
        }
    }, e.DialogManager.prototype.pushDialog = function (t) {
        if (this.pendingDialogStack.length >= i)throw"Too many modal dialogs";
        var e = document.createElement("div");
        e.className = "backdrop";
        var n = function (e) {
            var n = document.createEvent("MouseEvents");
            n.initMouseEvent(e.type, e.bubbles, e.cancelable, window, e.detail, e.screenX, e.screenY, e.clientX, e.clientY, e.ctrlKey, e.altKey, e.shiftKey, e.metaKey, e.button, e.relatedTarget), t.dispatchEvent(n)
        };
        e.addEventListener("click", n), t.parentNode.insertBefore(e, t.nextSibling), t.dialogPolyfillInfo.backdrop = e, t.dialogPolyfillInfo.clickEventListener = n, this.pendingDialogStack.push(t), this.updateStacking(), t.dialogPolyfillInfo.focusFirst = this.createFocusable(), t.dialogPolyfillInfo.focusLast = this.createFocusable(), t.appendChild(t.dialogPolyfillInfo.focusLast), t.insertBefore(t.dialogPolyfillInfo.focusFirst, t.firstChild)
    }, e.DialogManager.prototype.removeDialog = function (t) {
        var e = this.pendingDialogStack.indexOf(t);
        if (-1 != e) {
            this.pendingDialogStack.splice(e, 1);
            var n = t.dialogPolyfillInfo.backdrop, i = t.dialogPolyfillInfo.clickEventListener;
            n.removeEventListener("click", i), n.parentNode.removeChild(n), t.dialogPolyfillInfo.backdrop = null, t.dialogPolyfillInfo.clickEventListener = null, this.updateStacking(), t.removeChild(t.dialogPolyfillInfo.focusFirst), t.removeChild(t.dialogPolyfillInfo.focusLast), t.dialogPolyfillInfo.focusFirst = null, t.dialogPolyfillInfo.focusLast = null
        }
    }, e.dm = new e.DialogManager, document.addEventListener("keydown", e.dm.handleKey.bind(e.dm)), e
}();
!function t(e, n, i) {
    function r(s, a) {
        if (!n[s]) {
            if (!e[s]) {
                var u = "function" == typeof require && require;
                if (!a && u)return u(s, !0);
                if (o)return o(s, !0);
                var l = new Error("Cannot find module '" + s + "'");
                throw l.code = "MODULE_NOT_FOUND", l
            }
            var c = n[s] = {exports: {}};
            e[s][0].call(c.exports, function (t) {
                var n = e[s][1][t];
                return r(n ? n : t)
            }, c, c.exports, t, e, n, i)
        }
        return n[s].exports
    }

    for (var o = "function" == typeof require && require, s = 0; s < i.length; s++)r(i[s]);
    return r
}({
    1: [function (t, e, n) {
        (function (e) {
            "use strict";
            if (e._babelPolyfill)throw new Error("only one instance of babel/polyfill is allowed");
            e._babelPolyfill = !0, t("core-js/shim"), t("regenerator-babel/runtime")
        }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {})
    }, {"core-js/shim": 2, "regenerator-babel/runtime": 3}], 2: [function (t, e, n) {
        !function (t, n, i) {
            "use strict";
            function r(t) {
                return null !== t && ("object" == typeof t || "function" == typeof t)
            }

            function o(t) {
                return "function" == typeof t
            }

            function s(t, e, n) {
                t && !ge(t = n ? t : t[vt], Oe) && Ae(t, Oe, e)
            }

            function a(t) {
                return re.call(t).slice(8, -1)
            }

            function u(t) {
                var e, n;
                return t == i ? t === i ? "Undefined" : "Null" : "string" == typeof(n = (e = _t(t))[Oe]) ? n : a(e)
            }

            function l() {
                for (var t = j(this), e = arguments.length, n = Ft(e), i = 0, r = qe._, o = !1; e > i;)(n[i] = arguments[i++]) === r && (o = !0);
                return function () {
                    var i, s = this, a = arguments.length, u = 0, l = 0;
                    if (!o && !a)return d(t, n, s);
                    if (i = n.slice(), o)for (; e > u; u++)i[u] === r && (i[u] = arguments[l++]);
                    for (; a > l;)i.push(arguments[l++]);
                    return d(t, i, s)
                }
            }

            function c(t, e, n) {
                if (j(t), ~n && e === i)return t;
                switch (n) {
                    case 1:
                        return function (n) {
                            return t.call(e, n)
                        };
                    case 2:
                        return function (n, i) {
                            return t.call(e, n, i)
                        };
                    case 3:
                        return function (n, i, r) {
                            return t.call(e, n, i, r)
                        }
                }
                return function () {
                    return t.apply(e, arguments)
                }
            }

            function d(t, e, n) {
                var r = n === i;
                switch (0 | e.length) {
                    case 0:
                        return r ? t() : t.call(n);
                    case 1:
                        return r ? t(e[0]) : t.call(n, e[0]);
                    case 2:
                        return r ? t(e[0], e[1]) : t.call(n, e[0], e[1]);
                    case 3:
                        return r ? t(e[0], e[1], e[2]) : t.call(n, e[0], e[1], e[2]);
                    case 4:
                        return r ? t(e[0], e[1], e[2], e[3]) : t.call(n, e[0], e[1], e[2], e[3]);
                    case 5:
                        return r ? t(e[0], e[1], e[2], e[3], e[4]) : t.call(n, e[0], e[1], e[2], e[3], e[4])
                }
                return t.apply(n, e)
            }

            function h(t) {
                return ve(F(t))
            }

            function p(t) {
                return t
            }

            function f() {
                return this
            }

            function m(t, e) {
                return ge(t, e) ? t[e] : void 0
            }

            function g(t) {
                return P(t), fe ? pe(t).concat(fe(t)) : pe(t)
            }

            function v(t, e) {
                for (var n, i = h(t), r = he(i), o = r.length, s = 0; o > s;)if (i[n = r[s++]] === e)return n
            }

            function y(t) {
                return jt(t).split(",")
            }

            function b(t) {
                var e = 1 == t, n = 2 == t, r = 3 == t, o = 4 == t, s = 6 == t, a = 5 == t || s;
                return function (u) {
                    for (var l, d, h = _t(F(this)), p = arguments[1], f = ve(h), m = c(u, p, 3), g = T(f.length), v = 0, y = e ? Ft(g) : n ? [] : i; g > v; v++)if ((a || v in f) && (l = f[v], d = m(l, v, h), t))if (e)y[v] = d; else if (d)switch (t) {
                        case 3:
                            return !0;
                        case 5:
                            return l;
                        case 6:
                            return v;
                        case 2:
                            y.push(l)
                    } else if (o)return !1;
                    return s ? -1 : r || o ? o : y
                }
            }

            function w(t) {
                return function (e) {
                    var n = h(this), i = T(n.length), r = k(arguments[1], i);
                    if (t && e != e) {
                        for (; i > r; r++)if (x(n[r]))return t || r
                    } else for (; i > r; r++)if ((t || r in n) && n[r] === e)return t || r;
                    return !t && -1
                }
            }

            function C(t, e) {
                return "function" == typeof t ? t : e
            }

            function x(t) {
                return t != t
            }

            function S(t) {
                return isNaN(t) ? 0 : Fe(t)
            }

            function T(t) {
                return t > 0 ? $e(S(t), Ce) : 0
            }

            function k(t, e) {
                var t = S(t);
                return 0 > t ? Ee(t + e, 0) : $e(t, e)
            }

            function E(t, e, n) {
                var i = r(e) ? function (t) {
                    return e[t]
                } : e;
                return function (e) {
                    return jt(n ? e : this).replace(t, i)
                }
            }

            function $(t) {
                return function (e) {
                    var n, r, o = jt(F(this)), s = S(e), a = o.length;
                    return 0 > s || s >= a ? t ? "" : i : (n = o.charCodeAt(s), 55296 > n || n > 56319 || s + 1 === a || (r = o.charCodeAt(s + 1)) < 56320 || r > 57343 ? t ? o.charAt(s) : n : t ? o.slice(s, s + 2) : (n - 55296 << 10) + (r - 56320) + 65536)
                }
            }

            function _(t, e, n) {
                if (!t)throw Rt(n ? e + n : e)
            }

            function F(t) {
                if (t == i)throw Rt("Function called on null or undefined");
                return t
            }

            function j(t) {
                return _(o(t), t, " is not a function!"), t
            }

            function P(t) {
                return _(r(t), t, " is not an object!"), t
            }

            function A(t, e, n) {
                _(t instanceof e, n, ": use the 'new' operator!")
            }

            function I(t, e) {
                return {enumerable: !(1 & t), configurable: !(2 & t), writable: !(4 & t), value: e}
            }

            function L(t, e, n) {
                return t[e] = n, t
            }

            function D(t) {
                return je ? function (e, n, i) {
                    return ce(e, n, I(t, i))
                } : L
            }

            function N(t) {
                return pt + "(" + t + ")_" + (++Pe + _e())[bt](36)
            }

            function O(t, e) {
                return Ot && Ot[t] || (e ? Ot : Le)(pt + ne + t)
            }

            function M(t, e) {
                for (var n in e)Ae(t, n, e[n]);
                return t
            }

            function R(t) {
                !je || !n && ie(t) || ce(t, Me, {configurable: !0, get: f})
            }

            function H(e, i, r) {
                var s, a, u, l, d = e & Ve, h = d ? t : e & Ue ? t[i] : (t[i] || Zt)[vt], p = d ? He : He[i] || (He[i] = {});
                d && (r = i);
                for (s in r)a = !(e & Be) && h && s in h && (!o(h[s]) || ie(h[s])), u = (a ? h : r)[s], n || !d || o(h[s]) ? e & Xe && a ? l = c(u, t) : e & Qe && !n && h[s] == u ? (l = function (t) {
                    return this instanceof u ? new u(t) : u(t)
                }, l[vt] = u[vt]) : l = e & We && o(u) ? c(oe, u) : u : l = r[s], n && h && !a && (d ? h[s] = u : delete h[s] && Ae(h, s, u)), p[s] != u && Ae(p, s, l)
            }

            function q(t, e) {
                Ae(t, tt, e), Tt in Jt && Ae(t, Tt, e)
            }

            function z(t, e, n, i) {
                t[vt] = ae(i || Ze, {next: I(1, n)}), s(t, e + " Iterator")
            }

            function B(t, e, i, r) {
                var o = t[vt], a = m(o, tt) || m(o, Tt) || r && m(o, r) || i;
                if (n && (q(o, a), a !== i)) {
                    var u = ue(a.call(new t));
                    s(u, e + " Iterator", !0), ge(o, Tt) && q(u, f)
                }
                return Je[e] = a, Je[e + " Iterator"] = f, a
            }

            function V(t, e, n, i, r, o) {
                function s(t) {
                    return function () {
                        return new n(this, t)
                    }
                }

                z(n, e, i);
                var a = s(Ye + Ke), u = s(Ke);
                r == Ke ? u = B(t, e, u, "values") : a = B(t, e, a, "entries"), r && H(We + Be * tn, e, {
                    entries: a,
                    keys: o ? u : s(Ye),
                    values: u
                })
            }

            function U(t, e) {
                return {value: e, done: !!t}
            }

            function W(e) {
                var n = _t(e), i = t[pt], r = (i && i[St] || Tt) in n;
                return r || tt in n || ge(Je, u(n))
            }

            function X(e) {
                var n = t[pt], i = e[n && n[St] || Tt], r = i || e[tt] || Je[u(e)];
                return P(r.call(e))
            }

            function Q(t, e, n) {
                return n ? d(t, e) : t(e)
            }

            function G(t) {
                var e = !0, n = {
                    next: function () {
                        throw 1
                    }, "return": function () {
                        e = !1
                    }
                };
                n[tt] = f;
                try {
                    t(n)
                } catch (i) {
                }
                return e
            }

            function Y(t) {
                var e = t["return"];
                e !== i && e.call(t)
            }

            function K(t, e) {
                try {
                    t(e)
                } catch (n) {
                    throw Y(e), n
                }
            }

            function J(t, e, n, i) {
                K(function (t) {
                    for (var r, o = c(n, i, e ? 2 : 1); !(r = t.next()).done;)if (Q(o, r.value, e) === !1)return Y(t)
                }, X(t))
            }

            var Z, tt, et, nt = "Object", it = "Function", rt = "Array", ot = "String", st = "Number", at = "RegExp", ut = "Date", lt = "Map", ct = "Set", dt = "WeakMap", ht = "WeakSet", pt = "Symbol", ft = "Promise", mt = "Math", gt = "Arguments", vt = "prototype", yt = "constructor", bt = "toString", wt = bt + "Tag", Ct = "hasOwnProperty", xt = "forEach", St = "iterator", Tt = "@@" + St, kt = "process", Et = "createElement", $t = t[it], _t = t[nt], Ft = t[rt], jt = t[ot], Pt = t[st], At = t[at], It = (t[ut], t[lt]), Lt = t[ct], Dt = t[dt], Nt = t[ht], Ot = t[pt], Mt = t[mt], Rt = t.TypeError, Ht = t.RangeError, qt = t.setTimeout, zt = t.setImmediate, Bt = t.clearImmediate, Vt = t.parseInt, Ut = t.isFinite, Wt = t[kt], Xt = Wt && Wt.nextTick, Qt = t.document, Gt = Qt && Qt.documentElement, Yt = (t.navigator, t.define), Kt = t.console || {}, Jt = Ft[vt], Zt = _t[vt], te = $t[vt], ee = 1 / 0, ne = ".", ie = c(/./.test, /\[native code\]\s*\}\s*$/, 1), re = Zt[bt], oe = te.call, se = te.apply, ae = _t.create, ue = _t.getPrototypeOf, le = _t.setPrototypeOf, ce = _t.defineProperty, de = (_t.defineProperties, _t.getOwnPropertyDescriptor), he = _t.keys, pe = _t.getOwnPropertyNames, fe = _t.getOwnPropertySymbols, me = _t.isFrozen, ge = c(oe, Zt[Ct], 2), ve = _t, ye = _t.assign || function (t, e) {
                    for (var n = _t(F(t)), i = arguments.length, r = 1; i > r;)for (var o, s = ve(arguments[r++]), a = he(s), u = a.length, l = 0; u > l;)n[o = a[l++]] = s[o];
                    return n
                }, be = Jt.push, we = (Jt.unshift, Jt.slice, Jt.splice, Jt.indexOf, Jt[xt]), Ce = 9007199254740991, xe = Mt.pow, Se = Mt.abs, Te = Mt.ceil, ke = Mt.floor, Ee = Mt.max, $e = Mt.min, _e = Mt.random, Fe = Mt.trunc || function (t) {
                    return (t > 0 ? ke : Te)(t)
                }, je = !!function () {
                try {
                    return 2 == ce({}, "a", {
                            get: function () {
                                return 2
                            }
                        }).a
                } catch (t) {
                }
            }(), Pe = 0, Ae = D(1), Ie = Ot ? L : Ae, Le = Ot || N, De = O("unscopables"), Ne = Jt[De] || {}, Oe = O(wt), Me = O("species"), Re = a(Wt) == kt, He = {}, qe = n ? t : He, ze = t.core, Be = 1, Ve = 2, Ue = 4, We = 8, Xe = 16, Qe = 32;
            "undefined" != typeof e && e.exports ? e.exports = He : o(Yt) && Yt.amd ? Yt(function () {
                return He
            }) : et = !0, (et || n) && (He.noConflict = function () {
                return t.core = ze, He
            }, t.core = He), tt = O(St);
            var Ge = Le("iter"), Ye = 1, Ke = 2, Je = {}, Ze = {}, tn = "keys" in Jt && !("next" in [].keys());
            q(Ze, f), !function (e, n, i, r) {
                ie(Ot) || (Ot = function (t) {
                    _(!(this instanceof Ot), pt + " is not a " + yt);
                    var n = N(t), o = Ie(ae(Ot[vt]), e, n);
                    return i[n] = o, je && r && ce(Zt, n, {
                        configurable: !0, set: function (t) {
                            Ae(this, n, t)
                        }
                    }), o
                }, Ae(Ot[vt], bt, function () {
                    return this[e]
                })), H(Ve + Qe, {Symbol: Ot});
                var o = {
                    "for": function (t) {
                        return ge(n, t += "") ? n[t] : n[t] = Ot(t)
                    },
                    iterator: tt || O(St),
                    keyFor: l.call(v, n),
                    species: Me,
                    toStringTag: Oe = O(wt, !0),
                    unscopables: De,
                    pure: Le,
                    set: Ie,
                    useSetter: function () {
                        r = !0
                    },
                    useSimple: function () {
                        r = !1
                    }
                };
                we.call(y("hasInstance,isConcatSpreadable,match,replace,search,split,toPrimitive"), function (t) {
                    o[t] = O(t)
                }), H(Ue, pt, o), s(Ot, pt), H(Ue + Be * !ie(Ot), nt, {
                    getOwnPropertyNames: function (t) {
                        for (var e, n = pe(h(t)), r = [], o = 0; n.length > o;)ge(i, e = n[o++]) || r.push(e);
                        return r
                    }, getOwnPropertySymbols: function (t) {
                        for (var e, n = pe(h(t)), r = [], o = 0; n.length > o;)ge(i, e = n[o++]) && r.push(i[e]);
                        return r
                    }
                }), s(Mt, mt, !0), s(t.JSON, "JSON", !0)
            }(Le("tag"), {}, {}, !0), !function () {
                var t = {
                    assign: ye, is: function (t, e) {
                        return t === e ? 0 !== t || 1 / t === 1 / e : t != t && e != e
                    }
                };
                "__proto__" in Zt && function (e, n) {
                    try {
                        n = c(oe, de(Zt, "__proto__").set, 2), n({}, Jt)
                    } catch (i) {
                        e = !0
                    }
                    t.setPrototypeOf = le = le || function (t, i) {
                            return P(t), _(null === i || r(i), i, ": can't set as prototype!"), e ? t.__proto__ = i : n(t, i), t
                        }
                }(), H(Ue, nt, t)
            }(), !function (t) {
                t[Oe] = ne, a(t) != ne && Ae(Zt, bt, function () {
                    return "[object " + u(this) + "]"
                })
            }({}), !function () {
                function t(t, e) {
                    var n = _t[t], i = He[nt][t], o = 0, s = {};
                    if (!i || ie(i)) {
                        s[t] = 1 == e ? function (t) {
                            return r(t) ? n(t) : t
                        } : 2 == e ? function (t) {
                            return r(t) ? n(t) : !0
                        } : 3 == e ? function (t) {
                            return r(t) ? n(t) : !1
                        } : 4 == e ? function (t, e) {
                            return n(h(t), e)
                        } : function (t) {
                            return n(h(t))
                        };
                        try {
                            n(ne)
                        } catch (a) {
                            o = 1
                        }
                        H(Ue + Be * o, nt, s)
                    }
                }

                t("freeze", 1), t("seal", 1), t("preventExtensions", 1), t("isFrozen", 2), t("isSealed", 2), t("isExtensible", 3), t("getOwnPropertyDescriptor", 4), t("getPrototypeOf"), t("keys"), t("getOwnPropertyNames")
            }(), !function (t) {
                t in te || je && ce(te, t, {
                    configurable: !0, get: function () {
                        var e = jt(this).match(/^\s*function ([^ (]*)/), n = e ? e[1] : "";
                        return ge(this, t) || ce(this, t, I(5, n)), n
                    }, set: function (e) {
                        ge(this, t) || ce(this, t, I(0, e))
                    }
                })
            }("name"), Pt("0o1") && Pt("0b1") || function (e, n) {
                function i(t) {
                    if (r(t) && (t = s(t)), "string" == typeof t && t.length > 2 && 48 == t.charCodeAt(0)) {
                        var e = !1;
                        switch (t.charCodeAt(1)) {
                            case 66:
                            case 98:
                                e = !0;
                            case 79:
                            case 111:
                                return Vt(t.slice(2), e ? 2 : 8)
                        }
                    }
                    return +t
                }

                function s(t) {
                    var e, n;
                    if (o(e = t.valueOf) && !r(n = e.call(t)))return n;
                    if (o(e = t[bt]) && !r(n = e.call(t)))return n;
                    throw Rt("Can't convert object to number")
                }

                Pt = function a(t) {
                    return this instanceof a ? new e(i(t)) : i(t)
                }, we.call(je ? pe(e) : y("MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY"), function (t) {
                    t in Pt || ce(Pt, t, de(e, t))
                }), Pt[vt] = n, n[yt] = Pt, Ae(t, st, Pt)
            }(Pt, Pt[vt]), !function (t) {
                H(Ue, st, {
                    EPSILON: xe(2, -52), isFinite: function (t) {
                        return "number" == typeof t && Ut(t)
                    }, isInteger: t, isNaN: x, isSafeInteger: function (e) {
                        return t(e) && Se(e) <= Ce
                    }, MAX_SAFE_INTEGER: Ce, MIN_SAFE_INTEGER: -Ce, parseFloat: parseFloat, parseInt: Vt
                })
            }(Pt.isInteger || function (t) {
                    return !r(t) && Ut(t) && ke(t) === t
                }), !function () {
                function t(e) {
                    return Ut(e = +e) && 0 != e ? 0 > e ? -t(-e) : r(e + o(e * e + 1)) : e
                }

                function e(t) {
                    return 0 == (t = +t) ? t : t > -1e-6 && 1e-6 > t ? t + t * t / 2 : i(t) - 1
                }

                var n = Mt.E, i = Mt.exp, r = Mt.log, o = Mt.sqrt, s = Mt.sign || function (t) {
                        return 0 == (t = +t) || t != t ? t : 0 > t ? -1 : 1
                    };
                H(Ue, mt, {
                    acosh: function (t) {
                        return (t = +t) < 1 ? NaN : Ut(t) ? r(t / n + o(t + 1) * o(t - 1) / n) + 1 : t
                    }, asinh: t, atanh: function (t) {
                        return 0 == (t = +t) ? t : r((1 + t) / (1 - t)) / 2
                    }, cbrt: function (t) {
                        return s(t = +t) * xe(Se(t), 1 / 3)
                    }, clz32: function (t) {
                        return (t >>>= 0) ? 32 - t[bt](2).length : 32
                    }, cosh: function (t) {
                        return (i(t = +t) + i(-t)) / 2
                    }, expm1: e, fround: function (t) {
                        return new Float32Array([t])[0]
                    }, hypot: function (t, e) {
                        for (var n, i = 0, r = arguments.length, s = r, a = Ft(r), u = -ee; r--;) {
                            if (n = a[r] = +arguments[r], n == ee || n == -ee)return ee;
                            n > u && (u = n)
                        }
                        for (u = n || 1; s--;)i += xe(a[s] / u, 2);
                        return u * o(i)
                    }, imul: function (t, e) {
                        var n = 65535, i = +t, r = +e, o = n & i, s = n & r;
                        return 0 | o * s + ((n & i >>> 16) * s + o * (n & r >>> 16) << 16 >>> 0)
                    }, log1p: function (t) {
                        return (t = +t) > -1e-8 && 1e-8 > t ? t - t * t / 2 : r(1 + t)
                    }, log10: function (t) {
                        return r(t) / Mt.LN10
                    }, log2: function (t) {
                        return r(t) / Mt.LN2
                    }, sign: s, sinh: function (t) {
                        return Se(t = +t) < 1 ? (e(t) - e(-t)) / 2 : (i(t - 1) - i(-t - 1)) * (n / 2)
                    }, tanh: function (t) {
                        var n = e(t = +t), r = e(-t);
                        return n == ee ? 1 : r == ee ? -1 : (n - r) / (i(t) + i(-t))
                    }, trunc: Fe
                })
            }(), !function (t) {
                function e(t) {
                    if (a(t) == at)throw Rt()
                }

                H(Ue, ot, {
                    fromCodePoint: function (e) {
                        for (var n, i = [], r = arguments.length, o = 0; r > o;) {
                            if (n = +arguments[o++], k(n, 1114111) !== n)throw Ht(n + " is not a valid code point");
                            i.push(65536 > n ? t(n) : t(((n -= 65536) >> 10) + 55296, n % 1024 + 56320))
                        }
                        return i.join("")
                    }, raw: function (t) {
                        for (var e = h(t.raw), n = T(e.length), i = arguments.length, r = [], o = 0; n > o;)r.push(jt(e[o++])), i > o && r.push(jt(arguments[o]));
                        return r.join("")
                    }
                }), H(We, ot, {
                    codePointAt: $(!1), endsWith: function (t) {
                        e(t);
                        var n = jt(F(this)), r = arguments[1], o = T(n.length), s = r === i ? o : $e(T(r), o);
                        return t += "", n.slice(s - t.length, s) === t
                    }, includes: function (t) {
                        return e(t), !!~jt(F(this)).indexOf(t, arguments[1])
                    }, repeat: function (t) {
                        var e = jt(F(this)), n = "", i = S(t);
                        if (0 > i || i == ee)throw Ht("Count can't be negative");
                        for (; i > 0; (i >>>= 1) && (e += e))1 & i && (n += e);
                        return n
                    }, startsWith: function (t) {
                        e(t);
                        var n = jt(F(this)), i = T($e(arguments[1], n.length));
                        return t += "", n.slice(i, i + t.length) === t
                    }
                })
            }(jt.fromCharCode), !function () {
                H(Ue + Be * G(Ft.from), rt, {
                    from: function (t) {
                        var e, n, r, o = _t(F(t)), s = arguments[1], a = s !== i, u = a ? c(s, arguments[2], 2) : i, l = 0;
                        if (W(o))n = new (C(this, Ft)), K(function (t) {
                            for (; !(r = t.next()).done; l++)n[l] = a ? u(r.value, l) : r.value
                        }, X(o)); else for (n = new (C(this, Ft))(e = T(o.length)); e > l; l++)n[l] = a ? u(o[l], l) : o[l];
                        return n.length = l, n
                    }
                }), H(Ue, rt, {
                    of: function () {
                        for (var t = 0, e = arguments.length, n = new (C(this, Ft))(e); e > t;)n[t] = arguments[t++];
                        return n.length = e, n
                    }
                }), R(Ft)
            }(), !function () {
                H(We, rt, {
                    copyWithin: function (t, e) {
                        var n = _t(F(this)), r = T(n.length), o = k(t, r), s = k(e, r), a = arguments[2], u = a === i ? r : k(a, r), l = $e(u - s, r - o), c = 1;
                        for (o > s && s + l > o && (c = -1, s = s + l - 1, o = o + l - 1); l-- > 0;)s in n ? n[o] = n[s] : delete n[o], o += c, s += c;
                        return n
                    }, fill: function (t) {
                        for (var e = _t(F(this)), n = T(e.length), r = k(arguments[1], n), o = arguments[2], s = o === i ? n : k(o, n); s > r;)e[r++] = t;
                        return e
                    }, find: b(5), findIndex: b(6)
                }), n && (we.call(y("find,findIndex,fill,copyWithin,entries,keys,values"), function (t) {
                    Ne[t] = !0
                }), De in Jt || Ae(Jt, De, Ne))
            }(), !function (t) {
                V(Ft, rt, function (t, e) {
                    Ie(this, Ge, {o: h(t), i: 0, k: e})
                }, function () {
                    var t = this[Ge], e = t.o, n = t.k, r = t.i++;
                    return !e || r >= e.length ? (t.o = i, U(1)) : n == Ye ? U(0, r) : n == Ke ? U(0, e[r]) : U(0, [r, e[r]])
                }, Ke), Je[gt] = Je[rt], V(jt, ot, function (t) {
                    Ie(this, Ge, {o: jt(t), i: 0})
                }, function () {
                    var e, n = this[Ge], i = n.o, r = n.i;
                    return r >= i.length ? U(1) : (e = t.call(i, r), n.i += e.length, U(0, e))
                })
            }($(!0)), je && !function (e, n) {
                (function () {
                    try {
                        return "/a/i" == At(/a/g, "i")
                    } catch (t) {
                    }
                })() || (At = function (t, e) {
                    return new n(a(t) == at && e !== i ? t.source : t, e)
                }, we.call(pe(n), function (t) {
                    t in At || ce(At, t, {
                        configurable: !0, get: function () {
                            return n[t]
                        }, set: function (e) {
                            n[t] = e
                        }
                    })
                }), e[yt] = At, At[vt] = e, Ae(t, at, At)), "g" != /./g.flags && ce(e, "flags", {
                    configurable: !0,
                    get: E(/^.*\/(\w*)$/, "$1")
                }), R(At)
            }(At[vt], At), o(zt) && o(Bt) || function (e) {
                function n(t) {
                    if (ge(m, t)) {
                        var e = m[t];
                        delete m[t], e()
                    }
                }

                function i(t) {
                    n(t.data)
                }

                var r, s, a, u = t.postMessage, h = t.addEventListener, p = t.MessageChannel, f = 0, m = {};
                zt = function (t) {
                    for (var e = [], n = 1; arguments.length > n;)e.push(arguments[n++]);
                    return m[++f] = function () {
                        d(o(t) ? t : $t(t), e)
                    }, r(f), f
                }, Bt = function (t) {
                    delete m[t]
                }, Re ? r = function (t) {
                    Xt(l.call(n, t))
                } : h && o(u) && !t.importScripts ? (r = function (t) {
                    u(t, "*")
                }, h("message", i, !1)) : o(p) ? (s = new p, a = s.port2, s.port1.onmessage = i, r = c(a.postMessage, a, 1)) : r = Qt && e in Qt[Et]("script") ? function (t) {
                    Gt.appendChild(Qt[Et]("script"))[e] = function () {
                        Gt.removeChild(this), n(t)
                    }
                } : function (t) {
                    qt(n, 0, t)
                }
            }("onreadystatechange"), H(Ve + Xe, {setImmediate: zt, clearImmediate: Bt}), !function (t, e) {
                o(t) && o(t.resolve) && t.resolve(e = new t(function () {
                })) == e || function (e, n) {
                    function s(t) {
                        var e;
                        return r(t) && (e = t.then), o(e) ? e : !1
                    }

                    function a(t) {
                        var e, i = t[n], r = i.c, o = 0;
                        if (i.h)return !0;
                        for (; r.length > o;)if (e = r[o++], e.fail || a(e.P))return !0
                    }

                    function u(t, n) {
                        var i = t.c;
                        (n || i.length) && e(function () {
                            var e = t.p, r = t.v, u = 1 == t.s, l = 0;
                            if (n && !a(e))qt(function () {
                                a(e) || (Re ? !Wt.emit("unhandledRejection", r, e) : o(Kt.error) && Kt.error("Unhandled promise rejection", r))
                            }, 1e3); else for (; i.length > l;)!function (e) {
                                var n, i, o = u ? e.ok : e.fail;
                                try {
                                    o ? (u || (t.h = !0), n = o === !0 ? r : o(r), n === e.P ? e.rej(Rt(ft + "-chain cycle")) : (i = s(n)) ? i.call(n, e.res, e.rej) : e.res(n)) : e.rej(r);
                                } catch (a) {
                                    e.rej(a)
                                }
                            }(i[l++]);
                            i.length = 0
                        })
                    }

                    function l(t) {
                        var e, n, i = this;
                        if (!i.d) {
                            i.d = !0, i = i.r || i;
                            try {
                                (e = s(t)) ? (n = {
                                    r: i,
                                    d: !1
                                }, e.call(t, c(l, n, 1), c(d, n, 1))) : (i.v = t, i.s = 1, u(i))
                            } catch (r) {
                                d.call(n || {r: i, d: !1}, r)
                            }
                        }
                    }

                    function d(t) {
                        var e = this;
                        e.d || (e.d = !0, e = e.r || e, e.v = t, e.s = 2, u(e, !0))
                    }

                    function h(t) {
                        var e = P(t)[Me];
                        return e != i ? e : t
                    }

                    t = function (e) {
                        j(e), A(this, t, ft);
                        var r = {p: this, c: [], s: 0, d: !1, v: i, h: !1};
                        Ae(this, n, r);
                        try {
                            e(c(l, r, 1), c(d, r, 1))
                        } catch (o) {
                            d.call(r, o)
                        }
                    }, M(t[vt], {
                        then: function (e, r) {
                            var s = P(P(this)[yt])[Me], a = {
                                ok: o(e) ? e : !0,
                                fail: o(r) ? r : !1
                            }, l = a.P = new (s != i ? s : t)(function (t, e) {
                                a.res = j(t), a.rej = j(e)
                            }), c = this[n];
                            return c.c.push(a), c.s && u(c), l
                        }, "catch": function (t) {
                            return this.then(i, t)
                        }
                    }), M(t, {
                        all: function (t) {
                            var e = h(this), n = [];
                            return new e(function (i, r) {
                                J(t, !1, be, n);
                                var o = n.length, s = Ft(o);
                                o ? we.call(n, function (t, n) {
                                    e.resolve(t).then(function (t) {
                                        s[n] = t, --o || i(s)
                                    }, r)
                                }) : i(s)
                            })
                        }, race: function (t) {
                            var e = h(this);
                            return new e(function (n, i) {
                                J(t, !1, function (t) {
                                    e.resolve(t).then(n, i)
                                })
                            })
                        }, reject: function (t) {
                            return new (h(this))(function (e, n) {
                                n(t)
                            })
                        }, resolve: function (t) {
                            return r(t) && n in t && ue(t) === this[vt] ? t : new (h(this))(function (e, n) {
                                e(t)
                            })
                        }
                    })
                }(Xt || zt, Le("record")), s(t, ft), R(t), H(Ve + Be * !ie(t), {Promise: t})
            }(t[ft]), !function () {
                function t(t, e, r, o, a, u) {
                    function l(t, e) {
                        return e != i && J(e, a, t[p], t), t
                    }

                    function c(t, e) {
                        var i = f[t];
                        n && (f[t] = function (t, n) {
                            var r = i.call(this, 0 === t ? 0 : t, n);
                            return e ? this : r
                        })
                    }

                    var p = a ? "set" : "add", f = t && t[vt], y = {};
                    if (ie(t) && (u || !tn && ge(f, xt) && ge(f, "entries"))) {
                        var w, C = t, x = new t, S = x[p](u ? {} : -0, 1);
                        G(function (e) {
                            new t(e)
                        }) && (t = function (n) {
                            return A(this, t, e), l(new C, n)
                        }, t[vt] = f, n && (f[yt] = t)), u || x[xt](function (t, e) {
                            w = 1 / e === -ee
                        }), w && (c("delete"), c("has"), a && c("get")), (w || S !== x) && c(p, !0)
                    } else t = u ? function (n) {
                        A(this, t, e), Ie(this, d, b++), l(this, n)
                    } : function (n) {
                        var r = this;
                        A(r, t, e), Ie(r, h, ae(null)), Ie(r, v, 0), Ie(r, m, i), Ie(r, g, i), l(r, n)
                    }, M(M(t[vt], r), o), u || !je || ce(t[vt], "size", {
                        get: function () {
                            return F(this[v])
                        }
                    });
                    return s(t, e), R(t), y[e] = t, H(Ve + Qe + Be * !ie(t), y), u || V(t, e, function (t, e) {
                        Ie(this, Ge, {o: t, k: e})
                    }, function () {
                        for (var t = this[Ge], e = t.k, n = t.l; n && n.r;)n = n.p;
                        return t.o && (t.l = n = n ? n.n : t.o[g]) ? e == Ye ? U(0, n.k) : e == Ke ? U(0, n.v) : U(0, [n.k, n.v]) : (t.o = i, U(1))
                    }, a ? Ye + Ke : Ke, !a), t
                }

                function e(t, e) {
                    if (!r(t))return ("string" == typeof t ? "S" : "P") + t;
                    if (me(t))return "F";
                    if (!ge(t, d)) {
                        if (!e)return "E";
                        Ae(t, d, ++b)
                    }
                    return "O" + t[d]
                }

                function o(t, n) {
                    var i, r = e(n);
                    if ("F" != r)return t[h][r];
                    for (i = t[g]; i; i = i.n)if (i.k == n)return i
                }

                function a(t, n, r) {
                    var s, a, u = o(t, n);
                    return u ? u.v = r : (t[m] = u = {
                        i: a = e(n, !0),
                        k: n,
                        v: r,
                        p: s = t[m],
                        n: i,
                        r: !1
                    }, t[g] || (t[g] = u), s && (s.n = u), t[v]++, "F" != a && (t[h][a] = u)), t
                }

                function u(t, e, n) {
                    return me(P(e)) ? l(t).set(e, n) : (ge(e, p) || Ae(e, p, {}), e[p][t[d]] = n), t
                }

                function l(t) {
                    return t[f] || Ae(t, f, new It)[f]
                }

                var d = Le("uid"), h = Le("O1"), p = Le("weak"), f = Le("leak"), m = Le("last"), g = Le("first"), v = je ? Le("size") : "size", b = 0, w = {}, C = {
                    clear: function () {
                        for (var t = this, e = t[h], n = t[g]; n; n = n.n)n.r = !0, n.p && (n.p = n.p.n = i), delete e[n.i];
                        t[g] = t[m] = i, t[v] = 0
                    }, "delete": function (t) {
                        var e = this, n = o(e, t);
                        if (n) {
                            var i = n.n, r = n.p;
                            delete e[h][n.i], n.r = !0, r && (r.n = i), i && (i.p = r), e[g] == n && (e[g] = i), e[m] == n && (e[m] = r), e[v]--
                        }
                        return !!n
                    }, forEach: function (t) {
                        for (var e, n = c(t, arguments[1], 3); e = e ? e.n : this[g];)for (n(e.v, e.k, this); e && e.r;)e = e.p
                    }, has: function (t) {
                        return !!o(this, t)
                    }
                };
                It = t(It, lt, {
                    get: function (t) {
                        var e = o(this, t);
                        return e && e.v
                    }, set: function (t, e) {
                        return a(this, 0 === t ? 0 : t, e)
                    }
                }, C, !0), Lt = t(Lt, ct, {
                    add: function (t) {
                        return a(this, t = 0 === t ? 0 : t, t)
                    }
                }, C);
                var x = {
                    "delete": function (t) {
                        return r(t) ? me(t) ? l(this)["delete"](t) : ge(t, p) && ge(t[p], this[d]) && delete t[p][this[d]] : !1
                    }, has: function (t) {
                        return r(t) ? me(t) ? l(this).has(t) : ge(t, p) && ge(t[p], this[d]) : !1
                    }
                };
                Dt = t(Dt, dt, {
                    get: function (t) {
                        if (r(t)) {
                            if (me(t))return l(this).get(t);
                            if (ge(t, p))return t[p][this[d]]
                        }
                    }, set: function (t, e) {
                        return u(this, t, e)
                    }
                }, x, !0, !0), n && 7 != (new Dt).set(_t.freeze(w), 7).get(w) && we.call(y("delete,has,get,set"), function (t) {
                    var e = Dt[vt][t];
                    Dt[vt][t] = function (n, i) {
                        if (r(n) && me(n)) {
                            var o = l(this)[t](n, i);
                            return "set" == t ? this : o
                        }
                        return e.call(this, n, i)
                    }
                }), Nt = t(Nt, ht, {
                    add: function (t) {
                        return u(this, t, !0)
                    }
                }, x, !1, !0)
            }(), !function () {
                function t(t) {
                    var e, n = [];
                    for (e in t)n.push(e);
                    Ie(this, Ge, {o: t, a: n, i: 0})
                }

                function e(t) {
                    return function (e) {
                        P(e);
                        try {
                            return t.apply(i, arguments), !0
                        } catch (n) {
                            return !1
                        }
                    }
                }

                function n(t, e) {
                    var o, s = arguments.length < 3 ? t : arguments[2], a = de(P(t), e);
                    return a ? ge(a, "value") ? a.value : a.get === i ? i : a.get.call(s) : r(o = ue(t)) ? n(o, e, s) : i
                }

                function o(t, e, n) {
                    var s, a, u = arguments.length < 4 ? t : arguments[3], l = de(P(t), e);
                    if (!l) {
                        if (r(a = ue(t)))return o(a, e, n, u);
                        l = I(0)
                    }
                    return ge(l, "value") ? l.writable !== !1 && r(u) ? (s = de(u, e) || I(0), s.value = n, ce(u, e, s), !0) : !1 : l.set === i ? !1 : (l.set.call(u, n), !0)
                }

                z(t, nt, function () {
                    var t, e = this[Ge], n = e.a;
                    do if (e.i >= n.length)return U(1); while (!((t = n[e.i++]) in e.o));
                    return U(0, t)
                });
                var s = _t.isExtensible || p, a = {
                    apply: c(oe, se, 3), construct: function (t, e) {
                        var n = j(arguments.length < 3 ? t : arguments[2])[vt], i = ae(r(n) ? n : Zt), o = se.call(t, i, e);
                        return r(o) ? o : i
                    }, defineProperty: e(ce), deleteProperty: function (t, e) {
                        var n = de(P(t), e);
                        return n && !n.configurable ? !1 : delete t[e]
                    }, enumerate: function (e) {
                        return new t(P(e))
                    }, get: n, getOwnPropertyDescriptor: function (t, e) {
                        return de(P(t), e)
                    }, getPrototypeOf: function (t) {
                        return ue(P(t))
                    }, has: function (t, e) {
                        return e in t
                    }, isExtensible: function (t) {
                        return !!s(P(t))
                    }, ownKeys: g, preventExtensions: e(_t.preventExtensions || p), set: o
                };
                le && (a.setPrototypeOf = function (t, e) {
                    return le(P(t), e), !0
                }), H(Ve, {Reflect: {}}), H(Ue, "Reflect", a)
            }(), !function () {
                function t(t) {
                    return function (e) {
                        var n, i = h(e), r = he(e), o = r.length, s = 0, a = Ft(o);
                        if (t)for (; o > s;)a[s] = [n = r[s++], i[n]]; else for (; o > s;)a[s] = i[r[s++]];
                        return a
                    }
                }

                H(We, rt, {includes: w(!0)}), H(We, ot, {at: $(!0)}), H(Ue, nt, {
                    getOwnPropertyDescriptors: function (t) {
                        var e = h(t), n = {};
                        return we.call(g(e), function (t) {
                            ce(n, t, I(0, de(e, t)))
                        }), n
                    }, values: t(!1), entries: t(!0)
                }), H(Ue, at, {escape: E(/([\\\-[\]{}()*+?.,^$|])/g, "\\$1", !0)})
            }(), !function (t) {
                function e(t) {
                    if (t) {
                        var e = t[vt];
                        Ae(e, Z, e.get), Ae(e, n, e.set), Ae(e, i, e["delete"])
                    }
                }

                Z = O(t + "Get", !0);
                var n = O(t + ct, !0), i = O(t + "Delete", !0);
                H(Ue, pt, {referenceGet: Z, referenceSet: n, referenceDelete: i}), Ae(te, Z, f), e(It), e(Dt)
            }("reference"), !function (t) {
                function e(e, n) {
                    we.call(y(e), function (e) {
                        e in Jt && (t[e] = c(oe, Jt[e], n))
                    })
                }

                e("pop,reverse,shift,keys,values,entries", 1), e("indexOf,every,some,forEach,map,filter,find,findIndex,includes", 3), e("join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill,turn"), H(Ue, rt, t)
            }({}), !function (t) {
                !n || !t || tt in t[vt] || Ae(t[vt], tt, Je[rt]), Je.NodeList = Je[rt]
            }(t.NodeList)
        }("undefined" != typeof self && self.Math === Math ? self : Function("return this")(), !0)
    }, {}], 3: [function (t, e, n) {
        (function (t) {
            !function (t) {
                "use strict";
                function n(t, e, n, i) {
                    return new s(t, e, n || null, i || [])
                }

                function i(t, e, n) {
                    try {
                        return {type: "normal", arg: t.call(e, n)}
                    } catch (i) {
                        return {type: "throw", arg: i}
                    }
                }

                function r() {
                }

                function o() {
                }

                function s(t, e, n, r) {
                    function o(e, r) {
                        if (u === b)throw new Error("Generator is already running");
                        if (u === w)return d();
                        for (; ;) {
                            var o = a.delegate;
                            if (o) {
                                var s = i(o.iterator[e], o.iterator, r);
                                if ("throw" === s.type) {
                                    a.delegate = null, e = "throw", r = s.arg;
                                    continue
                                }
                                e = "next", r = h;
                                var l = s.arg;
                                if (!l.done)return u = y, l;
                                a[o.resultName] = l.value, a.next = o.nextLoc, a.delegate = null
                            }
                            if ("next" === e) {
                                if (u === v && "undefined" != typeof r)throw new TypeError("attempt to send " + JSON.stringify(r) + " to newborn generator");
                                u === y ? a.sent = r : delete a.sent
                            } else if ("throw" === e) {
                                if (u === v)throw u = w, r;
                                a.dispatchException(r) && (e = "next", r = h)
                            } else"return" === e && a.abrupt("return", r);
                            u = b;
                            var s = i(t, n, a);
                            if ("normal" === s.type) {
                                u = a.done ? w : y;
                                var l = {value: s.arg, done: a.done};
                                if (s.arg !== C)return l;
                                a.delegate && "next" === e && (r = h)
                            } else"throw" === s.type && (u = w, "next" === e ? a.dispatchException(s.arg) : r = s.arg)
                        }
                    }

                    var s = e ? Object.create(e.prototype) : this, a = new l(r), u = v;
                    return s.next = o.bind(s, "next"), s["throw"] = o.bind(s, "throw"), s["return"] = o.bind(s, "return"), s
                }

                function a(t) {
                    var e = {tryLoc: t[0]};
                    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e)
                }

                function u(t) {
                    var e = t.completion || {};
                    e.type = "normal", delete e.arg, t.completion = e
                }

                function l(t) {
                    this.tryEntries = [{tryLoc: "root"}], t.forEach(a, this), this.reset()
                }

                function c(t) {
                    if (t) {
                        var e = t[f];
                        if (e)return e.call(t);
                        if ("function" == typeof t.next)return t;
                        if (!isNaN(t.length)) {
                            var n = -1, i = function r() {
                                for (; ++n < t.length;)if (p.call(t, n))return r.value = t[n], r.done = !1, r;
                                return r.value = h, r.done = !0, r
                            };
                            return i.next = i
                        }
                    }
                    return {next: d}
                }

                function d() {
                    return {value: h, done: !0}
                }

                var h, p = Object.prototype.hasOwnProperty, f = "function" == typeof Symbol && Symbol.iterator || "@@iterator", m = "object" == typeof e, g = t.regeneratorRuntime;
                if (g)return void(m && (e.exports = g));
                g = t.regeneratorRuntime = m ? e.exports : {}, g.wrap = n;
                var v = "suspendedStart", y = "suspendedYield", b = "executing", w = "completed", C = {}, x = o.prototype = s.prototype;
                r.prototype = x.constructor = o, o.constructor = r, r.displayName = "GeneratorFunction", g.isGeneratorFunction = function (t) {
                    var e = "function" == typeof t && t.constructor;
                    return e ? e === r || "GeneratorFunction" === (e.displayName || e.name) : !1
                }, g.mark = function (t) {
                    return t.__proto__ = o, t.prototype = Object.create(x), t
                }, g.async = function (t, e, r, o) {
                    return new Promise(function (s, a) {
                        function u(t) {
                            var e = i(this, null, t);
                            if ("throw" === e.type)return void a(e.arg);
                            var n = e.arg;
                            n.done ? s(n.value) : Promise.resolve(n.value).then(c, d)
                        }

                        var l = n(t, e, r, o), c = u.bind(l.next), d = u.bind(l["throw"]);
                        c()
                    })
                }, x[f] = function () {
                    return this
                }, x.toString = function () {
                    return "[object Generator]"
                }, g.keys = function (t) {
                    var e = [];
                    for (var n in t)e.push(n);
                    return e.reverse(), function i() {
                        for (; e.length;) {
                            var n = e.pop();
                            if (n in t)return i.value = n, i.done = !1, i
                        }
                        return i.done = !0, i
                    }
                }, g.values = c, l.prototype = {
                    constructor: l, reset: function () {
                        this.prev = 0, this.next = 0, this.sent = h, this.done = !1, this.delegate = null, this.tryEntries.forEach(u);
                        for (var t, e = 0; p.call(this, t = "t" + e) || 20 > e; ++e)this[t] = null
                    }, stop: function () {
                        this.done = !0;
                        var t = this.tryEntries[0], e = t.completion;
                        if ("throw" === e.type)throw e.arg;
                        return this.rval
                    }, dispatchException: function (t) {
                        function e(e, i) {
                            return o.type = "throw", o.arg = t, n.next = e, !!i
                        }

                        if (this.done)throw t;
                        for (var n = this, i = this.tryEntries.length - 1; i >= 0; --i) {
                            var r = this.tryEntries[i], o = r.completion;
                            if ("root" === r.tryLoc)return e("end");
                            if (r.tryLoc <= this.prev) {
                                var s = p.call(r, "catchLoc"), a = p.call(r, "finallyLoc");
                                if (s && a) {
                                    if (this.prev < r.catchLoc)return e(r.catchLoc, !0);
                                    if (this.prev < r.finallyLoc)return e(r.finallyLoc)
                                } else if (s) {
                                    if (this.prev < r.catchLoc)return e(r.catchLoc, !0)
                                } else {
                                    if (!a)throw new Error("try statement without catch or finally");
                                    if (this.prev < r.finallyLoc)return e(r.finallyLoc)
                                }
                            }
                        }
                    }, abrupt: function (t, e) {
                        for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                            var i = this.tryEntries[n];
                            if (i.tryLoc <= this.prev && p.call(i, "finallyLoc") && this.prev < i.finallyLoc) {
                                var r = i;
                                break
                            }
                        }
                        r && ("break" === t || "continue" === t) && r.tryLoc <= e && e < r.finallyLoc && (r = null);
                        var o = r ? r.completion : {};
                        return o.type = t, o.arg = e, r ? this.next = r.finallyLoc : this.complete(o), C
                    }, complete: function (t, e) {
                        if ("throw" === t.type)throw t.arg;
                        return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = t.arg, this.next = "end") : "normal" === t.type && e && (this.next = e), C
                    }, finish: function (t) {
                        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                            var n = this.tryEntries[e];
                            if (n.finallyLoc === t)return this.complete(n.completion, n.afterLoc)
                        }
                    }, "catch": function (t) {
                        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                            var n = this.tryEntries[e];
                            if (n.tryLoc === t) {
                                var i = n.completion;
                                if ("throw" === i.type) {
                                    var r = i.arg;
                                    u(n)
                                }
                                return r
                            }
                        }
                        throw new Error("illegal catch attempt")
                    }, delegateYield: function (t, e, n) {
                        return this.delegate = {iterator: c(t), resultName: e, nextLoc: n}, C
                    }
                }
            }("object" == typeof t ? t : "object" == typeof window ? window : this)
        }).call(this, "undefined" != typeof global ? global : "undefined" != typeof self ? self : "undefined" != typeof window ? window : {})
    }, {}]
}, {}, [1]), !function () {
    "use strict";
    function t(i) {
        if (!i)throw new Error("No options passed to Waypoint constructor");
        if (!i.element)throw new Error("No element option passed to Waypoint constructor");
        if (!i.handler)throw new Error("No handler option passed to Waypoint constructor");
        this.key = "waypoint-" + e, this.options = t.Adapter.extend({}, t.defaults, i), this.element = this.options.element, this.adapter = new t.Adapter(this.element), this.callback = i.handler, this.axis = this.options.horizontal ? "horizontal" : "vertical", this.enabled = this.options.enabled, this.triggerPoint = null, this.group = t.Group.findOrCreate({
            name: this.options.group,
            axis: this.axis
        }), this.context = t.Context.findOrCreateByElement(this.options.context), t.offsetAliases[this.options.offset] && (this.options.offset = t.offsetAliases[this.options.offset]), this.group.add(this), this.context.add(this), n[this.key] = this, e += 1
    }

    var e = 0, n = {};
    t.prototype.queueTrigger = function (t) {
        this.group.queueTrigger(this, t)
    }, t.prototype.trigger = function (t) {
        this.enabled && this.callback && this.callback.apply(this, t)
    }, t.prototype.destroy = function () {
        this.context.remove(this), this.group.remove(this), delete n[this.key]
    }, t.prototype.disable = function () {
        return this.enabled = !1, this
    }, t.prototype.enable = function () {
        return this.context.refresh(), this.enabled = !0, this
    }, t.prototype.next = function () {
        return this.group.next(this)
    }, t.prototype.previous = function () {
        return this.group.previous(this)
    }, t.invokeAll = function (t) {
        var e = [];
        for (var i in n)e.push(n[i]);
        for (var r = 0, o = e.length; o > r; r++)e[r][t]()
    }, t.destroyAll = function () {
        t.invokeAll("destroy")
    }, t.disableAll = function () {
        t.invokeAll("disable")
    }, t.enableAll = function () {
        t.invokeAll("enable")
    }, t.refreshAll = function () {
        t.Context.refreshAll()
    }, t.viewportHeight = function () {
        return window.innerHeight || document.documentElement.clientHeight
    }, t.viewportWidth = function () {
        return document.documentElement.clientWidth
    }, t.adapters = [], t.defaults = {
        context: window,
        continuous: !0,
        enabled: !0,
        group: "default",
        horizontal: !1,
        offset: 0
    }, t.offsetAliases = {
        "bottom-in-view": function () {
            return this.context.innerHeight() - this.adapter.outerHeight()
        }, "right-in-view": function () {
            return this.context.innerWidth() - this.adapter.outerWidth()
        }
    }, window.Waypoint = t
}(), function () {
    "use strict";
    function t(t) {
        window.setTimeout(t, 1e3 / 60)
    }

    function e(t) {
        this.element = t, this.Adapter = r.Adapter, this.adapter = new this.Adapter(t), this.key = "waypoint-context-" + n, this.didScroll = !1, this.didResize = !1, this.oldScroll = {
            x: this.adapter.scrollLeft(),
            y: this.adapter.scrollTop()
        }, this.waypoints = {
            vertical: {},
            horizontal: {}
        }, t.waypointContextKey = this.key, i[t.waypointContextKey] = this, n += 1, this.createThrottledScrollHandler(), this.createThrottledResizeHandler()
    }

    var n = 0, i = {}, r = window.Waypoint, o = window.onload;
    e.prototype.add = function (t) {
        var e = t.options.horizontal ? "horizontal" : "vertical";
        this.waypoints[e][t.key] = t, this.refresh()
    }, e.prototype.checkEmpty = function () {
        var t = this.Adapter.isEmptyObject(this.waypoints.horizontal), e = this.Adapter.isEmptyObject(this.waypoints.vertical);
        t && e && (this.adapter.off(".waypoints"), delete i[this.key])
    }, e.prototype.createThrottledResizeHandler = function () {
        function t() {
            e.handleResize(), e.didResize = !1
        }

        var e = this;
        this.adapter.on("resize.waypoints", function () {
            e.didResize || (e.didResize = !0, r.requestAnimationFrame(t))
        })
    }, e.prototype.createThrottledScrollHandler = function () {
        function t() {
            e.handleScroll(), e.didScroll = !1
        }

        var e = this;
        this.adapter.on("scroll.waypoints", function () {
            (!e.didScroll || r.isTouch) && (e.didScroll = !0, r.requestAnimationFrame(t))
        })
    }, e.prototype.handleResize = function () {
        r.Context.refreshAll()
    }, e.prototype.handleScroll = function () {
        var t = {}, e = {
            horizontal: {
                newScroll: this.adapter.scrollLeft(),
                oldScroll: this.oldScroll.x,
                forward: "right",
                backward: "left"
            },
            vertical: {
                newScroll: this.adapter.scrollTop(),
                oldScroll: this.oldScroll.y,
                forward: "down",
                backward: "up"
            }
        };
        for (var n in e) {
            var i = e[n], r = i.newScroll > i.oldScroll, o = r ? i.forward : i.backward;
            for (var s in this.waypoints[n]) {
                var a = this.waypoints[n][s], u = i.oldScroll < a.triggerPoint, l = i.newScroll >= a.triggerPoint, c = u && l, d = !u && !l;
                (c || d) && (a.queueTrigger(o), t[a.group.id] = a.group)
            }
        }
        for (var h in t)t[h].flushTriggers();
        this.oldScroll = {x: e.horizontal.newScroll, y: e.vertical.newScroll}
    }, e.prototype.innerHeight = function () {
        return this.element == this.element.window ? r.viewportHeight() : this.adapter.innerHeight()
    }, e.prototype.remove = function (t) {
        delete this.waypoints[t.axis][t.key], this.checkEmpty()
    }, e.prototype.innerWidth = function () {
        return this.element == this.element.window ? r.viewportWidth() : this.adapter.innerWidth()
    }, e.prototype.destroy = function () {
        var t = [];
        for (var e in this.waypoints)for (var n in this.waypoints[e])t.push(this.waypoints[e][n]);
        for (var i = 0, r = t.length; r > i; i++)t[i].destroy()
    }, e.prototype.refresh = function () {
        var t, e = this.element == this.element.window, n = this.adapter.offset(), i = {};
        this.handleScroll(), t = {
            horizontal: {
                contextOffset: e ? 0 : n.left,
                contextScroll: e ? 0 : this.oldScroll.x,
                contextDimension: this.innerWidth(),
                oldScroll: this.oldScroll.x,
                forward: "right",
                backward: "left",
                offsetProp: "left"
            },
            vertical: {
                contextOffset: e ? 0 : n.top,
                contextScroll: e ? 0 : this.oldScroll.y,
                contextDimension: this.innerHeight(),
                oldScroll: this.oldScroll.y,
                forward: "down",
                backward: "up",
                offsetProp: "top"
            }
        };
        for (var r in t) {
            var o = t[r];
            for (var s in this.waypoints[r]) {
                var a, u, l, c, d, h = this.waypoints[r][s], p = h.options.offset, f = h.triggerPoint, m = 0, g = null == f;
                h.element !== h.element.window && (m = h.adapter.offset()[o.offsetProp]), "function" == typeof p ? p = p.apply(h) : "string" == typeof p && (p = parseFloat(p), h.options.offset.indexOf("%") > -1 && (p = Math.ceil(o.contextDimension * p / 100))), a = o.contextScroll - o.contextOffset, h.triggerPoint = m + a - p, u = f < o.oldScroll, l = h.triggerPoint >= o.oldScroll, c = u && l, d = !u && !l, !g && c ? (h.queueTrigger(o.backward), i[h.group.id] = h.group) : !g && d ? (h.queueTrigger(o.forward), i[h.group.id] = h.group) : g && o.oldScroll >= h.triggerPoint && (h.queueTrigger(o.forward), i[h.group.id] = h.group)
            }
        }
        for (var v in i)i[v].flushTriggers();
        return this
    }, e.findOrCreateByElement = function (t) {
        return e.findByElement(t) || new e(t)
    }, e.refreshAll = function () {
        for (var t in i)i[t].refresh()
    }, e.findByElement = function (t) {
        return i[t.waypointContextKey]
    }, window.onload = function () {
        o && o(), e.refreshAll()
    }, r.requestAnimationFrame = function (e) {
        var n = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || t;
        n.call(window, e)
    }, r.Context = e
}(), function () {
    "use strict";
    function t(t, e) {
        return t.triggerPoint - e.triggerPoint
    }

    function e(t, e) {
        return e.triggerPoint - t.triggerPoint
    }

    function n(t) {
        this.name = t.name, this.axis = t.axis, this.id = this.name + "-" + this.axis, this.waypoints = [], this.clearTriggerQueues(), i[this.axis][this.name] = this
    }

    var i = {vertical: {}, horizontal: {}}, r = window.Waypoint;
    n.prototype.add = function (t) {
        this.waypoints.push(t)
    }, n.prototype.clearTriggerQueues = function () {
        this.triggerQueues = {up: [], down: [], left: [], right: []}
    }, n.prototype.flushTriggers = function () {
        for (var n in this.triggerQueues) {
            var i = this.triggerQueues[n], r = "up" === n || "left" === n;
            i.sort(r ? e : t);
            for (var o = 0, s = i.length; s > o; o += 1) {
                var a = i[o];
                (a.options.continuous || o === i.length - 1) && a.trigger([n])
            }
        }
        this.clearTriggerQueues()
    }, n.prototype.next = function (e) {
        this.waypoints.sort(t);
        var n = r.Adapter.inArray(e, this.waypoints), i = n === this.waypoints.length - 1;
        return i ? null : this.waypoints[n + 1]
    }, n.prototype.previous = function (e) {
        this.waypoints.sort(t);
        var n = r.Adapter.inArray(e, this.waypoints);
        return n ? this.waypoints[n - 1] : null
    }, n.prototype.queueTrigger = function (t, e) {
        this.triggerQueues[e].push(t)
    }, n.prototype.remove = function (t) {
        var e = r.Adapter.inArray(t, this.waypoints);
        e > -1 && this.waypoints.splice(e, 1)
    }, n.prototype.first = function () {
        return this.waypoints[0]
    }, n.prototype.last = function () {
        return this.waypoints[this.waypoints.length - 1]
    }, n.findOrCreate = function (t) {
        return i[t.axis][t.name] || new n(t)
    }, r.Group = n
}(), function () {
    "use strict";
    function t(t) {
        return t === t.window
    }

    function e(e) {
        return t(e) ? e : e.defaultView
    }

    function n(t) {
        this.element = t, this.handlers = {}
    }

    var i = window.Waypoint;
    n.prototype.innerHeight = function () {
        var e = t(this.element);
        return e ? this.element.innerHeight : this.element.clientHeight
    }, n.prototype.innerWidth = function () {
        var e = t(this.element);
        return e ? this.element.innerWidth : this.element.clientWidth
    }, n.prototype.off = function (t, e) {
        function n(t, e, n) {
            for (var i = 0, r = e.length - 1; r > i; i++) {
                var o = e[i];
                n && n !== o || t.removeEventListener(o)
            }
        }

        var i = t.split("."), r = i[0], o = i[1], s = this.element;
        if (o && this.handlers[o] && r)n(s, this.handlers[o][r], e), this.handlers[o][r] = []; else if (r)for (var a in this.handlers)n(s, this.handlers[a][r] || [], e), this.handlers[a][r] = []; else if (o && this.handlers[o]) {
            for (var u in this.handlers[o])n(s, this.handlers[o][u], e);
            this.handlers[o] = {}
        }
    }, n.prototype.offset = function () {
        if (!this.element.ownerDocument)return null;
        var t = this.element.ownerDocument.documentElement, n = e(this.element.ownerDocument), i = {top: 0, left: 0};
        return this.element.getBoundingClientRect && (i = this.element.getBoundingClientRect()), {
            top: i.top + n.pageYOffset - t.clientTop,
            left: i.left + n.pageXOffset - t.clientLeft
        }
    }, n.prototype.on = function (t, e) {
        var n = t.split("."), i = n[0], r = n[1] || "__default", o = this.handlers[r] = this.handlers[r] || {}, s = o[i] = o[i] || [];
        s.push(e), this.element.addEventListener(i, e)
    }, n.prototype.outerHeight = function (e) {
        var n, i = this.innerHeight();
        return e && !t(this.element) && (n = window.getComputedStyle(this.element), i += parseInt(n.marginTop, 10), i += parseInt(n.marginBottom, 10)), i
    }, n.prototype.outerWidth = function (e) {
        var n, i = this.innerWidth();
        return e && !t(this.element) && (n = window.getComputedStyle(this.element), i += parseInt(n.marginLeft, 10), i += parseInt(n.marginRight, 10)), i
    }, n.prototype.scrollLeft = function () {
        var t = e(this.element);
        return t ? t.pageXOffset : this.element.scrollLeft
    }, n.prototype.scrollTop = function () {
        var t = e(this.element);
        return t ? t.pageYOffset : this.element.scrollTop
    }, n.extend = function () {
        function t(t, e) {
            if ("object" == typeof t && "object" == typeof e)for (var n in e)e.hasOwnProperty(n) && (t[n] = e[n]);
            return t
        }

        for (var e = Array.prototype.slice.call(arguments), n = 1, i = e.length; i > n; n++)t(e[0], e[n]);
        return e[0]
    }, n.inArray = function (t, e, n) {
        return null == e ? -1 : e.indexOf(t, n)
    }, n.isEmptyObject = function (t) {
        for (var e in t)return !1;
        return !0
    }, i.adapters.push({name: "noframework", Adapter: n}), i.Adapter = n
}(), function () {
    function t() {
        Object.freeze || (Object.freeze = function (t) {
            return t
        }), function (t) {
            for (var e, n, i = {}, r = function () {
            }, o = "memory".split(","), s = "assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn".split(","); e = o.pop();)t[e] = t[e] || i;
            for (; n = s.pop();)t[n] = t[n] || r
        }(window.console || {}), Function.prototype.bind || (Function.prototype.bind = function (t) {
            if ("function" != typeof this)throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");
            var e = Array.prototype.slice.call(arguments, 1), n = this, i = function () {
            }, r = function () {
                return n.apply(this instanceof i && t ? this : t, e.concat(Array.prototype.slice.call(arguments)))
            };
            return i.prototype = this.prototype, r.prototype = new i, r
        }), Array.prototype.filter || (Array.prototype.filter = function (t) {
            if (void 0 === this || null === this)throw new TypeError;
            var e = Object(this), n = e.length >>> 0;
            if ("function" != typeof t)throw new TypeError;
            for (var i = [], r = arguments.length >= 2 ? arguments[1] : void 0, o = 0; n > o; o++)if (o in e) {
                var s = e[o];
                t.call(r, s, o, e) && i.push(s)
            }
            return i
        }), Array.prototype.map || (Array.prototype.map = function (t, e) {
            var n, i, r;
            if (null == this)throw new TypeError(" this is null or not defined");
            var o = Object(this), s = o.length >>> 0;
            if ("function" != typeof t)throw new TypeError(t + " is not a function");
            for (arguments.length > 1 && (n = e), i = new Array(s), r = 0; s > r;) {
                var a, u;
                r in o && (a = o[r], u = t.call(n, a, r, o), i[r] = u), r++
            }
            return i
        }), document.querySelectorAll || (document.querySelectorAll = function (t) {
            var e, n = document.createElement("style"), i = [];
            for (document.documentElement.firstChild.appendChild(n), document._qsa = [], n.styleSheet.cssText = t + "{x-qsa:expression(document._qsa && document._qsa.push(this))}", window.scrollBy(0, 0), n.parentNode.removeChild(n); document._qsa.length;)e = document._qsa.shift(), e.style.removeAttribute("x-qsa"), i.push(e);
            return document._qsa = null, i
        }), document.querySelector || (document.querySelector = function (t) {
            var e = document.querySelectorAll(t);
            return e.length ? e[0] : null
        }), Array.prototype.indexOf || (Array.prototype.indexOf = function (t) {
            for (var e = 0; e < this.length; e++)if (this[e] === t)return e;
            return -1
        }), Array.isArray || (Array.isArray = function (t) {
            return "[object Array]" === Object.prototype.toString.call(t)
        }), Object.keys || (Object.keys = function () {
            var t = Object.prototype.hasOwnProperty, e = !{toString: null}.propertyIsEnumerable("toString"), n = ["toString", "toLocaleString", "valueOf", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "constructor"], i = n.length;
            return function (r) {
                if ("object" != typeof r && ("function" != typeof r || null === r))throw new TypeError("Object.keys called on non-object");
                var o, s, a = [];
                for (o in r)t.call(r, o) && a.push(o);
                if (e)for (s = 0; i > s; s++)t.call(r, n[s]) && a.push(n[s]);
                return a
            }
        }()), !("getComputedStyle" in window) && (window.getComputedStyle = function () {
            function t(e, n, i, r) {
                var o, s = n[i], a = parseFloat(s), u = s.split(/\d/)[0];
                return r = null != r ? r : /%|em/.test(u) && e.parentElement ? t(e.parentElement, e.parentElement.currentStyle, "fontSize", null) : 16, o = "fontSize" == i ? r : /width/i.test(i) ? e.clientWidth : e.clientHeight, "em" == u ? a * r : "in" == u ? 96 * a : "pt" == u ? 96 * a / 72 : "%" == u ? a / 100 * o : a
            }

            function e(t, e) {
                var n = "border" == e ? "Width" : "", i = e + "Top" + n, r = e + "Right" + n, o = e + "Bottom" + n, s = e + "Left" + n;
                t[e] = (t[i] == t[r] == t[o] == t[s] ? [t[i]] : t[i] == t[o] && t[s] == t[r] ? [t[i], t[r]] : t[s] == t[r] ? [t[i], t[r], t[o]] : [t[i], t[r], t[o], t[s]]).join(" ")
            }

            function n(n) {
                var i = n.currentStyle, r = this, o = t(n, i, "fontSize", null);
                for (property in i)/width|height|margin.|padding.|border.+W/.test(property) && "auto" !== r[property] ? r[property] = t(n, i, property, o) + "px" : "styleFloat" === property ? r["float"] = i[property] : r[property] = i[property];
                return e(r, "margin"), e(r, "padding"), e(r, "border"), r.fontSize = o + "px", r
            }

            function i(t) {
                return new n(t)
            }

            return n.prototype = {
                constructor: n, getPropertyPriority: function () {
                }, getPropertyValue: function (t) {
                    return this[t] || ""
                }, item: function () {
                }, removeProperty: function () {
                }, setProperty: function () {
                }, getPropertyCSSValue: function () {
                }
            }, i
        }(window)), function () {
            function t(t, e) {
                return function () {
                    t.apply(e, arguments)
                }
            }

            function e(e) {
                if ("object" != typeof this)throw new TypeError("Promises must be constructed via new");
                if ("function" != typeof e)throw new TypeError("not a function");
                this._state = null, this._value = null, this._deferreds = [], a(e, t(i, this), t(r, this))
            }

            function n(t) {
                var e = this;
                return null === this._state ? void this._deferreds.push(t) : void l(function () {
                    var n = e._state ? t.onFulfilled : t.onRejected;
                    if (null === n)return void(e._state ? t.resolve : t.reject)(e._value);
                    var i;
                    try {
                        i = n(e._value)
                    } catch (r) {
                        return void t.reject(r)
                    }
                    t.resolve(i)
                })
            }

            function i(e) {
                try {
                    if (e === this)throw new TypeError("A promise cannot be resolved with itself.");
                    if (e && ("object" == typeof e || "function" == typeof e)) {
                        var n = e.then;
                        if ("function" == typeof n)return void a(t(n, e), t(i, this), t(r, this))
                    }
                    this._state = !0, this._value = e, o.call(this)
                } catch (s) {
                    r.call(this, s)
                }
            }

            function r(t) {
                this._state = !1, this._value = t, o.call(this)
            }

            function o() {
                for (var t = 0, e = this._deferreds.length; e > t; t++)n.call(this, this._deferreds[t]);
                this._deferreds = null
            }

            function s(t, e, n, i) {
                this.onFulfilled = "function" == typeof t ? t : null, this.onRejected = "function" == typeof e ? e : null, this.resolve = n, this.reject = i
            }

            function a(t, e, n) {
                var i = !1;
                try {
                    t(function (t) {
                        i || (i = !0, e(t))
                    }, function (t) {
                        i || (i = !0, n(t))
                    })
                } catch (r) {
                    if (i)return;
                    i = !0, n(r)
                }
            }

            var u;
            u = "object" == typeof window && window ? window : global, "undefined" != typeof module && module.exports ? module.exports = u.Promise ? u.Promise : e : u.Promise || (u.Promise = e);
            var l = u.setImmediate || function (t) {
                    setTimeout(t, 1)
                }, c = Array.isArray || function (t) {
                    return "[object Array]" === Object.prototype.toString.call(t)
                };
            e.prototype["catch"] = function (t) {
                return this.then(null, t)
            }, e.prototype.then = function (t, i) {
                var r = this;
                return new e(function (e, o) {
                    n.call(r, new s(t, i, e, o))
                })
            }, e.all = function () {
                var t = Array.prototype.slice.call(1 === arguments.length && c(arguments[0]) ? arguments[0] : arguments);
                return new e(function (e, n) {
                    function i(o, s) {
                        try {
                            if (s && ("object" == typeof s || "function" == typeof s)) {
                                var a = s.then;
                                if ("function" == typeof a)return void a.call(s, function (t) {
                                    i(o, t)
                                }, n)
                            }
                            t[o] = s, 0 === --r && e(t)
                        } catch (u) {
                            n(u)
                        }
                    }

                    if (0 === t.length)return e([]);
                    for (var r = t.length, o = 0; o < t.length; o++)i(o, t[o])
                })
            }, e.resolve = function (t) {
                return t && "object" == typeof t && t.constructor === e ? t : new e(function (e) {
                    e(t)
                })
            }, e.reject = function (t) {
                return new e(function (e, n) {
                    n(t)
                })
            }, e.race = function (t) {
                return new e(function (e, n) {
                    for (var i = 0, r = t.length; r > i; i++)t[i].then(e, n)
                })
            }
        }()
    }

    function e() {
        return a
    }

    "undefined" != typeof window && t();
    var n = this, i = {version: "1.1.2"};
    "undefined" != typeof exports ? ("undefined" != typeof module && module.exports && (exports = module.exports = i), exports.imgix = i) : n.imgix = i;
    var r = "imgix-usable";
    i.helpers = {
        debouncer: function (t, e) {
            var n;
            return function () {
                var i = this, r = arguments, o = function () {
                    n = null, t.apply(i, r)
                };
                window.clearTimeout(n), n = window.setTimeout(o, e)
            }
        }, throttler: function (t, e) {
            var n;
            return function () {
                var i, r = this, o = arguments;
                n || (i = function () {
                    n = null, t.apply(r, o)
                }, n = window.setTimeout(i, e))
            }
        }, urlParser: function () {
            function t(t) {
                return !isNaN(parseFloat(t)) && isFinite(t)
            }

            return function (e, n) {
                var i = n || window.location.toString();
                if (!e)return i;
                e = e.toString(), "//" === i.substring(0, 2) ? i = "http:" + i : 1 === i.split("://").length && (i = "http://" + i), n = i.split("/");
                var r = {auth: ""}, o = n[2].split("@");
                1 === o.length ? o = o[0].split(":") : (r.auth = o[0], o = o[1].split(":")), r.protocol = n[0], r.hostname = o[0], r.port = o[1] || ("https" === r.protocol.split(":")[0].toLowerCase() ? "443" : "80"), r.pathname = (n.length > 3 ? "/" : "") + n.slice(3, n.length).join("/").split("?")[0].split("#")[0];
                var s = r.pathname;
                "/" === s.charAt(s.length - 1) && (s = s.substring(0, s.length - 1));
                var a = r.hostname, u = a.split("."), l = s.split("/");
                if ("hostname" === e)return a;
                if ("domain" === e)return /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/.test(a) ? a : u.slice(-2).join(".");
                if ("sub" === e)return u.slice(0, u.length - 2).join(".");
                if ("port" === e)return r.port;
                if ("protocol" === e)return r.protocol.split(":")[0];
                if ("auth" === e)return r.auth;
                if ("user" === e)return r.auth.split(":")[0];
                if ("pass" === e)return r.auth.split(":")[1] || "";
                if ("path" === e)return r.pathname;
                if ("." === e.charAt(0)) {
                    if (e = e.substring(1), t(e))return e = parseInt(e, 10), u[0 > e ? u.length + e : e - 1] || ""
                } else {
                    if (t(e))return e = parseInt(e, 10), l[0 > e ? l.length + e : e] || "";
                    if ("file" === e)return l.slice(-1)[0];
                    if ("filename" === e)return l.slice(-1)[0].split(".")[0];
                    if ("fileext" === e)return l.slice(-1)[0].split(".")[1] || "";
                    if ("?" === e.charAt(0) || "#" === e.charAt(0)) {
                        var c = i, d = null;
                        if ("?" === e.charAt(0) ? c = (c.split("?")[1] || "").split("#")[0] : "#" === e.charAt(0) && (c = c.split("#")[1] || ""), !e.charAt(1))return c;
                        e = e.substring(1), c = c.split("&");
                        for (var h = 0, p = c.length; p > h; h++)if (d = c[h].split("="), d[0] === e)return d[1] || "";
                        return null
                    }
                }
                return ""
            }
        }(), mergeObject: function () {
            for (var t, e = {}, n = 0, i = arguments.length; i > n; n++)for (t in arguments[n])arguments[n].hasOwnProperty(t) && (e[t] = arguments[n][t]);
            return e
        }, pixelRound: function (t, e) {
            return Math.ceil(t / e) * e
        }, isNumber: function (t) {
            return !isNaN(parseFloat(t)) && isFinite(t)
        }, getZoom: function () {
            var t, e = "http://www.w3.org/2000/svg", n = 1;
            return document.createElementNS && (t = document.createElementNS(e, "svg"), t.setAttribute("xmlns", e), t.setAttribute("version", "1.1"), document.body.appendChild(t), n = t.currentScale || 1, document.body.removeChild(t)), n
        }, getDPR: function () {
            var t = window.devicePixelRatio ? window.devicePixelRatio : 1;
            if (t % 1 !== 0) {
                var e = t.toString();
                e = e.split(".")[1], t = e.length > 1 && "0" !== e.slice(1, 2) ? t.toFixed(2) : t.toFixed(1)
            }
            return t
        }, getWindowWidth: function () {
            return Math.max(document.documentElement.clientWidth, window.innerWidth || 0) || 1024
        }, getWindowHeight: function () {
            return Math.max(document.documentElement.clientHeight, window.innerHeight || 0) || 768
        }, getImgSrc: function (t) {
            return t.getAttribute("data-src") || t.getAttribute("src")
        }, calculateElementSize: function (t) {
            var e = {width: t.offsetWidth, height: t.offsetHeight};
            if (null === t.parentNode || t === document.body)return e.width = this.getWindowWidth(), e.height = this.getWindowHeight(), e;
            if (0 !== e.width || 0 !== e.height)return t.alt && !t.fluid ? (t.fluid = !0, this.calculateElementSize(t.parentNode)) : e;
            var n, i, r = {}, o = {position: "absolute", visibility: "hidden", display: "block"};
            for (i in o)o.hasOwnProperty(i) && (r[i] = t.style[i], t.style[i] = o[i]);
            n = {width: t.offsetWidth, height: t.offsetHeight};
            for (i in o)o.hasOwnProperty(i) && (t.style[i] = r[i]);
            return 0 === n.width || 0 === n.height ? this.calculateElementSize(t.parentNode) : n
        }, isReallyObject: function (t) {
            return t && "object" == typeof t && "[object Object]" === t.toString()
        }, isFluidSet: function (t) {
            return t && "object" == typeof t && "[object FluidSet]" === t.toString()
        }, extractInt: function (t) {
            return void 0 === t ? 0 : "number" == typeof t ? t : parseInt(t.replace(/\D/g, ""), 10) || 0
        }, camelize: function (t) {
            return t.replace(/[-_\s]+(.)?/g, function (t, e) {
                return e ? e.toUpperCase() : ""
            })
        }, getElementCssProperty: function (t, e) {
            return window.getComputedStyle ? window.getComputedStyle(t, null).getPropertyValue(e) : t && t.style && e ? t.style[this.camelize(e)] : ""
        }, matchesSelector: function (t, e) {
            var n = (t.parentNode || document).querySelectorAll(e);
            return Array.prototype.slice.call(n).indexOf(t) > -1
        }
    }, i.getElementByXPathClassName = function (t) {
        return document.querySelector("." + i.getXPathClass(t));
    }, i.getElementImageByXPathClassName = function (t) {
        return i.getElementImage(i.getElementByXPathClassName(t))
    }, i.isImageElement = function (t) {
        return t && t.tagName && "img" === t.tagName.toLowerCase()
    }, i.setElementImageAfterLoad = function (t, e, n) {
        var r = new Image;
        r.onload = function () {
            i.setElementImage(t, e), "function" == typeof n && n(t, e)
        }, r.src = e
    }, i.setElementImage = function (t, e) {
        if (!t)return !1;
        if (i.isImageElement(t))return t.src !== e && (t.src = e), !0;
        var n = i.getBackgroundImage(t);
        return n !== e ? n ? (t.style.cssText = t.style.cssText.replace(n, e), !0) : (document.addEventListener ? t.style.backgroundImage = "url(" + e + ")" : t.style.cssText = "background-image:url(" + e + ")", !0) : !1
    }, i.getEmptyImage = function () {
        return i.versionifyUrl("https://assets.imgix.net/pixel.gif")
    }, i.getElementImage = function (t) {
        return i.isImageElement(t) ? t.src : i.getBackgroundImage(t)
    }, i.getRawBackgroundImage = function (t) {
        return t.style.cssText.match(/url\(([^\)]+)/)
    }, i.getBackgroundImage = function (t) {
        var e = i.getRawBackgroundImage(t);
        return e && 2 === e.length ? e[1] : ""
    }, i.getColorBrightness = function (t) {
        if (!t)return 0;
        "#" === t.slice(0, 1) && (t = i.hexToRGB(t));
        var e = t.replace(/[^0-9,]+/g, "").split(","), n = parseInt(e[0], 10), r = parseInt(e[1], 10), o = parseInt(e[2], 10);
        return Math.sqrt(n * n * .241 + r * r * .691 + o * o * .068)
    }, i.applyAlphaToRGB = function (t, e) {
        var n = "rgba" !== t.slice(0, 4), i = t.split(",");
        return i = i.map(function (t) {
            return parseInt(t.replace(/\D/g, ""), 10)
        }), n ? i.push(e) : 4 === i.length && (i[3] = e), "rgba(" + i.join(", ") + ")"
    }, i.hexToRGB = function (t) {
        function e(t) {
            return (t + t).toString()
        }

        if (t)if ("#" === t.slice(0, 1))t = t.slice(1, t.length); else if ("rgb" === t.slice(0, 3))return t;
        var n = 0, i = 0, r = 0;
        return 3 === t.length ? (n = parseInt(e(t.slice(0, 1)), 16), i = parseInt(e(t.slice(1, 2)), 16), r = parseInt(e(t.slice(2, 3)), 16)) : 6 === t.length ? (n = parseInt(t.slice(0, 2), 16), i = parseInt(t.slice(2, 4), 16), r = parseInt(t.slice(4, 6), 16)) : console.warn("invalid hex color:", t), "rgb(" + n + ", " + i + ", " + r + ")"
    }, i.getElementsWithImages = function () {
        return i.markElementsWithImages(), document.querySelectorAll("." + r)
    }, i.hasImage = function (t) {
        var e = t.style.cssText ? t.style.cssText.toLowerCase() : t.style.cssText;
        return t && (i.isImageElement(t) || -1 !== e.indexOf("background-image"))
    }, i.markElementsWithImages = function () {
        for (var t = document.getElementsByTagName("*"), e = 0, n = t.length; n > e; e++)i.hasImage(t[e]) && i.setImgixClass(t[e])
    }, i.hasClass = function (t, e) {
        return (" " + t.className + " ").indexOf(" " + e + " ") > -1
    }, i.setImgixClass = function (t) {
        if (i.hasClass(t, r))return i.getImgixClass(t);
        var e = i.getXPathClass(i.getElementTreeXPath(t));
        return t.classList.add(e), t.classList.add(r), i.getImgixClass(t)
    }, i.getImgixClass = function (t) {
        return i.hasClass(t, r) ? t.className.match(/imgix-el-[^\s]+/)[0] : void 0
    }, i.getXPathClass = function (t) {
        var e;
        return e = t ? i.hashCode(t) : (new Date).getTime().toString(36), "imgix-el-" + e
    }, i.rgbToHex = function (t) {
        var e = t.split(",");
        return e = e.map(function (t) {
            return i.componentToHex(parseInt(t.replace(/\D/g, "")))
        }), e.join("")
    }, i.componentToHex = function (t) {
        var e = t.toString(16);
        return 1 === e.length ? "0" + e : e
    }, i.getElementTreeXPath = function (t) {
        for (var e = []; t && t.nodeType === Node.ELEMENT_NODE; t = t.parentNode) {
            for (var n = 0, i = t.previousSibling; i; i = i.previousSibling)i.nodeType !== Node.DOCUMENT_TYPE_NODE && i.nodeName === t.nodeName && ++n;
            var r = (t.prefix ? t.prefix + ":" : "") + t.localName, o = n ? "[" + (n + 1) + "]" : "";
            e.splice(0, 0, r + o)
        }
        return e.length ? "/" + e.join("/") : null
    }, i.getFontLookup = function () {
        return {
            "American Typewriter": "American Typewriter",
            "American Typewriter Bold": "American Typewriter,bold",
            "American Typewriter Condensed": "American Typewriter Condensed",
            "American Typewriter Condensed Bold": "American Typewriter Condensed,bold",
            "American Typewriter Condensed Light": "American Typewriter Condensed Light",
            "American Typewriter Light": "American Typewriter Light",
            "Andale Mono": "Andale Mono",
            Arial: "Arial",
            "Arial Black": "Arial Black",
            "Arial Bold": "Arial,bold",
            "Arial Bold Italic": "Arial,bold,italic",
            "Arial Italic": "Arial,italic",
            Baskerville: "Baskerville",
            "Big Caslon": "Big Caslon",
            "Brush Script MT": "Brush Script MT",
            Cochin: "Cochin",
            Copperplate: "Copperplate",
            Courier: "Courier",
            "Courier Bold": "Courier,bold",
            "Courier Oblique": "Courier Oblique",
            Didot: "Didot",
            Futura: "Futura",
            "Futura Condensed": "Futura Condensed Medium",
            "Futura Italic": "Futura Medium,italic",
            Georgia: "Georgia",
            "Georgia Bold": "Georgia,bold",
            "Georgia Bold Italic": "Georgia,bold,italic",
            "Georgia Italic": "Georgia,italic",
            "Gill Sans": "Gill Sans",
            "Gill Sans Bold": "Gill Sans,bold",
            "Gill Sans Bold Italic": "Gill Sans,bold,italic",
            "Gill Sans Italic": "Gill Sans,italic",
            "Gill Sans Light": "Gill Sans Light",
            "Gill Sans Light Italic": "Gill Sans Light,italic",
            Helvetica: "Helvetica",
            "Helvetica Bold": "Helvetica,bold",
            "Helvetica Light": "Helvetica Light",
            "Helvetica Light Oblique": "Helvetica Light Oblique",
            "Helvetica Neue": "Helvetica Neue",
            "Helvetica Neue Bold": "Helvetica Neue,bold",
            "Helvetica Neue Bold Italic": "Helvetica Neue,bold,italic",
            "Helvetica Neue Condensed Black": "Helvetica Neue Condensed Black",
            "Helvetica Neue Condensed Bold": "Helvetica Neue Condensed,bold",
            "Helvetica Neue Light": "Helvetica Neue Light",
            "Helvetica Neue Light Italic": "Helvetica Neue Light,italic",
            "Helvetica Neue Medium": "Helvetica Neue Medium",
            "Helvetica Neue UltraLight": "Helvetica Neue UltraLight",
            "Helvetica Neue UltraLight Italic": "Helvetica Neue UltraLight,italic",
            "Helvetica Oblique": "Helvetica Oblique",
            Herculanum: "Herculanum",
            Impact: "Impact",
            "Marker Felt Thin": "Marker Felt Thin",
            "Marker Felt Wide": "Marker Felt Wide",
            Optima: "Optima",
            "Optima Bold": "Optima,bold",
            "Optima Bold Italic": "Optima,bold,italic",
            "Optima ExtraBlack": "Optima ExtraBlack",
            "Optima Italic": "Optima,italic",
            Papyrus: "Papyrus",
            "Papyrus Condensed": "Papyrus Condensed",
            Times: "Times",
            "Times Bold": "Times,bold",
            "Times Bold Italic": "Times,bold,italic",
            "Times Italic": "Times,italic",
            "Times New Roman": "Times New Roman",
            "Times New Roman Bold": "Times New Roman,bold",
            "Times New Roman Bold Italic": "Times New Roman,bold,italic",
            "Times New Roman Italic": "Times New Roman,italic",
            "Trebuchet MS": "Trebuchet MS",
            "Trebuchet MS Bold": "Trebuchet MS,bold",
            "Trebuchet MS Bold Italic": "Trebuchet MS,bold,italic",
            "Trebuchet MS Italic": "Trebuchet MS,italic",
            Verdana: "Verdana",
            "Verdana Bold": "Verdana,bold",
            "Verdana Bold Italic": "Verdana,bold,italic",
            "Verdana Italic": "Verdana,italic",
            Zapfino: "Zapfino"
        }
    }, i.getFonts = function () {
        return Object.keys(i.getFontLookup())
    }, i.searchFonts = function (t) {
        return t = t.toLowerCase(), i.getFonts().filter(function (e) {
            return -1 !== e.toLowerCase().indexOf(t)
        })
    }, i.isFontAvailable = function (t) {
        return i.isDef(i.getFontLookup()[t])
    }, i.getAllParams = function () {
        return ["bri", "con", "exp", "gam", "high", "hue", "invert", "int", "sat", "shad", "sharp", "usm", "usmrad", "vib", "auto", "bg", "ba", "balph", "bc", "bf", "bh", "blend", "bm", "bp", "bs", "bw", "border", "pad", "dl", "fm", "q", "mask", "nr", "nrs", "class", "colors", "prefix", "palette", "page", "dpr", "flip", "or", "rot", "crop", "fit", "h", "rect", "w", "blur", "htn", "mono", "px", "sepia", "txt", "txtalign", "txtclip", "txtclr", "txtfit", "txtfont", "txtline", "txtlineclr", "txtpad", "txtshad", "txtsize", "trim", "trimcolor", "trimmd", "mark", "markalign", "markalpha", "markfit", "markh", "markpad", "markscale", "markw"]
    }, i.getParamAliases = function () {
        return {
            t: "txt",
            tf: "txtfont",
            tsz: "txtsize",
            tl: "txtline",
            tsh: "txtshad",
            tp: "txtpad",
            txtlinecolor: "txtlineclr",
            ta: "txtalign",
            intensity: "int",
            monochrome: "mono",
            f: "fit",
            orient: "or",
            m: "watermark",
            mf: "markfit",
            ms: "markscale",
            ma: "markalign",
            mp: "markpad"
        }
    }, i.getDefaultParamValues = function () {
        return {
            bri: 0,
            con: 0,
            exp: 0,
            gam: 0,
            high: 0,
            hue: 0,
            sat: 0,
            shad: 0,
            sharp: 0,
            usm: 0,
            usmrad: 2.5,
            vib: 0,
            ba: "middle,center",
            balph: 100,
            bf: "clip",
            bp: 0,
            pad: 0,
            q: 75,
            nr: 20,
            nrs: 20,
            colors: 6,
            prefix: "image",
            palette: "",
            page: 1,
            dpr: 1,
            rot: 0,
            fit: "clip",
            blur: 0,
            htn: 0,
            px: 0,
            sepia: 0,
            txtalign: "bottom,right",
            txtclip: "end",
            txtclr: "000",
            txtfont: "Helvetica",
            txtline: 0,
            txtlineclr: "FFF",
            txtpad: 10,
            txtsize: 12,
            trimmd: 11,
            markalign: "bottom,right",
            markalpha: 100,
            markfit: "clip",
            markpad: 10
        }
    }, i.getDefaultParamValue = function (t) {
        return i.getDefaultParamValues()[t]
    }, i.getDefaultParams = function () {
        return Object.keys(i.getDefaultParamValues())
    }, i.makeCssClass = function (t) {
        return "tmp_" + i.hashCode(t)
    }, i.injectStyleSheet = function (t) {
        var e = document.createElement("link");
        e.type = "text/css", e.rel = "stylesheet", e.href = t, document.getElementsByTagName("head")[0].appendChild(e)
    }, i.findInjectedStyleSheet = function (t) {
        if (document.styleSheets)for (var e = 0; e < document.styleSheets.length; e++)if (document.styleSheets[e].href === t)return !0;
        return !1
    }, i.getElementImageSize = function (t) {
        var e = 0, n = 0;
        return i.isImageElement(t) ? (e = t.naturalWidth, n = t.naturalHeight) : (e = i.helpers.extractInt(i.getCssProperty(t, "width")), n = i.helpers.extractInt(i.getCssProperty(t, "height"))), {
            width: e,
            height: n
        }
    }, i.getCssPropertyById = function (t, e) {
        var n = document.getElementById(t);
        return i.helpers.getElementCssProperty(n, e)
    }, i.getCssProperty = function (t, e) {
        return i.helpers.getElementCssProperty(t, e)
    }, i.getCssPropertyBySelector = function (t, e) {
        var n = document.querySelector(t);
        return i.helpers.getElementCssProperty(n, e)
    }, i.instanceOfImgixURL = function (t) {
        return t && "[object imgixURL]" === t.toString()
    }, i.setGradientOnElement = function (t, e, n) {
        var r = [];
        if ("undefined" == typeof n)r = ["transparent", "transparent"]; else {
            var o = i.hexToRGB(n);
            "rgba" === o.slice(0, 4) ? (r.push(o), r.push(i.applyAlphaToRGB(o, 0))) : (r.push(i.applyAlphaToRGB(o, .5)), r.push(i.applyAlphaToRGB(o, 0)))
        }
        for (var s = ["-ms-linear-gradient(top, " + r[0] + " 0%, " + r[1] + " 100%),-ms-linear-gradient(bottom left, " + e[2] + " 0%," + e[4] + " 25%, " + e[6] + " 50%, " + e[8] + " 75%," + e[10] + " 100%)", "-webkit-gradient(linear, 50% 0%, 50% 100%, color-stop(0%, " + r[1] + "), color-stop(100%, " + r[0] + ")),-webkit-gradient(linear, 0% 100%, 100% 0%, color-stop(0%, " + e[2] + "), color-stop(25%, " + e[4] + "), color-stop(50%, " + e[6] + "), color-stop(75%, " + e[7] + "), color-stop(100%, " + e[10] + "))", "-webkit-linear-gradient(top, " + r[0] + ", " + r[1] + " 100%),-webkit-linear-gradient(bottom left, " + e[2] + ", " + e[4] + ", " + e[6] + "," + e[8] + ")", "-moz-linear-gradient(top, " + r[0] + ", " + r[1] + " ),-moz-linear-gradient(bottom left, " + e[2] + ", " + e[4] + ", " + e[6] + "," + e[8] + ")", "-o-linear-gradient(top, " + r[0] + "," + r[1] + "),-o-linear-gradient(bottom left, " + e[2] + ", " + e[4] + ", " + e[6] + "," + e[8] + ")", "linear-gradient(top, " + r[0] + "," + r[1] + "),linear-gradient(bottom left, " + e[2] + ", " + e[4] + ", " + e[6] + "," + e[8] + ")"], a = 0; a < s.length; a++)t.style.backgroundImage = s[a]
    }, i.URL = function (t, e) {
        this._autoUpdateSel = null, this._autoUpdateCallback = null, t && "//" === t.slice(0, 2) && window && window.location && (t = window.location.protocol + t), this.setUrl(t), "object" == typeof e && this.setParams(e), this.paramAliases = {}
    }, i.URL.prototype.attachGradientTo = function (t, e, n) {
        this.getColors(16, function (r) {
            if (r && r.length < 9)return console.warn("not enough colors to create a gradient"), void(n && "function" == typeof n && n(!1));
            if ("string" == typeof t) {
                var o = document.querySelectorAll(t);
                if (o && o.length > 0)for (var s = 0; s < o.length; s++)i.setGradientOnElement(o[s], r, e)
            } else i.setGradientOnElement(t, r, e);
            n && "function" == typeof n && n(!0)
        })
    }, i.URL.prototype.attachImageTo = function (t, e) {
        if ("string" == typeof t) {
            var n = document.querySelectorAll(t);
            if (n && n.length > 0)for (var r = 0; r < n.length; r++)i.setElementImageAfterLoad(n[r], this.getUrl(), e)
        } else i.setElementImageAfterLoad(t, this.getUrl(), e)
    }, i.createParamString = function () {
        return new i.URL("")
    }, i.updateVersion = {};
    var o = {};
    i.URL.prototype.getColors = function (t, e) {
        var n = new i.URL(this.getUrl()), r = i.makeCssClass(this.getUrl());
        if ("function" == typeof t)if ("number" == typeof e) {
            var s = e;
            e = t, t = s
        } else e = t, t = 10;
        n.setPaletteColorNumber(t), n.setPalette("css"), n.setPaletteClass(r);
        var a = n.getUrl();
        i.injectStyleSheet(a);
        var u = function () {
            if (i.findInjectedStyleSheet(a)) {
                var n = null;
                setTimeout(function () {
                    for (var s = [], u = 100, l = 1; t >= l; l++)!function (t) {
                        var e = document.createElement("span");
                        e.id = r + "-" + t, e.className = r + "-fg-" + t, document.body.appendChild(e), s.push(new Promise(function (r, o) {
                            var s, a = 0;
                            s = function () {
                                var o = i.getCssPropertyById(e.id, "color");
                                o !== n ? (document.body.removeChild(e), r({
                                    num: t,
                                    color: o
                                }), n = o) : ++a < u ? setTimeout(s, 50) : (document.body.removeChild(e), r({
                                    num: t,
                                    color: "rgb(255, 255, 255)"
                                }))
                            }, setTimeout(s, 300)
                        }))
                    }(l);
                    Promise.all(s).then(function (t) {
                        var n = [];
                        t = t.sort(function (t, e) {
                            return t.num - e.num
                        });
                        for (var r = 0; r < t.length; r++)n.push(i.hexToRGB(t[r].color));
                        n && n.length > 1 && i.getColorBrightness(n[n.length - 1]) < i.getColorBrightness(n[0]) && n.reverse(), o[a] = n, e && e(n)
                    })
                }, 10)
            } else setTimeout(u, 100)
        };
        o.hasOwnProperty(a) ? e && e(o[a]) : u()
    }, i.URL.prototype._handleAutoUpdate = function () {
        function t(t) {
            return a === r._autoUpdateSel && t === i.updateVersion[a]
        }

        function e(e, n) {
            n in u || (u[n] = [], function () {
                var e = document.createElement("img"), l = i.updateVersion[a], c = (new Date).getTime();
                e.src = n, e.onload = e.onerror = function () {
                    if (t(l))for (var e = 0; e < u[n].length; e++)if (i.setElementImage(u[n][e], n), s++, "function" == typeof r._autoUpdateCallback) {
                        var a = {
                            element: u[n][e],
                            isComplete: s === o,
                            percentComplete: s / o * 100,
                            totalComplete: s,
                            loadTime: (new Date).getTime() - c,
                            total: o
                        };
                        r._autoUpdateCallback(a)
                    }
                }
            }()), u[n].push(e)
        }

        function n(t) {
            var n = i.getElementImage(t), o = n;
            n && -1 !== n.indexOf("?") && (o = n.split("?")[0]), r.getBaseUrl() ? e(t, r.getUrl()) : o && r.getQueryString() ? e(t, o + "?" + r.getQueryString()) : s++
        }

        var r = this, o = 0, s = 0, a = this._autoUpdateSel, u = {};
        if (i.isDef(i.updateVersion[a]) ? i.updateVersion[a]++ : i.updateVersion[a] = 1, null !== this._autoUpdateSel) {
            var l = document.querySelectorAll(this._autoUpdateSel);
            if (o = l.length, l && 1 === o)n(l[0]); else for (var c = 0; o > c; c++)n(l[c])
        }
    }, i.URL.prototype.autoUpdateImg = function (t, e) {
        this._autoUpdateSel = t, this._autoUpdateCallback = e, this._handleAutoUpdate()
    }, i.URL.prototype.setUrl = function (t) {
        t && "string" == typeof t && 0 !== t.length || (t = i.getEmptyImage()), this.urlParts = i.parseUrl(t)
    }, i.URL.prototype.setURL = function (t) {
        return this.setUrl(t)
    }, i.URL.prototype.getURL = function () {
        return this.getUrl()
    }, i.URL.prototype.toString = function () {
        return "[object imgixURL]"
    }, i.URL.prototype.getUrl = function () {
        var t = i.buildUrl(this.urlParts);
        return t && 0 !== t.length ? t = i.versionifyUrl(t) : i.getEmptyImage()
    }, i.URL.prototype.removeParam = function (t) {
        this.urlParts.paramValues.hasOwnProperty(t) && (delete this.urlParts.paramValues[t], this.urlParts.params = Object.keys(this.urlParts.paramValues))
    }, i.URL.prototype.clearThenSetParams = function (t) {
        this.clearParams(!1), this.setParams(t)
    }, i.URL.prototype.clearParams = function (t) {
        t = i.isDef(t) ? t : !0;
        for (var e in this.urlParts.paramValues)this.urlParts.paramValues.hasOwnProperty(e) && this.removeParam(e);
        t && this._handleAutoUpdate()
    }, i.URL.prototype.setParams = function (t, e) {
        if (i.instanceOfImgixURL(t))return void console.warn("setParams warning: dictionary of imgix params expectd. imgix URL instance passed instead");
        for (var n in t)t.hasOwnProperty(n) && this.setParam(n, t[n], e, !0);
        this._handleAutoUpdate()
    }, i.URL.prototype.setParam = function (t, e, n, r) {
        if (t = t.toLowerCase(), n = i.isDef(n) ? n : !0, r = i.isDef(r) ? r : !1, ("col" === t || "colorize" === t || "blend" === t || "mono" === t || "monochrome" === t) && "rgb" === e.slice(0, 3) && (e = i.rgbToHex(e)), -1 === i.getAllParams().indexOf(t))return console.warn("'" + t + "' is an invalid imgix param"), this;
        if (!n && this.urlParts.paramValues[t])return this;
        if ("txtfont" === t && i.isFontAvailable(e)) {
            var o = i.getFontLookup()[e];
            o && (e = o)
        }
        return i.getDefaultParamValue(t) !== e && i.isDef(e) && null !== e && 0 !== e.length ? (-1 === this.urlParts.params.indexOf(t) && this.urlParts.params.push(t), decodeURIComponent(e) === e && (e = encodeURIComponent(e)), this.urlParts.paramValues[t] = String(e), r || this._handleAutoUpdate(), this) : (this.removeParam(t), this)
    }, i.URL.prototype.getParam = function (t) {
        if ("mark" === t || "mask" === t) {
            var e = this.urlParts.paramValues[t];
            return decodeURIComponent(e) !== e ? decodeURIComponent(e) : e
        }
        return this.urlParts.paramValues[t]
    }, i.URL.prototype.getParams = function () {
        return this.urlParts.paramValues ? this.urlParts.paramValues : {}
    }, i.URL.prototype.getBaseUrl = function () {
        var t = this.getUrl();
        return -1 !== t.indexOf("?") && (t = this.getUrl().split("?")[0]), t !== window.location.href ? t : ""
    }, i.URL.prototype.getQueryString = function () {
        var t = this.getUrl();
        return -1 !== t.indexOf("?") ? this.getUrl().split("?")[1] : ""
    }, i.URL.theGetSetFuncs = Object.freeze({
        bri: "Brightness",
        con: "Contrast",
        exp: "Exposure",
        gam: "Gamma",
        high: "Highlight",
        hue: "Hue",
        invert: "Invert",
        sat: "Saturation",
        shad: "Shadow",
        sharp: "Sharpness",
        usm: "UnsharpMask",
        usmrad: "UnsharpMaskRadius",
        vib: "Vibrance",
        auto: "Auto",
        bg: "Background",
        ba: "BlendAlign",
        balph: "BlendAlpha",
        bc: "BlendCrop",
        bf: "BlendFit",
        bh: "BlendHeight",
        blend: "Blend",
        bm: "BlendMode",
        bp: "BlendPadding",
        bs: "BlendSize",
        bw: "BlendWidth",
        border: "Border",
        pad: "Pad",
        dl: "Download",
        fm: "Format",
        q: "Quality",
        mask: "Mask",
        nr: "NoiseReduction",
        nrs: "NoiseReductionSharpen",
        palette: "Palette",
        "class": "PaletteClass",
        prefix: "PalettePrefix",
        colors: "PaletteColorNumber",
        page: "Page",
        dpr: "DPR",
        flip: "Flip",
        or: "Orient",
        rot: "Rotate",
        crop: "Crop",
        fit: "Fit",
        h: "Height",
        rect: "Rectangle",
        w: "Width",
        blur: "Blur",
        htn: "Halftone",
        mono: "Monochrome",
        px: "Pixelate",
        sepia: "Sepia",
        txt: "Text",
        txtalign: "TextAlign",
        txtclip: "TextClip",
        txtclr: "TextColor",
        txtfit: "TextFit",
        txtfont: "TextFont",
        txtline: "TextLine",
        txtlineclr: "TextLineColor",
        txtpad: "TextPad",
        txtsize: "TextSize",
        txtshad: "TextShadow",
        trim: "Trim",
        trimcolor: "TrimColor",
        trimmd: "TrimMeanDifference",
        mark: "Watermark",
        markalign: "WatermarkAlign",
        markalpha: "WatermarkAlpha",
        markfit: "WatermarkFit",
        markh: "WatermarkHeight",
        markpad: "WatermarkPadding",
        markscale: "WatermarkScale",
        markw: "WatermarkWidth"
    });
    for (var s in i.URL.theGetSetFuncs)i.URL.theGetSetFuncs.hasOwnProperty(s) && !function (t) {
        i.URL.prototype["set" + i.URL.theGetSetFuncs[t]] = function (e, n) {
            return this.setParam(t, e, n)
        }, i.URL.prototype["get" + i.URL.theGetSetFuncs[t]] = function () {
            return this.getParam(t)
        }
    }(s);
    i.parseUrl = function (t) {
        for (var e = ["protocol", "hostname", "port", "path", "?", "#", "hostname"], n = ["protocol", "hostname", "port", "pathname", "search", "hash", "host"], r = {}, o = 0; o < n.length; o++)r[n[o]] = i.helpers.urlParser(e[o], t);
        var s = r.search;
        if (r.paramValues = {}, r.params = [], r.baseUrl = t.split("?")[0], s && s.length > 0) {
            "?" === s[0] && (s = s.substr(1, s.length));
            for (var a = s.split("&"), u = 0; u < a.length; u++) {
                var l = a[u].split("=");
                l[0] && l[0].length && "s" !== l[0] && (r.paramValues[l[0]] = 2 === l.length ? l[1] : "", -1 === r.params.indexOf(l[0]) && r.params.push(l[0]))
            }
        }
        return r
    }, i.buildUrl = function (t) {
        var e = t.protocol + "://" + t.host + t.pathname;
        if (t.params.length > 0) {
            t.params = t.params.map(function (t) {
                return t.toLowerCase()
            }), t.params = t.params.filter(function (t, e, n) {
                return n.indexOf(t) === e
            }), t.params = t.params.sort(function (t, e) {
                return e > t ? -1 : t > e ? 1 : 0
            });
            for (var n = [], i = 0; i < t.params.length; i++)t.paramValues[t.params[i]].length > 0 && n.push(t.params[i] + "=" + t.paramValues[t.params[i]]);
            -1 !== e.indexOf("?") && (e = e.split("?")[0]), e += "?" + n.join("&")
        }
        return e
    }, i.versionifyUrl = function (t) {
        var e = i.parseUrl(t), n = "ixjsv";
        return e.params.push(n), e.paramValues[n] = i.version, i.buildUrl(e)
    }, i.isDef = function (t) {
        return "undefined" != typeof t
    }, i.hashCode = function (t) {
        var e, n, i = 2166136261;
        for (e = 0, n = t.length; n > e; e++)i ^= t.charCodeAt(e), i += (i << 1) + (i << 4) + (i << 7) + (i << 8) + (i << 24);
        return ("0000000" + (i >>> 0).toString(16)).substr(-8)
    };
    var a = {
        fluidClass: "imgix-fluid",
        updateOnResize: !0,
        updateOnResizeDown: !1,
        updateOnPinchZoom: !1,
        highDPRAutoScaleQuality: !0,
        onChangeParamOverride: null,
        autoInsertCSSBestPractices: !1,
        fitImgTagToContainerWidth: !0,
        fitImgTagToContainerHeight: !1,
        ignoreDPR: !1,
        pixelStep: 10,
        debounce: 200,
        lazyLoad: !1,
        lazyLoadColor: null,
        lazyLoadOffsetVertical: 20,
        lazyLoadOffsetHorizontal: 20,
        throttle: 200,
        maxHeight: 5e3,
        maxWidth: 5e3,
        onLoad: null
    };
    i.FluidSet = function (t) {
        i.helpers.isReallyObject(t) ? this.options = i.helpers.mergeObject(e(), t) : this.options = i.helpers.mergeObject(e(), {}), this.lazyLoadOffsets = {
            t: Math.max(this.options.lazyLoadOffsetVertical, 0),
            b: Math.max(this.options.lazyLoadOffsetVertical, 0),
            l: Math.max(this.options.lazyLoadOffsetHorizontal, 0),
            r: Math.max(this.options.lazyLoadOffsetHorizontal, 0)
        }, this.namespace = Math.random().toString(36).substring(7), this.windowResizeEventBound = !1, this.windowScrollEventBound = !1, this.windowLastWidth = 0, this.windowLastHeight = 0
    }, i.FluidSet.prototype.updateSrc = function (t, e) {
        if (t.hasAttribute("src") && "" === t.getAttribute("src") && t.setAttribute("src", i.getEmptyImage()), t.offsetWidth || t.offsetHeight || t.getClientRects().length) {
            var n = this.getImgDetails(t, e || 1), r = n.url, o = n.width, s = n.height;
            if (this.options.lazyLoad) {
                var a = t.getBoundingClientRect(), u = {
                    left: 0 - this.lazyLoadOffsets.l,
                    top: 0 - this.lazyLoadOffsets.t,
                    bottom: (window.innerHeight || document.documentElement.clientHeight) + this.lazyLoadOffsets.b,
                    right: (window.innerWidth || document.documentElement.clientWidth) + this.lazyLoadOffsets.r
                };
                if (a.top > u.bottom || a.left > u.right || a.top + s < u.top || a.left + o < u.left) {
                    if (!t.fluidLazyColored && this.options.lazyLoadColor) {
                        t.fluidLazyColored = 1;
                        var l = this, c = typeof this.options.lazyLoadColor, d = new i.URL(i.helpers.getImgSrc(t));
                        d.getColors(16, function (e) {
                            if (!e)return void console.warn("No colors found for", d.getURL(), "for element", t);
                            var n = null;
                            "boolean" === c ? n = e[0] : "number" === c && l.options.lazyLoadColor < e.length ? n = e[l.options.lazyLoadColor] : "function" === c && (n = l.options.lazyLoadColor(t, e)), null !== n && (i.isImageElement(t) && t.parentNode && "body" !== t.parentNode.tagName.toLowerCase() ? t.parentNode.style.backgroundColor = n : t.style.backgroundColor = n)
                        })
                    }
                    return
                }
            }
            if (t.lastWidth = t.lastWidth || 0, t.lastHeight = t.lastHeight || 0, !(this.options.updateOnResizeDown === !1 && t.lastWidth >= o && t.lastHeight >= s)) {
                t.fluidUpdateCount || (t.fluidUpdateCount = 0);
                var h = function () {
                };
                this.options.onLoad && "function" == typeof this.options.onLoad && (h = this.options.onLoad);
                var p = function (t, e) {
                    t.fluidUpdateCount = parseInt(t.fluidUpdateCount, 10) + 1, h(t, e)
                };
                i.setElementImageAfterLoad(t, r, p), t.lastWidth = o, t.lastHeight = s
            }
        }
    }, i.FluidSet.prototype.getImgDetails = function (t, e) {
        if (t) {
            var n = i.helpers.getDPR(t), r = this.options.pixelStep, o = i.helpers.calculateElementSize(i.isImageElement(t) ? t.parentNode : t), s = i.helpers.pixelRound(o.width * e, r), a = i.helpers.pixelRound(o.height * e, r), u = new i.URL(i.helpers.getImgSrc(t));
            u.setHeight(""), u.setWidth(""), s = Math.min(s, this.options.maxWidth), a = Math.min(a, this.options.maxHeight), 1 === n || this.options.ignoreDPR || u.setDPR(n), this.options.highDPRAutoScaleQuality && n > 1 && u.setQuality(Math.min(Math.max(parseInt(100 / n, 10), 30), 75)), this.options.fitImgTagToContainerHeight && this.options.fitImgTagToContainerWidth && u.setFit("crop"), "crop" === u.getFit() ? (a > 0 && (!i.isImageElement(t) || i.isImageElement(t) && this.options.fitImgTagToContainerHeight) && u.setHeight(a), s > 0 && (!i.isImageElement(t) || i.isImageElement(t) && this.options.fitImgTagToContainerWidth) && u.setWidth(s)) : s >= a ? u.setWidth(s) : u.setHeight(a), !i.isImageElement(t) && this.options.autoInsertCSSBestPractices && t.style && (t.style.backgroundRepeat = "no-repeat", t.style.backgroundSize = "cover", t.style.backgroundPosition = "50% 50%");
            var l = {};
            null !== this.options.onChangeParamOverride && "function" == typeof this.options.onChangeParamOverride && (l = this.options.onChangeParamOverride(s, a, u.getParams(), t));
            for (var c in l)l.hasOwnProperty(c) && u.setParam(c, l[c]);
            return {url: u.getURL(), width: s, height: a}
        }
    }, i.FluidSet.prototype.toString = function () {
        return "[object FluidSet]"
    }, i.FluidSet.prototype.reload = function () {
        i.fluid(this), this.windowLastWidth = i.helpers.getWindowWidth(), this.windowLastHeight = i.helpers.getWindowHeight()
    }, i.FluidSet.prototype.attachGestureEvent = function (t) {
        var e = this;
        t.addEventListener && !t.listenerAttached && (t.addEventListener("gestureend", function (t) {
            e.updateSrc(this, t.scale)
        }, !1), t.addEventListener("gesturechange", function () {
            e.updateSrc(this)
        }, !1), t.listenerAttached = !0)
    };
    var u = {}, l = {};
    i.FluidSet.prototype.attachScrollListener = function () {
        u[this.namespace] = i.helpers.throttler(function () {
            this.reload()
        }.bind(this), this.options.throttle), document.addEventListener ? window.addEventListener("scroll", u[this.namespace], !1) : window.attachEvent("onscroll", u[this.namespace]), this.windowScrollEventBound = !0
    }, i.FluidSet.prototype.attachWindowResizer = function () {
        l[this.namespace] = i.helpers.debouncer(function () {
            (this.windowLastWidth !== i.helpers.getWindowWidth() || this.windowLastHeight !== i.helpers.getWindowHeight()) && this.reload()
        }.bind(this), this.options.debounce), window.addEventListener ? window.addEventListener("resize", l[this.namespace], !1) : window.attachEvent && window.attachEvent("onresize", l[this.namespace]), this.windowResizeEventBound = !0
    }, i.fluid = function () {
        var t, n;
        if (arguments.length > 0 && 1 === arguments[0].nodeType ? (n = arguments[0], t = arguments[1]) : t = arguments[0], null !== t) {
            var r, o;
            if (i.helpers.isReallyObject(t)) {
                for (var s = Object.keys(t), a = Object.keys(e()), u = 0; u < s.length; u++)-1 === a.indexOf(s[u]) && console.warn("'" + s[u] + "' is not a valid imgix.fluid config option. See https://github.com/imgix/imgix.js/blob/master/docs/api.md#imgix.fluid for a list of valid options.");
                r = i.helpers.mergeObject(e(), t), o = new i.FluidSet(r), t = null
            } else i.helpers.isFluidSet(t) ? (o = t, r = o.options) : (r = i.helpers.mergeObject(e(), {}), o = new i.FluidSet(r));
            var l;
            if (t && !i.helpers.isFluidSet(t))l = Array.isArray(t) ? t : [t]; else {
                var c = r.fluidClass.toString();
                c = "." === c.slice(0, 1) ? c : "." + c, l = (n || document).querySelectorAll(c), n && i.helpers.matchesSelector(n, c) && (l = Array.prototype.slice.call(l), l.unshift(n))
            }
            for (var d = 0; d < l.length; d++)null !== l[d] && (r.updateOnPinchZoom && o.attachGestureEvent(l[d]), o.updateSrc(l[d]));
            return r.lazyLoad && !o.windowScrollEventBound && o.attachScrollListener(), r.updateOnResize && !o.windowResizeEventBound && o.attachWindowResizer(), o
        }
    }, "undefined" != typeof window && (i.onready = function () {
        function t() {
            var t;
            for (s = !0; t = i.shift();)t()
        }

        var e, n, i = [], r = document.documentElement.doScroll, o = r ? /^loaded|^c/ : /^loaded|c/, s = o.test(document.readyState);
        return document.addEventListener ? (n = function () {
            document.removeEventListener("DOMContentLoaded", n, !1), t()
        }, document.addEventListener("DOMContentLoaded", n, !1)) : document.attachEvent && (n = function () {
            /^c/.test(document.readyState) && (document.detachEvent("onreadystatechange", n), t())
        }, document.attachEvent("onreadystatechange", n)), e = r ? function (t) {
            window.self != window.top ? s ? t() : i.push(t) : !function () {
                try {
                    document.documentElement.doScroll("left")
                } catch (n) {
                    return setTimeout(function () {
                        e(t)
                    }, 50)
                }
                t()
            }()
        } : function (t) {
            s ? t() : i.push(t)
        }
    }()), "function" == typeof define && define.amd && define("imgix", [], function () {
        return i
    })
}.call(this), !function (t) {
    "function" == typeof define && define.amd ? define(["jquery"], t) : "object" == typeof exports ? module.exports = t(require("jquery")) : t(jQuery)
}(function (t) {
    "use strict";
    function e(t, e, n) {
        var i;
        return function () {
            var r = this, o = arguments, s = function () {
                i = null, n || t.apply(r, o)
            }, a = n && !i;
            clearTimeout(i), i = setTimeout(s, e), a && t.apply(r, o)
        }
    }

    function n(t) {
        var e = ++l;
        return String(null == t ? "rmjs-" : t) + e
    }

    function i(t) {
        var e = t.clone().css({
            height: "auto",
            width: t.width(),
            maxHeight: "none",
            overflow: "hidden"
        }).insertAfter(t), n = e.outerHeight(), i = parseInt(e.css({maxHeight: ""}).css("max-height").replace(/[^-\d\.]/g, ""), 10), r = t.data("defaultHeight");
        e.remove();
        var o = i || t.data("collapsedHeight") || r;
        t.data({expandedHeight: n, maxHeight: i, collapsedHeight: o}).css({maxHeight: "none"})
    }

    function r(t) {
        if (!u[t.selector]) {
            var e = " ";
            t.embedCSS && "" !== t.blockCSS && (e += t.selector + " + [data-readmore-toggle], " + t.selector + "[data-readmore]{" + t.blockCSS + "}"), e += t.selector + "[data-readmore]{transition: height " + t.speed + "ms;overflow: hidden;}", function (t, e) {
                var n = t.createElement("style");
                n.type = "text/css", n.styleSheet ? n.styleSheet.cssText = e : n.appendChild(t.createTextNode(e)), t.getElementsByTagName("head")[0].appendChild(n)
            }(document, e), u[t.selector] = !0
        }
    }

    function o(e, n) {
        this.element = e, this.options = t.extend({}, a, n), r(this.options), this._defaults = a, this._name = s, this.init(), window.addEventListener ? (window.addEventListener("load", c), window.addEventListener("resize", c)) : (window.attachEvent("load", c), window.attachEvent("resize", c))
    }

    var s = "readmore", a = {
        speed: 100,
        collapsedHeight: 200,
        heightMargin: 16,
        moreLink: '<a href="#">Read More</a>',
        lessLink: '<a href="#">Close</a>',
        embedCSS: !0,
        blockCSS: "display: block; width: 100%;",
        startOpen: !1,
        beforeToggle: function () {
        },
        afterToggle: function () {
        }
    }, u = {}, l = 0, c = e(function () {
        t("[data-readmore]").each(function () {
            var e = t(this), n = "true" === e.attr("aria-expanded");
            i(e), e.css({height: e.data(n ? "expandedHeight" : "collapsedHeight")})
        })
    }, 100);
    o.prototype = {
        init: function () {
            var e = t(this.element);
            e.data({defaultHeight: this.options.collapsedHeight, heightMargin: this.options.heightMargin}), i(e);
            var r = e.data("collapsedHeight"), o = e.data("heightMargin");
            if (e.outerHeight(!0) <= r + o)return !0;
            var s = e.attr("id") || n(), a = this.options.startOpen ? this.options.lessLink : this.options.moreLink;
            e.attr({
                "data-readmore": "",
                "aria-expanded": this.options.startOpen,
                id: s
            }), e.after(t(a).on("click", function (t) {
                return function (n) {
                    t.toggle(this, e[0], n)
                }
            }(this)).attr({
                "data-readmore-toggle": "",
                "aria-controls": s
            })), this.options.startOpen || e.css({height: r})
        }, toggle: function (e, n, i) {
            i && i.preventDefault(), e || (e = t('[aria-controls="' + _this.element.id + '"]')[0]), n || (n = _this.element);
            var r = t(n), o = "", s = "", a = !1, u = r.data("collapsedHeight");
            r.height() <= u ? (o = r.data("expandedHeight") + "px", s = "lessLink", a = !0) : (o = u, s = "moreLink"), this.options.beforeToggle(e, r, !a), r.css({height: o}), r.on("transitionend", function (n) {
                return function () {
                    n.options.afterToggle(e, r, a), t(this).attr({"aria-expanded": a}).off("transitionend")
                }
            }(this)), t(e).replaceWith(t(this.options[s]).on("click", function (t) {
                return function (e) {
                    t.toggle(this, n, e)
                }
            }(this)).attr({"data-readmore-toggle": "", "aria-controls": r.attr("id")}))
        }, destroy: function () {
            t(this.element).each(function () {
                var e = t(this);
                e.attr({"data-readmore": null, "aria-expanded": null}).css({
                    maxHeight: "",
                    height: ""
                }).next("[data-readmore-toggle]").remove(), e.removeData()
            })
        }
    }, t.fn.readmore = function (e) {
        var n = arguments, i = this.selector;
        return e = e || {}, "object" == typeof e ? this.each(function () {
            if (t.data(this, "plugin_" + s)) {
                var n = t.data(this, "plugin_" + s);
                n.destroy.apply(n)
            }
            e.selector = i, t.data(this, "plugin_" + s, new o(this, e))
        }) : "string" == typeof e && "_" !== e[0] && "init" !== e ? this.each(function () {
            var i = t.data(this, "plugin_" + s);
            i instanceof o && "function" == typeof i[e] && i[e].apply(i, Array.prototype.slice.call(n, 1))
        }) : void 0
    }
}), function (t, e) {
    "use strict";
    t.rails !== e && t.error("jquery-ujs has already been loaded!");
    var n, i = t(document);
    t.rails = n = {
        linkClickSelector: "a[data-confirm], a[data-method], a[data-remote]:not([disabled]), a[data-disable-with], a[data-disable]",
        buttonClickSelector: "button[data-remote]:not([form]):not(form button), button[data-confirm]:not([form]):not(form button)",
        inputChangeSelector: "select[data-remote], input[data-remote], textarea[data-remote]",
        formSubmitSelector: "form",
        formInputClickSelector: "form input[type=submit], form input[type=image], form button[type=submit], form button:not([type]), input[type=submit][form], input[type=image][form], button[type=submit][form], button[form]:not([type])",
        disableSelector: "input[data-disable-with]:enabled, button[data-disable-with]:enabled, textarea[data-disable-with]:enabled, input[data-disable]:enabled, button[data-disable]:enabled, textarea[data-disable]:enabled",
        enableSelector: "input[data-disable-with]:disabled, button[data-disable-with]:disabled, textarea[data-disable-with]:disabled, input[data-disable]:disabled, button[data-disable]:disabled, textarea[data-disable]:disabled",
        requiredInputSelector: "input[name][required]:not([disabled]), textarea[name][required]:not([disabled])",
        fileInputSelector: "input[type=file]:not([disabled])",
        linkDisableSelector: "a[data-disable-with], a[data-disable]",
        buttonDisableSelector: "button[data-remote][data-disable-with], button[data-remote][data-disable]",
        csrfToken: function () {
            return t("meta[name=csrf-token]").attr("content")
        },
        csrfParam: function () {
            return t("meta[name=csrf-param]").attr("content")
        },
        CSRFProtection: function (t) {
            var e = n.csrfToken();
            e && t.setRequestHeader("X-CSRF-Token", e)
        },
        refreshCSRFTokens: function () {
            t('form input[name="' + n.csrfParam() + '"]').val(n.csrfToken())
        },
        fire: function (e, n, i) {
            var r = t.Event(n);
            return e.trigger(r, i), r.result !== !1
        },
        confirm: function (t) {
            return confirm(t)
        },
        ajax: function (e) {
            return t.ajax(e)
        },
        href: function (t) {
            return t[0].href
        },
        isRemote: function (t) {
            return t.data("remote") !== e && t.data("remote") !== !1
        },
        handleRemote: function (i) {
            var r, o, s, a, u, l;
            if (n.fire(i, "ajax:before")) {
                if (a = i.data("with-credentials") || null, u = i.data("type") || t.ajaxSettings && t.ajaxSettings.dataType, i.is("form")) {
                    r = i.data("ujs:submit-button-formmethod") || i.attr("method"), o = i.data("ujs:submit-button-formaction") || i.attr("action"), s = t(i[0]).serializeArray();
                    var c = i.data("ujs:submit-button");
                    c && (s.push(c), i.data("ujs:submit-button", null)), i.data("ujs:submit-button-formmethod", null), i.data("ujs:submit-button-formaction", null)
                } else i.is(n.inputChangeSelector) ? (r = i.data("method"), o = i.data("url"), s = i.serialize(), i.data("params") && (s = s + "&" + i.data("params"))) : i.is(n.buttonClickSelector) ? (r = i.data("method") || "get", o = i.data("url"), s = i.serialize(), i.data("params") && (s = s + "&" + i.data("params"))) : (r = i.data("method"), o = n.href(i), s = i.data("params") || null);
                return l = {
                    type: r || "GET", data: s, dataType: u, beforeSend: function (t, r) {
                        return r.dataType === e && t.setRequestHeader("accept", "*/*;q=0.5, " + r.accepts.script), n.fire(i, "ajax:beforeSend", [t, r]) ? void i.trigger("ajax:send", t) : !1
                    }, success: function (t, e, n) {
                        i.trigger("ajax:success", [t, e, n]);
                    }, complete: function (t, e) {
                        i.trigger("ajax:complete", [t, e])
                    }, error: function (t, e, n) {
                        i.trigger("ajax:error", [t, e, n])
                    }, crossDomain: n.isCrossDomain(o)
                }, a && (l.xhrFields = {withCredentials: a}), o && (l.url = o), n.ajax(l)
            }
            return !1
        },
        isCrossDomain: function (t) {
            var e = document.createElement("a");
            e.href = location.href;
            var n = document.createElement("a");
            try {
                return n.href = t, n.href = n.href, !((!n.protocol || ":" === n.protocol) && !n.host || e.protocol + "//" + e.host == n.protocol + "//" + n.host)
            } catch (i) {
                return !0
            }
        },
        handleMethod: function (i) {
            var r = n.href(i), o = i.data("method"), s = i.attr("target"), a = n.csrfToken(), u = n.csrfParam(), l = t('<form method="post" action="' + r + '"></form>'), c = '<input name="_method" value="' + o + '" type="hidden" />';
            u === e || a === e || n.isCrossDomain(r) || (c += '<input name="' + u + '" value="' + a + '" type="hidden" />'), s && l.attr("target", s), l.hide().append(c).appendTo("body"), l.submit()
        },
        formElements: function (e, n) {
            return e.is("form") ? t(e[0].elements).filter(n) : e.find(n)
        },
        disableFormElements: function (e) {
            n.formElements(e, n.disableSelector).each(function () {
                n.disableFormElement(t(this))
            })
        },
        disableFormElement: function (t) {
            var n, i;
            n = t.is("button") ? "html" : "val", i = t.data("disable-with"), i !== e && (t.data("ujs:enable-with", t[n]()), t[n](i)), t.prop("disabled", !0), t.data("ujs:disabled", !0)
        },
        enableFormElements: function (e) {
            n.formElements(e, n.enableSelector).each(function () {
                n.enableFormElement(t(this))
            })
        },
        enableFormElement: function (t) {
            var n = t.is("button") ? "html" : "val";
            t.data("ujs:enable-with") !== e && (t[n](t.data("ujs:enable-with")), t.removeData("ujs:enable-with")), t.prop("disabled", !1), t.removeData("ujs:disabled")
        },
        allowAction: function (t) {
            var e, i = t.data("confirm"), r = !1;
            if (!i)return !0;
            if (n.fire(t, "confirm")) {
                try {
                    r = n.confirm(i)
                } catch (o) {
                    (console.error || console.log).call(console, o.stack || o)
                }
                e = n.fire(t, "confirm:complete", [r])
            }
            return r && e
        },
        blankInputs: function (e, n, i) {
            var r, o, s, a, u = t(), l = n || "input,textarea", c = e.find(l), d = {};
            return c.each(function () {
                r = t(this), r.is("input[type=radio]") ? (a = r.attr("name"), d[a] || (0 === e.find('input[type=radio]:checked[name="' + a + '"]').length && (s = e.find('input[type=radio][name="' + a + '"]'), u = u.add(s)), d[a] = a)) : (o = r.is("input[type=checkbox],input[type=radio]") ? r.is(":checked") : !!r.val(), o === i && (u = u.add(r)))
            }), u.length ? u : !1
        },
        nonBlankInputs: function (t, e) {
            return n.blankInputs(t, e, !0)
        },
        stopEverything: function (e) {
            return t(e.target).trigger("ujs:everythingStopped"), e.stopImmediatePropagation(), !1
        },
        disableElement: function (t) {
            var i = t.data("disable-with");
            i !== e && (t.data("ujs:enable-with", t.html()), t.html(i)), t.bind("click.railsDisable", function (t) {
                return n.stopEverything(t)
            }), t.data("ujs:disabled", !0)
        },
        enableElement: function (t) {
            t.data("ujs:enable-with") !== e && (t.html(t.data("ujs:enable-with")), t.removeData("ujs:enable-with")), t.unbind("click.railsDisable"), t.removeData("ujs:disabled")
        }
    }, n.fire(i, "rails:attachBindings") && (t.ajaxPrefilter(function (t, e, i) {
        t.crossDomain || n.CSRFProtection(i)
    }), t(window).on("pageshow.rails", function () {
        t(t.rails.enableSelector).each(function () {
            var e = t(this);
            e.data("ujs:disabled") && t.rails.enableFormElement(e)
        }), t(t.rails.linkDisableSelector).each(function () {
            var e = t(this);
            e.data("ujs:disabled") && t.rails.enableElement(e)
        })
    }), i.delegate(n.linkDisableSelector, "ajax:complete", function () {
        n.enableElement(t(this))
    }), i.delegate(n.buttonDisableSelector, "ajax:complete", function () {
        n.enableFormElement(t(this))
    }), i.delegate(n.linkClickSelector, "click.rails", function (e) {
        var i = t(this), r = i.data("method"), o = i.data("params"), s = e.metaKey || e.ctrlKey;
        if (!n.allowAction(i))return n.stopEverything(e);
        if (!s && i.is(n.linkDisableSelector) && n.disableElement(i), n.isRemote(i)) {
            if (s && (!r || "GET" === r) && !o)return !0;
            var a = n.handleRemote(i);
            return a === !1 ? n.enableElement(i) : a.fail(function () {
                n.enableElement(i)
            }), !1
        }
        return r ? (n.handleMethod(i), !1) : void 0
    }), i.delegate(n.buttonClickSelector, "click.rails", function (e) {
        var i = t(this);
        if (!n.allowAction(i) || !n.isRemote(i))return n.stopEverything(e);
        i.is(n.buttonDisableSelector) && n.disableFormElement(i);
        var r = n.handleRemote(i);
        return r === !1 ? n.enableFormElement(i) : r.fail(function () {
            n.enableFormElement(i)
        }), !1
    }), i.delegate(n.inputChangeSelector, "change.rails", function (e) {
        var i = t(this);
        return n.allowAction(i) && n.isRemote(i) ? (n.handleRemote(i), !1) : n.stopEverything(e)
    }), i.delegate(n.formSubmitSelector, "submit.rails", function (i) {
        var r, o, s = t(this), a = n.isRemote(s);
        if (!n.allowAction(s))return n.stopEverything(i);
        if (s.attr("novalidate") === e)if (s.data("ujs:formnovalidate-button") === e) {
            if (r = n.blankInputs(s, n.requiredInputSelector, !1), r && n.fire(s, "ajax:aborted:required", [r]))return n.stopEverything(i)
        } else s.data("ujs:formnovalidate-button", e);
        if (a) {
            if (o = n.nonBlankInputs(s, n.fileInputSelector)) {
                setTimeout(function () {
                    n.disableFormElements(s)
                }, 13);
                var u = n.fire(s, "ajax:aborted:file", [o]);
                return u || setTimeout(function () {
                    n.enableFormElements(s)
                }, 13), u
            }
            return n.handleRemote(s), !1
        }
        setTimeout(function () {
            n.disableFormElements(s)
        }, 13)
    }), i.delegate(n.formInputClickSelector, "click.rails", function (e) {
        var i = t(this);
        if (!n.allowAction(i))return n.stopEverything(e);
        var r = i.attr("name"), o = r ? {name: r, value: i.val()} : null, s = i.closest("form");
        0 === s.length && (s = t("#" + i.attr("form"))), s.data("ujs:submit-button", o), s.data("ujs:formnovalidate-button", i.attr("formnovalidate")), s.data("ujs:submit-button-formaction", i.attr("formaction")), s.data("ujs:submit-button-formmethod", i.attr("formmethod"))
    }), i.delegate(n.formSubmitSelector, "ajax:send.rails", function (e) {
        this === e.target && n.disableFormElements(t(this))
    }), i.delegate(n.formSubmitSelector, "ajax:complete.rails", function (e) {
        this === e.target && n.enableFormElements(t(this))
    }), t(function () {
        n.refreshCSRFTokens()
    }))
}(jQuery), !function (t) {
    t.extend(t.fn, {
        validate: function (e) {
            if (!this.length)return void(e && e.debug && window.console && console.warn("Nothing selected, can't validate, returning nothing."));
            var n = t.data(this[0], "validator");
            return n ? n : (this.attr("novalidate", "novalidate"), n = new t.validator(e, this[0]), t.data(this[0], "validator", n), n.settings.onsubmit && (this.validateDelegate(":submit", "click", function (e) {
                n.settings.submitHandler && (n.submitButton = e.target), t(e.target).hasClass("cancel") && (n.cancelSubmit = !0), void 0 !== t(e.target).attr("formnovalidate") && (n.cancelSubmit = !0)
            }), this.submit(function (e) {
                function i() {
                    var i;
                    return n.settings.submitHandler ? (n.submitButton && (i = t("<input type='hidden'/>").attr("name", n.submitButton.name).val(t(n.submitButton).val()).appendTo(n.currentForm)), n.settings.submitHandler.call(n, n.currentForm, e), n.submitButton && i.remove(), !1) : !0
                }

                return n.settings.debug && e.preventDefault(), n.cancelSubmit ? (n.cancelSubmit = !1, i()) : n.form() ? n.pendingRequest ? (n.formSubmitted = !0, !1) : i() : (n.focusInvalid(), !1)
            })), n)
        }, valid: function () {
            if (t(this[0]).is("form"))return this.validate().form();
            var e = !0, n = t(this[0].form).validate();
            return this.each(function () {
                e = e && n.element(this)
            }), e
        }, removeAttrs: function (e) {
            var n = {}, i = this;
            return t.each(e.split(/\s/), function (t, e) {
                n[e] = i.attr(e), i.removeAttr(e)
            }), n
        }, rules: function (e, n) {
            var i = this[0];
            if (e) {
                var r = t.data(i.form, "validator").settings, o = r.rules, s = t.validator.staticRules(i);
                switch (e) {
                    case"add":
                        t.extend(s, t.validator.normalizeRule(n)), delete s.messages, o[i.name] = s, n.messages && (r.messages[i.name] = t.extend(r.messages[i.name], n.messages));
                        break;
                    case"remove":
                        if (!n)return delete o[i.name], s;
                        var a = {};
                        return t.each(n.split(/\s/), function (t, e) {
                            a[e] = s[e], delete s[e]
                        }), a
                }
            }
            var u = t.validator.normalizeRules(t.extend({}, t.validator.classRules(i), t.validator.attributeRules(i), t.validator.dataRules(i), t.validator.staticRules(i)), i);
            if (u.required) {
                var l = u.required;
                delete u.required, u = t.extend({required: l}, u)
            }
            return u
        }
    }), t.extend(t.expr[":"], {
        blank: function (e) {
            return !t.trim("" + t(e).val())
        }, filled: function (e) {
            return !!t.trim("" + t(e).val())
        }, unchecked: function (e) {
            return !t(e).prop("checked")
        }
    }), t.validator = function (e, n) {
        this.settings = t.extend(!0, {}, t.validator.defaults, e), this.currentForm = n, this.init()
    }, t.validator.format = function (e, n) {
        return 1 === arguments.length ? function () {
            var n = t.makeArray(arguments);
            return n.unshift(e), t.validator.format.apply(this, n)
        } : (arguments.length > 2 && n.constructor !== Array && (n = t.makeArray(arguments).slice(1)), n.constructor !== Array && (n = [n]), t.each(n, function (t, n) {
            e = e.replace(new RegExp("\\{" + t + "\\}", "g"), function () {
                return n
            })
        }), e)
    }, t.extend(t.validator, {
        defaults: {
            messages: {},
            groups: {},
            rules: {},
            errorClass: "error",
            validClass: "valid",
            errorElement: "label",
            focusInvalid: !0,
            errorContainer: t([]),
            errorLabelContainer: t([]),
            onsubmit: !0,
            ignore: ":hidden",
            ignoreTitle: !1,
            onfocusin: function (t, e) {
                this.lastActive = t, this.settings.focusCleanup && !this.blockFocusCleanup && (this.settings.unhighlight && this.settings.unhighlight.call(this, t, this.settings.errorClass, this.settings.validClass), this.addWrapper(this.errorsFor(t)).hide())
            },
            onfocusout: function (t, e) {
                this.checkable(t) || !(t.name in this.submitted) && this.optional(t) || this.element(t)
            },
            onkeyup: function (t, e) {
                (9 !== e.which || "" !== this.elementValue(t)) && (t.name in this.submitted || t === this.lastElement) && this.element(t)
            },
            onclick: function (t, e) {
                t.name in this.submitted ? this.element(t) : t.parentNode.name in this.submitted && this.element(t.parentNode)
            },
            highlight: function (e, n, i) {
                "radio" === e.type ? this.findByName(e.name).addClass(n).removeClass(i) : t(e).addClass(n).removeClass(i)
            },
            unhighlight: function (e, n, i) {
                "radio" === e.type ? this.findByName(e.name).removeClass(n).addClass(i) : t(e).removeClass(n).addClass(i)
            }
        },
        setDefaults: function (e) {
            t.extend(t.validator.defaults, e)
        },
        messages: {
            required: "This field is required.",
            remote: "Please fix this field.",
            email: "Please enter a valid email address.",
            url: "Please enter a valid URL.",
            date: "Please enter a valid date.",
            dateISO: "Please enter a valid date (ISO).",
            number: "Please enter a valid number.",
            digits: "Please enter only digits.",
            creditcard: "Please enter a valid credit card number.",
            equalTo: "Please enter the same value again.",
            maxlength: t.validator.format("Please enter no more than {0} characters."),
            minlength: t.validator.format("Please enter at least {0} characters."),
            rangelength: t.validator.format("Please enter a value between {0} and {1} characters long."),
            range: t.validator.format("Please enter a value between {0} and {1}."),
            max: t.validator.format("Please enter a value less than or equal to {0}."),
            min: t.validator.format("Please enter a value greater than or equal to {0}.")
        },
        autoCreateRanges: !1,
        prototype: {
            init: function () {
                function e(e) {
                    var n = t.data(this[0].form, "validator"), i = "on" + e.type.replace(/^validate/, "");
                    n.settings[i] && n.settings[i].call(n, this[0], e)
                }

                this.labelContainer = t(this.settings.errorLabelContainer), this.errorContext = this.labelContainer.length && this.labelContainer || t(this.currentForm), this.containers = t(this.settings.errorContainer).add(this.settings.errorLabelContainer), this.submitted = {}, this.valueCache = {}, this.pendingRequest = 0, this.pending = {}, this.invalid = {}, this.reset();
                var n = this.groups = {};
                t.each(this.settings.groups, function (e, i) {
                    "string" == typeof i && (i = i.split(/\s/)), t.each(i, function (t, i) {
                        n[i] = e
                    })
                });
                var i = this.settings.rules;
                t.each(i, function (e, n) {
                    i[e] = t.validator.normalizeRule(n)
                }), t(this.currentForm).validateDelegate(":text, [type='password'], [type='file'], select, textarea, [type='number'], [type='search'] ,[type='tel'], [type='url'], [type='email'], [type='datetime'], [type='date'], [type='month'], [type='week'], [type='time'], [type='datetime-local'], [type='range'], [type='color'] ", "focusin focusout keyup", e).validateDelegate("[type='radio'], [type='checkbox'], select, option", "click", e), this.settings.invalidHandler && t(this.currentForm).bind("invalid-form.validate", this.settings.invalidHandler)
            }, form: function () {
                return this.checkForm(), t.extend(this.submitted, this.errorMap), this.invalid = t.extend({}, this.errorMap), this.valid() || t(this.currentForm).triggerHandler("invalid-form", [this]), this.showErrors(), this.valid()
            }, checkForm: function () {
                this.prepareForm();
                for (var t = 0, e = this.currentElements = this.elements(); e[t]; t++)this.check(e[t]);
                return this.valid()
            }, element: function (e) {
                e = this.validationTargetFor(this.clean(e)), this.lastElement = e, this.prepareElement(e), this.currentElements = t(e);
                var n = this.check(e) !== !1;
                return n ? delete this.invalid[e.name] : this.invalid[e.name] = !0, this.numberOfInvalids() || (this.toHide = this.toHide.add(this.containers)), this.showErrors(), n
            }, showErrors: function (e) {
                if (e) {
                    t.extend(this.errorMap, e), this.errorList = [];
                    for (var n in e)this.errorList.push({message: e[n], element: this.findByName(n)[0]});
                    this.successList = t.grep(this.successList, function (t) {
                        return !(t.name in e)
                    })
                }
                this.settings.showErrors ? this.settings.showErrors.call(this, this.errorMap, this.errorList) : this.defaultShowErrors()
            }, resetForm: function () {
                t.fn.resetForm && t(this.currentForm).resetForm(), this.submitted = {}, this.lastElement = null, this.prepareForm(), this.hideErrors(), this.elements().removeClass(this.settings.errorClass).removeData("previousValue")
            }, numberOfInvalids: function () {
                return this.objectLength(this.invalid)
            }, objectLength: function (t) {
                var e = 0;
                for (var n in t)e++;
                return e
            }, hideErrors: function () {
                this.addWrapper(this.toHide).hide()
            }, valid: function () {
                return 0 === this.size()
            }, size: function () {
                return this.errorList.length
            }, focusInvalid: function () {
                if (this.settings.focusInvalid)try {
                    t(this.findLastActive() || this.errorList.length && this.errorList[0].element || []).filter(":visible").focus().trigger("focusin")
                } catch (e) {
                }
            }, findLastActive: function () {
                var e = this.lastActive;
                return e && 1 === t.grep(this.errorList, function (t) {
                        return t.element.name === e.name
                    }).length && e
            }, elements: function () {
                var e = this, n = {};
                return t(this.currentForm).find("input, select, textarea").not(":submit, :reset, :image, [disabled]").not(this.settings.ignore).filter(function () {
                    return !this.name && e.settings.debug && window.console && console.error("%o has no name assigned", this), this.name in n || !e.objectLength(t(this).rules()) ? !1 : (n[this.name] = !0, !0)
                })
            }, clean: function (e) {
                return t(e)[0]
            }, errors: function () {
                var e = this.settings.errorClass.replace(" ", ".");
                return t(this.settings.errorElement + "." + e, this.errorContext)
            }, reset: function () {
                this.successList = [], this.errorList = [], this.errorMap = {}, this.toShow = t([]), this.toHide = t([]), this.currentElements = t([])
            }, prepareForm: function () {
                this.reset(), this.toHide = this.errors().add(this.containers)
            }, prepareElement: function (t) {
                this.reset(), this.toHide = this.errorsFor(t)
            }, elementValue: function (e) {
                var n = t(e).attr("type"), i = t(e).val();
                return "radio" === n || "checkbox" === n ? t("input[name='" + t(e).attr("name") + "']:checked").val() : "string" == typeof i ? i.replace(/\r/g, "") : i
            }, check: function (e) {
                e = this.validationTargetFor(this.clean(e));
                var n, i = t(e).rules(), r = !1, o = this.elementValue(e);
                for (var s in i) {
                    var a = {method: s, parameters: i[s]};
                    try {
                        if (n = t.validator.methods[s].call(this, o, e, a.parameters), "dependency-mismatch" === n) {
                            r = !0;
                            continue
                        }
                        if (r = !1, "pending" === n)return void(this.toHide = this.toHide.not(this.errorsFor(e)));
                        if (!n)return this.formatAndAdd(e, a), !1
                    } catch (u) {
                        throw this.settings.debug && window.console && console.log("Exception occurred when checking element " + e.id + ", check the '" + a.method + "' method.", u), u
                    }
                }
                return r ? void 0 : (this.objectLength(i) && this.successList.push(e), !0)
            }, customDataMessage: function (e, n) {
                return t(e).data("msg-" + n.toLowerCase()) || e.attributes && t(e).attr("data-msg-" + n.toLowerCase())
            }, customMessage: function (t, e) {
                var n = this.settings.messages[t];
                return n && (n.constructor === String ? n : n[e])
            }, findDefined: function () {
                for (var t = 0; t < arguments.length; t++)if (void 0 !== arguments[t])return arguments[t];
                return void 0
            }, defaultMessage: function (e, n) {
                return this.findDefined(this.customMessage(e.name, n), this.customDataMessage(e, n), !this.settings.ignoreTitle && e.title || void 0, t.validator.messages[n], "<strong>Warning: No message defined for " + e.name + "</strong>")
            }, formatAndAdd: function (e, n) {
                var i = this.defaultMessage(e, n.method), r = /\$?\{(\d+)\}/g;
                "function" == typeof i ? i = i.call(this, n.parameters, e) : r.test(i) && (i = t.validator.format(i.replace(r, "{$1}"), n.parameters)), this.errorList.push({
                    message: i,
                    element: e
                }), this.errorMap[e.name] = i, this.submitted[e.name] = i
            }, addWrapper: function (t) {
                return this.settings.wrapper && (t = t.add(t.parent(this.settings.wrapper))), t
            }, defaultShowErrors: function () {
                var t, e;
                for (t = 0; this.errorList[t]; t++) {
                    var n = this.errorList[t];
                    this.settings.highlight && this.settings.highlight.call(this, n.element, this.settings.errorClass, this.settings.validClass), this.showLabel(n.element, n.message)
                }
                if (this.errorList.length && (this.toShow = this.toShow.add(this.containers)), this.settings.success)for (t = 0; this.successList[t]; t++)this.showLabel(this.successList[t]);
                if (this.settings.unhighlight)for (t = 0, e = this.validElements(); e[t]; t++)this.settings.unhighlight.call(this, e[t], this.settings.errorClass, this.settings.validClass);
                this.toHide = this.toHide.not(this.toShow), this.hideErrors(), this.addWrapper(this.toShow).show()
            }, validElements: function () {
                return this.currentElements.not(this.invalidElements())
            }, invalidElements: function () {
                return t(this.errorList).map(function () {
                    return this.element
                })
            }, showLabel: function (e, n) {
                var i = this.errorsFor(e);
                i.length ? (i.removeClass(this.settings.validClass).addClass(this.settings.errorClass), i.html(n)) : (i = t("<" + this.settings.errorElement + ">").attr("for", this.idOrName(e)).addClass(this.settings.errorClass).html(n || ""), this.settings.wrapper && (i = i.hide().show().wrap("<" + this.settings.wrapper + "/>").parent()), this.labelContainer.append(i).length || (this.settings.errorPlacement ? this.settings.errorPlacement(i, t(e)) : i.insertAfter(e))), !n && this.settings.success && (i.text(""), "string" == typeof this.settings.success ? i.addClass(this.settings.success) : this.settings.success(i, e)), this.toShow = this.toShow.add(i)
            }, errorsFor: function (e) {
                var n = this.idOrName(e);
                return this.errors().filter(function () {
                    return t(this).attr("for") === n
                })
            }, idOrName: function (t) {
                return this.groups[t.name] || (this.checkable(t) ? t.name : t.id || t.name)
            }, validationTargetFor: function (t) {
                return this.checkable(t) && (t = this.findByName(t.name).not(this.settings.ignore)[0]), t
            }, checkable: function (t) {
                return /radio|checkbox/i.test(t.type)
            }, findByName: function (e) {
                return t(this.currentForm).find("[name='" + e + "']")
            }, getLength: function (e, n) {
                switch (n.nodeName.toLowerCase()) {
                    case"select":
                        return t("option:selected", n).length;
                    case"input":
                        if (this.checkable(n))return this.findByName(n.name).filter(":checked").length
                }
                return e.length
            }, depend: function (t, e) {
                return this.dependTypes[typeof t] ? this.dependTypes[typeof t](t, e) : !0
            }, dependTypes: {
                "boolean": function (t, e) {
                    return t
                }, string: function (e, n) {
                    return !!t(e, n.form).length
                }, "function": function (t, e) {
                    return t(e)
                }
            }, optional: function (e) {
                var n = this.elementValue(e);
                return !t.validator.methods.required.call(this, n, e) && "dependency-mismatch"
            }, startRequest: function (t) {
                this.pending[t.name] || (this.pendingRequest++, this.pending[t.name] = !0)
            }, stopRequest: function (e, n) {
                this.pendingRequest--, this.pendingRequest < 0 && (this.pendingRequest = 0), delete this.pending[e.name], n && 0 === this.pendingRequest && this.formSubmitted && this.form() ? (t(this.currentForm).submit(), this.formSubmitted = !1) : !n && 0 === this.pendingRequest && this.formSubmitted && (t(this.currentForm).triggerHandler("invalid-form", [this]), this.formSubmitted = !1)
            }, previousValue: function (e) {
                return t.data(e, "previousValue") || t.data(e, "previousValue", {
                        old: null,
                        valid: !0,
                        message: this.defaultMessage(e, "remote")
                    })
            }
        },
        classRuleSettings: {
            required: {required: !0},
            email: {email: !0},
            url: {url: !0},
            date: {date: !0},
            dateISO: {dateISO: !0},
            number: {number: !0},
            digits: {digits: !0},
            creditcard: {creditcard: !0}
        },
        addClassRules: function (e, n) {
            e.constructor === String ? this.classRuleSettings[e] = n : t.extend(this.classRuleSettings, e)
        },
        classRules: function (e) {
            var n = {}, i = t(e).attr("class");
            return i && t.each(i.split(" "), function () {
                this in t.validator.classRuleSettings && t.extend(n, t.validator.classRuleSettings[this])
            }), n
        },
        attributeRules: function (e) {
            var n = {}, i = t(e), r = i[0].getAttribute("type");
            for (var o in t.validator.methods) {
                var s;
                "required" === o ? (s = i.get(0).getAttribute(o), "" === s && (s = !0), s = !!s) : s = i.attr(o), /min|max/.test(o) && (null === r || /number|range|text/.test(r)) && (s = Number(s)), s ? n[o] = s : r === o && "range" !== r && (n[o] = !0)
            }
            return n.maxlength && /-1|2147483647|524288/.test(n.maxlength) && delete n.maxlength, n
        },
        dataRules: function (e) {
            var n, i, r = {}, o = t(e);
            for (n in t.validator.methods)i = o.data("rule-" + n.toLowerCase()), void 0 !== i && (r[n] = i);
            return r
        },
        staticRules: function (e) {
            var n = {}, i = t.data(e.form, "validator");
            return i.settings.rules && (n = t.validator.normalizeRule(i.settings.rules[e.name]) || {}), n
        },
        normalizeRules: function (e, n) {
            return t.each(e, function (i, r) {
                if (r === !1)return void delete e[i];
                if (r.param || r.depends) {
                    var o = !0;
                    switch (typeof r.depends) {
                        case"string":
                            o = !!t(r.depends, n.form).length;
                            break;
                        case"function":
                            o = r.depends.call(n, n)
                    }
                    o ? e[i] = void 0 !== r.param ? r.param : !0 : delete e[i]
                }
            }), t.each(e, function (i, r) {
                e[i] = t.isFunction(r) ? r(n) : r
            }), t.each(["minlength", "maxlength"], function () {
                e[this] && (e[this] = Number(e[this]))
            }), t.each(["rangelength", "range"], function () {
                var n;
                e[this] && (t.isArray(e[this]) ? e[this] = [Number(e[this][0]), Number(e[this][1])] : "string" == typeof e[this] && (n = e[this].split(/[\s,]+/), e[this] = [Number(n[0]), Number(n[1])]))
            }), t.validator.autoCreateRanges && (e.min && e.max && (e.range = [e.min, e.max], delete e.min, delete e.max), e.minlength && e.maxlength && (e.rangelength = [e.minlength, e.maxlength], delete e.minlength, delete e.maxlength)), e
        },
        normalizeRule: function (e) {
            if ("string" == typeof e) {
                var n = {};
                t.each(e.split(/\s/), function () {
                    n[this] = !0
                }), e = n
            }
            return e
        },
        addMethod: function (e, n, i) {
            t.validator.methods[e] = n, t.validator.messages[e] = void 0 !== i ? i : t.validator.messages[e], n.length < 3 && t.validator.addClassRules(e, t.validator.normalizeRule(e))
        },
        methods: {
            required: function (e, n, i) {
                if (!this.depend(i, n))return "dependency-mismatch";
                if ("select" === n.nodeName.toLowerCase()) {
                    var r = t(n).val();
                    return r && r.length > 0
                }
                return this.checkable(n) ? this.getLength(e, n) > 0 : t.trim(e).length > 0
            }, email: function (t, e) {
                return this.optional(e) || /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i.test(t)
            }, url: function (t, e) {
                return this.optional(e) || /^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(t)
            }, date: function (t, e) {
                return this.optional(e) || !/Invalid|NaN/.test(new Date(t).toString())
            }, dateISO: function (t, e) {
                return this.optional(e) || /^\d{4}[\/\-]\d{1,2}[\/\-]\d{1,2}$/.test(t)
            }, number: function (t, e) {
                return this.optional(e) || /^-?(?:\d+|\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(t)
            }, digits: function (t, e) {
                return this.optional(e) || /^\d+$/.test(t)
            }, creditcard: function (t, e) {
                if (this.optional(e))return "dependency-mismatch";
                if (/[^0-9 \-]+/.test(t))return !1;
                var n = 0, i = 0, r = !1;
                t = t.replace(/\D/g, "");
                for (var o = t.length - 1; o >= 0; o--) {
                    var s = t.charAt(o);
                    i = parseInt(s, 10), r && (i *= 2) > 9 && (i -= 9), n += i, r = !r
                }
                return n % 10 === 0
            }, minlength: function (e, n, i) {
                var r = t.isArray(e) ? e.length : this.getLength(t.trim(e), n);
                return this.optional(n) || r >= i
            }, maxlength: function (e, n, i) {
                var r = t.isArray(e) ? e.length : this.getLength(t.trim(e), n);
                return this.optional(n) || i >= r
            }, rangelength: function (e, n, i) {
                var r = t.isArray(e) ? e.length : this.getLength(t.trim(e), n);
                return this.optional(n) || r >= i[0] && r <= i[1]
            }, min: function (t, e, n) {
                return this.optional(e) || t >= n
            }, max: function (t, e, n) {
                return this.optional(e) || n >= t
            }, range: function (t, e, n) {
                return this.optional(e) || t >= n[0] && t <= n[1]
            }, equalTo: function (e, n, i) {
                var r = t(i);
                return this.settings.onfocusout && r.unbind(".validate-equalTo").bind("blur.validate-equalTo", function () {
                    t(n).valid()
                }), e === r.val()
            }, remote: function (e, n, i) {
                if (this.optional(n))return "dependency-mismatch";
                var r = this.previousValue(n);
                if (this.settings.messages[n.name] || (this.settings.messages[n.name] = {}), r.originalMessage = this.settings.messages[n.name].remote, this.settings.messages[n.name].remote = r.message, i = "string" == typeof i && {url: i} || i, r.old === e)return r.valid;
                r.old = e;
                var o = this;
                this.startRequest(n);
                var s = {};
                return s[n.name] = e, t.ajax(t.extend(!0, {
                    url: i,
                    mode: "abort",
                    port: "validate" + n.name,
                    dataType: "json",
                    data: s,
                    success: function (i) {
                        o.settings.messages[n.name].remote = r.originalMessage;
                        var s = i === !0 || "true" === i;
                        if (s) {
                            var a = o.formSubmitted;
                            o.prepareElement(n), o.formSubmitted = a, o.successList.push(n), delete o.invalid[n.name], o.showErrors()
                        } else {
                            var u = {}, l = i || o.defaultMessage(n, "remote");
                            u[n.name] = r.message = t.isFunction(l) ? l(e) : l, o.invalid[n.name] = !0, o.showErrors(u)
                        }
                        r.valid = s, o.stopRequest(n, s)
                    }
                }, i)), "pending"
            }
        }
    }), t.format = t.validator.format
}(jQuery), !function (t) {
    var e = {};
    if (t.ajaxPrefilter)t.ajaxPrefilter(function (t, n, i) {
        var r = t.port;
        "abort" === t.mode && (e[r] && e[r].abort(), e[r] = i)
    }); else {
        var n = t.ajax;
        t.ajax = function (i) {
            var r = ("mode" in i ? i : t.ajaxSettings).mode, o = ("port" in i ? i : t.ajaxSettings).port;
            return "abort" === r ? (e[o] && e[o].abort(), e[o] = n.apply(this, arguments), e[o]) : n.apply(this, arguments)
        }
    }
}(jQuery), !function (t) {
    t.extend(t.fn, {
        validateDelegate: function (e, n, i) {
            return this.bind(n, function (n) {
                var r = t(n.target);
                return r.is(e) ? i.apply(r, arguments) : void 0
            })
        }
    })
}(jQuery), function () {
    var t, e, n, i, r, o, s, a, u, l, c, d, h, p, f, m, g, v, y, b, w, C, x, S, T = [].slice, k = [].indexOf || function (t) {
            for (var e = 0, n = this.length; n > e; e++)if (e in this && this[e] === t)return e;
            return -1
        };
    t = window.jQuery || window.Zepto || window.$, t.payment = {}, t.payment.fn = {}, t.fn.payment = function () {
        var e, n;
        return n = arguments[0], e = 2 <= arguments.length ? T.call(arguments, 1) : [], t.payment.fn[n].apply(this, e)
    }, r = /(\d{1,4})/g, t.payment.cards = i = [{
        type: "visaelectron",
        patterns: [4026, 417500, 4405, 4508, 4844, 4913, 4917],
        format: r,
        length: [16],
        cvcLength: [3],
        luhn: !0
    }, {
        type: "maestro",
        patterns: [5018, 502, 503, 56, 58, 639, 6220, 67],
        format: r,
        length: [12, 13, 14, 15, 16, 17, 18, 19],
        cvcLength: [3],
        luhn: !0
    }, {
        type: "forbrugsforeningen",
        patterns: [600],
        format: r,
        length: [16],
        cvcLength: [3],
        luhn: !0
    }, {type: "dankort", patterns: [5019], format: r, length: [16], cvcLength: [3], luhn: !0}, {
        type: "visa",
        patterns: [4],
        format: r,
        length: [13, 16],
        cvcLength: [3],
        luhn: !0
    }, {
        type: "mastercard",
        patterns: [51, 52, 53, 54, 55, 22, 23, 24, 25, 26, 27],
        format: r,
        length: [16],
        cvcLength: [3],
        luhn: !0
    }, {
        type: "amex",
        patterns: [34, 37],
        format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
        length: [15],
        cvcLength: [3, 4],
        luhn: !0
    }, {
        type: "dinersclub",
        patterns: [30, 36, 38, 39],
        format: /(\d{1,4})(\d{1,6})?(\d{1,4})?/,
        length: [14],
        cvcLength: [3],
        luhn: !0
    }, {
        type: "discover",
        patterns: [60, 64, 65, 622],
        format: r,
        length: [16],
        cvcLength: [3],
        luhn: !0
    }, {
        type: "unionpay",
        patterns: [62, 88],
        format: r,
        length: [16, 17, 18, 19],
        cvcLength: [3],
        luhn: !1
    }, {type: "jcb", patterns: [35], format: r, length: [16], cvcLength: [3], luhn: !0}], e = function (t) {
        var e, n, r, o, s, a, u, l;
        for (t = (t + "").replace(/\D/g, ""), o = 0, a = i.length; a > o; o++)for (e = i[o], l = e.patterns, s = 0, u = l.length; u > s; s++)if (r = l[s], n = r + "", t.substr(0, n.length) === n)return e
    }, n = function (t) {
        var e, n, r;
        for (n = 0, r = i.length; r > n; n++)if (e = i[n], e.type === t)return e
    }, h = function (t) {
        var e, n, i, r, o, s;
        for (i = !0, r = 0, n = (t + "").split("").reverse(), o = 0, s = n.length; s > o; o++)e = n[o], e = parseInt(e, 10), (i = !i) && (e *= 2), e > 9 && (e -= 9), r += e;
        return r % 10 === 0
    }, d = function (t) {
        var e;
        return null != t.prop("selectionStart") && t.prop("selectionStart") !== t.prop("selectionEnd") ? !0 : null != ("undefined" != typeof document && null !== document && null != (e = document.selection) ? e.createRange : void 0) && document.selection.createRange().text ? !0 : !1
    }, x = function (t, e) {
        var n, i, r;
        try {
            n = e.prop("selectionStart")
        } catch (o) {
            i = o, n = null
        }
        return r = e.val(), e.val(t), null !== n && e.is(":focus") ? (n === r.length && (n = t.length), e.prop("selectionStart", n), e.prop("selectionEnd", n)) : void 0
    }, v = function (t) {
        var e, n, i, r, o, s, a, u;
        for (null == t && (t = ""), i = "\uff10\uff11\uff12\uff13\uff14\uff15\uff16\uff17\uff18\uff19", r = "0123456789", s = "", e = t.split(""), a = 0, u = e.length; u > a; a++)n = e[a], o = i.indexOf(n), o > -1 && (n = r[o]), s += n;
        return s
    }, g = function (e) {
        return setTimeout(function () {
            var n, i;
            return n = t(e.currentTarget), i = n.val(), i = v(i), i = i.replace(/\D/g, ""), x(i, n)
        })
    }, f = function (e) {
        return setTimeout(function () {
            var n, i;
            return n = t(e.currentTarget), i = n.val(), i = v(i), i = t.payment.formatCardNumber(i), x(i, n)
        })
    }, a = function (n) {
        var i, r, o, s, a, u, l;
        return o = String.fromCharCode(n.which), !/^\d+$/.test(o) || (i = t(n.currentTarget), l = i.val(), r = e(l + o), s = (l.replace(/\D/g, "") + o).length, u = 16, r && (u = r.length[r.length.length - 1]), s >= u || null != i.prop("selectionStart") && i.prop("selectionStart") !== l.length) ? void 0 : (a = r && "amex" === r.type ? /^(\d{4}|\d{4}\s\d{6})$/ : /(?:^|\s)(\d{4})$/, a.test(l) ? (n.preventDefault(), setTimeout(function () {
            return i.val(l + " " + o)
        })) : a.test(l + o) ? (n.preventDefault(), setTimeout(function () {
            return i.val(l + o + " ")
        })) : void 0)
    }, o = function (e) {
        var n, i;
        return n = t(e.currentTarget), i = n.val(), 8 !== e.which || null != n.prop("selectionStart") && n.prop("selectionStart") !== i.length ? void 0 : /\d\s$/.test(i) ? (e.preventDefault(), setTimeout(function () {
            return n.val(i.replace(/\d\s$/, ""))
        })) : /\s\d?$/.test(i) ? (e.preventDefault(), setTimeout(function () {
            return n.val(i.replace(/\d$/, ""))
        })) : void 0
    }, m = function (e) {
        return setTimeout(function () {
            var n, i;
            return n = t(e.currentTarget), i = n.val(), i = v(i), i = t.payment.formatExpiry(i), x(i, n)
        })
    }, u = function (e) {
        var n, i, r;
        return i = String.fromCharCode(e.which), /^\d+$/.test(i) ? (n = t(e.currentTarget), r = n.val() + i, /^\d$/.test(r) && "0" !== r && "1" !== r ? (e.preventDefault(), setTimeout(function () {
            return n.val("0" + r + " / ")
        })) : /^\d\d$/.test(r) ? (e.preventDefault(), setTimeout(function () {
            var t, e;
            return t = parseInt(r[0], 10), e = parseInt(r[1], 10), e > 2 && 0 !== t ? n.val("0" + t + " / " + e) : n.val("" + r + " / ")
        })) : void 0) : void 0
    }, l = function (e) {
        var n, i, r;
        return i = String.fromCharCode(e.which), /^\d+$/.test(i) ? (n = t(e.currentTarget), r = n.val(), /^\d\d$/.test(r) ? n.val("" + r + " / ") : void 0) : void 0
    }, c = function (e) {
        var n, i, r;
        return r = String.fromCharCode(e.which), "/" === r || " " === r ? (n = t(e.currentTarget), i = n.val(), /^\d$/.test(i) && "0" !== i ? n.val("0" + i + " / ") : void 0) : void 0
    }, s = function (e) {
        var n, i;
        return n = t(e.currentTarget), i = n.val(), 8 !== e.which || null != n.prop("selectionStart") && n.prop("selectionStart") !== i.length ? void 0 : /\d\s\/\s$/.test(i) ? (e.preventDefault(), setTimeout(function () {
            return n.val(i.replace(/\d\s\/\s$/, ""))
        })) : void 0
    }, p = function (e) {
        return setTimeout(function () {
            var n, i;
            return n = t(e.currentTarget), i = n.val(), i = v(i), i = i.replace(/\D/g, "").slice(0, 4), x(i, n)
        })
    }, C = function (t) {
        var e;
        return t.metaKey || t.ctrlKey ? !0 : 32 === t.which ? !1 : 0 === t.which ? !0 : t.which < 33 ? !0 : (e = String.fromCharCode(t.which), !!/[\d\s]/.test(e))
    }, b = function (n) {
        var i, r, o, s;
        return i = t(n.currentTarget), o = String.fromCharCode(n.which), /^\d+$/.test(o) && !d(i) ? (s = (i.val() + o).replace(/\D/g, ""), r = e(s), r ? s.length <= r.length[r.length.length - 1] : s.length <= 16) : void 0
    }, w = function (e) {
        var n, i, r;
        return n = t(e.currentTarget), i = String.fromCharCode(e.which), /^\d+$/.test(i) && !d(n) ? (r = n.val() + i, r = r.replace(/\D/g, ""), r.length > 6 ? !1 : void 0) : void 0
    }, y = function (e) {
        var n, i, r;
        return n = t(e.currentTarget), i = String.fromCharCode(e.which), /^\d+$/.test(i) && !d(n) ? (r = n.val() + i, r.length <= 4) : void 0
    }, S = function (e) {
        var n, r, o, s, a;
        return n = t(e.currentTarget), a = n.val(), s = t.payment.cardType(a) || "unknown", n.hasClass(s) ? void 0 : (r = function () {
            var t, e, n;
            for (n = [], t = 0, e = i.length; e > t; t++)o = i[t], n.push(o.type);
            return n
        }(), n.removeClass("unknown"), n.removeClass(r.join(" ")), n.addClass(s), n.toggleClass("identified", "unknown" !== s), n.trigger("payment.cardType", s))
    }, t.payment.fn.formatCardCVC = function () {
        return this.on("keypress", C), this.on("keypress", y), this.on("paste", p), this.on("change", p), this.on("input", p), this
    }, t.payment.fn.formatCardExpiry = function () {
        return this.on("keypress", C),
            this.on("keypress", w), this.on("keypress", u), this.on("keypress", c), this.on("keypress", l), this.on("keydown", s), this.on("change", m), this.on("input", m), this
    }, t.payment.fn.formatCardNumber = function () {
        return this.on("keypress", C), this.on("keypress", b), this.on("keypress", a), this.on("keydown", o), this.on("keyup", S), this.on("paste", f), this.on("change", f), this.on("input", f), this.on("input", S), this
    }, t.payment.fn.restrictNumeric = function () {
        return this.on("keypress", C), this.on("paste", g), this.on("change", g), this.on("input", g), this
    }, t.payment.fn.cardExpiryVal = function () {
        return t.payment.cardExpiryVal(t(this).val())
    }, t.payment.cardExpiryVal = function (t) {
        var e, n, i, r;
        return r = t.split(/[\s\/]+/, 2), e = r[0], i = r[1], 2 === (null != i ? i.length : void 0) && /^\d+$/.test(i) && (n = (new Date).getFullYear(), n = n.toString().slice(0, 2), i = n + i), e = parseInt(e, 10), i = parseInt(i, 10), {
            month: e,
            year: i
        }
    }, t.payment.validateCardNumber = function (t) {
        var n, i;
        return t = (t + "").replace(/\s+|-/g, ""), /^\d+$/.test(t) ? (n = e(t), n ? (i = t.length, k.call(n.length, i) >= 0 && (n.luhn === !1 || h(t))) : !1) : !1
    }, t.payment.validateCardExpiry = function (e, n) {
        var i, r, o;
        return "object" == typeof e && "month" in e && (o = e, e = o.month, n = o.year), e && n ? (e = t.trim(e), n = t.trim(n), /^\d+$/.test(e) && /^\d+$/.test(n) && e >= 1 && 12 >= e ? (2 === n.length && (n = 70 > n ? "20" + n : "19" + n), 4 !== n.length ? !1 : (r = new Date(n, e), i = new Date, r.setMonth(r.getMonth() - 1), r.setMonth(r.getMonth() + 1, 1), r > i)) : !1) : !1
    }, t.payment.validateCardCVC = function (e, i) {
        var r, o;
        return e = t.trim(e), /^\d+$/.test(e) ? (r = n(i), null != r ? (o = e.length, k.call(r.cvcLength, o) >= 0) : e.length >= 3 && e.length <= 4) : !1
    }, t.payment.cardType = function (t) {
        var n;
        return t ? (null != (n = e(t)) ? n.type : void 0) || null : null
    }, t.payment.formatCardNumber = function (n) {
        var i, r, o, s;
        return n = n.replace(/\D/g, ""), (i = e(n)) ? (o = i.length[i.length.length - 1], n = n.slice(0, o), i.format.global ? null != (s = n.match(i.format)) ? s.join(" ") : void 0 : (r = i.format.exec(n), null != r ? (r.shift(), r = t.grep(r, function (t) {
            return t
        }), r.join(" ")) : void 0)) : n
    }, t.payment.formatExpiry = function (t) {
        var e, n, i, r;
        return (n = t.match(/^\D*(\d{1,2})(\D+)?(\d{1,4})?/)) ? (e = n[1] || "", i = n[2] || "", r = n[3] || "", r.length > 0 ? i = " / " : " /" === i ? (e = e.substring(0, 1), i = "") : 2 === e.length || i.length > 0 ? i = " / " : 1 === e.length && "0" !== e && "1" !== e && (e = "0" + e, i = " / "), e + i + r) : ""
    }
}.call(this), !function (t) {
    "function" == typeof define && define.amd ? define(["jquery"], t) : t("object" == typeof exports ? require("jquery") : jQuery)
}(function (t) {
    var e, n = navigator.userAgent, i = /iphone/i.test(n), r = /chrome/i.test(n), o = /android/i.test(n);
    t.mask = {
        definitions: {9: "[0-9]", a: "[A-Za-z]", "*": "[A-Za-z0-9]"},
        autoclear: !0,
        dataName: "rawMaskFn",
        placeholder: "_"
    }, t.fn.extend({
        caret: function (t, e) {
            var n;
            return 0 === this.length || this.is(":hidden") ? void 0 : "number" == typeof t ? (e = "number" == typeof e ? e : t, this.each(function () {
                this.setSelectionRange ? this.setSelectionRange(t, e) : this.createTextRange && (n = this.createTextRange(), n.collapse(!0), n.moveEnd("character", e), n.moveStart("character", t), n.select())
            })) : (this[0].setSelectionRange ? (t = this[0].selectionStart, e = this[0].selectionEnd) : document.selection && document.selection.createRange && (n = document.selection.createRange(), t = 0 - n.duplicate().moveStart("character", -1e5), e = t + n.text.length), {
                begin: t,
                end: e
            })
        }, unmask: function () {
            return this.trigger("unmask")
        }, mask: function (n, s) {
            var a, u, l, c, d, h, p, f;
            if (!n && this.length > 0) {
                a = t(this[0]);
                var m = a.data(t.mask.dataName);
                return m ? m() : void 0
            }
            return s = t.extend({
                autoclear: t.mask.autoclear,
                placeholder: t.mask.placeholder,
                completed: null
            }, s), u = t.mask.definitions, l = [], c = p = n.length, d = null, t.each(n.split(""), function (t, e) {
                "?" == e ? (p--, c = t) : u[e] ? (l.push(new RegExp(u[e])), null === d && (d = l.length - 1), c > t && (h = l.length - 1)) : l.push(null)
            }), this.trigger("unmask").each(function () {
                function a() {
                    if (s.completed) {
                        for (var t = d; h >= t; t++)if (l[t] && _[t] === m(t))return;
                        s.completed.call($)
                    }
                }

                function m(t) {
                    return s.placeholder.charAt(t < s.placeholder.length ? t : 0)
                }

                function g(t) {
                    for (; ++t < p && !l[t];);
                    return t
                }

                function v(t) {
                    for (; --t >= 0 && !l[t];);
                    return t
                }

                function y(t, e) {
                    var n, i;
                    if (!(0 > t)) {
                        for (n = t, i = g(e); p > n; n++)if (l[n]) {
                            if (!(p > i && l[n].test(_[i])))break;
                            _[n] = _[i], _[i] = m(i), i = g(i)
                        }
                        k(), $.caret(Math.max(d, t))
                    }
                }

                function b(t) {
                    var e, n, i, r;
                    for (e = t, n = m(t); p > e; e++)if (l[e]) {
                        if (i = g(e), r = _[e], _[e] = n, !(p > i && l[i].test(r)))break;
                        n = r
                    }
                }

                function w() {
                    var t = $.val(), e = $.caret();
                    if (t.length < f.length) {
                        for (E(!0); e.begin > 0 && !l[e.begin - 1];)e.begin--;
                        if (0 === e.begin)for (; e.begin < d && !l[e.begin];)e.begin++;
                        $.caret(e.begin, e.begin)
                    } else {
                        for (E(!0); e.begin < p && !l[e.begin];)e.begin++;
                        $.caret(e.begin, e.begin)
                    }
                    a()
                }

                function C() {
                    E(), $.val() != j && $.change()
                }

                function x(t) {
                    if (!$.prop("readonly")) {
                        var e, n, r, o = t.which || t.keyCode;
                        f = $.val(), 8 === o || 46 === o || i && 127 === o ? (e = $.caret(), n = e.begin, r = e.end, r - n === 0 && (n = 46 !== o ? v(n) : r = g(n - 1), r = 46 === o ? g(r) : r), T(n, r), y(n, r - 1), t.preventDefault()) : 13 === o ? C.call(this, t) : 27 === o && ($.val(j), $.caret(0, E()), t.preventDefault())
                    }
                }

                function S(e) {
                    if (!$.prop("readonly")) {
                        var n, i, r, s = e.which || e.keyCode, u = $.caret();
                        if (!(e.ctrlKey || e.altKey || e.metaKey || 32 > s) && s && 13 !== s) {
                            if (u.end - u.begin !== 0 && (T(u.begin, u.end), y(u.begin, u.end - 1)), n = g(u.begin - 1), p > n && (i = String.fromCharCode(s), l[n].test(i))) {
                                if (b(n), _[n] = i, k(), r = g(n), o) {
                                    var c = function () {
                                        t.proxy(t.fn.caret, $, r)()
                                    };
                                    setTimeout(c, 0)
                                } else $.caret(r);
                                u.begin <= h && a()
                            }
                            e.preventDefault()
                        }
                    }
                }

                function T(t, e) {
                    var n;
                    for (n = t; e > n && p > n; n++)l[n] && (_[n] = m(n))
                }

                function k() {
                    $.val(_.join(""))
                }

                function E(t) {
                    var e, n, i, r = $.val(), o = -1;
                    for (e = 0, i = 0; p > e; e++)if (l[e]) {
                        for (_[e] = m(e); i++ < r.length;)if (n = r.charAt(i - 1), l[e].test(n)) {
                            _[e] = n, o = e;
                            break
                        }
                        if (i > r.length) {
                            T(e + 1, p);
                            break
                        }
                    } else _[e] === r.charAt(i) && i++, c > e && (o = e);
                    return t ? k() : c > o + 1 ? s.autoclear || _.join("") === F ? ($.val() && $.val(""), T(0, p)) : k() : (k(), $.val($.val().substring(0, o + 1))), c ? e : d
                }

                var $ = t(this), _ = t.map(n.split(""), function (t, e) {
                    return "?" != t ? u[t] ? m(e) : t : void 0
                }), F = _.join(""), j = $.val();
                $.data(t.mask.dataName, function () {
                    return t.map(_, function (t, e) {
                        return l[e] && t != m(e) ? t : null
                    }).join("")
                }), $.one("unmask", function () {
                    $.off(".mask").removeData(t.mask.dataName)
                }).on("focus.mask", function () {
                    if (!$.prop("readonly")) {
                        clearTimeout(e);
                        var t;
                        j = $.val(), t = E(), e = setTimeout(function () {
                            k(), t == n.replace("?", "").length ? $.caret(0, t) : $.caret(t)
                        }, 10)
                    }
                }).on("blur.mask", C).on("keydown.mask", x).on("keypress.mask", S).on("input.mask paste.mask", function () {
                    $.prop("readonly") || setTimeout(function () {
                        var t = E(!0);
                        $.caret(t), a()
                    }, 0)
                }), r && o && $.off("input.mask").on("input.mask", w), E()
            })
        }
    })
});
var Query = function (t) {
    "use strict";
    var e = function (t) {
        var e, n, i, r, o = [];
        if ("undefined" == typeof t || null === t || "" === t)return o;
        for (0 === t.indexOf("?") && (t = t.substring(1)), n = t.toString().split(/[&;]/), e = 0; e < n.length; e++)i = n[e], r = i.split("="), o.push([r[0], r[1]]);
        return o
    }, n = e(t), i = function () {
        var t, e, i = "";
        for (t = 0; t < n.length; t++)e = n[t], i.length > 0 && (i += "&"), i += e.join("=");
        return i.length > 0 ? "?" + i : i
    }, r = function (t) {
        return t = decodeURIComponent(t), t = t.replace("+", " ")
    }, o = function (t) {
        var e, i;
        for (i = 0; i < n.length; i++)if (e = n[i], r(t) === r(e[0]))return e[1]
    }, s = function (t) {
        var e, i, o = [];
        for (e = 0; e < n.length; e++)i = n[e], r(t) === r(i[0]) && o.push(i[1]);
        return o
    }, a = function (t, e) {
        var i, o, s, a, u = [];
        for (i = 0; i < n.length; i++)o = n[i], s = r(o[0]) === r(t), a = r(o[1]) === r(e), (1 === arguments.length && !s || 2 === arguments.length && !s && !a) && u.push(o);
        return n = u, this
    }, u = function (t, e, i) {
        return 3 === arguments.length && -1 !== i ? (i = Math.min(i, n.length), n.splice(i, 0, [t, e])) : arguments.length > 0 && n.push([t, e]), this
    }, l = function (t, e, i) {
        var o, s, l = -1;
        if (3 === arguments.length) {
            for (o = 0; o < n.length; o++)if (s = n[o], r(s[0]) === r(t) && decodeURIComponent(s[1]) === r(i)) {
                l = o;
                break
            }
            a(t, i).addParam(t, e, l)
        } else {
            for (o = 0; o < n.length; o++)if (s = n[o], r(s[0]) === r(t)) {
                l = o;
                break
            }
            a(t), u(t, e, l)
        }
        return this
    };
    return {getParamValue: o, getParamValues: s, deleteParam: a, addParam: u, replaceParam: l, toString: i}
}, Uri = function (t) {
    "use strict";
    var e = !1, n = function (t) {
        for (var n = {
            strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
            loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
        }, i = ["source", "protocol", "authority", "userInfo", "user", "password", "host", "port", "relative", "path", "directory", "file", "query", "anchor"], r = {
            name: "queryKey",
            parser: /(?:^|&)([^&=]*)=?([^&]*)/g
        }, o = n[e ? "strict" : "loose"].exec(t), s = {}, a = 14; a--;)s[i[a]] = o[a] || "";
        return s[r.name] = {}, s[i[12]].replace(r.parser, function (t, e, n) {
            e && (s[r.name][e] = n)
        }), s
    }, i = n(t || ""), r = new Query(i.query), o = function (t) {
        return "undefined" != typeof t && (i.protocol = t), i.protocol
    }, s = null, a = function (t) {
        return "undefined" != typeof t && (s = t), null === s ? -1 !== i.source.indexOf("//") : s
    }, u = function (t) {
        return "undefined" != typeof t && (i.userInfo = t), i.userInfo
    }, l = function (t) {
        return "undefined" != typeof t && (i.host = t), i.host
    }, c = function (t) {
        return "undefined" != typeof t && (i.port = t), i.port
    }, d = function (t) {
        return "undefined" != typeof t && (i.path = t), i.path
    }, h = function (t) {
        return "undefined" != typeof t && (r = new Query(t)), r
    }, p = function (t) {
        return "undefined" != typeof t && (i.anchor = t), i.anchor
    }, f = function (t) {
        return o(t), this
    }, m = function (t) {
        return a(t), this
    }, g = function (t) {
        return u(t), this
    }, v = function (t) {
        return l(t), this
    }, y = function (t) {
        return c(t), this
    }, b = function (t) {
        return d(t), this
    }, w = function (t) {
        return h(t), this
    }, C = function (t) {
        return p(t), this
    }, x = function (t) {
        return h().getParamValue(t)
    }, S = function (t) {
        return h().getParamValues(t)
    }, T = function (t, e) {
        return 2 === arguments.length ? h().deleteParam(t, e) : h().deleteParam(t), this
    }, k = function (t, e, n) {
        return 3 === arguments.length ? h().addParam(t, e, n) : h().addParam(t, e), this
    }, E = function (t, e, n) {
        return 3 === arguments.length ? h().replaceParam(t, e, n) : h().replaceParam(t, e), this
    }, $ = function () {
        var t = "", e = function (t) {
            return null !== t && "" !== t
        };
        return e(o()) ? (t += o(), o().indexOf(":") !== o().length - 1 && (t += ":"), t += "//") : a() && e(l()) && (t += "//"), e(u()) && e(l()) && (t += u(), u().indexOf("@") !== u().length - 1 && (t += "@")), e(l()) && (t += l(), e(c()) && (t += ":" + c())), e(d()) ? t += d() : e(l()) && (e(h().toString()) || e(p())) && (t += "/"), e(h().toString()) && (0 !== h().toString().indexOf("?") && (t += "?"), t += h().toString()), e(p()) && (0 !== p().indexOf("#") && (t += "#"), t += p()), t
    }, _ = function () {
        return new Uri($())
    };
    return {
        protocol: o,
        hasAuthorityPrefix: a,
        userInfo: u,
        host: l,
        port: c,
        path: d,
        query: h,
        anchor: p,
        setProtocol: f,
        setHasAuthorityPrefix: m,
        setUserInfo: g,
        setHost: v,
        setPort: y,
        setPath: b,
        setQuery: w,
        setAnchor: C,
        getQueryParamValue: x,
        getQueryParamValues: S,
        deleteQueryParam: T,
        addQueryParam: k,
        replaceQueryParam: E,
        toString: $,
        clone: _
    }
}, jsUri = Uri;
(function () {
    window.Spree = function () {
        function t() {
        }

        return t.ready = function (t) {
            return jQuery(document).ready(t)
        }, t.mountedAt = function () {
            return "/"
        }, t.pathFor = function (t) {
            var e;
            return e = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ":" + window.location.port : ""), "" + e + this.mountedAt() + t
        }, t.url = function (e, n) {
            return ("development" === t.env || "test" === t.env) && console.warn("Spree.url is deprecated, please use Spree.ajax for your request instead."), void 0 === e.path && (e = new Uri(e)), n && $.each(n, function (t, n) {
                return e.addQueryParam(t, n)
            }), e
        }, t.ajax = function (e, n) {
            return "object" == typeof e && (n = e, e = void 0), n = n || {}, n = $.extend(n, {headers: {"X-Spree-Token": t.api_key}}), $.ajax(e, n)
        }, t.routes = {
            states_search: t.pathFor("api/states"), apply_coupon_code: function (e) {
                return t.pathFor("api/orders/" + e + "/apply_coupon_code")
            }
        }, t.getJSON = function (t, e, n) {
            return "function" == typeof e && (n = e, e = void 0), this.ajax({
                dataType: "json",
                url: t,
                data: e,
                success: n
            })
        }, t
    }()
}).call(this), window.SolidusPaypalBraintree = {
    APPLE_PAY_API_VERSION: 1, fetchToken: function (t) {
        Spree.ajax({
            dataType: "json",
            type: "POST",
            url: Spree.pathFor("/spree/api/solidus_paypal_braintree/client_token"),
            success: function (e) {
                t(e.client_token, e.payment_method_id)
            },
            error: function (t) {
                console.error("Error fetching braintree token")
            }
        })
    }, initialize: function (t, e) {
        braintree.client.create({authorization: t}, function (t, n) {
            return t ? void console.error("Error creating client:", t) : void e(n)
        })
    }, setupApplePay: function (t, e, n) {
        if (window.ApplePaySession) {
            var i = ApplePaySession.canMakePaymentsWithActiveCard(e);
            i.then(function (e) {
                e && braintree.applePay.create({client: t}, function (t, e) {
                    return t ? void console.error("Error creating ApplePay:", t) : void n(e)
                })
            })
        }
    }, initializeApplePaySession: function (t, e, n, i) {
        var r = ["postalAddress", "phone"];
        Spree.current_email || r.push("email"), n.requiredShippingContactFields = r;
        var n = t.createPaymentRequest(n), o = new ApplePaySession(SolidusPaypalBraintree.APPLE_PAY_API_VERSION, n);
        o.onvalidatemerchant = function (n) {
            t.performValidation({validationURL: n.validationURL, displayName: e}, function (t, e) {
                return t ? (console.error("Error validating Apple Pay:", t), void o.abort()) : void o.completeMerchantValidation(e)
            })
        }, o.onpaymentauthorized = function (e) {
            t.tokenize({token: e.payment.token}, function (t, n) {
                t && (console.error("Error tokenizing Apple Pay:", t), o.completePayment(ApplePaySession.STATUS_FAILURE)), shipping_contact = e.payment.shippingContact, address_hash = {
                    country_code: shipping_contact.countryCode,
                    first_name: shipping_contact.givenName,
                    last_name: shipping_contact.familyName,
                    state_code: shipping_contact.administrativeArea,
                    city: shipping_contact.locality,
                    zip: shipping_contact.postalCode,
                    address_line_1: shipping_contact.addressLines[0]
                }, shipping_contact.addressLines.length > 1 && (address_hash.address_line_2 = shipping_contact.addressLines[1]), transaction_params = {
                    transaction: {
                        nonce: n.nonce,
                        phone: shipping_contact.phoneNumber,
                        email: Spree.current_email || shipping_contact.emailAddress,
                        payment_type: n.type,
                        address_attributes: address_hash
                    }, payment_method_id: Spree.braintreePaymentMethodId
                }, Spree.ajax({
                    data: transaction_params,
                    dataType: "json",
                    type: "POST",
                    url: Spree.pathFor("solidus_paypal_braintree/transactions"),
                    success: function (t) {
                        o.completePayment(ApplePaySession.STATUS_SUCCESS), window.location.replace(t.redirectUrl)
                    },
                    error: function (t) {
                        if (422 === t.status) {
                            var e = t.responseJSON.errors;
                            e && (e.Address || e.TransactionAddress) ? o.completePayment(ApplePaySession.STATUS_INVALID_SHIPPING_POSTAL_ADDRESS) : o.completePayment(ApplePaySession.STATUS_FAILURE)
                        }
                    }
                })
            })
        }, i(o), o.begin()
    }
};
var Mailcheck = {
    domainThreshold: 2,
    secondLevelThreshold: 2,
    topLevelThreshold: 2,
    defaultDomains: ["msn.com", "bellsouth.net", "telus.net", "comcast.net", "optusnet.com.au", "earthlink.net", "qq.com", "sky.com", "icloud.com", "mac.com", "sympatico.ca", "googlemail.com", "att.net", "xtra.co.nz", "web.de", "cox.net", "gmail.com", "ymail.com", "aim.com", "rogers.com", "verizon.net", "rocketmail.com", "google.com", "optonline.net", "sbcglobal.net", "aol.com", "me.com", "btinternet.com", "charter.net", "shaw.ca"],
    defaultSecondLevelDomains: ["yahoo", "hotmail", "mail", "live", "outlook", "gmx"],
    defaultTopLevelDomains: ["com", "com.au", "com.tw", "ca", "co.nz", "co.uk", "de", "fr", "it", "ru", "net", "org", "edu", "gov", "jp", "nl", "kr", "se", "eu", "ie", "co.il", "us", "at", "be", "dk", "hk", "es", "gr", "ch", "no", "cz", "in", "net", "net.au", "info", "biz", "mil", "co.jp", "sg", "hu"],
    run: function (t) {
        t.domains = t.domains || Mailcheck.defaultDomains, t.secondLevelDomains = t.secondLevelDomains || Mailcheck.defaultSecondLevelDomains, t.topLevelDomains = t.topLevelDomains || Mailcheck.defaultTopLevelDomains, t.distanceFunction = t.distanceFunction || Mailcheck.sift3Distance;
        var e = function (t) {
            return t
        }, n = t.suggested || e, i = t.empty || e, r = Mailcheck.suggest(Mailcheck.encodeEmail(t.email), t.domains, t.secondLevelDomains, t.topLevelDomains, t.distanceFunction);
        return r ? n(r) : i()
    },
    suggest: function (t, e, n, i, r) {
        t = t.toLowerCase();
        var o = this.splitEmail(t);
        if (n && i && -1 !== n.indexOf(o.secondLevelDomain) && -1 !== i.indexOf(o.topLevelDomain))return !1;
        var s = this.findClosestDomain(o.domain, e, r, this.domainThreshold);
        if (s)return s == o.domain ? !1 : {address: o.address, domain: s, full: o.address + "@" + s};
        var a = this.findClosestDomain(o.secondLevelDomain, n, r, this.secondLevelThreshold), u = this.findClosestDomain(o.topLevelDomain, i, r, this.topLevelThreshold);
        if (o.domain) {
            var s = o.domain, l = !1;
            if (a && a != o.secondLevelDomain && (s = s.replace(o.secondLevelDomain, a), l = !0), u && u != o.topLevelDomain && (s = s.replace(o.topLevelDomain, u), l = !0), 1 == l)return {
                address: o.address,
                domain: s,
                full: o.address + "@" + s
            }
        }
        return !1
    },
    findClosestDomain: function (t, e, n, i) {
        i = i || this.topLevelThreshold;
        var r, o = 99, s = null;
        if (!t || !e)return !1;
        n || (n = this.sift3Distance);
        for (var a = 0; a < e.length; a++) {
            if (t === e[a])return t;
            r = n(t, e[a]), o > r && (o = r, s = e[a])
        }
        return i >= o && null !== s ? s : !1
    },
    sift3Distance: function (t, e) {
        if (null == t || 0 === t.length)return null == e || 0 === e.length ? 0 : e.length;
        if (null == e || 0 === e.length)return t.length;
        for (var n = 0, i = 0, r = 0, o = 0, s = 5; n + i < t.length && n + r < e.length;) {
            if (t.charAt(n + i) == e.charAt(n + r))o++; else {
                i = 0, r = 0;
                for (var a = 0; s > a; a++) {
                    if (n + a < t.length && t.charAt(n + a) == e.charAt(n)) {
                        i = a;
                        break
                    }
                    if (n + a < e.length && t.charAt(n) == e.charAt(n + a)) {
                        r = a;
                        break
                    }
                }
            }
            n++
        }
        return (t.length + e.length) / 2 - o
    },
    splitEmail: function (t) {
        var e = t.trim().split("@");
        if (e.length < 2)return !1;
        for (var n = 0; n < e.length; n++)if ("" === e[n])return !1;
        var i = e.pop(), r = i.split("."), o = "", s = "";
        if (0 == r.length)return !1;
        if (1 == r.length)s = r[0]; else {
            o = r[0];
            for (var n = 1; n < r.length; n++)s += r[n] + ".";
            s = s.substring(0, s.length - 1)
        }
        return {topLevelDomain: s, secondLevelDomain: o, domain: i, address: e.join("@")}
    },
    encodeEmail: function (t) {
        var e = encodeURI(t);
        return e = e.replace("%20", " ").replace("%25", "%").replace("%5E", "^").replace("%60", "`").replace("%7B", "{").replace("%7C", "|").replace("%7D", "}")
    }
};
"undefined" != typeof module && module.exports && (module.exports = Mailcheck), "function" == typeof define && define.amd && define("mailcheck", [], function () {
    return Mailcheck
}), "undefined" != typeof window && window.jQuery && !function (t) {
    t.fn.mailcheck = function (t) {
        var e = this;
        if (t.suggested) {
            var n = t.suggested;
            t.suggested = function (t) {
                n(e, t)
            }
        }
        if (t.empty) {
            var i = t.empty;
            t.empty = function () {
                i.call(null, e)
            }
        }
        t.email = this.val(), Mailcheck.run(t)
    }
}(jQuery), function (t) {
    "use strict";
    var e = !1;
    if ("undefined" != typeof module && module.exports) {
        e = !0;
        var n = require("request")
    }
    var i = !1, r = !1;
    try {
        var o = new XMLHttpRequest;
        "undefined" != typeof o.withCredentials ? i = !0 : "XDomainRequest" in window && (i = !0, r = !0)
    } catch (s) {
    }
    var a = Array.prototype.indexOf, u = function (t, e) {
        var n = 0, i = t.length;
        if (a && t.indexOf === a)return t.indexOf(e);
        for (; i > n; n++)if (t[n] === e)return n;
        return -1
    }, l = function (t) {
        return this && this instanceof l ? ("string" == typeof t && (t = {key: t}), this.callback = t.callback, this.wanted = t.wanted || [], this.key = t.key, this.simpleSheet = !!t.simpleSheet, this.parseNumbers = !!t.parseNumbers, this.wait = !!t.wait, this.reverse = !!t.reverse, this.postProcess = t.postProcess, this.debug = !!t.debug, this.query = t.query || "", this.orderby = t.orderby, this.endpoint = t.endpoint || "https://spreadsheets.google.com", this.singleton = !!t.singleton, this.simple_url = !!t.simple_url, this.callbackContext = t.callbackContext, this.prettyColumnNames = "undefined" == typeof t.prettyColumnNames ? !0 : t.prettyColumnNames, "undefined" != typeof t.proxy && (this.endpoint = t.proxy.replace(/\/$/, ""), this.simple_url = !0, this.singleton = !0, i = !1), this.parameterize = t.parameterize || !1, this.singleton && ("undefined" != typeof l.singleton && this.log("WARNING! Tabletop singleton already defined"), l.singleton = this), /key=/.test(this.key) && (this.log("You passed an old Google Docs url as the key! Attempting to parse."), this.key = this.key.match("key=(.*?)(&|#|$)")[1]), /pubhtml/.test(this.key) && (this.log("You passed a new Google Spreadsheets url as the key! Attempting to parse."), this.key = this.key.match("d\\/(.*?)\\/pubhtml")[1]), this.key ? (this.log("Initializing with key " + this.key), this.models = {}, this.model_names = [], this.base_json_path = "/feeds/worksheets/" + this.key + "/public/basic?alt=", e || i ? this.base_json_path += "json" : this.base_json_path += "json-in-script", void(this.wait || this.fetch())) : void this.log("You need to pass Tabletop a key!")) : new l(t)
    };
    l.callbacks = {}, l.init = function (t) {
        return new l(t)
    }, l.sheets = function () {
        this.log("Times have changed! You'll want to use var tabletop = Tabletop.init(...); tabletop.sheets(...); instead of Tabletop.sheets(...)")
    }, l.prototype = {
        fetch: function (t) {
            "undefined" != typeof t && (this.callback = t), this.requestData(this.base_json_path, this.loadSheets)
        }, requestData: function (t, n) {
            if (e)this.serverSideFetch(t, n); else {
                var o = this.endpoint.split("//").shift() || "http";
                !i || r && o !== location.protocol ? this.injectScript(t, n) : this.xhrFetch(t, n)
            }
        }, xhrFetch: function (t, e) {
            var n = r ? new XDomainRequest : new XMLHttpRequest;
            n.open("GET", this.endpoint + t);
            var i = this;
            n.onload = function () {
                try {
                    var t = JSON.parse(n.responseText)
                } catch (r) {
                    console.error(r)
                }
                e.call(i, t)
            }, n.send()
        }, injectScript: function (t, e) {
            var n, i = document.createElement("script");
            if (this.singleton)e === this.loadSheets ? n = "Tabletop.singleton.loadSheets" : e === this.loadSheet && (n = "Tabletop.singleton.loadSheet"); else {
                var r = this;
                n = "tt" + +new Date + Math.floor(1e5 * Math.random()), l.callbacks[n] = function () {
                    var t = Array.prototype.slice.call(arguments, 0);
                    e.apply(r, t), i.parentNode.removeChild(i), delete l.callbacks[n]
                }, n = "Tabletop.callbacks." + n
            }
            var o = t + "&callback=" + n;
            this.simple_url ? -1 !== t.indexOf("/list/") ? i.src = this.endpoint + "/" + this.key + "-" + t.split("/")[4] : i.src = this.endpoint + "/" + this.key : i.src = this.endpoint + o, this.parameterize && (i.src = this.parameterize + encodeURIComponent(i.src)), document.getElementsByTagName("script")[0].parentNode.appendChild(i)
        }, serverSideFetch: function (t, e) {
            var i = this;
            n({url: this.endpoint + t, json: !0}, function (t, n, r) {
                return t ? console.error(t) : void e.call(i, r)
            })
        }, isWanted: function (t) {
            return 0 === this.wanted.length ? !0 : -1 !== u(this.wanted, t)
        }, data: function () {
            return 0 === this.model_names.length ? void 0 : this.simpleSheet ? (this.model_names.length > 1 && this.debug && this.log("WARNING You have more than one sheet but are using simple sheet mode! Don't blame me when something goes wrong."), this.models[this.model_names[0]].all()) : this.models
        }, addWanted: function (t) {
            -1 === u(this.wanted, t) && this.wanted.push(t)
        }, loadSheets: function (t) {
            var n, r, o = [];
            for (this.foundSheetNames = [], n = 0, r = t.feed.entry.length; r > n; n++)if (this.foundSheetNames.push(t.feed.entry[n].title.$t), this.isWanted(t.feed.entry[n].content.$t)) {
                var s = t.feed.entry[n].link.length - 1, a = t.feed.entry[n].link[s].href.split("/").pop(), u = "/feeds/list/" + this.key + "/" + a + "/public/values?alt=";
                u += e || i ? "json" : "json-in-script", this.query && (u += "&sq=" + this.query), this.orderby && (u += "&orderby=column:" + this.orderby.toLowerCase()), this.reverse && (u += "&reverse=true"), o.push(u)
            }
            for (this.sheetsToLoad = o.length, n = 0, r = o.length; r > n; n++)this.requestData(o[n], this.loadSheet)
        }, sheets: function (t) {
            return "undefined" == typeof t ? this.models : "undefined" == typeof this.models[t] ? void 0 : this.models[t]
        }, sheetReady: function (t) {
            this.models[t.name] = t, -1 === u(this.model_names, t.name) && this.model_names.push(t.name), this.sheetsToLoad--, 0 === this.sheetsToLoad && this.doCallback()
        }, loadSheet: function (t) {
            var e = this;
            new l.Model({
                data: t,
                parseNumbers: this.parseNumbers,
                postProcess: this.postProcess,
                tabletop: this,
                prettyColumnNames: this.prettyColumnNames,
                onReady: function () {
                    e.sheetReady(this)
                }
            })
        }, doCallback: function () {
            0 === this.sheetsToLoad && this.callback.apply(this.callbackContext || this, [this.data(), this])
        }, log: function (t) {
            this.debug && "undefined" != typeof console && "undefined" != typeof console.log && Function.prototype.apply.apply(console.log, [console, arguments])
        }
    }, l.Model = function (t) {
        var e, n, i, r;
        if (this.column_names = [], this.name = t.data.feed.title.$t, this.tabletop = t.tabletop, this.elements = [], this.onReady = t.onReady, this.raw = t.data, "undefined" == typeof t.data.feed.entry)return t.tabletop.log("Missing data for " + this.name + ", make sure you didn't forget column headers"), void(this.elements = []);
        for (var o in t.data.feed.entry[0])/^gsx/.test(o) && this.column_names.push(o.replace("gsx$", ""));
        for (this.original_columns = this.column_names, e = 0, i = t.data.feed.entry.length; i > e; e++) {
            for (var s = t.data.feed.entry[e], a = {}, n = 0, r = this.column_names.length; r > n; n++) {
                var u = s["gsx$" + this.column_names[n]];
                "undefined" != typeof u ? t.parseNumbers && "" !== u.$t && !isNaN(u.$t) ? a[this.column_names[n]] = +u.$t : a[this.column_names[n]] = u.$t : a[this.column_names[n]] = ""
            }
            void 0 === a.rowNumber && (a.rowNumber = e + 1), t.postProcess && t.postProcess(a), this.elements.push(a)
        }
        t.prettyColumnNames ? this.fetchPrettyColumns() : this.onReady.call(this)
    }, l.Model.prototype = {
        all: function () {
            return this.elements
        }, fetchPrettyColumns: function () {
            if (!this.raw.feed.link[3])return this.ready();
            var t = this.raw.feed.link[3].href.replace("/feeds/list/", "/feeds/cells/").replace("https://spreadsheets.google.com", ""), e = this;
            this.tabletop.requestData(t, function (t) {
                e.loadPrettyColumns(t)
            })
        }, ready: function () {
            this.onReady.call(this)
        }, loadPrettyColumns: function (t) {
            for (var e = {}, n = this.column_names, i = 0, r = n.length; r > i; i++)"undefined" != typeof t.feed.entry[i].content.$t ? e[n[i]] = t.feed.entry[i].content.$t : e[n[i]] = n[i];
            this.pretty_columns = e, this.prettifyElements(), this.ready()
        }, prettifyElements: function () {
            var t, e, n, i, r, o = [], r = [];
            for (e = 0, i = this.column_names.length; i > e; e++)r.push(this.pretty_columns[this.column_names[e]]);
            for (t = 0, n = this.elements.length; n > t; t++) {
                var s = {};
                for (e = 0, i = this.column_names.length; i > e; e++) {
                    var a = this.pretty_columns[this.column_names[e]];
                    s[a] = this.elements[t][this.column_names[e]]
                }
                o.push(s)
            }
            this.elements = o, this.column_names = r
        }, toArray: function () {
            var t, e, n, i, r = [];
            for (t = 0, n = this.elements.length; n > t; t++) {
                var o = [];
                for (e = 0, i = this.column_names.length; i > e; e++)o.push(this.elements[t][this.column_names[e]]);
                r.push(o)
            }
            return r
        }
    }, e ? module.exports = l : "function" == typeof define && define.amd ? define(function () {
        return l
    }) : t.Tabletop = l
}(this), function () {
    window.Alphabet = {
        Modules: {AlphabetMod: {}},
        Views: {AlphabetMod: {}, Checkout: {}}
    }, Spree.Checkout = {}, Spree.disableSaveOnClick = function () {
        return $("#update_cart").submit(function () {
            return $(this).find(":submit, :image").attr("disabled", !0).removeClass("primary").addClass("disabled")
        })
    }, $(document).ready(function () {
        return $(document).trigger("Alphabet:load")
    }), $(document).on("page:load", function () {
        return $(document).trigger("Alphabet:load")
    }), $(document).on("Alphabet:load", function () {
        return new Alphabet.Views.Initializer
    }), Spree.mountedAt = function () {
        return $('meta[name="locale-root"]').attr("content")
    }
}.call(this), function () {
    var t, e = [].indexOf || function (t) {
            for (var e = 0, n = this.length; n > e; e++)if (e in this && this[e] === t)return e;
            return -1
        };
    t = ["extended", "included"], Alphabet.Base = function () {
        function n() {
        }

        return n.extend = function (n) {
            var i, r, o;
            for (i in n)o = n[i], e.call(t, i) < 0 && (this[i] = o);
            return null != (r = n.extended) && r.apply(this), this
        }, n.include = function (n) {
            var i, r, o;
            for (i in n)o = n[i], e.call(t, i) < 0 && (this.prototype[i] = o);
            return null != (r = n.included) && r.apply(this), this
        }, n
    }()
}.call(this), function () {
    var t = function (t, e) {
        return function () {
            return t.apply(e, arguments)
        }
    }, e = function (t, e) {
        function i() {
            this.constructor = t
        }

        for (var r in e)n.call(e, r) && (t[r] = e[r]);
        return i.prototype = e.prototype, t.prototype = new i, t.__super__ = e.prototype, t
    }, n = {}.hasOwnProperty;
    Alphabet.Modules.Address = function (n) {
        function i() {
            return this.toggleCountry = t(this.toggleCountry, this), this.setCountryToggleInitialState = t(this.setCountryToggleInitialState, this), this.fetchAddressForm = t(this.fetchAddressForm, this), this.initZipMask = t(this.initZipMask, this), this.getCountryId = t(this.getCountryId, this), i.__super__.constructor.apply(this, arguments)
        }

        var r, o, s, a, u, l, c;
        return e(i, n), u = $("#js-shipping-form"), r = $(".js-form-fieldset-address"), l = ".js-form-field-state", c = ".js-form-field-zip", o = $(".js-checkout-button"), s = new CustomEvent("currency-changed", {detail: {}}), a = document.getElementById("order-summary-widget"), i.prototype.getCountryId = function () {
            return $("#js-form-toggle-locale").on("change", ".js-locale-input", function (t) {
                return function (e) {
                    var n, i;
                    return n = $(e.currentTarget), i = n.parents(".js-form-field-locale:first"), t.disableForm(), u.length ? $.post(Spree.pathFor("orders/country"), {country_id: n.val()}, function (e) {
                        return t.fetchAddressForm("shipping", n.val(), t.toggleCountry(i))
                    }) : t.fetchAddressForm("billing", n.val(), t.toggleCountry(i))
                }
            }(this))
        }, i.prototype.initPhoneMask = function () {
            return window.AlphabetShimPromise.then(function (t) {
                return function (t) {
                    return t.phoneValidator.init(".js-form-input-phone")
                }
            }(this))
        }, i.prototype.initZipMask = function () {
            return $(".js-form-input-zip--can").mask("a9a 9a9")
        }, i.prototype.fetchAddressForm = function (t, e, n) {
            var i, r, o, u;
            return null == n && (n = null), o = {}, "shipping" === t ? (u = ["#js-order-summary-table", l, c], i = "ship_address_attributes", r = "address") : (u = [l, c], i = "bill_address_attributes", r = "payment"), o[i] = {country_id: e}, s.detail.country_id = e, $.get(Spree.pathFor("checkout/" + r + ".html"), o, function (t) {
                return function (e) {
                    var i, r, o, l;
                    for (i = $(e).find("#js-form-checkout"), r = 0, o = u.length; o > r; r++)l = u[r], $(l).replaceWith(i.find(l));
                    return t.enableForm(), a.dispatchEvent(s), "function" == typeof n ? n() : void 0
                }
            }(this))
        }, i.prototype.setCountryToggleInitialState = function () {
            return $(".js-form-field-locale").each(function () {
                var t;
                return t = $(this).find("input:checked"), t.parents(".js-form-field-locale").addClass("is-selected")
            })
        }, i.prototype.toggleCountry = function (t) {
            return t.addClass("is-selected")
        }, i.prototype.enableForm = function () {
            return r.removeClass("is-disabled"), o.removeClass("is-disabled"), this.initZipMask()
        }, i.prototype.disableForm = function () {
            return r.addClass("is-disabled"), o.addClass("is-disabled"), $(".js-form-field-locale").removeClass("is-selected")
        }, i
    }(Alphabet.Base)
}.call(this), function () {
    var t = function (t, e) {
        return function () {
            return t.apply(e, arguments)
        }
    };
    Alphabet.Modules.Carousel = function () {
        function e(e) {
            this.options = e, this.setActiveSlide = t(this.setActiveSlide, this), this.setActiveThumb = t(this.setActiveThumb, this), this.mainImageSlideChangeHandler = t(this.mainImageSlideChangeHandler, this), this.prevSlide = t(this.prevSlide, this), this.nextSlide = t(this.nextSlide, this), this.goToSlide = t(this.goToSlide, this), this.initImageHandlers = t(this.initImageHandlers, this), this.index = 0, this.$slides = $(this.options.sectionName).find(this.options.slides), this.$tracker = $(this.options.sectionName).find(this.options.tracker), this.$mainSlide = $(this.options.sectionName).find(this.options.mainSlide), this.$next = $(this.options.sectionName).find(this.options.next), this.$prev = $(this.options.sectionName).find(this.options.prev), this.initImageHandlers()
        }

        return e.prototype.initImageHandlers = function () {
            var t, e;
            return this.setActiveThumb(this.$tracker.first()), this.setActiveSlide(this.$slides.first()), $(document).keydown(function (t) {
                return function (e) {
                    return 37 === e.keyCode && t.prevSlide(), 39 === e.keyCode ? t.nextSlide() : void 0
                }
            }(this)), this.$next.on("click", this.nextSlide), this.$prev.on("click", this.prevSlide), t = null, e = null, $(this.options.mainSlide).on("touchstart", function (n) {
                return t = n.originalEvent.touches[0].clientX, e = n.originalEvent.touches[0].clientY
            }), $(this.options.mainSlide).on("touchmove", function (n) {
                return function (i) {
                    var r, o, s, a;
                    if (t && e)return o = i.originalEvent.touches[0].clientX, a = i.originalEvent.touches[0].clientY, r = t - o, s = e - a, Math.abs(r) > Math.abs(s) && (r > 0 ? n.nextSlide() : n.prevSlide()), t = null, e = null
                }
            }(this)), $(window).resize(function (t) {
                return function () {
                    return t.goToSlide($(t.options.mainSlide), t.index)
                }
            }(this)), this.$tracker.on("click", function (t) {
                return function (e) {
                    return e.preventDefault(), t.index = t.$tracker.index(e.currentTarget), t.goToSlide($(t.options.mainSlide), t.index)
                }
            }(this))
        }, e.prototype.goToSlide = function (t, e) {
            var n, i;
            return n = this.$slides[0].offsetLeft, i = this.$slides[e].offsetLeft - n, t.css("transform", "translate3d(" + -i + "px, 0, 0)"), t.css("oTransform", "translate3d(" + -i + "px, 0, 0)"), t.css("msTransform", "translate3d(" + -i + "px, 0, 0)"), t.css("mozTransform", "translate3d(" + -i + "px, 0, 0)"), t.css("webkitTransform", "translate3d(" + -i + "px, 0, 0)"), this.mainImageSlideChangeHandler(this.index), this.$prev.show(), 0 === this.index ? this.$prev.hide() : void 0
        }, e.prototype.nextSlide = function () {
            return this.index < this.$slides.length - 1 ? this.index++ : this.index = 0, this.goToSlide($(this.options.mainSlide), this.index)
        }, e.prototype.prevSlide = function () {
            return this.index > 0 ? (this.index--, this.goToSlide($(this.options.mainSlide), this.index)) : void 0
        }, e.prototype.mainImageSlideChangeHandler = function (t) {
            var e, n;
            return n = this.$tracker.eq(t), this.setActiveThumb(n), e = this.$slides.eq(t), this.setActiveSlide(e)
        }, e.prototype.setActiveThumb = function (t) {
            return this.$tracker.removeClass(this.options.activeIdentifier), t.addClass(this.options.activeIdentifier)
        }, e.prototype.setActiveSlide = function (t) {
            return this.$slides.removeClass(this.options.activeIdentifier), t.addClass(this.options.activeIdentifier)
        }, e
    }()
}.call(this), jQuery.fn.outerHTML = function (t) {
    return t ? this.before(t).remove() : jQuery("<p>").append(this.eq(0).clone()).html()
}, function () {
    var t = function (t, e) {
        return function () {
            return t.apply(e, arguments)
        }
    }, e = function (t, e) {
        function i() {
            this.constructor = t
        }

        for (var r in e)n.call(e, r) && (t[r] = e[r]);
        return i.prototype = e.prototype, t.prototype = new i, t.__super__ = e.prototype, t
    }, n = {}.hasOwnProperty;
    Alphabet.Modules.Promo = function (n) {
        function i(e) {
            this.options = e, this.convertroTrackSource = t(this.convertroTrackSource, this), this.initPromoToggle = t(this.initPromoToggle, this), this.initAjaxSubmit = t(this.initAjaxSubmit, this), this.clearNotify = t(this.clearNotify, this), this.notifyEmpty = t(this.notifyEmpty, this), this.notifyError = t(this.notifyError, this), this.notifySuccess = t(this.notifySuccess, this), this.ajaxSubmit = t(this.ajaxSubmit, this), this.removePromos = t(this.removePromos, this),
                this.changePromoDisability = t(this.changePromoDisability, this), o.val(""), window.AlphabetShimPromise.then(function (t) {
                return function (e) {
                    return t.shim = e, a.data("ajaxSubmit") && t.initAjaxSubmit(), t.initPromoToggle()
                }
            }(this))
        }

        var r, o, s, a, u, l, c, d;
        return e(i, n), o = $(".js-form-input-promo"), a = $("#js-form-promo"), u = $(".js-form-field-apply-promo"), r = $("#js-btn-apply-promo"), d = $("#js-promo-toggle"), l = new CustomEvent("promotion-applied", {detail: {}}), c = new CustomEvent("promotion-removed", {detail: {}}), s = document.getElementById("order-summary-widget"), i.prototype.changePromoDisability = function (t, e) {
            return t ? (a.addClass("is-invisible"), Spree.current_order_promotion_count > 0 ? ($(e.currentTarget).parent().parent(".js-form-payment-method-affirm").find(".js-checkout-button").addClass("is-disabled").attr("disabled", !0), $(".affirm-coupon-codes").removeClass("is-invisible")) : void 0) : (a.removeClass("is-invisible"), $(".affirm-coupon-codes").addClass("is-invisible"), $("#checkout-submit-button").removeClass("is-disabled"))
        }, i.prototype.removePromos = function (t) {
            var e, n;
            return t.preventDefault(), e = a.data("source"), n = Spree.url(Spree.pathFor("api/orders/" + Spree.current_order_id + "/remove_promos.json"), {
                order_token: Spree.current_order_token,
                source: e
            }), Spree.ajax({
                dataType: "json", async: !1, method: "PATCH", url: n, success: function (t) {
                    return function (e) {
                        var n, i;
                        return i = e.success, t.notifySuccess(i), Spree.current_order_promotion_count = e.promotion_count, n = e.html, c.detail.promotionsRemovedCount = e.promotion_count, $("#js-order-summary-table").replaceWith(n), s.dispatchEvent(c), affirm.checkout.set("total", e.affirm_total), affirm.checkout.set("tax_amount", e.affirm_tax_amount), $(".affirm-coupon-codes").addClass("is-invisible"), $(".js-form-payment-method-affirm").find(".js-checkout-button").removeClass("is-disabled").attr("disabled", !1), !0
                    }
                }(this), error: function (t) {
                    var e, n;
                    return n = JSON.parse(t.responseText), e = n.error, this.notifyError(e), !1
                }
            })
        }, i.prototype.ajaxSubmit = function () {
            var t, e, n, i;
            return t = $.trim(o.val()), n = a.data("source"), e = $("#session_id").val(), r.addClass("is-loading"), "" === t ? void this.notifyEmpty() : (i = Spree.url(Spree.routes.apply_coupon_code(Spree.current_order_id)), Spree.ajax({
                dataType: "json",
                type: "PUT",
                url: i,
                data: {order_token: Spree.current_order_token, coupon_code: t, source: n, session_id: e},
                success: function (t) {
                    return function (e) {
                        var n, i;
                        return i = e.success, t.notifySuccess(i), Spree.current_order_promotion_count = e.promotion_count, n = e.html, $("#js-order-summary-table").replaceWith(n), o.val(""), $("#form-fieldset-promo").addClass("is-hidden"), l.detail.promotionCount = e.promotion_count, l.detail.couponCode = e.coupon_code, l.detail.source = e.source, s && s.dispatchEvent(l), t.convertroTrackSource(e.convertro_enabled, e.convertro_sources), r.removeClass("is-loading")
                    }
                }(this),
                error: function (t) {
                    return function (e, n, i) {
                        var o, s;
                        return s = e.responseJSON, o = s.error, t.notifyError(o), r.removeClass("is-loading")
                    }
                }(this)
            }))
        }, i.prototype.notifySuccess = function (t) {
            return this.clearNotify(), this.notify = new this.shim.Notify("#page-notify", {
                msg: t,
                type: "success"
            }), this.notify.init()
        }, i.prototype.notifyError = function (t) {
            return this.clearNotify(), this.notify = new this.shim.Notify("#page-notify", {
                msg: t,
                type: "error"
            }), this.notify.init()
        }, i.prototype.notifyEmpty = function () {
            return this.clearNotify(), this.notify = new this.shim.Notify("#page-notify", {
                msg: this.shim.translations.t.checkout.blank_promo_field,
                type: "error"
            }), this.notify.init()
        }, i.prototype.clearNotify = function () {
            return this.notify && !this.notify.isDestroyed() ? this.notify.destroy() : void 0
        }, i.prototype.initAjaxSubmit = function () {
            return r.click(function (t) {
                return function (e) {
                    return e.preventDefault(), t.ajaxSubmit()
                }
            }(this)), o.keypress(function (t) {
                return function (e) {
                    return 13 === (e.keyCode || e.which) ? (e.preventDefault(), t.ajaxSubmit()) : void 0
                }
            }(this)), !0
        }, i.prototype.initPromoToggle = function () {
            return d.one("click", function () {
                return d.addClass("is-invisible"), u.removeClass("is-invisible")
            })
        }, i.prototype.convertroTrackSource = function (t, e) {
            return t ? (void 0 === window.$CVO && (window.$CVO = []), window.$CVO.push(["trackSource", e])) : void 0
        }, i
    }(Alphabet.Base)
}.call(this), function () {
    Alphabet.Modules.Utils = function () {
        function t() {
        }

        return t.getParams = function () {
            var t, e, n, i, r, o, s, a, u;
            for (r = window.location.search.substring(1), o = r.split("&"), i = {}, t = 0, n = o.length; n > t; t++)a = o[t], s = a.split("="), e = s[0], u = s[1], i[e] = decodeURIComponent(u);
            return i
        }, t.trackUser = function (t) {
            var e;
            return e = this.djb2Hash(t), this.heapCall(e), void 0 === window.$CVO && (window.$CVO = []), window.$CVO.push(["trackUser", {id: e}])
        }, t.heapCall = function (t) {
            var e;
            return e = {integrations: {All: !1, Heap: !0}}, analytics.track("User Track", {user_id: t}, e)
        }, t.djb2Hash = function (t) {
            var e, n, i, r;
            for (n = 5381, r = Math.pow(2, 32), i = 0; i < t.length;)e = t.charCodeAt(i), n = (33 * n + e) % r, i++;
            return n
        }, t
    }()
}.call(this), function () {
    var t = function (t, e) {
        return function () {
            return t.apply(e, arguments)
        }
    }, e = function (t, e) {
        function i() {
            this.constructor = t
        }

        for (var r in e)n.call(e, r) && (t[r] = e[r]);
        return i.prototype = e.prototype, t.prototype = new i, t.__super__ = e.prototype, t
    }, n = {}.hasOwnProperty;
    Alphabet.Views.Amazon = function (n) {
        function i(e) {
            this.options = e, this.createContact = t(this.createContact, this), this.initPhoneMask = t(this.initPhoneMask, this), this.zipCodeValidator = t(this.zipCodeValidator, this), this.customValidation = t(this.customValidation, this), this.zipCodeValidator(), this.customValidation(), this.initPhoneMask(), this.createContact()
        }

        return e(i, n), i.prototype.customValidation = function () {
            return $(".js-amazon-salesforce-form").validate({
                rules: {state: {minlength: 2}},
                onfocusout: function (t, e) {
                    return t.value = t.value.trim()
                },
                errorPlacement: function (t, e) {
                    return e.prevAll("span.required").html(t)
                },
                showErrors: function (t, e) {
                    var n, i;
                    return this.defaultShowErrors(), n = $("label.error:visible").length, i = "Please review the " + n + " problem(s) below.", n >= 0 && this.notify && !this.notify.isDestroyed() && this.notify.destroy(), n > 0 ? window.AlphabetShimPromise.then(function (t) {
                        return function (e) {
                            return t.notify = new e.Notify("#page-notify", {msg: i, type: "error"}), t.notify.init()
                        }
                    }(this)) : void 0
                }
            })
        }, i.prototype.zipCodeValidator = function () {
            return jQuery.validator.addMethod("zipcodeUS", function (t, e) {
                return this.optional(e) || /\d{5}-\d{4}$|^\d{5}$/.test(t)
            }, "The specified US ZIP Code is invalid")
        }, i.prototype.initPhoneMask = function () {
            var t;
            return t = $(".js-amazon-phone-input"), t.mask("+1 (999) 999 - 9999")
        }, i.prototype.createContact = function () {
            var t;
            return t = $(".js-amazon-salesforce-form"), t.submit(function (e) {
                var n;
                return e.preventDefault(), n = {
                    origin: $("#00N34000005OOHx").val(),
                    campaign: $("#00N34000005ZjGu").val(),
                    source: $("#00N34000005GJkm").val(),
                    email: $("input[name=email]").val(),
                    locale: $("#00N34000005WYZH").val(),
                    firstname: $("#first_name").val(),
                    lastname: $("#last_name").val(),
                    phone: $("input[name=phone]").val(),
                    city: $("#city").val(),
                    state: $("#state_state_id").val(),
                    zip: $("#zip").val(),
                    mattress_size: $("#00N34000005GJkX").val(),
                    comments: "Amazon Comments: " + $("#00N34000005GJkh").val()
                }, $.ajax(Spree.pathFor("contacts"), {
                    type: "POST",
                    contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                    data: n,
                    success: function () {
                        return t.unbind("submit"), t.submit()
                    }
                })
            })
        }, i
    }(Alphabet.Base)
}.call(this), function () {
    var t = function (t, e) {
        return function () {
            return t.apply(e, arguments)
        }
    }, e = function (t, e) {
        function i() {
            this.constructor = t
        }

        for (var r in e)n.call(e, r) && (t[r] = e[r]);
        return i.prototype = e.prototype, t.prototype = new i, t.__super__ = e.prototype, t
    }, n = {}.hasOwnProperty, i = [].indexOf || function (t) {
            for (var e = 0, n = this.length; n > e; e++)if (e in this && this[e] === t)return e;
            return -1
        };
    Alphabet.Views.Checkout.Billing = function (n) {
        function r(e) {
            this.options = e, this.applyInlineSuccess = t(this.applyInlineSuccess, this), this.toggleValid = t(this.toggleValid, this), this.toggleAllCardFieldsValid = t(this.toggleAllCardFieldsValid, this), this.toggleCardCodeValid = t(this.toggleCardCodeValid, this), this.toggleCardDateValid = t(this.toggleCardDateValid, this), this.toggleCardNumberValid = t(this.toggleCardNumberValid, this), this.allCardFieldsValid = t(this.allCardFieldsValid, this), this.cardCodeValid = t(this.cardCodeValid, this), this.cardDateValid = t(this.cardDateValid, this), this.cardNumberValid = t(this.cardNumberValid, this), this.showPaymentMethods = t(this.showPaymentMethods, this), this.update_billing_form_state = t(this.update_billing_form_state, this), this.populateStripe = t(this.populateStripe, this), this.populateAffirm = t(this.populateAffirm, this), this.billAddressAttributes = t(this.billAddressAttributes, this), this.saveBillingAddress = t(this.saveBillingAddress, this), this.handleIosCardScanFields = t(this.handleIosCardScanFields, this), this.customValidation = t(this.customValidation, this), this.methodIsAffirm = t(this.methodIsAffirm, this), this.displayCardType = t(this.displayCardType, this), this.initPromoCodeForm = t(this.initPromoCodeForm, this), this.disableEnablePromo = t(this.disableEnablePromo, this), this.bindPaymentToggle = t(this.bindPaymentToggle, this), this.appendBillingAddressForm = t(this.appendBillingAddressForm, this), this.bindAffirmFailLoading = t(this.bindAffirmFailLoading, this), window.AlphabetShimPromise.then(function (t) {
                return function (e) {
                    return t.shim = e, t.showRatepayError(), t.initAdyenPayment()
                }
            }(this)), this.customValidation(), this.initCreditCardPayment(), this.initAffirmPayment(), this.initPhoneMask(), this.promoCodeForm = this.initPromoCodeForm(), this.getCountryId(), this.handleIosCardScanFields(), this.setCountryToggleInitialState(), this.bindPaymentExpanding(), this.bindPaymentToggle(), window.affirm && this.bindAffirmFailLoading(), $("#card_number").on("blur keyup", function (t) {
                return function (e) {
                    return t.displayCardType(e)
                }
            }(this)), $("#card_number").on("blur", function (t) {
                return function (e) {
                    return t.toggleCardNumberValid(e)
                }
            }(this)), $("#card_expiry").on("blur", function (t) {
                return function (e) {
                    return t.toggleCardDateValid(e)
                }
            }(this)), $("#card_code").on("blur", function (t) {
                return function (e) {
                    return t.toggleCardCodeValid(e)
                }
            }(this)), $(".js-card-field").on("keyup", function (t) {
                return function () {
                    return t.toggleSubmitEnabled()
                }
            }(this)), c.change(function (t) {
                return function () {
                    return t.update_billing_form_state(c.is(":checked"))
                }
            }(this)), this.update_billing_form_state(c.is(":checked")), $("#remove-promos-button").on("click", function (t) {
                return function (e) {
                    return t.promoCodeForm.removePromos(e)
                }
            }(this)), $(".js-payment-method-toggle").on("change", function (t) {
                return function (e) {
                    return t.disableEnablePromo(e)
                }
            }(this))
        }

        var o, s, a, u, l, c, d;
        return e(r, n), a = $("#js-form-input-card-number"), u = $("#js-card-type"), s = $("#js-form-billing"), o = ".js-fieldset-address", c = $("#order_use_shipping"), d = $("#checkout_form_payment"), l = $("#checkout-submit-button"), r.prototype.bindAffirmFailLoading = function () {
            return affirm.ui ? affirm.ui.ready(function () {
                return affirm.ui.error.on("close", function () {
                    return $(".js-checkout-button").removeClass("is-loading")
                })
            }) : void 0
        }, r.prototype.appendBillingAddressForm = function (t) {
            var e;
            if (!t.closest(".js-form-payment-method").hasClass("js-form-payment-method-adyen"))return e = $("#js-form-billing"), e.find(".js-checkout-button").attr("disabled", !1), t.closest(".js-form-payment-method").find(".js-form-payment-method-details").append(e)
        }, r.prototype.bindPaymentExpanding = function () {
            return $('input[type="radio"][name="order[payments_attributes][][payment_method_id]"]').click(function () {
                return $("#payment-methods li").removeClass("is-expanded"), $("#payment_method_" + this.value).addClass("is-expanded")
            })
        }, r.prototype.bindPaymentToggle = function () {
            return $(".js-payment-method-toggle").on("click", function (t) {
                return function (e) {
                    return t.appendBillingAddressForm($(e.currentTarget))
                }
            }(this))
        }, r.prototype.disableEnablePromo = function (t) {
            var e;
            return e = this.methodIsAffirm(), this.promoCodeForm.changePromoDisability(e, t)
        }, r.prototype.initPromoCodeForm = function () {
            return new Alphabet.Modules.Promo
        }, r.prototype.displayCardType = function (t) {
            var e, n;
            return n = $.payment.cardType($("#card_number").val()), e = $("#card_code"), null != n ? (u.html("" + n).removeClass("is-invisible"), null != n.match(/amex/) ? e.attr({
                maxlength: 4,
                minlength: 4
            }) : e.attr({maxlength: 3, minlength: 3})) : (u.addClass("is-invisible"), e.attr("minlength", 0))
        }, r.prototype.methodIsAffirm = function () {
            return $("input.js-form-input-affirm").is(":checked")
        }, r.prototype.customValidation = function () {
            return $.validator.setDefaults({
                errorClass: "has-errors", success: function (t) {
                    return $(t).closest("label").removeClass("has-errors")
                }, invalidHandler: function (t, e) {
                    return $.event.special.submit = {
                        handle: function (t) {
                            return t.stopImmediatePropagation(), $.event.special.submit = {}, !1
                        }
                    }
                }, showErrors: function (t, e) {
                    return window.AlphabetShimPromise.then(function (t) {
                        return function (e) {
                            var n, i;
                            return e.translations.fetch(), t.defaultShowErrors(), n = $("label.has-errors").length, i = e.translations.t.spree.review_errors, n >= 0 && t.notify && !t.notify.isDestroyed() && t.notify.destroy(), n > 0 ? (t.notify = new e.Notify("#page-notify", {
                                msg: i,
                                type: "error"
                            }), t.notify.init()) : void 0
                        }
                    }(this))
                }
            })
        }, r.prototype.handleIosCardScanFields = function () {
            return $("#cardExpirationMonth, #cardExpirationYear").change(function () {
                var t, e;
                return t = $("#cardExpirationMonth").val(), e = $("#cardExpirationYear").val(), $("#card_expiry").val(t + "/" + e)
            })
        }, r.prototype.saveBillingAddress = function (t) {
            var e;
            return e = !1, Spree.ajax({
                dataType: "json",
                async: !1,
                method: "PATCH",
                url: Spree.url(Spree.pathFor("checkout/update_billing_address")),
                data: $(t).serialize(),
                success: function (t) {
                    return e = !0
                },
                error: function (n) {
                    return e = !1, t.find("#checkout-submit-button").removeClass("is-loading")
                }
            }), e
        }, r.prototype.billAddressAttributes = function () {
            var t;
            return t = "#order_bill_address_attributes", {
                firstnameVal: $(t + "_firstname").val(),
                lastnameVal: $(t + "_lastname").val(),
                address1Val: $(t + "_address1").val(),
                address2Val: $(t + "_address2").val(),
                cityVal: $(t + "_city").val(),
                stateVal: $(t + "_state_id").find("option:selected").text(),
                countryVal: $(".form-field-locale.is-selected").find("#country_iso").val(),
                zipVal: $(t + "_zipcode").val()
            }
        }, r.prototype.populateAffirm = function (t) {
            var e;
            return e = this.billAddressAttributes(), t.is(":checked") ? (affirm.checkout.set("billing.name", affirm.checkout.get("shipping.name")), affirm.checkout.set("billing.address", affirm.checkout.get("shipping.address"))) : (affirm.checkout.set("billing.name", e.firstnameVal + " " + e.lastnameVal), affirm.checkout.set("billing.address", {
                line1: e.address1Val,
                line2: e.address2Val,
                city: e.cityVal,
                state: e.stateVal,
                country: e.countryVal,
                zipcode: e.zipVal
            }))
        }, r.prototype.populateStripe = function (t) {
            var e;
            return e = this.billAddressAttributes(), t.is(":checked") ? Spree.stripeAdditionalInfo = Spree.shippingInfo : Spree.stripeAdditionalInfo = {
                name: e.firstnameVal + " " + e.lastnameVal,
                address_line1: e.address1Val,
                address_line2: e.address2Val,
                address_city: e.cityVal,
                address_state: e.stateVal,
                address_country: e.countryVal,
                address_zip: e.zipVal
            }
        }, r.prototype.update_billing_form_state = function (t) {
            var e;
            return e = $(".js-form-fieldset-address"), t ? (e.addClass("is-invisible"), e.find("select, input").prop("disabled", !0)) : (e.removeClass("is-invisible"), e.find("select, input:not(.is-disabled)").prop("disabled", !1))
        }, r.prototype.replaceAttribute = function (t, e, n, i) {
            return t.attr(e).replace(n, i)
        }, r.prototype.initPaymentTemplate = function (t, e) {
            var n, i, r;
            return i = t.clone(!0), n = i.find(".js-payment-method-toggle-input"), r = n.val(), i.attr("class", this.replaceAttribute(i, "class", "adyen", e)), i.attr("id", this.replaceAttribute(i, "id", r, e)), n.attr("id", this.replaceAttribute(n, "id", r, e)), n.attr("value", this.replaceAttribute(n, "value", r, e)), i
        }, r.prototype.disableCreditCardFields = function (t) {
            return t.find(".js-form-fieldset-cc").find("input, select").attr("disabled", !0)
        }, r.prototype.enableCreditCardFields = function (t) {
            return t.find(".js-form-fieldset-cc").find("input, select").attr("disabled", !1)
        }, r.prototype.startPaymentMethodSpinner = function () {
            return $(".js-payment-methods-container").addClass("is-loading")
        }, r.prototype.showPaymentMethods = function () {
            return $(".js-payment-methods-container").removeClass("is-loading"), this.preselectPaymentMethod()
        }, r.prototype.preselectPaymentMethod = function () {
            var t, e;
            return t = $(".js-payment-method-toggle-input:checked"), t.length > 0 ? void t.click() : (e = $(".js-form-payment-method").filter(":visible"), 1 === e.length ? e.find(".js-payment-method-toggle-input").click() : void 0)
        }, r.prototype.reorderPaymentMethods = function () {
            var t, e, n, i, r, o, s, a;
            for (o = ["ratepay", "adyen_encrypted_cc", "directEbanking"], e = $(".js-payment-methods"), s = o.reverse(), a = [], n = 0, i = s.length; i > n; n++)r = s[n], t = $(".form-payment-method-" + r), a.push(e.prepend(t));
            return a
        }, r.prototype.hasRatepayError = function () {
            return window.location.search.indexOf("ratepayError=true") > 0
        }, r.prototype.showRatepayError = function () {
            return this.hasRatepayError() ? (this.shim.translations.fetch(), this.notify = new this.shim.Notify("#page-notify", {
                msg: this.shim.translations.t.checkout.billing.ratepay.unapproved_error,
                type: "error"
            }), this.notify.init()) : void 0
        }, r.prototype.initAdyenPayment = function () {
            var t, e, n, i, r, o;
            return this.shim.country.fetch(), i = this.shim.country.data.code, "US" === i || "CA" === i ? void this.showPaymentMethods() : (r = document.querySelector("#js-adyen-hpp-details")) ? (o = r.getAttribute("data-directory-url"), e = $(".js-payment-methods-container"), t = $(".js-payment-methods"), n = $(".js-form-payment-method-template"), this.startPaymentMethodSpinner(), $.getJSON(o, function (e) {
                return function (r) {
                    return window.AlphabetShimPromise.then(function (o) {
                        return o.translations.fetch(), $.each(r, function (r, s) {
                            var a, u;
                            if ("ratepay" !== s.brand_code || !e.hasRatepayError() && "CH" !== i)return a = e.initPaymentTemplate(n, s.brand_code), u = o.translations.t.checkout.billing.payment_methods[s.brand_code], u && (a.find(".form-label-copy").html(u.name), a.find(".js-form-payment-method-description").html(""), $(".js-" + s.brand_code).appendTo(a.find(".js-form-payment-method-description")), a.find(".js-btn").attr("href", s.payment_url), a.removeClass("form-payment-method-template js-form-payment-method-template"), t.append(a)), "ratepay" === s.brand_code ? e.initRatepay() : void 0
                        }), e.reorderPaymentMethods(), e.showPaymentMethods()
                    })
                }
            }(this)).fail(function (t) {
                return function () {
                    return t.showPaymentMethods()
                }
            }(this)), $("body").on("click", ".js-form-payment-method-adyen a", function (t) {
                return function (e) {
                    return t.saveBillingAddress(d)
                }
            }(this))) : void this.showPaymentMethods()
        }, r.prototype.initCreditCardPayment = function () {
            return $("#checkout_form_payment").is("*") ? ($(".js-form-input-card-number").payment("formatCardNumber"), $(".js-form-input-expiry").payment("formatCardExpiry"), $(".js-form-input-cvv").payment("formatCardCVC"), $(document).on("click", "#cvv_link", function (t) {
                var e, n;
                return e = "cvv_info", n = "left=20,top=20,width=500,height=500,toolbar=0,resizable=0,scrollbars=1", window.open($(this).attr("href"), e, n), t.preventDefault()
            }), l.click(function (t) {
                return function (e) {
                    return !t.methodIsAffirm() && Spree.stripeAdditionalInfo ? t.populateStripe(c) : void 0
                }
            }(this)), $("#checkout_form_payment").submit(function (t) {
                return function (e) {
                    return t.methodIsAffirm() ? void 0 : t.allCardFieldsValid() ? (l.addClass("is-loading"), t.saveBillingAddress(d)) : (t.toggleAllCardFieldsValid(), !1)
                }
            }(this))) : void 0
        }, r.prototype.initAffirmPayment = function () {
            return null != window.affirm && null != window.affirm.ui && window.affirm.ui.ready(function () {
                return $(".js-form-payment-method-affirm").removeClass("form-payment-method--loading")
            }), l.click(function (t) {
                return function (e) {
                    var n;
                    return n = $(e.currentTarget).parents(".js-form-payment-method-affirm").find(".js-form-fieldset-address"), t.methodIsAffirm() ? (l.addClass("is-loading"), t.disableCreditCardFields(d), t.saveBillingAddress(d), t.populateAffirm(c)) : void 0
                }
            }(this))
        }, r.prototype.initRatepay = function () {
            var t, e, n, r, o, s, a, u, l, c, d, h, p, f;
            return a = [8, 9, 37, 39], r = $("#js-adyen-hpp-details"), e = $(".js-date-of-birth"), t = $("#js-date-of-birth-day"), o = $("#js-date-of-birth-month"), s = $("#js-date-of-birth-year"), n = $("#js-date-of-birth-button"), c = n.attr("href"), h = function (t) {
                return function (t) {
                    var e;
                    if (t)return e = r.data().detailsUrl + "&brand_code=ratepay&dob=" + t, $.getJSON(e, function (t) {
                        return n.attr("href", t.url)
                    }).fail(function (t, e, n) {
                        return console.log("Error generating signed URL: " + n)
                    })
                }
            }(this), d = function (t) {
                return function (t) {
                    return t.removeClass("is-disabled")
                }
            }(this), l = function (t) {
                return function (t) {
                    return t.addClass("is-disabled")
                }
            }(this), u = function (t) {
                return function (t) {
                    var n;
                    if (t)return n = e[e.index(t) + 1], n ? n.focus() : void 0
                }
            }(this), f = function (t) {
                return function (t) {
                    return parseInt(t.val(), 10) <= parseInt(t.attr("data-max-valid"), 10)
                }
            }(this), p = function (t) {
                return function (t) {
                    return t.val().length === parseInt(t.attr("maxlength"), 10)
                }
            }(this), e.on("keydown", function (t) {
                return function (t) {
                    var e;
                    return (t.which < 48 || t.which > 57) && (e = t.which, i.call(a, e) < 0) ? !1 : void 0
                }
            }(this)), e.on("keyup", function (e) {
                return function (r) {
                    var c, m, g, v;
                    return c = $(r.target), c.val() && p(c) ? (g = f(c) && p(c), e.toggleValid(c, g), !g || (v = r.which, i.call(a, v) >= 0) || u(c), m = "" + t.val() + o.val() + s.val(), 8 === m.length ? (h(m), d(n)) : l(n)) : void l(n)
                }
            }(this)), e.on("blur", function (t) {
                return function (e) {
                    var n, i;
                    return n = $(e.target), i = f(n) && p(n), t.toggleValid(n, i)
                }
            }(this))
        }, r.prototype.cardNumberValid = function () {
            var t, e;
            return t = $("#card_number"), e = t.val(), $.payment.validateCardNumber(e)
        }, r.prototype.cardDateValid = function () {
            var t, e, n;
            return e = $("#card_expiry"), n = e.val(), t = $.payment.cardExpiryVal(n), $.payment.validateCardExpiry(t.month, t.year)
        }, r.prototype.cardCodeValid = function () {
            var t;
            return t = $("#card_code"), $.payment.validateCardCVC(t.val())
        }, r.prototype.allCardFieldsValid = function () {
            return this.cardNumberValid() && this.cardCodeValid() && this.cardDateValid()
        }, r.prototype.toggleCardNumberValid = function () {
            var t, e;
            return t = $("#card_number"), e = this.cardNumberValid(), this.toggleValid(t, e)
        }, r.prototype.toggleCardDateValid = function () {
            var t, e, n, i;
            return e = $("#card_expiry"), i = e.val(), t = $.payment.cardExpiryVal(i), n = this.cardDateValid(), this.toggleValid(e, n), n ? ($("#card-expiry-month").val(t.month), $("#card-expiry-year").val(t.year)) : void 0
        }, r.prototype.toggleCardCodeValid = function () {
            var t, e;
            return t = $("#card_code"), e = this.cardCodeValid(), this.toggleValid(t, e)
        }, r.prototype.toggleAllCardFieldsValid = function () {
            return this.toggleCardNumberValid(), this.toggleCardCodeValid(), this.toggleCardDateValid()
        }, r.prototype.toggleValid = function (t, e) {
            return e ? this.applyInlineSuccess(t) : this.applyInlineError(t)
        }, r.prototype.applyInlineSuccess = function (t) {
            return t.parent().find(".form-inline-error").remove(), t.removeClass("has-errors"), this.toggleSubmitEnabled()
        }, r.prototype.applyInlineError = function (t) {
            return window.AlphabetShimPromise.then(function (e) {
                return function (n) {
                    var i;
                    return n.translations.fetch(), i = $("<label class='error form-inline-error'>" + n.translations.t.spree.invalid + "</label>"), l = d.find("#checkout-submit-button"), t.parent().find(".form-inline-error").remove(), t.parent().append(i), t.addClass("has-errors"), e.toggleSubmitEnabled()
                }
            }(this))
        }, r.prototype.toggleSubmitEnabled = function () {
            return this.allCardFieldsValid() ? $("#checkout-submit-button").attr("disabled", !1) : $("#checkout-submit-button").attr("disabled", "disabled")
        }, r
    }(Alphabet.Modules.Address)
}.call(this), function () {
    var t = function (t, e) {
        return function () {
            return t.apply(e, arguments)
        }
    }, e = function (t, e) {
        function i() {
            this.constructor = t
        }

        for (var r in e)n.call(e, r) && (t[r] = e[r]);
        return i.prototype = e.prototype, t.prototype = new i, t.__super__ = e.prototype, t
    }, n = {}.hasOwnProperty;
    Alphabet.Views.Checkout.Cart = function (n) {
        function i(e) {
            this.options = e, this.convertroAddToCart = t(this.convertroAddToCart, this), this.convertroTrackSource = t(this.convertroTrackSource, this), this.initPromoCodeForm = t(this.initPromoCodeForm, this), $(".js-close-Alphabet-cart-modal").on("click", this.closeAlphabetCartModal), $(".js-form-input-promo").val(""), this.initSpreeCart(), this.initPromoCodeForm(), this.convertroTrackSource(), this.convertroAddToCart(), this.bindCheckout()
        }

        return e(i, n), i.prototype.initPromoCodeForm = function () {
            return new Alphabet.Modules.Promo
        }, i.prototype.closeAlphabetCartModal = function (t) {
            return t.preventDefault(), $("#Alphabet_cart_modal_wrapper").hide()
        }, i.prototype.initSpreeCart = function () {
            return $("form#update-cart .btn--delete").one("click", function () {
                return $(this).parents(".order-ledger-item").find(".form-input-quantity").val(0), $(this).parents("form").first().submit(), !1
            }), $("form#update-cart").submit(function () {
                return $("form#update-cart #update-button").attr("disabled", !0)
            })
        }, i.prototype.convertroTrackSource = function () {
            return this.options.convertroEnabled ? (window.$CVO = [], $CVO.push(["trackSource", this.options.convertroSources])) : void 0
        }, i.prototype.convertroAddToCart = function () {
            return this.options.orderId && this.isReferrerMattress() ? (void 0 === window.$CVO && (window.$CVO = []), window.$CVO.push(["trackEvent", {
                type: "add-to-cart",
                id: null,
                amount: "1"
            }])) : void 0
        }, i.prototype.isReferrerMattress = function () {
            var t, e;
            return t = ["/mattresses"], e = document.referrer.replace(/^[^:]+:\/\/[^\/]+/, "").replace(/#.*/, "").replace(/\?.*/, ""), t.indexOf(e) > -1
        }, i.prototype.bindCheckout = function () {
            return $(".form-cart").find(".js-checkout-button").click(function (t) {
                return $(this).addClass("is-loading")
            })
        }, i
    }(Alphabet.Base)
}.call(this), function () {
    var t = function (t, e) {
        return function () {
            return t.apply(e, arguments)
        }
    }, e = function (t, e) {
        function i() {
            this.constructor = t
        }

        for (var r in e)n.call(e, r) && (t[r] = e[r]);
        return i.prototype = e.prototype, t.prototype = new i, t.__super__ = e.prototype, t
    }, n = {}.hasOwnProperty;
    Alphabet.Views.Checkout.Delivery = function (n) {
        function i(e) {
            this.options = e, this.bindFormSubmit = t(this.bindFormSubmit, this), this.initPromoCodeForm = t(this.initPromoCodeForm, this), this.setupFormValidation = t(this.setupFormValidation, this), this.initSMSToggle = t(this.initSMSToggle, this), this.initPromoCodeForm(), this.initSMSToggle(this.options.phone), this.initPhoneMask(), this.bindCheckout(), this.setupFormValidation(), this.bindFormSubmit()
        }

        return e(i, n), i.prototype.initPhoneMask = function () {
            return window.AlphabetShimPromise.then(function (t) {
                return function (t) {
                    return t.phoneValidator.init(".js-form-input-sms-number")
                }
            }(this))
        }, i.prototype.initSMSToggle = function (t) {
            return t && !$(".js-form-input-sms-number").val() && $(".js-form-input-sms-number").val(t), $("#order_send_text_message_alerts").on("change", function (t) {
                return this.checked ? $(".js-form-field-sms-number").removeClass("is-invisible") : $(".js-form-field-sms-number").addClass("is-invisible")
            })
        }, i.prototype.bindCheckout = function () {
            return $(".js-checkout-button").click(function (t) {
                return $("#checkout_form_delivery").valid() ? $(this).addClass("is-loading") : void 0
            })
        }, i.prototype.setupFormValidation = function () {
            return window.AlphabetShimPromise.then(function (t) {
                return function (t) {
                    return t.translations.fetch(), $.validator.messages.required = t.translations.t.spree.choose_courier_timeslot, $("#checkout_form_delivery").validate({
                        errorPlacement: function (t, e) {
                            return t.insertBefore(e.parents(".courier-timeslot-picker")), $("html, body").animate({scrollTop: $(".js-tab-header").offset().top}, 300)
                        }
                    })
                }
            }(this))
        }, i.prototype.initPromoCodeForm = function () {
            return new Alphabet.Modules.Promo
        }, i.prototype.bindFormSubmit = function () {
            return $("#checkout_form_delivery").on("submit", function (t) {
                return function () {
                    var t, e, n;
                    return e = $(".parcel-tabpanel").hasClass("is-active") ? "UPS" : "Courier", "UPS" === e ? (t = $(".js-form-input-sms").prop("checked"), n = $(".js-form-input-signature").prop("checked")) : (t = !1, n = !1), analytics.track("Completed Checkout Step", {
                        step: 2,
                        shippingMethod: e,
                        signatureRequired: n,
                        sendTextMessageAlerts: t
                    })
                }
            }(this))
        }, i
    }(Alphabet.Base)
}.call(this), function () {
    var t = function (t, e) {
        return function () {
            return t.apply(e, arguments)
        }
    }, e = function (t, e) {
        function i() {
            this.constructor = t
        }

        for (var r in e)n.call(e, r) && (t[r] = e[r]);
        return i.prototype = e.prototype, t.prototype = new i, t.__super__ = e.prototype, t
    }, n = {}.hasOwnProperty;
    Alphabet.Views.Checkout.Shipping = function (n) {
        function i(e) {
            this.options = e, this.bindUnrecognizedAddressButton = t(this.bindUnrecognizedAddressButton, this), this.bindAddressVerificationButton = t(this.bindAddressVerificationButton, this), this.completedCheckoutStepTrack = t(this.completedCheckoutStepTrack, this), this.initPromoCodeForm = t(this.initPromoCodeForm, this), this.bindShipAddressVerification = t(this.bindShipAddressVerification, this), this.validateButtonCheck = t(this.validateButtonCheck, this), this.initEuroSMSPhoneMask = t(this.initEuroSMSPhoneMask, this), this.bindEuroSMSToggle = t(this.bindEuroSMSToggle, this), this.bindEuroSMSKeyTracking = t(this.bindEuroSMSKeyTracking, this), this.customValidation = t(this.customValidation, this), this.customValidation(), this.initPhoneMask(), this.initPromoCodeForm(), this.getCountryId(), this.initZipMask(), this.bindEuroSMSToggle(), this.bindEuroSMSKeyTracking(), this.initEuroSMSPhoneMask(), this.bindShipAddressVerification(), this.setCountryToggleInitialState(), $("#checkout_form_address").validate()
        }

        return e(i, n), i.prototype.customValidation = function () {
            return $.validator.setDefaults({
                errorClass: "has-errors", invalidHandler: function (t) {
                    return function (e, n) {
                        return $("#order_ship_address_attributes_state_id").on("change", function () {
                            return t.validateButtonCheck($(e.currentTarget))
                        })
                    }
                }(this), onfocusout: function (t, e) {
                    return t.value = t.value.trim()
                }, onkeyup: function (t) {
                    return function (e, n) {
                        return t.validateButtonCheck($(n.currentTarget))
                    }
                }(this), success: function (t) {
                    return $(t).closest("label").removeClass("has-errors")
                }, showErrors: function (t, e) {
                    return window.AlphabetShimPromise.then(function (t) {
                        return function (e) {
                            var n, i;
                            return e.translations.fetch(), t.defaultShowErrors(), n = $("label.has-errors").length, i = e.translations.t.spree.review_errors, n >= 0 && t.notify && !t.notify.isDestroyed() && t.notify.destroy(), n > 0 ? (t.notify = new e.Notify("#page-notify", {
                                msg: i,
                                type: "error"
                            }), t.notify.init()) : void 0
                        }
                    }(this))
                }
            })
        }, i.prototype.bindEuroSMSKeyTracking = function () {
            return $(".js-form-input-sms-number-eu").keydown(function () {
                return $(this).attr("data-edited", "true")
            })
        }, i.prototype.bindEuroSMSToggle = function () {
            return $(".js-sms-alert-toggle").change(function () {
                return $(".js-form-field-sms-number-eu").toggleClass("is-invisible", !$(this).prop("checked")), $(".js-form-input-sms-number-eu").toggleClass("required", $(this).prop("checked")), "" === $(".js-form-input-sms-number-eu").attr("data-initial-value") && "true" !== $(".js-form-input-sms-number-eu").attr("data-edited") ? $(".js-form-input-sms-number-eu").val($(".js-form-input-phone").val()) : void 0
            })
        }, i.prototype.initEuroSMSPhoneMask = function () {
            return 0 !== $(".js-form-input-sms-number-eu").length ? window.AlphabetShimPromise.then(function (t) {
                return function (t) {
                    return t.phoneValidator.init(".js-form-input-sms-number-eu")
                }
            }(this)) : void 0
        }, i.prototype.validateButtonCheck = function (t) {
            var e;
            return e = t.find("#checkout-submit-button"), e.is(":disabled") && t.valid() ? e.removeAttr("disabled") : void 0
        }, i.prototype.bindShipAddressVerification = function () {
            return window.enable_address_verification ? $("#checkout_form_address").submit(function (t) {
                return function (e) {
                    var n, i, r;
                    return e.preventDefault(), n = $(e.currentTarget), r = n.find("#checkout-submit-button"), i = "is-loading", n.valid() ? t.submitting ? void 0 : (t.submitting = !0, Spree.ajax({
                        dataType: "json",
                        url: n.attr("action") + ".js",
                        type: n.find("[name='_method']").val(),
                        data: n.serialize(),
                        beforeSend: function () {
                            return r.addClass(i)
                        },
                        complete: function () {
                            return r.hasClass(i) ? r.removeClass(i) : void 0
                        },
                        success: function (e) {
                            var i;
                            return "err" === e.status ? ($("html,body").animate({scrollTop: 0}, 600), new Alphabet.Modules.AlphabetMod.Modal({
                                $el: null,
                                classes: "address-suggestion-dialog",
                                $alert: {message: e.html, requireConfirmation: !1}
                            }), i = function () {
                                return $(".address-suggestion").removeClass("checked"), $(".address-suggestion input:checked").parents(".address-suggestion").first().addClass("checked")
                            }, $(".address-suggestion input").change(i), t.bindAddressVerificationButton(), t.bindUnrecognizedAddressButton(), i()) : "invalid" !== e.status && e.redirect_path ? (t.completedCheckoutStepTrack(), window.location = e.redirect_path) : "invalid" === e.status && n.get(0).submit(), t.submitting = !1
                        },
                        error: function (e) {
                            var n;
                            return t.submitting = !1, n = $.parseJSON(e.responseText), n.redirect_path ? window.location = n.redirect_path : r.hasClass(i) ? r.removeClass(i) : void 0
                        }
                    })) : (r.attr("disabled", "disabled"), !1)
                }
            }(this)) : void 0
        }, i.prototype.initPromoCodeForm = function () {
            return new Alphabet.Modules.Promo
        }, i.prototype.completedCheckoutStepTrack = function () {
            return analytics.track("Completed Checkout Step", {step: 1})
        }, i.prototype.bindAddressVerificationButton = function () {
            return $(".js-address-verification-button").on("click", function (t) {
                return function (e) {
                    var n;
                    return e.preventDefault(), n = $(e.currentTarget), $(".js-address-selection-input").val(n.attr("data-selection")), $(".js-ship-address-verification-form").submit(), t.completedCheckoutStepTrack()
                }
            }(this))
        }, i.prototype.bindUnrecognizedAddressButton = function () {
            return $(".js-unrecognized-address-continue").on("click", function (t) {
                return function (e) {
                    return t.completedCheckoutStepTrack()
                }
            }(this))
        }, i
    }(Alphabet.Modules.Address)
}.call(this), function () {
    var t = function (t, e) {
        return function () {
            return t.apply(e, arguments)
        }
    }, e = function (t, e) {
        function i() {
            this.constructor = t
        }

        for (var r in e)n.call(e, r) && (t[r] = e[r]);
        return i.prototype = e.prototype,
            t.prototype = new i, t.__super__ = e.prototype, t
    }, n = {}.hasOwnProperty;
    Alphabet.Views.Checkout.CustomerReturnsShow = function (n) {
        function i() {
            this.allLabelsPresent = t(this.allLabelsPresent, this), this.pollRMADetails = t(this.pollRMADetails, this), this.pollRMADetails(), window.rmaPollInterval = setInterval(this.pollRMADetails, 3e3)
        }

        return e(i, n), i.prototype.pollRMADetails = function () {
            return $.get(Spree.pathFor("shipments/" + window.rmaShipmentNumber + "/returns/" + window.rmaNumber + "/details"), function (t) {
                return function (e) {
                    var n, i, r, o, s, a;
                    for (s = e.return_authorization, o = s.shipments, i = 0, r = o.length; r > i; i++)a = o[i], n = $(".js-rma-packing-slip-link.is-loading[data-shipment-id='" + a.id + "']"), n.length && a.packing_slip_url && "" !== a.packing_slip_url ? (n.attr("href", a.packing_slip_url).removeClass("is-loading"), n.parents(".js-rma-shipment-well").addClass("packing-slip-loaded").removeClass("not-loaded")) : n.parents(".js-rma-shipment-well").removeClass("packing-slip-loaded").addClass("not-loaded");
                    return window.rmaPollInterval && t.allLabelsPresent(s) ? clearInterval(window.rmaPollInterval) : void 0
                }
            }(this))
        }, i.prototype.allLabelsPresent = function (t) {
            var e, n, i, r;
            for (i = t.shipments, e = 0, n = i.length; n > e; e++)if (r = i[e], !r.packing_slip_url || "" === r.packing_slip_url)return !1;
            return !0
        }, i
    }(Alphabet.Modules.Address)
}.call(this), function () {
    var t = function (t, e) {
        return function () {
            return t.apply(e, arguments)
        }
    }, e = function (t, e) {
        function i() {
            this.constructor = t
        }

        for (var r in e)n.call(e, r) && (t[r] = e[r]);
        return i.prototype = e.prototype, t.prototype = new i, t.__super__ = e.prototype, t
    }, n = {}.hasOwnProperty;
    Alphabet.Views.Initializer = function (n) {
        function i() {
            this.initPhoneMenuClick = t(this.initPhoneMenuClick, this), this.initCustomEasings = t(this.initCustomEasings, this), this.destroyHoverCssForTouch = t(this.destroyHoverCssForTouch, this), this.initSmoothScroll = t(this.initSmoothScroll, this), this.initSmoothScroll(), this.destroyHoverCssForTouch(), this.initMiniCart(), this.initCustomEasings(), this.initPhoneMenuClick(), this.identifyByRecipientEmail()
        }

        return e(i, n), i.prototype.initSmoothScroll = function () {
            var t;
            return t = 50, $("a[href*=#]:not([href=#])").on("click", function (e) {
                var n;
                return location.pathname.replace(/^\//, "") === this.pathname.replace(/^\//, "") && location.hostname === this.hostname && (n = $(this.hash), n = n.length ? n : $("[name=" + this.hash.slice(1) + "]"), n.length) ? (e.preventDefault(), $("html,body").animate({scrollTop: n.offset().top - t}, 1e3)) : void 0
            })
        }, i.prototype.destroyHoverCssForTouch = function () {
            var t, e, n, i, r, o, s, a, u, l, c, d;
            if ($("html").hasClass("touch")) {
                i = /:hover\b/;
                try {
                    for (a = document.styleSheets, l = [], t = 0, o = a.length; o > t; t++) {
                        for (d = a[t], n = [], u = d.cssRules, e = r = 0, s = u.length; s > r; e = ++r)c = u[e], c.type === CSSRule.STYLE_RULE && i.test(c.selectorText) && n.unshift(e);
                        l.push(function () {
                            var t, i, r;
                            for (r = [], t = 0, i = n.length; i > t; t++)e = n[t], r.push(d.deleteRule(e));
                            return r
                        }())
                    }
                    return l
                } catch (h) {
                }
            }
        }, i.prototype.initCustomEasings = function () {
            return $.extend($.easing, {
                easeInQuad: function (t, e, n, i, r) {
                    return i * (e /= r) * e + n
                }, easeOutQuad: function (t, e, n, i, r) {
                    return -i * (e /= r) * (e - 2) + n
                }, easeInOutQuad: function (t, e, n, i, r) {
                    return (e /= r / 2) < 1 ? i / 2 * e * e + n : -i / 2 * (--e * (e - 2) - 1) + n
                }, easeInCubic: function (t, e, n, i, r) {
                    return i * (e /= r) * e * e + n
                }, easeOutCubic: function (t, e, n, i, r) {
                    return i * ((e = e / r - 1) * e * e + 1) + n
                }, easeInOutCubic: function (t, e, n, i, r) {
                    return (e /= r / 2) < 1 ? i / 2 * e * e * e + n : i / 2 * ((e -= 2) * e * e + 2) + n
                }
            })
        }, i.prototype.initMiniCart = function () {
            return window.miniCart || (window.miniCart = new Alphabet.Views.MiniCart)
        }, i.prototype.initPhoneMenuClick = function () {
            return $("div.menu-link").click(function () {
                return window.location = $(this).find("a").attr("href"), !1
            })
        }, i.prototype.identifyByRecipientEmail = function () {
            var t;
            return (t = Alphabet.Modules.Utils.getParams().recipient_email) ? Alphabet.Modules.Utils.trackUser(t) : void 0
        }, i
    }(Alphabet.Base)
}.call(this), function () {
    var t = function (t, e) {
        return function () {
            return t.apply(e, arguments)
        }
    }, e = function (t, e) {
        function i() {
            this.constructor = t
        }

        for (var r in e)n.call(e, r) && (t[r] = e[r]);
        return i.prototype = e.prototype, t.prototype = new i, t.__super__ = e.prototype, t
    }, n = {}.hasOwnProperty;
    Alphabet.Views.Numbers = function (n) {
        function i(e) {
            this.options = e, this.setBackground = t(this.setBackground, this), this.scrollNumbersArrow = t(this.scrollNumbersArrow, this), this.scroll = t(this.scroll, this), this.initScroll = t(this.initScroll, this), this.initCounter = t(this.initCounter, this), this.resize = t(this.resize, this), this.initResize = t(this.initResize, this), this.initReport = t(this.initReport, this), this.nightsSlept = this.options.nights_slept, this.initReport(), this.initCounter(this.options.increase_interval), this.initResize(), this.initScroll()
        }

        return e(i, n), i.prototype.HEX_COLORS = ["1EDEC2", "00A9FA", "FF7C8D", "B89DFF", "006AFF", "9FC2FF", "DCC0FF", "44CFFF", "FF9000"], i.prototype.initReport = function () {
            var t, e, n, i, r;
            for ($(".hand-wrapper").addClass("crazy-intro"), setTimeout(function () {
                return $(".hand-wrapper").addClass("ticking")
            }, 2e3), $(".js-numbers-hero").removeClass("hidden"), $(".js-scroll-down").on("click", this.scrollToReport), r = [], e = n = 0, i = $(".fs-section").length; i > n; e = n += 1)t = $("<span class='legend-element'>"), t.css("background", "#" + this.HEX_COLORS[e]), r.push($(".js-legend").append(t));
            return r
        }, i.prototype.initResize = function () {
            return this.resize(), $(window).resize(function (t) {
                return function () {
                    return t.resize()
                }
            }(this))
        }, i.prototype.resize = function () {
            var t;
            return $(".js-full-height").css("height", $(window).outerHeight()), $(".js-full-height-sans-header").css("height", $(window).outerHeight() - 50), $(".js-half-height-sans-header").css("height", ($(window).outerHeight() - 50) / 2), t = ($(window).height() - 50) / $(".fs-section").length, $(".legend-element").css("height", t + "px"), $(".js-numbers-arrow").css("margin-top", t / 2 - $(".js-numbers-arrow").outerHeight() / 2), this.scroll()
        }, i.prototype.initCounter = function (t) {
            var e, n;
            return e = function (t) {
                return function () {
                    return $(".js-ratio").each(function (e, n) {
                        var i, r, o, s;
                        return i = $(n), o = parseFloat(i.attr("data-ratio")), r = parseInt(i.attr("data-float")), s = (t.nightsSlept * o).toFixed(r), i.text(t.addCommasToNumber(s))
                    })
                }
            }(this), e(), (n = function (t) {
                return function (i) {
                    return setTimeout(function () {
                        return t.nightsSlept += 1, e(), n(i)
                    }, i)
                }
            }(this))(t)
        }, i.prototype.initScroll = function () {
            return this.scroll(), $(window).on({"scroll DOMMouseScroll mousewheel wheel touchmove": this.scroll})
        }, i.prototype.scroll = function () {
            var t, e, n, i, r, o;
            return this.scrollNumbersArrow(), this.setBackground(), t = $(".js-fixed-rail, .js-legend-wrapper"), o = $(window).scrollTop(), r = o + $(window).height(), i = $(".js-numbers-hero").outerHeight(), e = $(".js-fs-sections").outerHeight(), n = $("footer").offset().top, r >= i + e + 2 ? t.removeClass("fixed").addClass("sticky-bottom") : o >= i - 48 ? t.removeClass("sticky-bottom").addClass("fixed") : t.removeClass("sticky-bottom fixed")
        }, i.prototype.scrollNumbersArrow = function () {
            var t, e, n, i, r;
            return e = 0, t = 100 - 100 / $(".fs-section").length, i = $(window).scrollTop() - $(".js-numbers-hero").outerHeight(), r = $(".js-fs-sections").outerHeight(), n = 100 * (i / r), n = Math.max(e, n), n = Math.min(t, n), $(".js-numbers-arrow").css("top", n + "%")
        }, i.prototype.setBackground = function () {
            var t;
            return t = $(".js-numbers-arrow").offset().top + $(".js-numbers-arrow").outerHeight() / 2, $(".legend-element").each(function (e) {
                return function (n, i) {
                    var r, o;
                    return o = $(i).offset().top, r = o + $(i).height(), r > t && t >= o ? ($(".fs-section-container").css("background", "#" + e.HEX_COLORS[n]), $("#numbers_spiral").css("fill", "#" + e.HEX_COLORS[n])) : void 0
                }
            }(this))
        }, i.prototype.scrollToReport = function () {
            return $("html,body").animate({scrollTop: $(".js-fs-sections").offset().top - 50}, 500, "easeInOutQuad")
        }, i.prototype.addCommasToNumber = function (t) {
            var e, n, i, r;
            for (t += "", n = t.split("."), i = n[0], r = n.length > 1 ? "." + n[1] : "", e = /(\d+)(\d{3})/; e.test(i);)i = i.replace(e, "$1,$2");
            return i + r
        }, i
    }(Alphabet.Base)
}.call(this), function () {
    var t, e = function (t, e) {
        return function () {
            return t.apply(e, arguments)
        }
    }, n = function (t, e) {
        function n() {
            this.constructor = t
        }

        for (var r in e)i.call(e, r) && (t[r] = e[r]);
        return n.prototype = e.prototype, t.prototype = new n, t.__super__ = e.prototype, t
    }, i = {}.hasOwnProperty;
    null == (t = Alphabet.Views).Orders && (t.Orders = {}), Alphabet.Views.Orders.ShipmentSummaryBox = function (t) {
        function i() {
            this.position_buttons = e(this.position_buttons, this), this.show_disabled_tracking_alert = e(this.show_disabled_tracking_alert, this), window.AlphabetShimPromise.then(function (t) {
                return function (e) {
                    return t.shim = e, t.shim.translations.fetch(), $(".js-shipment-tracking-link.disabled").click(t.show_disabled_tracking_alert)
                }
            }(this)), $(window).resize(this.position_buttons), this.position_buttons()
        }

        return n(i, t), i.prototype.show_disabled_tracking_alert = function (t) {
            return t.preventDefault(), alert(this.shim.translations.t.shipment.tracking_not_available)
        }, i.prototype.position_buttons = function () {
            var t;
            return t = this, $(".user-order-shipment, .user-order-rma").each(function () {
                var e;
                if (e = $(this), t.is_mobile()) {
                    if (!e.find(".js-bottom-button-wrap").find(".js-shipment-action-buttons").length)return e.find(".js-bottom-button-wrap").append(e.find(".js-shipment-action-buttons"))
                } else if (!e.find(".js-right-button-wrap").find(".js-shipment-action-buttons").length)return e.find(".js-right-button-wrap").append(e.find(".js-shipment-action-buttons"))
            })
        }, i.prototype.is_mobile = function () {
            return $(window).innerWidth() <= 750
        }, i
    }(Alphabet.Base), $(function () {
        return $(".js-user-order-box").length ? new Alphabet.Views.Orders.ShipmentSummaryBox : void 0
    })
}.call(this), function () {
    var t = function (t, e) {
        return function () {
            return t.apply(e, arguments)
        }
    }, e = function (t, e) {
        function i() {
            this.constructor = t
        }

        for (var r in e)n.call(e, r) && (t[r] = e[r]);
        return i.prototype = e.prototype, t.prototype = new i, t.__super__ = e.prototype, t
    }, n = {}.hasOwnProperty;
    Alphabet.Views.Press = function (n) {
        function i(e) {
            this.options = e, this.fadeInStories = t(this.fadeInStories, this), $(window).on("load", this.fadeInStories)
        }

        return e(i, n), i.prototype.fadeInStories = function () {
            return $("div.featured-press div.column.left div.story").each(function (t, e) {
                return setTimeout(function () {
                    return $(e).addClass("show")
                }, 2 * t * 600)
            }), $("div.featured-press div.column.right div.story").each(function (t, e) {
                return setTimeout(function () {
                    return $(e).addClass("show")
                }, 600 * (2 * t + 1))
            })
        }, i
    }(Alphabet.Base)
}.call(this), function () {
    var t = function (t, e) {
        return function () {
            return t.apply(e, arguments)
        }
    }, e = function (t, e) {
        function i() {
            this.constructor = t
        }

        for (var r in e)n.call(e, r) && (t[r] = e[r]);
        return i.prototype = e.prototype, t.prototype = new i, t.__super__ = e.prototype, t
    }, n = {}.hasOwnProperty;
    Alphabet.Views.Product = function (n) {
        function i(e) {
            this.options = e, this.bindATCAnalyticsTracking = t(this.bindATCAnalyticsTracking, this), this.setTestimonialSlide = t(this.setTestimonialSlide, this), this.setPrevTestimonialSlide = t(this.setPrevTestimonialSlide, this), this.setNextTestimonialSlide = t(this.setNextTestimonialSlide, this), this.setTestimonialBox = t(this.setTestimonialBox, this), this.initTestimonialInteractions = t(this.initTestimonialInteractions, this), this.toggleInfoSlide = t(this.toggleInfoSlide, this), this.setInfoSlideContent = t(this.setInfoSlideContent, this), this.setTabHeader = t(this.setTabHeader, this), this.clearTabHeaders = t(this.clearTabHeaders, this), this.setInfoSlide = t(this.setInfoSlide, this), this.slideInfoTabRight = t(this.slideInfoTabRight, this), this.slideInfoTabLeft = t(this.slideInfoTabLeft, this), this.setInfoSlideFromTitle = t(this.setInfoSlideFromTitle, this), this.setInfoSlideFromClick = t(this.setInfoSlideFromClick, this), this.getCurrentKey = t(this.getCurrentKey, this), this.initInfoInteractions = t(this.initInfoInteractions, this), this.updateSizeSelect = t(this.updateSizeSelect, this), this.initPriceToggleInteractions = t(this.initPriceToggleInteractions, this), this.setActiveThumb = t(this.setActiveThumb, this), this.setMainImage = t(this.setMainImage, this), this.mainImageSlideChangeHandler = t(this.mainImageSlideChangeHandler, this), this.prevSlide = t(this.prevSlide, this), this.nextSlide = t(this.nextSlide, this), this.goToSlide = t(this.goToSlide, this), this.initImageHandlers = t(this.initImageHandlers, this), this.hideVideo = t(this.hideVideo, this), this.showVideo = t(this.showVideo, this), this.bindVideoLinks = t(this.bindVideoLinks, this), this.scrollToTop = t(this.scrollToTop, this), this.initBackToTop = t(this.initBackToTop, this), this.infoTabs = {
                construction: {
                    prev: "setup",
                    next: "returns"
                },
                returns: {prev: "construction", next: "factories"},
                factories: {prev: "returns", next: "setup"},
                setup: {prev: "factories", next: "construction"}
            }, this.product = this.options.product, analytics.track("Viewed Product", {
                id: this.product.id,
                sku: this.product.sku,
                name: this.product.name,
                price: this.product.price,
                category: "Mattresses",
                nonInteraction: 1
            }), this.index = 0, this.$images = $(".js-main-image .multiple"), this.initBackToTop(), this.initImageHandlers(), this.initPriceToggleInteractions(), this.initInfoInteractions(), this.initTestimonialInteractions(), this.bindATCAnalyticsTracking(this.product), this.bindVideoLinks()
        }

        var r, o, s, a;
        return e(i, n), r = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent), s = [{
            name: "Facinorous Forties",
            "class": "colamill",
            url: "https://twitter.com/ColaMill/status/528533017980338176",
            text: "May not get out of my Alphabet today. Someone's not amused."
        }, {
            name: "Jessmyn West",
            "class": "jessamyn",
            url: "https://twitter.com/Alphabet/timelines/478566635113304065",
            text: 'Enjoyed helping our friend unbox and "install" her mattress. Super comfy!'
        }, {
            name: "Dianna_2ns",
            "class": "dianna_2ns",
            url: "http://twitter.com/dianna_2ns",
            text: "1st night on our new @Alphabet = \ud83d\udc4d \ud83d\udc4d Surprisingly comfy despite having come in a Tic Tac box"
        }, {
            name: "Katy Osadetz",
            "class": "katyosadetz",
            url: "https://twitter.com/Dianna_2Ns/status/518087299591319552",
            text: "Someone likes our new @Alphabet bed! #badassmattress"
        }], o = [{
            name: "Brooke Sines",
            "class": "brookesines",
            url: "https://twitter.com/brookesines/status/519611424931192833",
            text: "Enjoying our new mattress!"
        }, {
            name: "Sunny Stueve, Alexandria VA",
            "class": "review",
            text: "I rarely review products, they have to really change my life in some way, and Alphabet did!"
        }, {
            name: "Lauren Ponting Walsh",
            "class": "laurenpwalsh",
            url: "https://twitter.com/laurenpwalsh/status/520738476581740544",
            text: "Just let our @Alphabet out of the box and so far there are two members of the family who are pleased!"
        }, {
            name: "Jona Decker, Madison WI",
            "class": "review",
            text: "Best. Sleep. Ever."
        }, {
            name: "Carl Bausemer, Sutton MA",
            "class": "review",
            text: "I no longer wake with back pain. I'm not tossing and turning all night. My partner doesn't want to get out of the bed in the morning its so comfortable."
        }, {
            name: "Jonty Young",
            "class": "jontyoung",
            url: "https://twitter.com/jontyoung/status/502561133208039426",
            text: "The best purchase I've made in years. Thanks so much you guys - we'll sleep well tonight for sure!!"
        }, {name: "Trish, Wichita Falls TX", "class": "review", text: "This is an amazing mattress!!!"}, {
            name: "Slate",
            "class": "slate",
            url: "http://www.slate.com/blogs/moneybox/2014/08/07/foam_mattress_startup_Alphabet_has_one_density_option_and_delivers_in_a_box.html",
            text: "Watch Slate review the Alphabet"
        }, {
            name: "Amanda Don, Manahawkin NJ",
            "class": "review",
            text: "Seriously. Is this a joke? Got my Alphabet yesterday... and even on day 1 there is no question that was the BEST nights sleep EVER."
        }, {
            name: "Tara Mann",
            "class": "taramann",
            url: "https://twitter.com/TaraMann/status/526924782244495361",
            text: "Every last detail is on point with @Alphabet / got mine set up in 5 minutes. Sleep tight."
        }, {
            name: "Jim Ellis, Orlando FL",
            "class": "review",
            text: "TRY IT. There is no risk whatsoever. All these awesome reviews on the site don't lie, and neither does this one."
        }], a = [{
            name: "Nick Taylor",
            "class": "ntaylor360",
            url: "https://twitter.com/ntaylor360/status/523576840397795328",
            text: "Just got our @Alphabet mattress and we are loving how comfortable it is!"
        }, {
            name: "Chris Campbell",
            "class": "christophersonchristopherson",
            url: "http://instagram.com/p/uBj6oHNtrM/",
            text: "Just my mattress and my motorcycle #Alphabetmattress #Alphabetsleep"
        }, {
            name: "Rob Damiani",
            "class": "rob_damiani",
            url: "https://twitter.com/rob_damiani/status/525757120193777664",
            text: ""
        }], i.prototype.initBackToTop = function () {
            return $(".js-back-to-top").on("click", this.scrollToTop)
        }, i.prototype.scrollToTop = function (t) {
            return t.preventDefault(), $("html,body").animate({scrollTop: 0}, 500)
        }, i.prototype.bindVideoLinks = function () {
            return $(".box .content").on("click", function (t) {
                return function (e) {
                    return $(e.target).hasClass("slate") ? t.showVideo() : void 0
                }
            }(this)), $("#video_div").on("click", this.hideVideo)
        }, i.prototype.showVideo = function () {
            return $("#video_div").show(), $("#slate_video").get(0).play()
        }, i.prototype.hideVideo = function () {
            return $("#video_div").hide(), $("#slate_video").get(0).pause()
        }, i.prototype.initImageHandlers = function () {
            var t, e;
            return this.$thumbnails = $(".js-thumb-list .thumb-li"), this.setActiveThumb(this.$thumbnails.first()), $(document).keydown(function (t) {
                return function (e) {
                    return 37 === e.keyCode && t.prevSlide(), 39 === e.keyCode ? t.nextSlide() : void 0
                }
            }(this)), $(".next").on("click", this.nextSlide), $(".prev").on("click", this.prevSlide), t = null, e = null, $(".js-main-image").on("touchstart", function (n) {
                return t = n.originalEvent.touches[0].clientX, e = n.originalEvent.touches[0].clientY
            }), $(".js-main-image").on("touchmove", function (n) {
                return function (i) {
                    var r, o, s, a;
                    if (t && e)return o = i.originalEvent.touches[0].clientX, a = i.originalEvent.touches[0].clientY, r = t - o, s = e - a, Math.abs(r) > Math.abs(s) && (r > 0 ? n.nextSlide() : n.prevSlide()), t = null, e = null
                }
            }(this)), $(window).resize(function (t) {
                return function () {
                    return t.goToSlide($(".js-main-image"), t.index)
                }
            }(this)), this.$thumbnails.find("a").on("click", function (t) {
                return function (e) {
                    var n;
                    return e.preventDefault(), n = $(e.currentTarget).parent(".thumb-li"), t.index = t.$thumbnails.index(n), t.goToSlide($(".js-main-image"), t.index)
                }
            }(this))
        }, i.prototype.goToSlide = function (t, e) {
            var n;
            return n = this.$images[e].offsetLeft, t.css("transform", "translate3d(" + -n + "px, 0, 0)"), t.css("oTransform", "translate3d(" + -n + "px, 0, 0)"), t.css("msTransform", "translate3d(" + -n + "px, 0, 0)"), t.css("mozTransform", "translate3d(" + -n + "px, 0, 0)"), t.css("webkitTransform", "translate3d(" + -n + "px, 0, 0)"), this.mainImageSlideChangeHandler(this.index), $(".prev").show(), 0 === this.index ? $(".prev").hide() : void 0
        }, i.prototype.nextSlide = function () {
            return this.index < this.$images.length - 1 ? this.index++ : this.index = 0, this.goToSlide($(".js-main-image"), this.index)
        }, i.prototype.prevSlide = function () {
            return this.index > 0 ? (this.index--, this.goToSlide($(".js-main-image"), this.index)) : void 0
        }, i.prototype.mainImageSlideChangeHandler = function (t) {
            var e;
            return e = this.$thumbnails.eq(t), this.setActiveThumb(e)
        }, i.prototype.setMainImage = function (t) {
            return this.$mainImg.find("img").attr("src", t)
        }, i.prototype.setActiveThumb = function (t) {
            return this.$thumbnails.removeClass("active"), t.addClass("active")
        }, i.prototype.initPriceToggleInteractions = function () {
            return $(".js-size-trigger").on("click", this.updateSizeSelect)
        }, i.prototype.updateSizeSelect = function (t) {
            var e, n, i;
            return e = $(t.target), i = e.data("price"), $(".js-price-text").fadeOut(300, function () {
                return $(this).html(i), $(this).fadeIn(300)
            }), n = e.data("dimensions"), $(".js-dimensions-text").fadeOut(300, function () {
                return $(this).html(n), $(this).fadeIn(300)
            }), $(".js-financing-amount").fadeOut(300, function () {
                var t, e;
                return e = parseInt(i.replace(/\D/g, "")), t = Math.ceil(e / 6), $(this).html(t), $(this).fadeIn(300)
            })
        }, i.prototype.initInfoInteractions = function () {
            return $(".js-tab").on("click", this.setInfoSlideFromClick), $(".js-tab-left").on("click", this.slideInfoTabLeft), $(".js-tab-right").on("click", this.slideInfoTabRight), $(".js-tab-slide-title").on("click", this.setInfoSlideFromTitle), this.setInfoSlide("construction", !1)
        }, i.prototype.getCurrentKey = function () {
            return $(".js-active-tab").attr("data-tab-target")
        }, i.prototype.setInfoSlideFromClick = function (t) {
            var e;
            return t.preventDefault(), e = $(t.currentTarget).attr("data-tab-target"), this.setInfoSlide(e)
        }, i.prototype.setInfoSlideFromTitle = function (t) {
            var e, n;
            return t.preventDefault(), e = $(t.currentTarget), n = e.attr("data-tab-target"), this.toggleInfoSlide(n), this.clearTabHeaders(), e.hasClass("expanded") ? void 0 : this.setTabHeader(n)
        }, i.prototype.slideInfoTabLeft = function (t) {
            var e;
            return t.preventDefault(), e = this.infoTabs[this.getCurrentKey()].prev, this.setInfoSlide(e)
        }, i.prototype.slideInfoTabRight = function (t) {
            var e;
            return t.preventDefault(), e = this.infoTabs[this.getCurrentKey()].next, this.setInfoSlide(e)
        }, i.prototype.setInfoSlide = function (t, e) {
            return null == e && (e = !0), this.clearTabHeaders(), this.setTabHeader(t), this.setInfoSlideContent(t)
        }, i.prototype.clearTabHeaders = function () {
            return $(".js-active-tab").removeClass("active js-active-tab")
        }, i.prototype.setTabHeader = function (t) {
            return $(".js-tab[data-tab-target = " + t + "]").addClass("active js-active-tab")
        }, i.prototype.setInfoSlideContent = function (t) {
            return $(".js-tab-slide.active").removeClass("active").hide(), $(".js-tab-slide[data-tab-key = " + t + "]").addClass("active").show()
        }, i.prototype.toggleInfoSlide = function (t) {
            var e;
            return $(".js-tab-slide-title[data-tab-target = " + t + "]").toggleClass("expanded"), e = $(".js-tab-slide[data-tab-key = " + t + "]"), e.toggleClass("active")
        }, i.prototype.initTestimonialInteractions = function () {
            var t, e;
            return e = !1, t = function (t) {
                return function () {
                    var n, i, u, l, c;
                    return (r || !e && $(window).scrollTop() >= $(".testimonial-area").prop("offsetTop") - $(window).height()) && (e = !0, $(".box").each(function (t, e) {
                        return setTimeout(function () {
                            return $(e).removeClass("fade")
                        }, 300 * t)
                    }), !r) ? (n = 0, u = 0, l = 0, c = 0, i = $(".testimonial .box").length, setInterval(function () {
                        var e;
                        return e = $(".testimonial .box:eq(" + n + ")"), e.hasClass("tall") ? (t.setTestimonialBox(e, s[l]), l = (l + 1) % s.length) : e.hasClass("wide") ? (t.setTestimonialBox(e, a[c]), c = (c + 1) % a.length) : (t.setTestimonialBox(e, o[u]), u = (u + 1) % o.length), n = (n + 1) % i
                    }, 7e3)) : void 0
                }
            }(this), t(), r ? void 0 : $(window).scroll(t)
        }, i.prototype.setTestimonialBox = function (t, e) {
            return t.addClass("fade"), setTimeout(function () {
                var n, i;
                return "review" === e["class"] ? (t.removeClass("social").addClass(e["class"]), t.find(".content").attr("class", "content"), t.find(".quote .text").html("&ldquo;" + e.text + "&rdquo;"), t.find(".quote .reviewer").html("\u2013" + e.name)) : (t.removeClass("review").addClass("social"), t.find(".content").attr("class", "content " + e["class"]), i = '<a href="' + e.url + '" target="_blank">' + e.name + "</a>", t.find(".author .name").html(i), t.find(".preview").html(e.text), n = t.find(".body"), e.body ? (n.html(e.body), n.show()) : (n.html(""), n.hide())), t.removeClass("fade")
            }, 600)
        }, i.prototype.setNextTestimonialSlide = function (t) {
            var e, n, i, r, o;
            return t.preventDefault(), o = ".js-testimonial-slide", n = $(o + ":first"), e = $(o + ".active"), r = e.next("" + o), i = r.length > 0 ? r : n, this.setTestimonialSlide(e, i)
        }, i.prototype.setPrevTestimonialSlide = function (t) {
            var e, n, i, r, o;
            return t.preventDefault(), o = ".js-testimonial-slide", n = $(o + ":last"), e = $(o + ".active"), r = e.prev("" + o), i = r.length > 0 ? r : n, this.setTestimonialSlide(e, i)
        }, i.prototype.setTestimonialSlide = function (t, e) {
            return t.removeClass("active"), e.addClass("active")
        }, i.prototype.bindATCAnalyticsTracking = function (t) {
            return analytics.ready(function () {
                return $(".js-atc").on("click", function (e) {
                    return function (e) {
                        return $(".js-atc").css("pointer-events", "none"), $(".btn-add").addClass("load"), analytics.track("Added Product", {
                            id: t.id,
                            sku: $(".js-size-trigger:checked").data("sku"),
                            name: t.name + " - " + $(".js-size-trigger:checked").data("size"),
                            price: $(".js-size-trigger:checked").data("price"),
                            quantity: 1,
                            category: "Mattresses",
                            label: "purchase_add_to_cart",
                            value: 0,
                            size: $(".js-size-trigger:checked").data("size")
                        })
                    }
                }(this))
            })
        }, i
    }(Alphabet.Base)
}.call(this), function () {
    var t = function (t, e) {
        return function () {
            return t.apply(e, arguments)
        }
    };
    Alphabet.Modules.AlphabetMod.Gallery = function () {
        function e(e) {
            this.options = e, this.setActiveSlide = t(this.setActiveSlide, this), this.setActiveThumb = t(this.setActiveThumb, this), this.mainImageSlideChangeHandler = t(this.mainImageSlideChangeHandler, this), this.prevSlide = t(this.prevSlide, this), this.nextSlide = t(this.nextSlide, this), this.goToSlide = t(this.goToSlide, this), this.initImageHandlers = t(this.initImageHandlers, this), this.index = 0, this.$el = $(this.options.sectionName), this.$slides = this.$el.find(this.options.slides), this.$tracker = this.$el.find(this.options.tracker), this.$slider = this.$el.find(this.options.slider), this.$next = this.$el.find(this.options.next), this.$prev = this.$el.find(this.options.prev), this.activeClass = this.options.activeIdentifier, this.initialOffset = this.$slides[0].offsetLeft, this.offset = this.initialOffset, this.$slides.length <= 1 ? (this.$next.hide(), this.$prev.hide(), this.$tracker.hide()) : this.initImageHandlers()
        }

        return e.prototype.initImageHandlers = function () {
            var t, e;
            return this.setActiveThumb(this.$tracker.first()), this.setActiveSlide(this.$slides.first()), $(document).keydown(function (t) {
                return function (e) {
                    var n, i;
                    return i = t.$el.offset().top + t.$el.height() / 2, n = $(window).height() / 2 + 200, $(window).scrollTop() >= i - n && $(window).scrollTop() <= i + n && (37 === e.keyCode && t.prevSlide(), 39 === e.keyCode) ? t.nextSlide() : void 0
                }
            }(this)), this.$next.on("click", this.nextSlide), this.$prev.on("click", this.prevSlide), t = null, e = null, this.$el.on("touchstart", this.$slider, function (n) {
                return t = n.originalEvent.touches[0].clientX, e = n.originalEvent.touches[0].clientY
            }), this.$el.on("touchmove", this.$slider, function (n) {
                return function (i) {
                    var r, o, s, a;
                    if (t && e)return o = i.originalEvent.touches[0].clientX, a = i.originalEvent.touches[0].clientY, r = t - o, s = e - a, Math.abs(r) > Math.abs(s) && (r > 0 ? n.nextSlide() : n.prevSlide()), t = null, e = null
                }
            }(this)), $(window).resize(function (t) {
                return function () {
                    return t.goToSlide(t.index)
                }
            }(this)), this.$tracker.on("click", function (t) {
                return function (e) {
                    return e.preventDefault(), t.index = t.$tracker.index(e.currentTarget), t.goToSlide(t.index)
                }
            }(this))
        }, e.prototype.goToSlide = function (t) {
            return this.offset = this.initialOffset - this.$slides[t].offsetLeft, this.$slider.css("transform", "translate(" + this.offset + "px, 0)"), this.$slider.css("transform", "translate3d(" + this.offset + "px, 0, 0)"), this.mainImageSlideChangeHandler(this.index)
        }, e.prototype.nextSlide = function () {
            return this.index < this.$slides.length - 1 ? this.index++ : this.index = 0, this.goToSlide(this.index)
        }, e.prototype.prevSlide = function () {
            return this.index <= 0 && (this.index = this.$slides.length), this.index--, this.goToSlide(this.index)
        }, e.prototype.mainImageSlideChangeHandler = function (t) {
            var e, n;
            return n = this.$tracker.eq(t), this.setActiveThumb(n), e = this.$slides.eq(t), this.setActiveSlide(e)
        }, e.prototype.setActiveThumb = function (t) {
            return this.$tracker.removeClass(this.activeClass), t.addClass(this.activeClass)
        }, e.prototype.setActiveSlide = function (t) {
            return this.$slides.removeClass(this.activeClass), t.addClass(this.activeClass)
        }, e
    }()
}.call(this), function () {
    var t = function (t, e) {
        return function () {
            return t.apply(e, arguments)
        }
    }, e = function (t, e) {
        function i() {
            this.constructor = t
        }

        for (var r in e)n.call(e, r) && (t[r] = e[r]);
        return i.prototype = e.prototype, t.prototype = new i, t.__super__ = e.prototype, t
    }, n = {}.hasOwnProperty;
    Alphabet.Modules.AlphabetMod.Modal = function (n) {
        function i(e) {
            var n;
            if (this.options = e, this.open = t(this.open, this), this.closeIfOutsideClick = t(this.closeIfOutsideClick, this), this.isInsideDialog = t(this.isInsideDialog, this), this.close = t(this.close, this), window.AlphabetShimPromise.then(function (t) {
                    return function (e) {
                        return t.shim = e
                    }
                }(this)), null != this.options.$el && (this.$el = this.options.$el), null != this.options.link && (this.link = this.options.link), null != this.options.$alert && (this.alert = this.options.$alert), null != this.options.afterClose && (this.afterClose = this.options.afterClose), null != this.alert && null == this.alert.message)throw"Must have message property is alert wants to be used";
            if (null != this.alert && null != this.$el)throw"Ambigious intent; either $el or $alert must be defined, not both";
            if (null == this.alert && null == this.$el)throw"Invalid amount of parameters passed in Modal constructor. @alert with a message property  or @el must be used defined";
            null != this.$el ? null != (null != (n = this.alert) ? n.requireConfirmation : void 0) != !0 && this.$el.find(".js-modal-close").on("click", this.close) : null != this.alert && this.buildDynamicDialog(this.alert.message), null != this.link && $(document).on("click", this.link, function (t) {
                return function (e) {
                    return t.open(e)
                }
            }(this)), this.target = null, "showModal" in this.$el[0] || "show" in this.$el[0] || dialogPolyfill.registerDialog(this.$el[0])
        }

        return e(i, n), i.prototype.close = function (t) {
            return t.preventDefault(), this.$el[0].close(), null != this.target && this.target.focus(), null != this.afterClose ? this.afterClose(this) : void 0
        }, i.prototype.isInsideDialog = function (t) {
            var e;
            return e = this.$el[0].getBoundingClientRect(), e.top <= t.clientY && t.clientY <= e.top + e.height && e.left <= t.clientX && t.clientX <= e.left + e.width
        }, i.prototype.closeIfOutsideClick = function (t) {
            return !this.isInsideDialog(t) && this.$el[0].hasAttribute("open") ? this.$el[0].close() : void 0
        }, i.prototype.open = function (t) {
            return null != t && (t.preventDefault(), null != t.target && (this.target = t.target)), this.$el[0].showModal(), window.innerWidth <= 1024 && Modernizr.touch && this.shim.ScrollHelper.scrollTo(this.$el[0]), this.$el[0].addEventListener("click", this.closeIfOutsideClick)
        }, i.prototype.buildDynamicDialog = function (t) {
            return this.$el = $('<dialog id="modal" class="dialog"></dialog>').html($.trim("<div class='modal-inner r-centered'> <div class='modal-content'>" + t + "</div> </div>")), null != this.options.classes && this.$el.addClass(this.options.classes), this.alert.requireConfirmation !== !0 && this.$el.find(".modal-inner").prepend("<button class='btn--modal-close js-modal-close'><span data-icon='close'><svg class='icon'><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='#close'></use></svg></span></button>"), this.alert.requireConfirmation !== !1 && this.$el.find(".modal-inner").append("<button id='Alphabet-alert-ok' class='btn btn--primary js-modal-close'>OK</button>"), this.$el.find(".js-modal-close").on("click", this.close), this.$el[0].addEventListener("close", function () {
                return document.body.removeChild(this)
            }), $("body").append(this.$el), "showModal" in this.$el[0] || "show" in this.$el[0] || dialogPolyfill.registerDialog(this.$el[0]), this.$el[0].showModal(), window.matchMedia("(max-width: 768px)").matches && scroll(0, 0), this.$el[0].addEventListener("click", this.closeIfOutsideClick)
        }, i
    }(Alphabet.Base)
}.call(this), function () {
    var t = function (t, e) {
        return function () {
            return t.apply(e, arguments)
        }
    };
    Alphabet.Modules.AlphabetMod.Tabs = function () {
        function e(e) {
            this.options = e, this.setActiveSlide = t(this.setActiveSlide, this), this.setActiveTab = t(this.setActiveTab, this), this.init = t(this.init, this), this.$el = $(this.options.el), this.$tabs = $(this.options.tabsClass), this.$slides = $(this.options.slidesClass), this.init()
        }

        return e.prototype.init = function () {
            return this.$tabs.on("click", function (t) {
                return function (e) {
                    var n;
                    return n = $(e.target).closest(t.options.tabsClass), t.setActiveTab(n.data("name")), t.setActiveSlide(n.data("name"))
                }
            }(this)), this.$slides.on("click", function (t) {
                return function (e) {
                    var n;
                    return n = $(e.target).closest(t.options.slidesClass), t.setActiveSlide(n.data("name")), t.setActiveTab(n.data("name"))
                }
            }(this))
        }, e.prototype.setActiveTab = function (t) {
            return this.$tabs.removeClass("is-active"), this.$tabs.filter("[data-name='" + t + "']").addClass("is-active")
        }, e.prototype.setActiveSlide = function (t) {
            return this.$slides.removeClass("is-active"), this.$slides.filter("[data-name='" + t + "']").addClass("is-active")
        }, e
    }()
}.call(this), function () {
    var t = function (t, e) {
        return function () {
            return t.apply(e, arguments)
        }
    };
    Alphabet.Modules.AlphabetMod.Tooltip = function () {
        function e(e) {
            var n;
            this.options = e, this.setEdge = t(this.setEdge, this), this.init = t(this.init, this), this.$container = $(this.options.container), n = this.$container.find(this.options.toggle), this.$toggle = n.length ? n : this.$container, this.$tooltip = this.$container.find(this.options.tooltip), this.align = !!this.options.align, this.init(), this.align && (this.setEdge(), $(window).on("resize", function (t) {
                return function (e) {
                    return t.$toggle.removeClass("is-active"), t.setEdge()
                }
            }(this)))
        }

        return e.prototype.init = function () {
            return this.$toggle.click(function (t) {
                return function (e) {
                    return e.stopPropagation(), t.$toggle.toggleClass("is-active"), t.$tooltip.toggleClass("is-active")
                }
            }(this)), $(window).click(function (t) {
                return function (e) {
                    return $(e.target).closest(t.options.tooltip).length || $(e.target).closest(t.options.toggle).length || !t.$toggle.hasClass("is-active") ? void 0 : (t.$toggle.removeClass("is-active"), t.$tooltip.removeClass("is-active"))
                }
            }(this))
        }, e.prototype.setEdge = function () {
            var t;
            return t = (this.$tooltip.width() - this.$container.width()) / 2, this.$tooltip.removeClass("-left-align").removeClass("-right-align"), this.$container.offset().left - t < 0 ? this.$tooltip.addClass("-left-align") : this.$container.offset().left + this.$tooltip.width() >= $(window).width() ? this.$tooltip.addClass("-right-align") : void 0
        }, e
    }()
}.call(this), function () {
    var t = function (t, e) {
        return function () {
            return t.apply(e, arguments)
        }
    };
    Alphabet.Views.AlphabetMod.AddToCart = function () {
        function e(e) {
            this.options = e, this.convertroAddToCart = t(this.convertroAddToCart, this), this.bindATCLoadingState = t(this.bindATCLoadingState, this), this.updateSizeSelect = t(this.updateSizeSelect, this),
                this.initPriceToggleInteractions = t(this.initPriceToggleInteractions, this), this.truncateCopy = t(this.truncateCopy, this), this.initSizeSelector = t(this.initSizeSelector, this), window.AlphabetShimPromise.then(function (t) {
                return function (e) {
                    return t.shim = e, t.shim.translations.fetch(), $(".js-add-to-cart-one-size").length ? t.truncateCopy() : void 0
                }
            }(this)), this.product = this.options.product, this.initSizeSelector(), this.initPriceToggleInteractions(), this.bindATCLoadingState()
        }

        return e.prototype.initSizeSelector = function () {
            var t, e;
            return t = $(".js-size-selector"), e = $("#product-id").val(), t.find(".js-size-selector-option[data-variant-id='" + e + "']").addClass("is-selected"), $(".js-size-selector .js-size-selector-selected").click(function () {
                return t.toggleClass("is-expanded")
            }), $(".js-size-selector .js-size-selector-option").click(function (e) {
                return function (n) {
                    var i, r;
                    return i = $(n.target).closest(".js-size-selector-option"), r = $(".js-size-selector .js-size-selector-option").index(i), e.updateSizeSelect(i), t.removeClass("is-expanded")
                }
            }(this)), $(window).click(function (e) {
                return $(e.target).closest(".js-size-selector").length ? void 0 : t.removeClass("is-expanded")
            })
        }, e.prototype.truncateCopy = function () {
            return $(".js-product-description-body").readmore({
                speed: 200,
                moreLink: "<span><a href='#' class='continue-reading-link'>" + this.shim.translations.t.helpers.read_more + "</a></span>",
                lessLink: !1,
                afterToggle: this.setGalleryMaxHeight
            })
        }, e.prototype.initPriceToggleInteractions = function () {
            var t;
            return $(".js-size-trigger").on("click", this.updateSizeSelect), t = $(".js-size-selector-option.is-selected"), this.updateSizeSelect(t)
        }, e.prototype.updateSizeSelect = function (t) {
            var e, n, i, r;
            return $(".js-size-selector-option").removeClass("is-selected"), $(t).addClass("is-selected"), r = t.data("price"), $(".js-size-selector-name").text(t.data("size")), $(".js-size-selector-dimensions").html(t.data("dimensions")), $(".js-add-to-cart-price-text").html(r), $("#product-id").val(t.data("variant-id")), e = t.data("dimensions"), $(".js-size-selector-exposed-dimensions").html(e), i = parseInt(r.replace(/\D/g, "")), n = Math.ceil(i / 6), $(".js-financing-amount").html(n)
        }, e.prototype.bindATCLoadingState = function () {
            return $(".js-add-to-cart-button").on("click", function (t) {
                return function (t) {
                    return $(t.currentTarget).addClass("is-loading")
                }
            }(this))
        }, e.prototype.convertroAddToCart = function () {
            return void 0 === window.$CVO && (window.$CVO = []), window.$CVO.push(["trackEvent", {
                type: "add-to-cart",
                id: null,
                amount: "1"
            }])
        }, e
    }()
}.call(this), function () {
    var t = function (t, e) {
        return function () {
            return t.apply(e, arguments)
        }
    }, e = function (t, e) {
        function i() {
            this.constructor = t
        }

        for (var r in e)n.call(e, r) && (t[r] = e[r]);
        return i.prototype = e.prototype, t.prototype = new i, t.__super__ = e.prototype, t
    }, n = {}.hasOwnProperty;
    Alphabet.Views.AlphabetMod.Footer = function (n) {
        function i(e) {
            this.options = e, this.revealReferralLinks = t(this.revealReferralLinks, this), this.el = this.options.el, this.$el = $(this.el), $(document).bind("dynamic_content_loaded", this.revealReferralLinks)
        }

        return e(i, n), i.prototype.revealReferralLinks = function (t, e) {
            return e.logged_in && e.last_completed_order || e.user_completed_order ? ($(".js-referral-footer-links").removeClass("is-hidden"), $(".js-referral-mobile-nav-link").addClass("is-shown")) : void 0
        }, i
    }(Alphabet.Base)
}.call(this), function () {
    var t = function (t, e) {
        return function () {
            return t.apply(e, arguments)
        }
    }, e = function (t, e) {
        function i() {
            this.constructor = t
        }

        for (var r in e)n.call(e, r) && (t[r] = e[r]);
        return i.prototype = e.prototype, t.prototype = new i, t.__super__ = e.prototype, t
    }, n = {}.hasOwnProperty;
    Alphabet.Views.AlphabetMod.Help = function (n) {
        function i(e) {
            this.options = e, this.initTextUsFunctionality = t(this.initTextUsFunctionality, this), window.AlphabetShimPromise.then(function (t) {
                return function (e) {
                    return t.shim = e, t.shim.translations.fetch(), t.initTextUsFunctionality()
                }
            }(this))
        }

        return e(i, n), i.prototype.initTextUsFunctionality = function () {
            var t, e;
            return t = this.shim.translations.t.help.sms.desktop_text_us_message, e = 600, $(".js-sms-link").on("click", function (n) {
                return window.innerWidth >= e ? (n.preventDefault(), new Alphabet.Modules.AlphabetMod.Modal({
                    $el: null,
                    $alert: {message: t, requireConfirmation: !1}
                })) : void 0
            })
        }, i
    }(Alphabet.Base)
}.call(this), function () {
    var t = function (t, e) {
        return function () {
            return t.apply(e, arguments)
        }
    }, e = function (t, e) {
        function i() {
            this.constructor = t
        }

        for (var r in e)n.call(e, r) && (t[r] = e[r]);
        return i.prototype = e.prototype, t.prototype = new i, t.__super__ = e.prototype, t
    }, n = {}.hasOwnProperty;
    Alphabet.Views.Initializer = function (n) {
        function i() {
            this.initCustomEasings = t(this.initCustomEasings, this), this.initMiniCart(), this.initCustomEasings(), this.identifyByRecipientEmail()
        }

        return e(i, n), i.prototype.initCustomEasings = function () {
            return $.extend($.easing, {
                easeInQuad: function (t, e, n, i, r) {
                    return i * (e /= r) * e + n
                }, easeOutQuad: function (t, e, n, i, r) {
                    return -i * (e /= r) * (e - 2) + n
                }, easeInOutQuad: function (t, e, n, i, r) {
                    return (e /= r / 2) < 1 ? i / 2 * e * e + n : -i / 2 * (--e * (e - 2) - 1) + n
                }, easeInCubic: function (t, e, n, i, r) {
                    return i * (e /= r) * e * e + n
                }, easeOutCubic: function (t, e, n, i, r) {
                    return i * ((e = e / r - 1) * e * e + 1) + n
                }, easeInOutCubic: function (t, e, n, i, r) {
                    return (e /= r / 2) < 1 ? i / 2 * e * e * e + n : i / 2 * ((e -= 2) * e * e + 2) + n
                }
            })
        }, i.prototype.initMiniCart = function () {
            return window.miniCart || (window.miniCart = new Alphabet.Views.MiniCart)
        }, i.prototype.identifyByRecipientEmail = function () {
            var t;
            return (t = Alphabet.Modules.Utils.getParams().recipient_email) ? Alphabet.Modules.Utils.trackUser(t) : void 0
        }, i
    }(Alphabet.Base)
}.call(this), function () {
    var t = function (t, e) {
        return function () {
            return t.apply(e, arguments)
        }
    };
    Alphabet.Views.MiniCart = function () {
        function e() {
            this.convertroTrackSource = t(this.convertroTrackSource, this), this.testAndInsertValue = t(this.testAndInsertValue, this), this.toggleCartUpdating = t(this.toggleCartUpdating, this), this.unsetCartUpdating = t(this.unsetCartUpdating, this), this.setCartUpdating = t(this.setCartUpdating, this), this.clearNotify = t(this.clearNotify, this), this.notifyError = t(this.notifyError, this), this.notifySuccess = t(this.notifySuccess, this), this.getPromoVal = t(this.getPromoVal, this), this.updatePromoCode = t(this.updatePromoCode, this), this.applyPromoCode = t(this.applyPromoCode, this), this.updateQuantity = t(this.updateQuantity, this), this.deleteItem = t(this.deleteItem, this), this.hideCart = t(this.hideCart, this), this.showCart = t(this.showCart, this), this.setupOverlay = t(this.setupOverlay, this), this.setupCart = t(this.setupCart, this), this.updateTotals = t(this.updateTotals, this), this.updateCartCount = t(this.updateCartCount, this), this.enableQtyButton = t(this.enableQtyButton, this), this.disableQtyButton = t(this.disableQtyButton, this), this.toggleQtyButton = t(this.toggleQtyButton, this), this.updateCart = t(this.updateCart, this), this.updateLineItem = t(this.updateLineItem, this), this.setSpreeObjects = t(this.setSpreeObjects, this), this.initCart = t(this.initCart, this), this.$cart = $("#cart"), this.$navItemCart = $(".js-nav-item-cart"), this.$cartCount = $("#cart-count"), this.$authLink = $(".js-auth-link"), this.$cartContent = $("#cart-content"), this.$productList = $("#cart-product-list"), this.$cartItem = $($("#cart-item").html()), this.$shipmentTotal = $("#cart-shipping-total"), this.$subTotal = $("#cart-subtotal"), this.$salesTax = $("#cart-sales-tax"), this.$includedTaxTotal = $("#cart-included-tax-total"), this.$orderTotal = $("#cart-total"), this.$checkoutBtn = $("#cart-checkout"), this.$header = $("#header"), this.$navToggle = $(".js-nav-main"), this.overlay = document.getElementById("overlay-minicart"), this.closeButton = document.getElementById("cart-close"), this.cartPromoName = document.getElementById("cart-promo-name"), this.$promoDiscount = $("#cart-promo-discount"), this.$promoEdits = $(".js-cart-promo-edit"), this.$promoEditLower = $(".js-cart-promo-edit-lower"), this.$promoInfoGroups = $(".js-cart-promo-info-group"), this.$promoInputGroups = $(".js-cart-promo-input-group"), this.$promoInputs = $(".js-cart-promo-input"), this.$promoApplys = $(".js-cart-promo-apply"), this.updatableTotals = document.querySelectorAll("#minicart-order-summary .js-updatable"), this.activeRequests = 0, window.AlphabetShimPromise.then(function (t) {
                return function (e) {
                    return t.shim = e, t.shim.translations.fetch(), t.shim.country.fetch(), t.setupOverlay(), t.setupCart(), t.initCart()
                }
            }(this))
        }

        return e.prototype.initCart = function (t) {
            return Spree.ajax({
                dataType: "json", url: Spree.pathFor("dynamic_content"), success: function (e) {
                    return function (n) {
                        return $('meta[name="csrf-token"]').attr("content", n.csrf_token), n.item_count && 0 !== n.item_count && (e.updateCart(n, t), e.$cart.attr("data-currency", n.currency).removeClass("is-empty"), e.setSpreeObjects(n.order_id, n.order_token, n.current_email)), n.logged_in && e.$authLink.attr("href", e.shim.translations.t.minicart.account_path).text(e.shim.translations.t.minicart.account), $(document).trigger("dynamic_content_loaded", [n])
                    }
                }(this)
            })
        }, e.prototype.setSpreeObjects = function (t, e, n) {
            return Spree.current_order_id = t, Spree.current_order_token = e, Spree.current_email = n
        }, e.prototype.updateLineItem = function (t) {
            var e;
            return e = {order: {line_items_attributes: {}}}, e.order.line_items_attributes[t.index] = {
                id: t.id,
                quantity: t.quantity
            }, this.activeRequests++, this.setCartUpdating(), Spree.ajax({
                dataType: "json",
                type: "PATCH",
                dataType: "json",
                url: Spree.pathFor("orders/" + Spree.current_order_id),
                data: e,
                success: function (e) {
                    return function (n) {
                        return e.activeRequests--, e.updateTotals(n.order_summary), 0 === t.quantity && $.each(n.order_ledger, function (t, n) {
                            return e.$productList.children(".js-cart-item[data-id='" + n.item_id + "']").attr("data-line-item-attribute", n.item_index)
                        }), e.unsetCartUpdating()
                    }
                }(this),
                error: function (t) {
                    return function () {
                        return t.activeRequests--, t.notifyError(t.shim.translations.t.minicart.update_error_msg)
                    }
                }(this)
            })
        }, e.prototype.updateCart = function (t, e) {
            var n, i, r, o, s, a, u, l;
            if (a = 0, r = t.order_ledger, l = t.order_summary, this.updateCartCount(t.item_count), n = document.createDocumentFragment(), $.each(r, function (t) {
                    return function (e, i) {
                        var r, o, s, u, l, c, d, h, p, f, m;
                        return u = document.importNode(t.$cartItem[0], !0), c = u.query(".product-image"), f = u.query(".product-title"), d = u.query(".product-options"), l = u.query(".product-item-details"), m = l.query(".item-total"), p = l.query(".item-shipsby"), h = l.query(".item-quantity"), s = u.query(".btn-quantity--increase"), o = u.query(".btn-quantity--decrease"), "dataset" in u ? u.dataset.id = i.item_id : u.setAttribute("data-id", i.item_id), "dataset" in u ? u.dataset.lineItemAttribute = i.item_index : u.setAttribute("data-line-item-attribute", i.item_index), "dataset" in u ? u.dataset.sku = i.item_sku : u.setAttribute("data-sku", i.item_sku), "dataset" in u ? u.dataset.name = i.item_name : u.setAttribute("data-name", i.item_name), "dataset" in u ? u.dataset.price = i.item_price : u.setAttribute("data-price", i.item_price), "dataset" in u ? u.dataset.quantity = i.item_quantity : u.setAttribute("data-quantity", i.item_quantity), "dataset" in u ? u.dataset.options = i.item_size : u.setAttribute("data-options", i.item_size), "dataset" in u ? u.dataset.category = i.item_category : u.setAttribute("data-category", i.item_category), c.setAttribute("alt", i.item_name), c.setAttribute("src", i.item_image_path), f.textContent = i.item_name, d.textContent = t.stripParenthetical(i.item_size), "dataset" in u ? l.dataset.quantity = i.item_quantity : u.setAttribute("data-quantity", i.item_quantity), m.textContent = i.item_total, new Date(i.item_ships_by) > new Date ? p.textContent = "" + t.shim.translations.t.helpers.availability_message.unavailable + i.item_ships_by_formatted : (p.textContent = t.shim.translations.t.helpers.availability_message.available, a++), h.textContent = i.item_quantity, 1 === i.item_quantity ? o.setAttribute("disabled", "disabled") : o.removeAttribute("disabled"), r = t.shim._debounce(t.updateQuantity, 250), s.addEventListener("click", function (e) {
                            var n, i;
                            return i = parseInt(h.textContent, 10) + 1, n = parseInt(t.$cartCount[0].textContent, 10) + 1, h.textContent = i, t.updateCartCount(n), t.toggleQtyButton(o, i), r(e.target, "increase")
                        }), o.addEventListener("click", function (e) {
                            var n, i;
                            return i = parseInt(h.textContent, 10) - 1, n = parseInt(t.$cartCount[0].textContent, 10) - 1, 1 > i ? void 0 : (h.textContent = i, t.updateCartCount(n), t.toggleQtyButton(o, i), r(e.target, "decrease"))
                        }), n.appendChild(u)
                    }
                }(this)), this.$productList[0].innerHTML = "", n.queryAll(".js-item-shipsby").length === a)for (u = n.queryAll(".js-item-shipsby"), i = 0, o = u.length; o > i; i++)s = u[i], s.parentElement.remove();
            return this.$productList[0].appendChild(n), n = null, this.updateTotals(l), this.updatePromoCode(l.promo_name), l.promo_is_referral && this.toggleReferralMode(), e ? (this.showCart(), this.$checkoutBtn.focus()) : void 0
        }, e.prototype.toggleQtyButton = function (t, e) {
            return 1 >= e ? this.disableQtyButton(t) : this.enableQtyButton(t)
        }, e.prototype.disableQtyButton = function (t) {
            return t.classList.add("is-disabled"), t.setAttribute("disabled", "disabled")
        }, e.prototype.enableQtyButton = function (t) {
            return t.classList.remove("is-disabled"), t.removeAttribute("disabled")
        }, e.prototype.updateCartCount = function (t) {
            return this.$cartCount.text(t), 0 === t ? this.$navItemCart.removeClass("has-items") : this.$navItemCart.addClass("has-items")
        }, e.prototype.updateTotals = function (t) {
            return this.$subTotal.html(t.item_total), this.$orderTotal.html(t.total), t.shipment_total ? this.$shipmentTotal.html(t.shipment_total) : this.$shipmentTotal.html(this.shim.translations.t.spree.cart_summary.free_shipping_val), this.testAndInsertValue(t.included_tax_total, this.$includedTaxTotal), this.testAndInsertValue(t.tax_total, this.$salesTax), this.testAndInsertValue(t.promo_total, this.$promoDiscount, "promo")
        }, e.prototype.setupCart = function () {
            return this.$navItemCart.on("click", function (t) {
                return function (e) {
                    return e.preventDefault(), t.showCart()
                }
            }(this)), this.closeButton.addEventListener("click", this.hideCart), this.$productList.on("click", ".js-btn-delete", this.deleteItem), this.$promoEdits.on("click", function (t) {
                return function (e) {
                    return t.editWrapper = $(e.currentTarget).closest(".js-promo-edit-wrapper")[0], t.$promoInfoGroups.filter(function (e, n) {
                        return $.contains(t.editWrapper, n)
                    }).addClass("is-hidden"), t.$promoInputGroups.filter(function (e, n) {
                        return $.contains(t.editWrapper, n)
                    }).removeClass("is-hidden"), t.$promoInputs.filter(function (e, n) {
                        return $.contains(t.editWrapper, n)
                    }).focus()
                }
            }(this)), this.$promoApplys.on("click", this.applyPromoCode), this.$cart.on("submit", function (t) {
                return function (e) {
                    return e.preventDefault(), t.$promoInputs.is(":focus") ? t.applyPromoCode() : void 0
                }
            }(this))
        }, e.prototype.setupOverlay = function () {
            return this.overlay = new this.shim.Overlay("#overlay-minicart", {type: "minicart"}), this.overlay.init(), this.overlay.template.addEventListener("click", this.hideCart)
        }, e.prototype.showCart = function () {
            return document.documentElement.classList.add("is-frozen"), this.overlay.show(), this.$cart.removeClass("is-contracted"), this.$cart.addClass("is-expanded")
        }, e.prototype.hideCart = function () {
            return document.documentElement.classList.remove("is-frozen"), this.overlay.hide(), this.$cart.removeClass("is-expanded"), this.$cart.addClass("is-contracted")
        }, e.prototype.deleteItem = function (t) {
            var e, n, i, r, o, s;
            return e = $(t.currentTarget), n = e.parents(".js-cart-item"), r = parseInt(n.attr("data-quantity"), 10), i = parseInt(this.$cartCount.text(), 10), o = {
                id: n.data("id"),
                index: n.data("line-item-attribute"),
                quantity: 0
            }, this.updateLineItem(o), this.shim.CartAnalytics.removeItem(n), e.attr("disabled", "disabled"), s = function (t) {
                return function () {
                    return n.remove(), 0 === t.$productList.children(".js-cart-item").length ? t.$cart.addClass("is-empty") : void 0
                }
            }(this), n.addClass("slide-up").one("transitionend", function (t) {
                return function () {
                    return s()
                }
            }(this)), Modernizr.csstransitions || s(), this.updateCartCount(i - r)
        }, e.prototype.updateQuantity = function (t, e) {
            var n, i, r, o, s, a, u, l, c, d, h, p;
            if (r = $(t), n = r.parents(".js-cart-item"), i = r.siblings(".js-item-quantity"), c = n[0].query(".item-quantity"), l = parseInt(n.attr("data-quantity"), 10), d = parseInt(c.value ? c.value : c.textContent, 10), o = parseInt(this.$cartCount.text(), 10), d >= 1) {
                if (s = {
                        id: n.data("id"),
                        index: n.data("line-item-attribute"),
                        quantity: d
                    }, u = d * n.data("price"), a = this.shim.priceFormatter(u, !0), this.updateLineItem(s), r.siblings(".js-item-quantity").text(d), n.find(".js-item-total").text(a), n.attr("data-quantity", d), this.updateCartCount(o), "decrease" === e)return p = l - d, this.shim.CartAnalytics.removeItem(n, p);
                if ("increase" === e)return h = d - l, this.shim.CartAnalytics.addItem(n, h)
            }
        }, e.prototype.applyPromoCode = function () {
            var t;
            return t = this.getPromoVal(), t ? (this.activeRequests++, this.setCartUpdating(), Spree.ajax({
                dataType: "json",
                type: "PUT",
                url: Spree.url(Spree.routes.apply_coupon_code(Spree.current_order_id)),
                data: {order_token: Spree.current_order_token, coupon_code: t, source: "minicart"},
                success: function (e) {
                    return function (n) {
                        var i;
                        return i = n.success, e.notifySuccess(i), e.updatePromoCode(t), e.activeRequests--, Spree.current_order_promotion_count = n.promotion_count, e.updateTotals(n.order_summary), e.unsetCartUpdating(), e.convertroTrackSource(n.convertro_enabled, n.convertro_sources)
                    }
                }(this),
                error: function (t) {
                    return function (e, n, i) {
                        var r, o;
                        return r = t.shim.translations.t.minicart.apply_promo_error_msg, o = e.responseJSON.error, t.notifyError(o), t.activeRequests--, t.unsetCartUpdating()
                    }
                }(this)
            })) : void 0
        }, e.prototype.updatePromoCode = function (t) {
            return this.cartPromoName.innerHTML = t, this.$promoInputs.attr({placeholder: t}), t ? this.$cart[0].classList.add("has-promo") : this.$cart[0].classList.remove("has-promo")
        }, e.prototype.toggleReferralMode = function () {
            return this.$promoInfoGroups.addClass("is-referral"), this.cartPromoName.innerHTML = this.shim.translations.t.minicart.referral, this.$promoInputs.attr("placeholder", this.shim.translations.t.minicart.referral)
        }, e.prototype.getPromoVal = function () {
            var t;
            return t = $.map(this.$promoInputs, function (t) {
                return function (t) {
                    var e;
                    return e = t.value.trim(), "" !== e ? e : void 0
                }
            }(this)), t[0]
        }, e.prototype.notifySuccess = function (t) {
            return this.clearNotify(), this.notify = new this.shim.Notify("#cart-notify", {
                msg: t,
                type: "success"
            }), this.notify.init()
        }, e.prototype.notifyError = function (t) {
            return this.clearNotify(), this.notify = new this.shim.Notify("#cart-notify", {
                msg: t,
                type: "error"
            }), this.notify.init()
        }, e.prototype.clearNotify = function () {
            return this.notify && !this.notify.isDestroyed() ? this.notify.destroy() : void 0
        }, e.prototype.setCartUpdating = function () {
            return this.toggleCartUpdating(!0), this.$promoApplys.addClass("is-loading")
        }, e.prototype.unsetCartUpdating = function () {
            return 0 === this.activeRequests ? (this.toggleCartUpdating(!1), this.$promoApplys.removeClass("is-loading")) : void 0
        }, e.prototype.toggleCartUpdating = function (t) {
            var e;
            return e = t ? "add" : "remove", this.$cart[0].classList[e]("is-updating"), Array.prototype.forEach.call(this.updatableTotals, function (t) {
                return t.classList[e]("is-updating")
            })
        }, e.prototype.testAndInsertValue = function (t, e, n) {
            return t ? (e.html(t).parents(".is-hidden").removeClass("is-hidden"), "promo" === n ? (this.$promoInputGroups.addClass("is-hidden"), $("#cart-promo-wrapper-lower").addClass("is-hidden")) : void 0) : e.parents(".minicart-order-summary-item").addClass("is-hidden")
        }, e.prototype.stripParenthetical = function (t) {
            return t.replace(/\s\(.*\)/, "")
        }, e.prototype.convertroTrackSource = function (t, e) {
            return t ? (void 0 === window.$CVO && (window.$CVO = []), $CVO.push(["trackSource", e])) : void 0
        }, e
    }()
}.call(this), function () {
    var t = function (t, e) {
        return function () {
            return t.apply(e, arguments)
        }
    }, e = function (t, e) {
        function i() {
            this.constructor = t
        }

        for (var r in e)n.call(e, r) && (t[r] = e[r]);
        return i.prototype = e.prototype, t.prototype = new i, t.__super__ = e.prototype, t
    }, n = {}.hasOwnProperty;
    Alphabet.Views.AlphabetMod.WarrantyTrial = function (n) {
        function i(e) {
            this.options = null != e ? e : {}, this.starScrollHandler = t(this.starScrollHandler, this), this.scrollTransform = t(this.scrollTransform, this), this.initStarScroll = t(this.initStarScroll, this), this.parallaxHandler = t(this.parallaxHandler, this), this.el = this.options.el, this.$el = $(this.el), this.$smallStars = $(".js-parallax-small-stars"), this.$bigStars = $(".js-parallax-big-stars"), this.parallaxHandler(), $(window).on("resize", this.parallaxHandler)
        }

        return e(i, n), i.prototype.parallaxHandler = function () {
            return window.matchMedia("(min-width: 768px)").matches === !0 ? requestAnimationFrame(this.initStarScroll) : cancelAnimationFrame(this.initStarScroll)
        }, i.prototype.initStarScroll = function () {
            return this.smallStarSpeed = 1 / 6, this.bigStarSpeed = .25, this.starStartAdjustment = 0, this.$smallStars.offset().top > $(window).height() && (this.starStartAdjustment += this.$smallStars.offset().top - $(window).height(), this.scrollTransform(this.$smallStars, -this.starStartAdjustment * this.smallStarSpeed), this.scrollTransform(this.$bigStars, -this.starStartAdjustment * this.bigStarSpeed)), $(window).on("scroll", this.starScrollHandler), $(window).on("pointermove", this.starScrollHandler)
        }, i.prototype.scrollTransform = function (t, e) {
            return t.css("transform", "translate(0," + -e + "px)"), t.css("transform", "translate3D(0," + -e + "px, 0)")
        }, i.prototype.starScrollHandler = function (t) {
            return this.scrollTop = $(window).scrollTop(), this.scrollTransform(this.$smallStars, (-this.starStartAdjustment + this.scrollTop) * this.smallStarSpeed), this.scrollTransform(this.$bigStars, (-this.starStartAdjustment + this.scrollTop) * this.bigStarSpeed)
        }, i
    }(Alphabet.Base)
}.call(this);